export function GetMockCaseList() {
  return [
    {
      applicant: "Lindsay Davey",
      advisor: "Lindsay Davey",
      referralUser: "Lindsay Davey",
      id: 1,
      caseRef: "SAG1",
      referredById: 4,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 500000,
      plotNumber: "3",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "testing",
      dateOfReferral: "2022-02-01T11:17:26.6513783",
      offerExpiryDate: "2022-02-01T00:00:00",
      updatedDate: "2022-07-27T11:41:49.7747173",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 1,
      closedDate: "2022-08-18T00:35:47.8334394",
      isClosed: 1,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Charlie Peagram",
      advisor: "Ian Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 2,
      caseRef: "SAG2",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB",
      dateOfReferral: "2022-02-02T09:21:45.8051183",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-03T15:01:28.0764792",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 6,
      closedDate: "2022-02-11T14:22:38.1620008",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ashley Smith",
      advisor: "Ross Lilley",
      referralUser: "Irina Pinto Coutinho",
      id: 4,
      caseRef: "SAG4",
      referredById: 25,
      caseStatusId: 26,
      developmentId: 5,
      purchasePrice: 265000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB",
      dateOfReferral: "2022-02-02T10:02:30.6776205",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-12-19T16:55:02.6222499",
      isDeleted: 0,
      advisorId: 438,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 2,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Anupama Jain",
      advisor: "Nadia Bandula ",
      referralUser: "Kayleigh Ward                                 ",
      id: 5,
      caseRef: "SAG5",
      referredById: 24,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "",
      dateOfReferral: "2022-02-02T11:54:21.4356435",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-09T11:09:04.4425302",
      isDeleted: 1,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 1350,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage ",
      financialDetailsId: 3,
      closedDate: "2022-02-02T17:38:34.1152375",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chloe McFetridge",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 7,
      caseRef: "SAG7",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "Plot 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Friday after 2pm as Chloe will have finished work\n\nCalled on 4/2/22 and spoke with Chloe. Emailed to request payslips to assess income correctly.\n\nWorks in NHS as a HCA. Also does BANK work. \n\nStarted the job 5 weeks ago after moving from London working in a care home. No gap in employment. ",
      dateOfReferral: "2022-02-02T16:06:33.6495535",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T15:36:08.7503988",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 4500,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 15,
      closedDate: "2022-02-17T09:36:27.4739865",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Becky Holman",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 8,
      caseRef: "SAG8",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "Plot 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call after 4pm as Becky is a teacher\n\nThe customer did not meet affordability on the HCA due to outgoings and high FMV. \n\nCustomer just wanted information and does not want to look at any other properties. ",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-03T16:49:49.6632152",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 9,
      closedDate: "2022-02-03T16:49:54.234612",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "James Castor",
      advisor: "Deonne Samuels",
      referralUser: "Lia Wilkerson                                   ",
      id: 10,
      caseRef: "SAG10",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "only looking at the 2 beds not 1 beds, first time buyer\n\nno answer, left mess ",
      dateOfReferral: "2022-02-03T10:16:45.8834404",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T15:40:12.2007757",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-13T09:20:27.3957845",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mr Jassa Dhesi",
      advisor: "Christopher Taylor",
      referralUser: "Ara Stott                                            ",
      id: 11,
      caseRef: "SAG11",
      referredById: 22,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Case qualifies up to 70% and fits with leeds. Client wishes to see some properties you have available.",
      dateOfReferral: "2022-02-03T12:39:15.004249",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T10:35:40.7670012",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 7,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nicola Brindley",
      advisor: "Christopher Taylor",
      referralUser: "Joe Evans",
      id: 12,
      caseRef: "SAG12",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "plot 27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Nicola is interested in buying Plot 27, 83 Sorrel Close, Uttoxeter through us. she owns her house and we have valued it on 2/2/2022 for £190,000. she needs mortgage advice asap please and info on what share she can afford on this plot. she has 2 teenage kids living with her. please call friday 4/2/2022 between 11am and 2pm. thanks, Jo Evans (1908770)",
      dateOfReferral: "2022-02-03T13:07:56.9152856",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-07T11:28:48.0243652",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 11,
      closedDate: "2022-03-07T11:57:05.8472542",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ryan Christopher Sadler",
      advisor: "Arjun Dhunna",
      referralUser: "Ara Stott                                            ",
      id: 13,
      caseRef: "SAG13",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in one or two beds, which ever he can afford\n\nLM as no answer @13:19",
      dateOfReferral: "2022-02-03T13:08:33.0110888",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-08T11:00:22.3507111",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 8,
      closedDate: "2022-03-08T16:27:44.9319018",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Thomas Christopher Corbyn",
      advisor: "Steven Sanderson",
      referralUser: "Ara Stott                                            ",
      id: 14,
      caseRef: "SAG14",
      referredById: 22,
      caseStatusId: 28,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "3/2/22@to call back after 4.30pm\n\ntest test test",
      dateOfReferral: "2022-02-03T14:35:44.2076213",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T17:08:11.0345562",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 10,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Amy Keeling",
      advisor: "Laura Turner",
      referralUser: "Joe Evans",
      id: 15,
      caseRef: "SAG15",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She is interested in the new plots coming at Stafford Road Penkridge, which are due for release end Feb 2022. She is on the waiting list but wants pre-qualification checks done now in readiness. please call FRIDAY 04/02/2002. Thanks Jo",
      dateOfReferral: "2022-02-03T17:00:48.2138797",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T15:01:20.9933299",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 17250,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 13,
      closedDate: "2022-08-18T00:36:37.2820479",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Danielle Burks",
      advisor: "Christopher Taylor",
      referralUser: "Ara Stott                                            ",
      id: 16,
      caseRef: "SAG16",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Calling 12:00pm on Monday 7th Feb.\n\nSpoke with client. Is getting back to me later this week to confirm go-ahead.\n\nClient is employed - system won't let me change it (bug)",
      dateOfReferral: "2022-02-03T17:46:00.6635657",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-04T16:41:33.8328924",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 19,
      closedDate: "2022-06-27T09:15:07.8816335",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Cristina Constantinescu",
      advisor: "Gemma Painter",
      referralUser: "Ara Stott                                            ",
      id: 17,
      caseRef: "SAG17",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 187498,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-04T08:53:37.5345492",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T15:37:33.9300011",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 12,
      closedDate: "2022-06-28T08:13:47.0995649",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Diane Johnson",
      advisor: "Nadia Bandula ",
      referralUser: "Irina Pinto Coutinho",
      id: 18,
      caseRef: "SAG18",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "CASH BUYER. Already in shared ownership, selling her share and needs a new place. \n\nCustomer receives state pension and pension credits.",
      dateOfReferral: "2022-02-04T09:12:22.2097557",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-04T17:47:20.3017672",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 16,
      closedDate: "2022-02-04T17:51:50.2276568",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Elaine Fallon ",
      advisor: "Nadia Bandula ",
      referralUser: "Irina Pinto Coutinho",
      id: 19,
      caseRef: "SAG19",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 101250,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "CASH BUYER. Was living with partner but they've now split up & she can't afford to buy outright so wats shared ownership. ",
      dateOfReferral: "2022-02-04T09:15:53.4505193",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-09T11:08:47.0516572",
      isDeleted: 1,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 105000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 14,
      closedDate: "2022-02-04T13:14:17.2851591",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jodi Spence",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lia Wilkerson                                   ",
      id: 20,
      caseRef: "SAG20",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 13250,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "she's SSTC and know it needs to complete before she can complete on these, she doesnt know what her deposit would be wants to discuss it with you as would com from the sale. \nOpen to 1 and 2 bed property so please check affordability if needed on 1 beds.",
      dateOfReferral: "2022-02-04T13:40:38.5623452",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-04T16:39:46.1464219",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 1350,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-07T11:29:33.3617797",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "test",
      advisor: "Lindsay Davey",
      referralUser: "Trevor Hicks",
      id: 21,
      caseRef: "SAG21",
      referredById: 1,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 123,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-02-04T14:59:46.4680688",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T12:39:59.0378406",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 39,
      depositLevel: 123,
      serviceCharge: 123,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-18T00:37:09.1809419",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Winfred Wanjiru Kamau",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Laura Jones",
      id: 22,
      caseRef: "SAG22",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-04T16:06:36.9060946",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-08T12:46:36.726377",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 7375,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 18,
      closedDate: "2022-02-08T12:46:42.1737372",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Brenda Paterson",
      advisor: "Christopher Taylor",
      referralUser: "Nicola Pike",
      id: 24,
      caseRef: "SAG24",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "130",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Cash purchase affordability check only.\n\nCalled 9:30am on 7/2. Left v/m - sent follow up email.\n\nSpoke with client. Affordability calculator done.\n\n",
      dateOfReferral: "2022-02-04T16:45:12.7078507",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-09T10:38:36.6238361",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 142500,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 23,
      closedDate: "2022-06-27T09:46:18.0549249",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Abbie Eastwick",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 25,
      caseRef: "SAG25",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Public safety and national security staff: police and support staff.\n\nCalled 9:45am on 7/2 - left v/m",
      dateOfReferral: "2022-02-04T16:59:51.4250919",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-07T09:48:27.1297715",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 1200,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-14T10:12:39.2744199",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rachel Murphy ",
      advisor: "Paul Parker",
      referralUser: "Ara Stott                                            ",
      id: 26,
      caseRef: "SAG26",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Scheduled time to call - Thursday 10th Feb @ 5:30pm\n\nDidn't answer call at scheduled time. above Left v/m and sent email to request another day/time to suit her. \n\n",
      dateOfReferral: "2022-02-05T16:16:21.7508476",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T09:45:09.9241883",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-02-17T09:36:44.1099604",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emma Smith xxx",
      advisor: "Steven Sanderson",
      referralUser: "Ara Stott                                            ",
      id: 27,
      caseRef: "SAG27",
      referredById: 22,
      caseStatusId: 35,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "savings of 7k gift 7k - parents ",
      dateOfReferral: "2022-02-07T09:11:44.4030064",
      offerExpiryDate: "2022-11-05T00:00:00",
      updatedDate: "2022-09-21T16:48:57.8465928",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 24,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Samantha Mills",
      advisor: "Gemma Painter",
      referralUser: "Irina Pinto Coutinho",
      id: 29,
      caseRef: "SAG29",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB",
      dateOfReferral: "2022-02-07T09:29:19.5699565",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T16:24:12.2605394",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 17,
      closedDate: "2022-06-28T08:17:23.223249",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ryan Wyatts CC",
      advisor: "Laura Turner",
      referralUser: "Lia Wilkerson                                   ",
      id: 30,
      caseRef: "SAG30",
      referredById: 23,
      caseStatusId: 32,
      developmentId: 5,
      purchasePrice: 95000,
      plotNumber: "85",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "ftb - open to any 1 beds\n\n16.2.22 - lm to see if still interested",
      dateOfReferral: "2022-02-07T11:49:29.2762988",
      offerExpiryDate: "2022-10-27T23:00:00",
      updatedDate: "2022-09-20T10:04:29.6290058",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1350,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 20,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alfie Endicott",
      advisor: "Deonne Samuels",
      referralUser: "Lia Wilkerson                                   ",
      id: 31,
      caseRef: "SAG31",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB, any 1 beds ",
      dateOfReferral: "2022-02-07T11:51:42.0892061",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-07T12:47:06.0284092",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1350,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-16T15:41:02.6127598",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Daniela De Cervo",
      advisor: "Laura Turner",
      referralUser: "Charlotte Tomlinson",
      id: 32,
      caseRef: "SAG32",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118748,
      plotNumber: "plot 173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This lead came in as new but is an existing client of  Andrew Shields from late 2021.",
      dateOfReferral: "2022-02-07T11:56:45.1971119",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T17:54:46.9217895",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing ",
      financialDetailsId: null,
      closedDate: "2022-02-14T10:48:10.710941",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gvido Greinis",
      advisor: "Laura Turner",
      referralUser: "Charlotte Tomlinson",
      id: 33,
      caseRef: "SAG33",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "plot 173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-07T12:03:17.256805",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T17:57:19.569407",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing",
      financialDetailsId: 25,
      closedDate: "2022-02-22T10:12:13.106583",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Bolanle Bolaji",
      advisor: "Ian Parker",
      referralUser: "Ara Stott                                            ",
      id: 34,
      caseRef: "SAG34",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Interested in 2-bed flat instead - 50% = 132500.",
      dateOfReferral: "2022-02-07T16:04:29.9693338",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T18:25:53.2030852",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 22,
      closedDate: "2022-03-25T15:13:52.4336269",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jestina Diggs",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 35,
      caseRef: "SAG35",
      referredById: 54,
      caseStatusId: 26,
      developmentId: 4,
      purchasePrice: 295,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-07T16:59:14.9228254",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-07T17:23:51.6690317",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Shannah Cummings",
      advisor: "Aidan Pearce ",
      referralUser: "Ara Stott                                            ",
      id: 36,
      caseRef: "SAG36",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "been at current address for 12 years- living with parents ",
      dateOfReferral: "2022-02-08T09:08:52.3629126",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T11:08:48.7958382",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: 34000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 26,
      closedDate: "2022-02-11T11:20:08.2153226",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Yasmine Brassington ",
      advisor: "Arjun Dhunna",
      referralUser: "Eleanor Forbes",
      id: 37,
      caseRef: "SAG37",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "Plot 143",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-08T09:41:46.3952494",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T09:26:58.1020098",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-03-22T10:16:16.2184683",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Harley Furlong",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 38,
      caseRef: "SAG38",
      referredById: 25,
      caseStatusId: 29,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call around lunch time. Deposit can be £15,000 if need be.\n\nbeen at address for 10 years -living at home ",
      dateOfReferral: "2022-02-08T09:44:24.0588526",
      offerExpiryDate: "2022-11-05T00:00:00",
      updatedDate: "2022-05-10T08:46:46.6344106",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 27,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 51,
      lnhManagerId: null,
    },
    {
      applicant: "Samuel Frampton",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 39,
      caseRef: "SAG39",
      referredById: 25,
      caseStatusId: 33,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Employed by Thurrock Council. Parents are happy to be guarantors or bump up his deposit.\n\nbeen living at address since 2014 - parents address\n\nplease email first to arrange a time to speak to client and please note client is at funeral on 10th and 11th ",
      dateOfReferral: "2022-02-08T15:19:46.7697749",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:18:09.2111771",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 28,
      closedDate: "2022-02-08T16:46:02.649271",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sharon Liburd",
      advisor: "Ian Parker",
      referralUser: "Nicola Pike",
      id: 40,
      caseRef: "SAG40",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "173, 13 Cavalier Way",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Call anytime and voicemail if no answer.\n\nLegals sold\n\nclient has A.I.P with pepper for £150k and she wants the max share poss - ",
      dateOfReferral: "2022-02-09T11:46:40.1164047",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T14:30:19.7079435",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 31,
      closedDate: "2022-06-21T08:58:08.2283724",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Togcan Altinar",
      advisor: "Deonne Samuels",
      referralUser: "Lia Wilkerson                                   ",
      id: 41,
      caseRef: "SAG41",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 95000,
      plotNumber: "85",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTb, open to any 1 beds\n\nbeen at this property for 9 years- mum and dads ",
      dateOfReferral: "2022-02-09T12:30:12.5409051",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-14T16:20:26.4988347",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 8500,
      serviceCharge: 1350,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 29,
      closedDate: "2022-02-14T16:21:04.1626684",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kirsty Buckley",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Tomlinson",
      id: 42,
      caseRef: "SAG42",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "19 TERENCE AVE IS MUMS HOME AND WAS THERE FOR 1 YEAR \n\nCURRENTLY LIVES AT 11 RHODFA FLINT \nLL18 5WK - 5 MONTHS ",
      dateOfReferral: "2022-02-09T13:12:27.8526404",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-09T15:46:23.2871913",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 150000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing ",
      financialDetailsId: 30,
      closedDate: "2022-02-09T16:14:22.399365",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sue Stone",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Tomlinson",
      id: 43,
      caseRef: "SAG43",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 95000,
      plotNumber: "plots 172 /173 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-09T13:14:29.2986824",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T12:55:07.9525654",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 32,
      closedDate: "2022-02-11T13:27:36.3825493",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nick Parker",
      advisor: "Deonne Samuels",
      referralUser: "Nicola Pike",
      id: 44,
      caseRef: "SAG44",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-09T17:42:48.4976232",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-10T11:09:17.4128776",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Bethany Street",
      advisor: "Deonne Samuels",
      referralUser: "Ara Stott                                            ",
      id: 45,
      caseRef: "SAG45",
      referredById: 22,
      caseStatusId: 26,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-10T12:15:49.5869098",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T10:31:22.260496",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Maria Joyce Locuna Dougan",
      advisor: "Deonne Samuels",
      referralUser: "Ara Stott                                            ",
      id: 46,
      caseRef: "SAG46",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "- also getting gifted deposit from mother, didn't tell me figure\n\nbeen at address last 5 years  -living with sister ",
      dateOfReferral: "2022-02-10T12:17:48.4508747",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T14:24:35.5899989",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 33,
      closedDate: "2022-02-11T14:24:43.2220768",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rebecca Manson",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 47,
      caseRef: "SAG47",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 4,
      purchasePrice: 295,
      plotNumber: "27",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-10T12:37:47.7121967",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T12:58:34.8344584",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 77,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Marcy Keeley",
      advisor: "Paul Parker",
      referralUser: "Ara Stott                                            ",
      id: 48,
      caseRef: "SAG48",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called on 11/2 and client was unavailable to call. \n\nRe-scheduled for Monday morning at c.9:30am.\n\nCall client and phone went straight to voicemail. will trying again later today (14th)\n\nNo answer - closing lead",
      dateOfReferral: "2022-02-10T16:36:51.2408943",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T10:24:37.6108101",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-16T10:24:45.8792465",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MR SCOTT CREELMAN",
      advisor: "Nadia Bandula ",
      referralUser: "Joe Evans",
      id: 49,
      caseRef: "SAG49",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "BUYER IS VIEWING PLOT 27, 83 SORREL CLOSE ON WEDNESDAY 16/02/2022. IN RENTED - PLEASE CALL FRIDAY 11/02/2022 TO SO FULL MORTGAGE ADVICE AND SAGE CHECKS. MANY THANKS, JO (1908770)\n\n\nSpoke to Scott, and I need further documentation in order to verify his income and to be able to qualify him. He knows what documents he needs to send to me, and he should deliver those to me next week. ",
      dateOfReferral: "2022-02-11T10:34:38.5750486",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-11T18:57:51.3822116",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 7250,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "",
      financialDetailsId: null,
      closedDate: "2022-05-04T14:34:01.2601613",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Josh George",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Tomlinson",
      id: 50,
      caseRef: "SAG50",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "plot 173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "living here for 1 year and lives with grandma",
      dateOfReferral: "2022-02-11T14:23:55.4313139",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T14:52:05.845527",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 3000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 34,
      closedDate: "2022-03-09T14:28:27.2034644",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ellie Kettridge",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 51,
      caseRef: "SAG51",
      referredById: 54,
      caseStatusId: 26,
      developmentId: 4,
      purchasePrice: 295,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "been here for 4 years renting with partner ",
      dateOfReferral: "2022-02-11T15:41:48.3369425",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-17T13:48:29.5558725",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 50,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lauren Cooper",
      advisor: "Deonne Samuels",
      referralUser: "Ara Stott                                            ",
      id: 52,
      caseRef: "SAG52",
      referredById: 22,
      caseStatusId: 28,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "been at current address for just over one year -living with parents \n\nhad property with ex which she sold in 2021",
      dateOfReferral: "2022-02-11T16:38:16.9040006",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T14:52:35.6506466",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 35,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jessica Davies",
      advisor: "Deonne Samuels",
      referralUser: "Nicola Pike",
      id: 53,
      caseRef: "SAG53",
      referredById: 29,
      caseStatusId: 28,
      developmentId: 1,
      purchasePrice: 220000,
      plotNumber: "173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "BEEN AT ADDRESS SINCE AUG 2021 - LIVING WITH PARENTS \n\nBTB",
      dateOfReferral: "2022-02-12T13:04:13.5251788",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T14:53:43.2871928",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 36,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Bethany Selfe",
      advisor: "Deonne Samuels",
      referralUser: "Ara Stott                                            ",
      id: 54,
      caseRef: "SAG54",
      referredById: 22,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works 9-6 so she gets a break around 1-2 so try her mob if not the alternative no is her work phone, she is also available saturdays",
      dateOfReferral: "2022-02-12T14:15:35.4685356",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T16:36:07.5812372",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1201,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 46,
      closedDate: "2022-02-24T11:32:18.0618406",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Richard Worth",
      advisor: "Deonne Samuels",
      referralUser: "Nicola Pike",
      id: 55,
      caseRef: "SAG55",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "Plot 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please can you call Richard asap\n\ncurrently house in on market and been there for one year - offer is higher than expected so may be able to  put in  more  depending on offer \n\nlooking for the max share he can afford",
      dateOfReferral: "2022-02-12T16:23:21.2075015",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-14T12:35:27.1378603",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 37,
      closedDate: "2022-02-24T10:35:26.5870633",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Austen Hardie",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 56,
      caseRef: "SAG56",
      referredById: 25,
      caseStatusId: 26,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Care Assistant",
      dateOfReferral: "2022-02-12T16:42:54.4246983",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-14T08:54:07.4587652",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 2000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jack Grindlay",
      advisor: "Deonne Samuels",
      referralUser: "Eleanor Forbes",
      id: 57,
      caseRef: "SAG57",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 237500,
      plotNumber: "173",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit of £18,000 will be sale proceeds - house is on the market \n\n3 yrs at current address STC",
      dateOfReferral: "2022-02-14T09:40:33.4255206",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-14T13:57:30.6582719",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 38,
      closedDate: "2022-02-14T13:58:24.3749035",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Faye Frost",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Irina Pinto Coutinho",
      id: 58,
      caseRef: "SAG58",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with her son. Faye has an IVA but has received inheritance of £100,000. Currently in rented accommodation paying over £800 a month, \nSon is 18 years old - works in Forex Trading in London but only started 3 months ago.",
      dateOfReferral: "2022-02-14T13:40:31.5546854",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-15T09:30:22.5297465",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-18T16:45:47.6658364",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Crone",
      advisor: "Deonne Samuels",
      referralUser: "Lia Wilkerson                                   ",
      id: 59,
      caseRef: "SAG59",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 95000,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB open to 1 beds as well as 2, put the detail in for 2 bed but please check 1 bed as well if needed\n\n17 YEARS at current property , living with parents ",
      dateOfReferral: "2022-02-14T18:00:04.5772705",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-15T17:08:08.7533332",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 39,
      closedDate: "2022-02-15T17:08:17.7557064",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "John  Emery",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 60,
      caseRef: "SAG60",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-15T09:58:46.9579937",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-15T15:53:13.7433222",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 73750,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 40,
      closedDate: "2022-02-15T15:57:35.1131164",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jodie Willis",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 61,
      caseRef: "SAG61",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking to purchase alone as partner as he has bad credit and he went on monthly payments / rates will be too high. his daughters will be leaving with them (not Jodie's kids)\n\nbeen at current address for 16 years - living with parents \n\nlooking for max share ",
      dateOfReferral: "2022-02-15T10:45:58.5610036",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-15T16:41:59.7962749",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 41,
      closedDate: "2022-02-15T16:42:08.802683",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Perry Gale",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 62,
      caseRef: "SAG62",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - Public and environmental health staff. Perry & his 2 little boys\n\n#BEEN AT ADDRESS for 16 years with parents",
      dateOfReferral: "2022-02-15T11:13:42.6338534",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T11:11:15.4167783",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 8500,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 43,
      closedDate: "2022-02-16T11:11:31.896668",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jean Barnard-Hadley",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Irina Pinto Coutinho",
      id: 63,
      caseRef: "SAG63",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "2x pensions - £13000 a year",
      dateOfReferral: "2022-02-15T11:35:07.8081914",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-17T13:38:17.4854004",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-17T13:41:05.9534158",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Cathy Smedley",
      advisor: "Mark Ross",
      referralUser: "Nicola Pike",
      id: 64,
      caseRef: "SAG64",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "Plot 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals Sold\n\nPlease call before 9am or after 5pm thanks.",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T09:57:09.4048466",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 54,
      closedDate: "2022-02-24T09:57:52.2526488",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Curtis Millar",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 65,
      caseRef: "SAG65",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "3 years at current address- staying with fam",
      dateOfReferral: "2022-02-15T13:52:32.3340762",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T16:10:58.1563115",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 3000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 45,
      closedDate: "2022-02-16T16:11:07.7474251",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Matthew Douthwaite ",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 66,
      caseRef: "SAG66",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Ambulance care assistant\n\nbeen at property since 23 year - live with mum ",
      dateOfReferral: "2022-02-15T14:07:15.6008799",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-15T17:15:49.0892609",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 42,
      closedDate: "2022-02-15T17:15:56.2839456",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Georgina Baker",
      advisor: "Deonne Samuels",
      referralUser: "Claire Jenks",
      id: 67,
      caseRef: "SAG67",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "Plot 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in shared ownership on kingsbourne please call today if poss\n\n22 years at current property - tenant \n\nowned property before and sold it 5 years  - currently going through separation ",
      dateOfReferral: "2022-02-15T15:35:52.7345284",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T12:56:07.7920569",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 84,
      closedDate: "2022-02-25T12:57:10.7315229",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Seb Seville",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Tomlinson",
      id: 68,
      caseRef: "SAG68",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 95000,
      plotNumber: "Langport 144, 143 ,132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "been at current for around 4 years- living with parent \n\nmax shar which is affordable",
      dateOfReferral: "2022-02-15T16:02:37.6500235",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-16T11:38:55.9279301",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 44,
      closedDate: "2022-02-16T11:43:42.6331425",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Laura Everall",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 69,
      caseRef: "SAG69",
      referredById: 54,
      caseStatusId: 26,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking to sell her shared ownership in stone as needs to move away from area and upsize - has booked in a RICS val but sent referral through so i can book in viewing on property when she has sold  \n\nwants 75% share \n\n",
      dateOfReferral: "2022-02-15T16:28:41.6300219",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-19T14:14:47.4074148",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 73750,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 56,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "John Thornley",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 70,
      caseRef: "SAG70",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "available to speak after 12 on 16/02 \n\n5 YEARS - RENTING \n\nPARTNER WON'T BE GOING ON PROPERTY AS UNEMPLOYED \n\nMAX SHARE HE CAN HAVE ",
      dateOfReferral: "2022-02-15T17:03:53.7922387",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-18T14:37:48.3921795",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 49,
      closedDate: "2022-02-18T14:42:07.119797",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Amy Denton",
      advisor: "Deonne Samuels",
      referralUser: "Nicola Pike",
      id: 71,
      caseRef: "SAG71",
      referredById: 29,
      caseStatusId: 27,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "Plot 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Legals Sold\n\nPlease call after 5pm thanks\n\nJason been at property for 12 months ",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-19T14:04:13.3476849",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 47,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Hanif Motiwala",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 72,
      caseRef: "SAG72",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Senior consultant - cancer surgeon at Southend Hospital",
      dateOfReferral: "2022-02-16T10:10:38.6850734",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-17T13:47:50.565474",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 48,
      closedDate: "2022-06-27T09:21:26.6249432",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lucas Vale",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Laura Jones",
      id: 73,
      caseRef: "SAG73",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-16T11:26:12.9043511",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-18T10:42:59.0586707",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 51,
      closedDate: "2022-02-18T10:45:15.6790089",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lewis whitehouse",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Laura Jones",
      id: 74,
      caseRef: "SAG74",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call after 15:00PM today 16/02 - free anytime tomorrow ",
      dateOfReferral: "2022-02-16T11:36:04.6381288",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-17T14:57:02.8998286",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-02-23T10:24:05.5548664",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alina Ichim",
      advisor: "Mark Ross",
      referralUser: "Lia Wilkerson                                   ",
      id: 75,
      caseRef: "SAG75",
      referredById: 23,
      caseStatusId: 35,
      developmentId: 5,
      purchasePrice: 101250,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "interested in 2 beds but if cant then interested in plot 66 on for £101250.\nI didn't get how much deposit she has apologise.",
      dateOfReferral: "2022-02-16T12:48:53.0908224",
      offerExpiryDate: "2023-03-26T23:00:00",
      updatedDate: "2022-07-04T09:23:02.5635898",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 53,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Melissa Jayne Williams",
      advisor: "Laura Turner",
      referralUser: "Laura Jones",
      id: 76,
      caseRef: "SAG76",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-16T12:54:21.7848835",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-18T18:01:20.1081235",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 52,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Daniella Stark",
      advisor: "Christopher Taylor",
      referralUser: "Lia Wilkerson                                   ",
      id: 77,
      caseRef: "SAG77",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 265000,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "her and her partner Kyle Stuart, both FTB, if they cant afford the 2 bed please check 1 beds - £101250",
      dateOfReferral: "2022-02-16T15:33:48.7404454",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T13:14:38.2848193",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 26000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 64,
      closedDate: "2022-02-25T11:21:20.5928207",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Suzanne Gelshon",
      advisor: "Mark Ross",
      referralUser: "Eleanor Forbes",
      id: 78,
      caseRef: "SAG78",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Deposit will come from sale proceeds \n",
      dateOfReferral: "2022-02-16T15:46:25.6325831",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-25T13:34:00.3328979",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 55,
      closedDate: "2022-08-15T09:19:18.1659995",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tofunmi Lanipekun",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 79,
      caseRef: "SAG79",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "IT Consultant\n\nlives with parents been there 20 years",
      dateOfReferral: "2022-02-16T15:47:51.3260783",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-21T12:43:51.5033835",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 58,
      closedDate: "2022-02-24T10:33:08.4804938",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Andrew Batty",
      advisor: "Mark Ross",
      referralUser: "Charlotte Tomlinson",
      id: 80,
      caseRef: "SAG80",
      referredById: 32,
      caseStatusId: 34,
      developmentId: 1,
      purchasePrice: 95000,
      plotNumber: "Plot 142 132 langport ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Call scheduled for 6pm on 21/2",
      dateOfReferral: "2022-02-17T11:37:13.1440225",
      offerExpiryDate: "2022-10-31T00:00:00",
      updatedDate: "2022-06-27T08:34:02.9672431",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 63,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "RICKY BENNETT",
      advisor: "Ian Parker",
      referralUser: "Joe Evans",
      id: 81,
      caseRef: "SAG81",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "RICKY WOULD LIKE A CALL TODAY PLEASE (FRI 18/2/22) HE IS A FTB LOOKING AT THE NEW SAGE PLOTS AT PENKRIDGE. THESE WILL BE RELEASED END OF FEB AND WILL BE BUILD COMPLETE END AUG 2022. PRICES TBC FROM SAGE ALTHOUGH 2 BEDS SHOULD BE AROUND £230K.",
      dateOfReferral: "2022-02-18T08:52:47.7545832",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-07T17:54:16.05517",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 79,
      closedDate: "2022-06-27T16:41:26.6123153",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "rachael makinson",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 82,
      caseRef: "SAG82",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 210000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking at 50% share or more \n\nbeen there oct 2017- renting\n\nFTB \n\n4 bed classed as MUSE",
      dateOfReferral: "2022-02-18T11:17:52.2682942",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T12:08:20.9027915",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 74,
      closedDate: "2022-02-24T12:08:40.1563988",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rebecca Massey",
      advisor: "Deonne Samuels",
      referralUser: "Joe Evans",
      id: 83,
      caseRef: "SAG83",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "tbc",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call rebecca in next 24 hours. she is interested in getting checks done now for new sage houses at stafford rd which should be released at the end of feb 2022. she is looking for a 3 bed house ideally (prices tbc bt should be around 240-260k) SEMO DETACHED \n\n50%\n\nbeen there 33 years - living with parents\n\nFTB\n\n",
      dateOfReferral: "2022-02-18T11:32:36.5616031",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T12:33:19.598999",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 60,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 76,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gary peach",
      advisor: "Mark Ross",
      referralUser: "Laura Jones",
      id: 84,
      caseRef: "SAG84",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "6 years at property - tenant \n\n25-50% share ",
      dateOfReferral: "2022-02-18T12:05:08.3875114",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T12:58:36.2435831",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 57,
      closedDate: "2022-02-22T14:48:43.237991",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Miss Sophie Swift",
      advisor: "Paul Parker",
      referralUser: "Joe Evans",
      id: 85,
      caseRef: "SAG85",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "tbc",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call sophie to do sage checks as interested in the new 6 plots we will be getting at the end of feb at stafford rd site. JE\n\nCalled on 21/2 and sent email. no response back yet.\n\nBooked call for Monday 28/2 at 6pm",
      dateOfReferral: "2022-02-18T13:08:34.9683324",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T16:00:07.3691988",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-01T13:38:44.7188147",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Martin Hunter ",
      advisor: "Mark Ross",
      referralUser: "Emily Balloch",
      id: 86,
      caseRef: "SAG86",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "hatfield peverel site - NOT  Beaulieu - not able to pick site \n\nnot spoken to anyone about the mortgage before looking for advice ",
      dateOfReferral: "2022-02-18T14:00:42.2120284",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T12:58:27.6247952",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 59,
      closedDate: "2022-04-16T14:55:39.7681523",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Miss Farhena Begum",
      advisor: "Paul Parker",
      referralUser: "Joe Evans",
      id: 87,
      caseRef: "SAG87",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "203 to 205",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "interested in the shared ownership apartments at the fairways. 100% value is £160k. we are awaiting them to be build complete and receive the keys. Farhena would like the sage checks/FS advice now so she can apply if likes when we have access. JE\n\nSpoke on 21/2 - said she wants to put on hold for a couple weeks whilst her ex, who's buying her out, get things sorted.\n\nShe will get back in contact with me at that point.",
      dateOfReferral: "2022-02-18T14:08:07.6981381",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T12:58:39.8826895",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 120,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 60,
      closedDate: "2022-02-25T16:00:38.3299656",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Stephen Walls",
      advisor: "Steven Sanderson",
      referralUser: "Emily Balloch",
      id: 88,
      caseRef: "SAG88",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT Beaulieu - Hatfield Peverel - not bale to select this site \n\nwants mortgage advice - she has a lifetime ISA ",
      dateOfReferral: "2022-02-18T14:41:15.2889907",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-01T17:06:18.0739124",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 66,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chilala Choobe ",
      advisor: "Laura Turner",
      referralUser: "Emily Balloch",
      id: 89,
      caseRef: "SAG89",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT Beaulieu - Hatfield Peverel - not bale to select this site \n\nCalled c. 4pm 21/2 - waiting for payslips and credit file.",
      dateOfReferral: "2022-02-18T14:43:05.7542185",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-22T16:59:43.5193868",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 62,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chantelle Nugent",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 90,
      caseRef: "SAG90",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT  Beaulieu - Hatfield Peverel - not able to pick site \n\nnot spoken to anyone about the mortgage for quite a while so looking for advice \n\nEmailed on 4/7 to reconnect and book a call. No response yet.",
      dateOfReferral: "2022-02-18T14:46:08.0315316",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T13:03:55.0818139",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 67,
      closedDate: "2022-08-01T09:55:12.6020301",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gemma Sanderson",
      advisor: "Andrew Shields",
      referralUser: "Emily Balloch",
      id: 91,
      caseRef: "SAG91",
      referredById: 64,
      caseStatusId: 26,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT Beaulieu - Hatfield Peverel - not able to pick this site \n\nAIP expired so looking for more advice.\n\nCalled 23/2. Booked call for 4pm on 23/2.\n\nAndrew Shields dealt with before so passed to him.",
      dateOfReferral: "2022-02-18T14:51:10.3191025",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:09:18.96731",
      isDeleted: 1,
      advisorId: 12,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kevin Cherrington",
      advisor: "Paul Parker",
      referralUser: "Claire Jenks",
      id: 92,
      caseRef: "SAG92",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called 23/2 - left V/m and sent email.\n\nNot SSTC. Still unsure what he wants to do but he will keep in touch. \n\n",
      dateOfReferral: "2022-02-18T15:07:54.1722025",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T15:17:19.9254874",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 90000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-02-23T15:17:57.2564515",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ruth Duarte",
      advisor: "Ian Parker",
      referralUser: "Emily Balloch",
      id: 93,
      caseRef: "SAG93",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT Beaulieu - Hatfield Pev site - not able to select \n\nnot spoken to any for a while - looking for mortgage advice \n\nCalled on 22/2. Left voicemail\n\nSpoke on 23/2 - awaiting documents to confirm income/credit history. Sent email \n\nReceived documents. Qualified on 24/2 to take on next steps",
      dateOfReferral: "2022-02-18T15:13:26.9509888",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-26T10:10:10.2032663",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 73,
      closedDate: "2022-03-17T17:48:12.8502578",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Romario Dunne",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 94,
      caseRef: "SAG94",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 310000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT Beaulieu - Hatfield Pev - not able to select \n\nwould like mortgage advice.\n\nCalled on 23/2 at 1:15.\n\nBooked to call at 1pm on 24/2 - didn't answer and left v/m\n\nSent email to arrange new date/time.",
      dateOfReferral: "2022-02-18T17:25:21.7388832",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T16:19:27.3505273",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: null,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-01T13:37:03.3844769",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chandra Sullivan",
      advisor: "Laura Turner",
      referralUser: "Ara Stott                                            ",
      id: 95,
      caseRef: "SAG95",
      referredById: 22,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 265000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Lia's applicant but is off on holiday\n\n- WANTS TWO BED \n- IS BUYING WITH PARTNER \n\nCalled and spoke at 23/2 1:30pm.\n\nWaiting for payslips to confirm income - might be tight on affordability based on talking over the phone. \n\nHave Payslips and will pass to MA to take on next steps. \n",
      dateOfReferral: "2022-02-18T17:48:17.9793145",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T12:58:16.7331406",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 82,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MISS STACEY WILSON",
      advisor: "Deonne Samuels",
      referralUser: "Joe Evans",
      id: 96,
      caseRef: "SAG96",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SAGE SITE - PENKRIDGE - 6 NEW PLOTS DUE FOR RELEASE END FEB. SHE IS FTB AND WOULD LIKE TO GET QUALIFIED NOW PLEASE IN READINESS. PRICES OF PLOTS TBC. PLEASE CALL ASAP. JE",
      dateOfReferral: "2022-02-19T15:01:37.9979748",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T16:56:21.0613086",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 85,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MARIE FOSTER",
      advisor: "Baldev Dhanda",
      referralUser: "Joe Evans",
      id: 97,
      caseRef: "SAG97",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SAGE PLOTS N PENK - 6 NEW PLOTS WILL BE RELEASED TOWARD END FEB/BEG MARCH. SHE IS IN STAFFORD & RURAL RENTED ATM BUT NOW LOOKING FOR A HOUSE WITH GARDEN. HAD NO MORTGAGE ADVICE AT ALL SO FAR. SHE IS 53. WILL HAVE £5000 DEPOSIT. PLEASE CALL ASAP TO DO FULL MORTGAGE ADVICE AND SAGE CHECKS. JE\n\nUnable to qualify, client looking for a 2 bedroom property with a garden. Would only be able to qualify for a 25% share of a £150,000 property. *Baldev Dhanda*",
      dateOfReferral: "2022-02-19T15:06:56.7161618",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-30T09:55:19.6523818",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 181,
      closedDate: "2022-03-30T09:55:51.5659318",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Julie Monk",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 98,
      caseRef: "SAG98",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 101250,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Please email Julie to arrange an appointment as she works during the day. She's splitting up from her husband and getting 50% of the sale of their home so will be looking at a cash purchase.",
      dateOfReferral: "2022-02-21T09:52:29.7688841",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T11:12:13.1768097",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 101250,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 86,
      closedDate: "2022-02-28T11:12:23.1439814",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mr Scott Wain",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Joe Evans",
      id: 99,
      caseRef: "SAG99",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "plot 83",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Scott is currently living in Cyprus as he is in MOD. He is moving back to UK Beginning of June 2022 as starting work at JCB in August 2022. Looking at shared ownership houses in uttoxeter only. he has been online to do mortgage checks but not had one to one advice Please call to do Sagr eligibility checks and full mortgage advice. you can call him weekdays after 3pm due to his work. IDEALLY CALL AFTER 3PM ON TUESDAY 22/02/2022 ",
      dateOfReferral: "2022-02-21T10:42:23.6043221",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T10:44:14.1094757",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-02-28T16:30:13.2106826",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Zoe Welch",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Laura Jones",
      id: 100,
      caseRef: "SAG100",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Not ready to go mortgage wise, needs to view new property, if she likes it hers will go up for sale.",
      dateOfReferral: "2022-02-21T10:53:04.9741871",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T19:07:49.0573354",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 83,
      closedDate: "2022-06-22T08:16:06.7426282",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MISS HOLLY BATCHELOR",
      advisor: "Deonne Samuels",
      referralUser: "Joe Evans",
      id: 101,
      caseRef: "SAG101",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "83",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "HOLLY IS A FTB, HAS £15K DEPOSIT SAVED. SHE IS VIEWING THE PROPERTY ON WEDNESDAY  23/02/2022. PLEASE CALL IN NEXT 24 HOURS TO DO SAGE FULL CHECKS FOR AFFORDABILITY & FULL MORTGAGE ADVICE. JE",
      dateOfReferral: "2022-02-21T11:19:29.4659496",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T09:12:41.6953333",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-25T13:29:06.9939532",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David McCunnin",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Irina Pinto Coutinho",
      id: 102,
      caseRef: "SAG102",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works for Network Rail in London",
      dateOfReferral: "2022-02-21T11:35:46.6094418",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T16:10:49.4571195",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 69,
      closedDate: "2022-02-23T16:11:23.6349613",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Antony Dowell",
      advisor: "Steven Sanderson",
      referralUser: "Laura Jones",
      id: 104,
      caseRef: "SAG104",
      referredById: 54,
      caseStatusId: 29,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-21T13:49:26.9121919",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-09T16:04:09.2703296",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage ",
      financialDetailsId: 70,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sharon Fox",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 105,
      caseRef: "SAG105",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "divorced and looking to get back onto the property ladder and feels a shared ownership is the only route\nthe sale of the property she lived with her ex partner should be completing in a few weeks and she will have £60,000 deposit \n\nCalled on 23/2 - Call booked for 24/2 at 2pm - didn't answer. Sent email to get new date/time\n",
      dateOfReferral: "2022-02-21T14:17:43.6326762",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T16:19:48.7676978",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-01T13:37:28.039097",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tamas Hortobagyi",
      advisor: "Paul Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 106,
      caseRef: "SAG106",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Not just himself purchasing.\n\nSpoke on phone on 23/2. Will send email with details to get in touch with his mortgage advisor to complete HCA. They are Hungarian and require/required translators (vulnerable client).\n\n",
      dateOfReferral: "2022-02-21T14:26:11.117346",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T15:50:01.450046",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 1200,
      minPercShareAvailable: "45%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-01T13:22:14.8754047",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Carly Brough",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 107,
      caseRef: "SAG107",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "have sold current property and using equity for deposit.\n\nCalled at 3:30pm on 23/2. Left voicemail and sent email. Will try again tomorrow.\n\nClient replied by email. They are not proceeding. ",
      dateOfReferral: "2022-02-21T15:54:56.3775393",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T15:51:29.6480131",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 65000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-02-23T15:51:38.5825067",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lewis Clarke",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 108,
      caseRef: "SAG108",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 265000,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works until 4pm, please call after or email to arrange appointment.\n\nAttempted to call at 5pm on 23/2. Left voicemail and sent email\n\nSpoke on phone. Lewis is currently on a mortgage with her mum and is in the process of getting off it. Also, Jay's income is too low and is job hunting and knows he needs something with more hours to reach affordability. \n\nThey will get back in touch at a later date to pick things up. hoping the properties are still available then.",
      dateOfReferral: "2022-02-21T17:26:57.9562288",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T17:05:41.76747",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-02-25T17:05:46.5184601",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Victoria Tomlinson ",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Claire Jenks",
      id: 109,
      caseRef: "SAG109",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "Plot 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call asap, buying with a mortgage, interested in plot 176 CHalgrove or any other 3 beds we have ",
      dateOfReferral: "2022-02-22T10:35:33.6458154",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T17:50:34.4718189",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 58,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 71,
      closedDate: "2022-02-23T17:50:39.2275592",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nicola Leftbridge",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 110,
      caseRef: "SAG110",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 210000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call after 4:20PM as Nicola works in an office and she is unable to answer the phone before then - you can also email\n\nCalled at 5:10pm on 23/2. Left voicemail and sent email.\n\nSpoke on phone at 4:30pm on 24/2. Not SSTC yet. Will get back in touch when she has this to move forward. Property she is interested in is different to the one on the lead sheet.",
      dateOfReferral: "2022-02-22T13:31:36.5770914",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T17:35:29.5475559",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 81,
      closedDate: "2022-02-25T09:55:21.0245676",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Manpreet kaur",
      advisor: "Laura Turner",
      referralUser: "Laura Jones",
      id: 112,
      caseRef: "SAG112",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-02-23T13:01:11.8547728",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T13:25:14.4646108",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 75,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Shanice Isenschmid",
      advisor: "Christopher Taylor",
      referralUser: "Laura Jones",
      id: 113,
      caseRef: "SAG113",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called at 1pm on 24/2\n\nQualified at 50%. Passed for Mortgage advisor to call. Client keen to move fast so not to miss plot.\n\nLaura, please get in touch with Shanice to arrange a viewing.",
      dateOfReferral: "2022-02-23T13:29:27.7699998",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T14:13:57.4253318",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 120,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 78,
      closedDate: "2022-06-27T09:47:16.8276332",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Liz Turner",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 114,
      caseRef: "SAG114",
      referredById: 25,
      caseStatusId: 26,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works for Ramsey Healthcare\nbeen at property - 1 year - privately renting from mum. \nFTB \n2 BEDS - SEMI DETACHED HOUSE   ",
      dateOfReferral: "2022-02-23T13:29:30.258563",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T14:21:36.409753",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nina Webb",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 115,
      caseRef: "SAG115",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Call attempted @14:40 on 24/2",
      dateOfReferral: "2022-02-23T13:44:53.4900601",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-24T14:55:24.5279689",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 150000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 80,
      closedDate: "2022-02-24T14:55:29.9236157",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lisa James",
      advisor: "Laura Turner",
      referralUser: "Nicola Pike",
      id: 116,
      caseRef: "SAG116",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 240000,
      plotNumber: "Plot 172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "LEGALS SOLD",
      dateOfReferral: "2022-02-23T15:09:16.6494761",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-23T17:17:38.6680247",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ashitha Baby",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Ashitha Baby",
      id: 118,
      caseRef: "SAG118",
      referredById: 2,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-02-24T15:04:16.561892",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-03T09:34:31.6199516",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-03T09:36:06.486922",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chris Ross",
      advisor: "Paul Parker",
      referralUser: "Eleanor Forbes",
      id: 119,
      caseRef: "SAG119",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 190000,
      plotNumber: "130",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First time buyer \nSaid he has deposit level between £5,000 and £15,000",
      dateOfReferral: "2022-02-24T15:12:44.7432755",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-25T09:58:23.0338799",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-02-25T15:49:02.630093",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chloe Whiston",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 120,
      caseRef: "SAG120",
      referredById: 54,
      caseStatusId: 26,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "currently lives in a 25% shared property herself and we are going out to value it ",
      dateOfReferral: "2022-02-24T16:00:38.7499647",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T14:30:27.9055089",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kelly Semple",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 121,
      caseRef: "SAG121",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 410000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "MORTIMER PLACE, HATFIELD PEVEREL SITE\n open to more advice \n\n28/2 Called 1:45pm - left voicemail and sent email",
      dateOfReferral: "2022-02-25T17:28:40.2798634",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T13:49:59.0104522",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-02T15:37:00.08057",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tosin Dehinsilu",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 122,
      caseRef: "SAG122",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 265000,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Called 28/2. rescheduled for 8:30am on 1/3",
      dateOfReferral: "2022-02-28T11:41:18.544386",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-02-28T16:41:29.190919",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-01T13:39:51.0303353",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sharon Hough",
      advisor: "Paul Parker",
      referralUser: "Charlotte Tomlinson",
      id: 123,
      caseRef: "SAG123",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 237500,
      plotNumber: "plot 172, plot 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spoke on phone - Qualified on HCA.\n\n7/3 Now want to use JM as advisors. Requested documents to get DIP and be in place to reserve property.\n\n",
      dateOfReferral: "2022-02-28T12:58:04.340086",
      offerExpiryDate: "2022-10-16T23:00:00",
      updatedDate: "2022-04-28T14:49:57.3921024",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 11000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 87,
      closedDate: "2022-06-08T08:38:12.2720362",
      isClosed: 1,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "MRS HANNAH HANSON",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Joe Evans",
      id: 125,
      caseRef: "SAG125",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 295000,
      plotNumber: "27",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SHE ORIGINALLY ENQUIRED ABOUT PLOT 27 SORREL CLOSE WHICH NOW HAS 3 APPLICATIONS PENDING SO SHE IS AWARE IT WILL GO. SHE IS DIVORCING AND  MR IS BUYING HER OUT OF MARITAL HOME. SHE IS LOOKING FOR SHARED OWNERSHIP HOUSE IN UTTOXETER - 3 BEDS FOR HER AND THEIR KIDS. SHE WOULD LIKE SOME MORTGAGE ADVICE PLEASE AND SHARED OWNERSHIP SCHEME ADVICE AS WE WILL BE GETTING 7 MORE PLOTS LATER IN THE YEAR ON THIS DEVELOPMENT. PLEASE CALL IN NEXT 24 HOURS. ",
      dateOfReferral: "2022-02-28T16:34:48.926652",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-01T14:36:24.0451638",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-04T15:37:14.7934404",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nathan Murphy",
      advisor: "Paul Parker",
      referralUser: "Claire Jenks",
      id: 127,
      caseRef: "SAG127",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 120000,
      plotNumber: "Plot 172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Call today if poss, buying with a mortgage \n\n2/3 - called at 3:30pm - left voicemail and sent email.\n\nQualified - Waiting for documents to proceed with getting DIP and putting down reserve.\n\nPlease liaise with arranging viewing.",
      dateOfReferral: "2022-03-01T10:56:23.1776672",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-08T13:36:05.2239031",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 58,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 93,
      closedDate: "2022-03-21T15:31:05.4802114",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emma Stafford",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 128,
      caseRef: "SAG128",
      referredById: 29,
      caseStatusId: 34,
      developmentId: 1,
      purchasePrice: 177500,
      plotNumber: "209",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Friday after 1pm\n\nLegals Sold .\n\nCalled 4:30pm on 4/3. left voicemail and sent email.\n\nSpoke on 8/3 at 3pm. Waiting for documents to confirm income and if good, proceed with DIP and documents to put down reserve. ",
      dateOfReferral: "2022-03-01T10:56:32.7029144",
      offerExpiryDate: "2022-11-26T00:00:00",
      updatedDate: "2022-05-30T12:53:56.8467119",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Lee Ridgard",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 129,
      caseRef: "SAG129",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 221250,
      plotNumber: "Plot 27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please can you call as late as possible\n\nLegals Sold.\n\nSpoke on phone on 2/3 at 5:30. Waiting for documents to confirm income but should be fine to proceed.\n\nCancelled as property not available. Nicola, please follow up with lead to help their search.",
      dateOfReferral: "2022-03-01T13:36:41.326384",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-03T14:46:40.1497935",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 22000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-03T14:46:42.8864284",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sharne Everett",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 130,
      caseRef: "SAG130",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 180000,
      plotNumber: "213",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Sharne has sold her property and living with her son. She is retired.\n\nPlease call tomorrow after 1pm or anytime on Thursday or Friday.\n\nLegals Sold.\n\nSpoke on phone - qualified to 65%. Nicola please advise next steps.\n\nDetails sent to Vicky et al - now waiting for approval from Sage.",
      dateOfReferral: "2022-03-01T15:31:32.4464943",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T09:37:25.2951223",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 110000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 89,
      closedDate: "2022-03-21T14:28:56.4679427",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Karen Baldwin",
      advisor: "Paul Parker",
      referralUser: "Russell Davis",
      id: 131,
      caseRef: "SAG131",
      referredById: 19,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: null,
      plotNumber: "14,15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE NOTE THE SITE IS NOT LISTED ON DROP DOWN. SITE IS 2558 Mortimer PLace\n\nSorry I didn't get her address. \n\nSchool teacher, would prefer a call at 6.30pm on either Tuesday's or Wednesdays. \n\nProperty Reference: 31CO5 9NX\nProperty Address: Plot 15, Kelvedon, Kelvedon, Braintree, CO5 9NX\nName: Karen Baldwin\nProperty Enquiry: I am interested in the following property: Plot 15, Kelvedon, CO5 9NX | CO5 9NX - 3 bedroom house in Kelvedon\nTelephone Number: 07900561754\nMobile Number: 07900561754\nEmail: karencossil@gmail.com\nHow would you prefer to be contacted by the housing provider/sales agent?: Email or phone call\nHome Location: CM1 - Chelmsford District\nWork Location: Grays - Thurrock\nHousehold Income: 37000\nHousehold Deposit: 10000\nCurrent Status: Council/Housing Association Tenant\nNumber of people in household: 4\nIs anyone in the household a wheelchair user or otherwise have mobility issues: No\nDate of birth: 08 03 1974\nChildren/Dependents in household: Yes\nIs key worker? Yes\nKey worker role: Education and childcare workers\n",
      dateOfReferral: "2022-03-02T08:52:21.8192359",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-02T09:25:01.8157227",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-02T15:04:00.4377129",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "ALex Scott",
      advisor: "Alexander Scott",
      referralUser: "Alexander Scott",
      id: 132,
      caseRef: "SAG132",
      referredById: 37,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 500000,
      plotNumber: "55",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Test Do not CALL!!!!!",
      dateOfReferral: "2022-03-02T10:08:00.7948009",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-08T11:05:01.1733731",
      isDeleted: 0,
      advisorId: 37,
      propertyStatusId: 39,
      depositLevel: 200000,
      serviceCharge: 1500,
      minPercShareAvailable: "25",
      housingAssociation: "MTV",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Libby Malkin",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Nicola Pike",
      id: 133,
      caseRef: "SAG133",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 120000,
      plotNumber: "172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Libby & Sam are currently living with Libby's Mum and want to get their first home. They are saving for a deposit and want to know what they need to save. They have had no mortgage advise. \n\nLegals Sold",
      dateOfReferral: "2022-03-02T10:12:44.6902461",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-02T13:51:26.4558971",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 1,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-02T13:52:56.3953497",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Joe Havelock Wilkinson",
      advisor: "Christopher Taylor",
      referralUser: "Laura Jones",
      id: 134,
      caseRef: "SAG134",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-02T13:36:27.4927174",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-04T14:05:23.5339417",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 90,
      closedDate: "2022-06-27T09:49:43.4713831",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Miss Laura Jayne Furgusson",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Nicola Pike",
      id: 135,
      caseRef: "SAG135",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 140000,
      plotNumber: "Plots 155 & 156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call anytime on Friday\n\nLegals Sold\n\nPlots 155 &156 Bilbrook will be build complete in September Laura is aware these are off plan",
      dateOfReferral: "2022-03-02T13:39:38.6130423",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-04T11:19:39.9538963",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 22000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 92,
      closedDate: "2022-03-04T11:20:53.6976307",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chloe-Jordann Simmonds",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 136,
      caseRef: "SAG136",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 101250,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "buying with husband, want to check if it affects their credit score at all.\nLooking at 1 beds\n\nChloe spoke to Jon-Luigi on Friday 4/3/22 asking for call back during the week commencing Monday 7th March. \n\nFurther attempts made to contact client on 08/03/22, 09/03/22 & 11/03/22 with voicemails left and no response.",
      dateOfReferral: "2022-03-02T15:32:17.0350386",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T09:27:04.9526196",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-11T12:23:51.1063731",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rakinder Kaur",
      advisor: "Baldev Dhanda",
      referralUser: "Russell Davis",
      id: 137,
      caseRef: "SAG137",
      referredById: 19,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 405000,
      plotNumber: "14 or 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She has a 50% shared ownership property currently. \n\n*** THIS IS SITE 2258 AYLETTS GREEN KELVEDON *** NOT ON DROP DOWN YET\n\nPLEASE CALL ON EVENING 5.45 PM \n\nUnresponsive - called 07/03/22 @ 18:30, 09/03/22 @17:20, 11/03/22 @ 09:20 and 14/3/22 @ 18:10. Voicemail left on 3 occasions",
      dateOfReferral: "2022-03-03T09:50:04.8728198",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T18:13:50.7379156",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-14T18:13:59.1808583",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Britney Mellor",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 139,
      caseRef: "SAG139",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called 4/3. Putting purchase on hold due to extra costs of moving. Will keep in touch with client.",
      dateOfReferral: "2022-03-04T09:32:15.5822624",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-04T17:07:23.7252878",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 4000,
      serviceCharge: 144.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 94,
      closedDate: "2022-03-04T17:07:26.7995618",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Patrycja Mirga",
      advisor: "Paul Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 140,
      caseRef: "SAG140",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Zygmunt Mirga - husband \nlooking at 2 beds as have a child \nAny 2 beds try and see if will work for them.\n\nCalled at 2:45pm on 7/3. Calling back at 6:30pm.\n\nCould not get DIP due to affordability and criteria. Lead Closed. 22/3/22",
      dateOfReferral: "2022-03-04T11:49:48.6792622",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T09:59:27.2356598",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 114,
      closedDate: "2022-03-23T10:04:34.1267637",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Beverley Taylar",
      advisor: "Paul Parker",
      referralUser: "Claire Jenks",
      id: 141,
      caseRef: "SAG141",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "call asap please.\n\nCalled 2:30pm on 7/3 - left voicemail and sent email",
      dateOfReferral: "2022-03-04T12:42:34.9084479",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-07T14:40:13.619266",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 80000,
      serviceCharge: 58,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-14T13:50:14.8473079",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jon Baskerville",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 142,
      caseRef: "SAG142",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 120000,
      plotNumber: "Plot 172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call after 3 or after 2 on Thursday\n\nLegals Sold.\n\nCalled at 3pm on 7/3 - left voicemail and sent email\n\nLeft 2nd voicemail at 3:30pm on Thursday 10/3.",
      dateOfReferral: "2022-03-05T10:06:04.8568526",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T15:24:31.5014982",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 150000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-14T10:00:42.9028257",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sophie Aldridge",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 143,
      caseRef: "SAG143",
      referredById: 25,
      caseStatusId: 28,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works for South Essex Homes with the council. Hostel manager. Has already sold current property. ",
      dateOfReferral: "2022-03-05T12:40:51.9002548",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-20T13:35:37.2618146",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 43000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 95,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Catherine Marling",
      advisor: "Peter Hill",
      referralUser: "Lia Wilkerson                                   ",
      id: 144,
      caseRef: "SAG144",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 133500,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Single mum with child, living with her mum as left an abusive relationship. \nWants any 2 bed \n\n\n\nWants call Friday 11th in the morning\n\nDoesnt want to proceed as no balcony",
      dateOfReferral: "2022-03-05T16:32:43.4160515",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T12:16:49.8021832",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-17T14:08:34.4351977",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Donna Mackey",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 145,
      caseRef: "SAG145",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 100000,
      plotNumber: "Various ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Monday after 3pm as Donna is a teacher\n\nLegals Sold.\n\nNot SSTC yet. Doesn't meet affordability as Self Employed - will be looking to go Employed in September. \n\nNicola - Please liaise with Donna about her property to get it sold.",
      dateOfReferral: "2022-03-05T16:36:27.2410067",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-07T17:04:53.5965008",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 98,
      closedDate: "2022-03-07T17:05:14.9722979",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Owen Pegram",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 146,
      caseRef: "SAG146",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spoke on the phone on 9/3.\n\nHCA calculator works for 40% share. Waiting to hear back from Sam Bowyer as to whether this is possible.",
      dateOfReferral: "2022-03-07T12:00:18.6510962",
      offerExpiryDate: "2023-02-13T00:00:00",
      updatedDate: "2022-05-25T13:36:47.5967864",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 114.99,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: 167,
      closedDate: "2022-06-30T10:53:46.6542951",
      isClosed: 1,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Diane West",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 147,
      caseRef: "SAG147",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Lovely older couple, he works full time she looks after her grandson. They used to live in surrounding area her kids went to school locally would love to move back that way. \nThey sold their home roughly a year ago and have had offers accepted on different properties but have fallen through unfortunately so they are currently renting.\nThe have registered for help to buy and have a reference number available looking at shared ownership. \n\n\nCalled 7/3 at 16:33 and left voicemail",
      dateOfReferral: "2022-03-07T12:12:41.9813924",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T14:42:40.2611538",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 104,
      closedDate: "2022-06-06T13:31:32.2363159",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Louise Stevens",
      advisor: "Laura Turner",
      referralUser: "Lia Wilkerson                                   ",
      id: 148,
      caseRef: "SAG148",
      referredById: 23,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 133500,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "open to 2 beds and 1 beds, just her, no pets or children",
      dateOfReferral: "2022-03-07T12:15:32.6767797",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T11:49:22.3322118",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 96,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jordana Woolley",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 149,
      caseRef: "SAG149",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Jordana is a teacher so please call after school hours or lunch time, \n\nJordana does not qualify based on her current salary. She has advised that she will get a pay increase in September 2022. Her new proposed salary would enable her to qualify on the HCA qualifier and on a lender affordability calculator.",
      dateOfReferral: "2022-03-07T12:22:24.4109414",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-08T18:08:55.6088819",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 103,
      closedDate: "2022-03-08T18:09:31.6008113",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Micah Mitchell",
      advisor: "Laura Turner",
      referralUser: "Lauren Ruff",
      id: 150,
      caseRef: "SAG150",
      referredById: 66,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: null,
      plotNumber: "14",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Separating from partner she has 2 kids (7 & 11), looking for shared ownership only, needs to be close/easy access to get to Chelmsford as that where their life is. Very sweet lady.  ",
      dateOfReferral: "2022-03-07T12:46:49.1835615",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T11:53:31.5816481",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 101,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Liam Stevenson",
      advisor: "Laura Turner",
      referralUser: "Irina Pinto Coutinho",
      id: 151,
      caseRef: "SAG151",
      referredById: 25,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works as a technical manager for an events company",
      dateOfReferral: "2022-03-07T13:05:44.325196",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T16:38:55.1334696",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 97,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Artur Pisarek",
      advisor: "Christopher Taylor",
      referralUser: "Lia Wilkerson                                   ",
      id: 152,
      caseRef: "SAG152",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "105",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "just him, no children or pets, open to 1 or 2 beds. put in the most expensive 2bed as then he would be able to afford all, please check other prices if cant afford this one.",
      dateOfReferral: "2022-03-07T13:51:59.6731492",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T13:55:36.4239753",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 100,
      closedDate: "2022-06-27T09:24:37.7605951",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Simon Crabtree",
      advisor: "Arjun Dhunna",
      referralUser: "Eleanor Forbes",
      id: 153,
      caseRef: "SAG153",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 180000,
      plotNumber: "Plot 169",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-07T14:45:05.6677984",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-08T13:56:28.249963",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-03-08T13:57:38.205775",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Oliver Wiggins",
      advisor: "Deonne Samuels",
      referralUser: "Lia Wilkerson                                   ",
      id: 154,
      caseRef: "SAG154",
      referredById: 23,
      caseStatusId: 28,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "105",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "nothing to sell, not a ftb, wants a 2 bed. Flat \n\ncurrently living with parents since June 2019- \n\nprior owned his own property, 29 Twyford avenue , SS30EZ\n\n",
      dateOfReferral: "2022-03-07T15:13:11.2342299",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T13:10:15.9700796",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 99,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lesley Dixon",
      advisor: "Baldev Dhanda",
      referralUser: "Charlotte Tomlinson",
      id: 155,
      caseRef: "SAG155",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 180000,
      plotNumber: "209,212,213, thomas aston place ",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Retired has 100k cash \n\nClient does not qualify as her monthly payments to net mortgageable household income ratio is below 25%",
      dateOfReferral: "2022-03-08T09:43:07.2804263",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T12:11:51.2901388",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing ",
      financialDetailsId: 106,
      closedDate: "2022-03-09T12:11:58.4704119",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Fiona Roche",
      advisor: "Laura Turner",
      referralUser: "Charlotte Tomlinson",
      id: 156,
      caseRef: "SAG156",
      referredById: 32,
      caseStatusId: 34,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "2 bed",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "selling her property \n\nDidnt fit HCA with 3 bed she wanted but will consider the 2 bed.\n\nShe fits HCA for the 2 bed properties.",
      dateOfReferral: "2022-03-08T12:46:18.9390626",
      offerExpiryDate: "2022-10-27T23:00:00",
      updatedDate: "2022-05-12T09:30:21.1602415",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage housing ",
      financialDetailsId: 102,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Christopher Stark",
      advisor: "Laura Turner",
      referralUser: "Laura Jones",
      id: 157,
      caseRef: "SAG157",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "77",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "current property is being sold - separating from partner - house should be complete by 10/04 - using deposit from sale \n\nCalled 8/3 @1700 left voicemail",
      dateOfReferral: "2022-03-08T15:10:37.6976668",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T11:17:35.4196177",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 55000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 105,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Maddy Fuller",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 158,
      caseRef: "SAG158",
      referredById: 25,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "legal secretary & part time job at grosvenor casino",
      dateOfReferral: "2022-03-08T17:26:36.4089423",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T17:01:59.9278817",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 10500,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 107,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ngoni Vhondo",
      advisor: "Laura Turner",
      referralUser: "Laura Jones",
      id: 159,
      caseRef: "SAG159",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "77",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-09T11:05:29.3920937",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T17:28:14.7448798",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 110,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mrs Murphy",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 160,
      caseRef: "SAG160",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "having her current property valued on Friday 11/03 so currently unsure how much deposit she will have when its sold\n\nI have spoken to client, who has requested a call back to get a better detail about her deposit and current outstanding finance on 17/03/22.\n\nClient would be able to qualify based on the new information she has provided around her car, deposit and Cc. However, as she is not SSTC she can not be qualified. *baldev dhanda*",
      dateOfReferral: "2022-03-09T11:19:57.7146347",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T10:18:35.6362297",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 108,
      closedDate: "2022-03-17T10:23:29.237828",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Cyrus Guiver",
      advisor: "Peter Hill",
      referralUser: "Irina Pinto Coutinho",
      id: 161,
      caseRef: "SAG161",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "EMAIL FOR APPOINTMENT HE'S IN CYPRUS IN THE ARMY\n\nWorks for British Army - infantry. Deposit £14,000. Gets 50% of the salary so all together £24,000. \n\n\nSent an email to arrange Call ",
      dateOfReferral: "2022-03-09T12:57:59.9662112",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T16:44:06.2225677",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 24000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-07T11:28:16.1739676",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nelly Kibirige",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 162,
      caseRef: "SAG162",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Senior Consultant in Accountancy Firm. \n\nSpoke on 9/3 at 3:30pm. Passed HCA - waiting for documents to get DIP",
      dateOfReferral: "2022-03-09T13:10:40.029639",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T16:13:12.6184309",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 109,
      closedDate: "2022-03-16T16:02:04.2103929",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gemma Phoenix",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 163,
      caseRef: "SAG163",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: null,
      plotNumber: "Plot 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She is currently in rented, sold there home recently. Has two children one goes to school in Kelvedon and the other in Tiptree. Has always lived around Kelvedon and works there in construction currently. ",
      dateOfReferral: "2022-03-09T13:58:33.1868448",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-09T14:00:55.235248",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1200,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-14T09:21:30.9208436",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kelly Chamberlain",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 164,
      caseRef: "SAG164",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "Plot 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Kelly is a police officer working in Braintree going through a divorce so would like all info by email not post. Loves the area and the close proximity to work and her ex partner as he works in Colchester. \n(Not sure on the service charge fees so that's subject to the final numbers).\n\nCalled at 1pm on 10/3. left voicemail and sent email.\n\nTried again on 14/3 - left v/m\n\nNo answer on 3rd try on 18/3. Closing lead",
      dateOfReferral: "2022-03-09T14:36:24.9259839",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T09:44:48.4582613",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-21T09:44:56.4289069",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Samantha Shead",
      advisor: "Peter Hill",
      referralUser: "Lauren Ruff",
      id: 165,
      caseRef: "SAG165",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "Plot 14",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Samantha is a Mental heath care worker working bank hours, worked there just over a year has struggled to get a mortgage. Has £120,000 in inheritance money from Mum wants to put £100,000 down as deposit and use the rest for fee's etc. Currently living in a council property, looking for her first home with her 5year old son. \n\nLeft Voicemail 9/3/22 @ 15:26\n\nPeter Hill Phoned and dealt with",
      dateOfReferral: "2022-03-09T14:53:58.5088741",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T11:00:26.8285497",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 113,
      closedDate: "2022-03-10T11:08:36.3490832",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jason Girling",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 166,
      caseRef: "SAG166",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Would like mortgage advice - does not have an AIP ",
      dateOfReferral: "2022-03-09T15:24:20.6406645",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T13:54:03.95822",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-16T12:24:05.5886855",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "SEHAR SIDDIQUI",
      advisor: "Gemma Painter",
      referralUser: "Emily Balloch",
      id: 167,
      caseRef: "SAG167",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - Would like mortgage advice - not spoken to anyone about the mortgage yet \n\nSpoke with Sehar and Ahmed on 14/03/22 @10:30 and qualified both for a 50% share. *Baldev Dhanda*",
      dateOfReferral: "2022-03-09T15:28:30.3813762",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T18:38:51.8780354",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 121,
      closedDate: "2022-06-28T08:16:40.6790188",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rachel Elliott",
      advisor: "Gemma Painter",
      referralUser: "Emily Balloch",
      id: 168,
      caseRef: "SAG168",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Would like more mortgage advice - has spoken to a broker but no AIP \n\nPeter Hill phoned and qualified",
      dateOfReferral: "2022-03-09T15:31:39.9847738",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T18:43:51.753138",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 300000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 112,
      closedDate: "2022-06-28T08:18:15.3752901",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Micah Mitchell",
      advisor: "Laura Turner",
      referralUser: "Emily Balloch",
      id: 169,
      caseRef: "SAG169",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "has spoken to a broker - not got AIP - looking for more advise ",
      dateOfReferral: "2022-03-09T15:34:45.9917088",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T11:20:26.9616628",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE ",
      financialDetailsId: 111,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rayna Stoyanova",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 170,
      caseRef: "SAG170",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB - no AIP - looking for mortgage advise ",
      dateOfReferral: "2022-03-09T15:37:25.8961739",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T16:24:48.2236752",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-10T16:24:57.849228",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "George Barrett-Hague",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 171,
      caseRef: "SAG171",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 240000,
      plotNumber: "Plot 172",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Please call after 5pm\n\nLegals Sold",
      dateOfReferral: "2022-03-10T13:51:40.9863104",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T14:56:22.8757051",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-15T12:17:55.1953325",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "SHAUN MARTIN AND AMY SHARP",
      advisor: "Paul Parker",
      referralUser: "Joe Evans",
      id: 172,
      caseRef: "SAG172",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "85, 77, 75 OR 76",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "HELLO, CAN SOMEONE PLEASE CALL AMY IN THE NEXT 24 HOURS TO DO SAGE CHECKS AND FULL MORTGAGE ADVICE. SITE IS 384 STAFFORD ROAD, PENKRIDGE - PLOTS AVAILABLE; 75 & 76 - 2 BED MID TERRACED = 100% £225,000, PLOT 77 - 2 BED END TERRACED = 100% AT £230,000 AND PLOT 85 - 2 BED SEMI DETACHED HOUSE = 100% AT £230,000. THEY ARE FIRST TIME BUYERS LIVING WITH FAMILY. THANKS, JO\n\nSpoke at 3:30pm on 10/3 - waiting for docs to do DIP",
      dateOfReferral: "2022-03-10T14:48:23.3252983",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-10T16:59:32.0453262",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 115,
      closedDate: "2022-04-21T09:51:44.9461131",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "ELLEN Nancy MATTHEWS",
      advisor: "Steven Sanderson",
      referralUser: "Joe Evans",
      id: 173,
      caseRef: "SAG173",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204 OR 205",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE CALL ELLEN IN NEXT 24 HOURS TO DO FULL CHECKS AND MORTGAGE ADVICE. SHE IS A FTB AND LIVING WITH FAMILY. SHE HAS £8K DEPOSIT SAVED, SHE HAS BEEN ONTO LLOYDS BANKING APP FOR MORTGAGE CALCULATOR AND BEEN ADVISED CAN LEND UPTO £110K MAX. WE HAVE 2 X PLOTS LEFT - BOTH 1ST FLOOR APARTMENTS (2 BEDS) 100% VALUE IS £160K. CAN YOU PLEASE CALL HER TO WORK OUT SHARE VALUE, MORTGAGE BORROWING, REMT PAYMENTS ETC. THANKS, JO\n\nAdviser notes wont update, just keeps going round, left message and sent email but email address is wrong as I got a undelivered message back ",
      dateOfReferral: "2022-03-10T15:16:40.5100499",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-05T09:20:09.8943643",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 115,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 125,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Scott Wheeler",
      advisor: "Peter Hill",
      referralUser: "Mark Shynn",
      id: 174,
      caseRef: "SAG174",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 7,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Enq'd with Persimmon directly at Castellum Grange...... aware that we are dealing with the shared ownership hence the enquiry. \nHappy to have the call now in readiness..... \nBetter for a call after 5:30pm or Saturday\n\n\nCalled 5:30 on 15/3  left voicemail",
      dateOfReferral: "2022-03-10T15:17:52.3010795",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T17:23:25.909646",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-04-12T12:47:54.2206469",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Daisy Musto",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 175,
      caseRef: "SAG175",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Daisy is currently living with her parents after selling her shared ownership flat in Chelmsford. Purchasing for her and for her parents to live in also around there traveling.  \n\nClient did not qualify for a 50% share of a property with a FVM of £405,000 *Baldev Dhanda 11/3/22*",
      dateOfReferral: "2022-03-10T15:28:15.9547864",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T15:03:25.7462235",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 118,
      closedDate: "2022-03-11T15:04:53.102843",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rita Mccartney",
      advisor: "Gemma Painter",
      referralUser: "Mark Shynn",
      id: 176,
      caseRef: "SAG176",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Property currently sold via Beaulieu Park Estates\nservice charge - is a rough figure",
      dateOfReferral: "2022-03-10T16:32:54.1078472",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T09:17:54.8642755",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 202500,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing",
      financialDetailsId: 117,
      closedDate: "2022-06-28T08:18:59.4036007",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sam Mather",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 177,
      caseRef: "SAG177",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Approved for help to buy through Cheryl Damen- Just mortgages - has SSTC his property. Full time employed just him in the purchase. Also interested in the 2 beds when we get them.",
      dateOfReferral: "2022-03-10T17:15:28.8540284",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T08:51:26.9693061",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 116,
      closedDate: "2022-04-20T09:36:57.0690284",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Paige Chesterman",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 178,
      caseRef: "SAG178",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "service charge is rough\nShe has spoken to Joy Brooks from the Witham office recently.\nIf she doesn't answer leave a message or email her. ",
      dateOfReferral: "2022-03-10T17:39:40.4201301",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T09:06:03.4574977",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-14T09:25:38.0854876",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Charlotte Gifford",
      advisor: "Baldev Dhanda",
      referralUser: "Ellis Gamon",
      id: 179,
      caseRef: "SAG179",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-11T09:11:28.5110962",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T09:28:18.1473455",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-16T15:59:38.2268303",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Eleanor Whitcker",
      advisor: "Arjun Dhunna",
      referralUser: "Ellis Gamon",
      id: 180,
      caseRef: "SAG180",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 97500,
      plotNumber: "65",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-11T10:17:27.724555",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T17:17:44.7441112",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-11T17:28:32.3776538",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Craig Everett",
      advisor: "Deonne Samuels",
      referralUser: "Ellis Gamon",
      id: 181,
      caseRef: "SAG181",
      referredById: 79,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 102500,
      plotNumber: "87",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "\n\nPeter Hill taken on to qualify\n\nTried 14:27 on 11/3 - no answer - left voicemail",
      dateOfReferral: "2022-03-11T10:23:02.6120572",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T12:06:35.7230625",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 119,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Philp Ikhoyameh",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 182,
      caseRef: "SAG182",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "*Service charge is approx*\n\nCurrently renting, Customer service rep, spoke to his sister as he works nights at the moment so will be available for a call anytime after 15:00. \nThanks \n\nDid not qualify for a property based on a FMV of £405,000. *Baldev Dhanda*",
      dateOfReferral: "2022-03-11T10:53:57.4069974",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T10:17:28.3564578",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 166,
      closedDate: "2022-03-23T10:27:59.3350333",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Umut & Natalie Unal",
      advisor: "Peter Hill",
      referralUser: "Lauren Ruff",
      id: 183,
      caseRef: "SAG183",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Natalie works in Colchester, Umut works in London so Kelvedon is the perfect location for them both. \nThey are currently selling his home should sell by next week. Using the equity from that sale as the deposit. \n\n\nPeter Hill to qualify \n\nRung 14:35 on 11/3  -   no answer so left voicemail\n.\nRung\n\nRung 17/3 @1450    left another voicemail",
      dateOfReferral: "2022-03-11T11:28:35.1244939",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T14:50:11.9721928",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-17T14:54:46.9209303",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jenny Eldred",
      advisor: "Christopher Taylor",
      referralUser: "Emily Balloch",
      id: 184,
      caseRef: "SAG184",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "not spoken to anyone recently - would like advice \n\nPeter Hill to qualify \n\nRung 14:35 on 11/3  -   no answer so left voicemail\nTried again 14/3\nTried again 15/3 @1130",
      dateOfReferral: "2022-03-11T12:13:29.8492644",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T08:18:51.7592768",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 130,
      closedDate: "2022-06-27T09:28:13.5525824",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chelsea Richards",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 185,
      caseRef: "SAG185",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "spoken to a few other brokers but would rather keep in houses so looking for more advice ",
      dateOfReferral: "2022-03-11T12:14:45.3500072",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T14:23:18.4441246",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE ",
      financialDetailsId: null,
      closedDate: "2022-03-14T12:53:44.1954167",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alida Chacin",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 186,
      caseRef: "SAG186",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "has MIP with Halifax - went dirext - would like more advice please - SSTC - selling a shared ownership with Clarion",
      dateOfReferral: "2022-03-11T12:24:58.589493",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T14:23:28.288718",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-15T09:42:30.3719972",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Will Kirby ",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 187,
      caseRef: "SAG187",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "He is a mortgage advisor  - does not have an AIP. would also like to do a HCA for the 2 bed at Mortimer Place - Off plan , £310,000, 45% min share - SAGE ",
      dateOfReferral: "2022-03-11T12:43:15.2231229",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-11T15:32:48.5941113",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-17T10:02:04.5873452",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "ELLY MICKLEWRIGHT",
      advisor: "Steven Sanderson",
      referralUser: "Joe Evans",
      id: 188,
      caseRef: "SAG188",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "85",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE CALL ELLY WITHIN NEXT 24 HOURS TO DO FULL SAGE CHECKS AND MORTGAGE ADVICE. SHE IS LOOKING AT PLOT 85 WHICH IS A 2 BED SEMI DETACHED HOUSE, 100% = £230,000. MIN SHARE IS 50% TO 75%. SHE IF FTB. LET ME KNOW, THANKS\n\n\nPeter Hill Qualified\n\nadvisor notes are not updating - no answer when called so left a message - sent email as well ",
      dateOfReferral: "2022-03-11T14:41:29.1178482",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-05T09:20:12.484616",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 124,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Troy Hawthorne",
      advisor: "Paul Parker",
      referralUser: "Mark Shynn",
      id: 189,
      caseRef: "SAG189",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sold & completed Monday 7th March\nCurrently living with in-laws \nNothing To Sell\n\nPeter Hill qualified",
      dateOfReferral: "2022-03-11T15:29:34.3033052",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T14:00:00.4893147",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 122,
      closedDate: "2022-03-14T15:58:14.2699935",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Glen Allan",
      advisor: "Joanna Halliday",
      referralUser: "Mark Shynn",
      id: 190,
      caseRef: "SAG190",
      referredById: 71,
      caseStatusId: 29,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Both first time buyers \nBest to speak with Glen as Chloe works in a school\n\nQualified 14/03/22 for a 50% share *Baldev Dhanda*",
      dateOfReferral: "2022-03-11T15:59:17.4533376",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-17T09:42:18.101091",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 123,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Aaron Bootlez",
      advisor: "Laura Turner",
      referralUser: "Mark Shynn",
      id: 191,
      caseRef: "SAG191",
      referredById: 71,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Cydney is self employed\nAaron is employed\nPotentially this deposit might come from equity release with his dad.",
      dateOfReferral: "2022-03-11T17:26:03.9036638",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-16T10:07:50.88455",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 120,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emily Marshall-Jones",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 192,
      caseRef: "SAG192",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "AIP with LS Finance - still looking for more advice \n\nDoes not qualify for a 45% share of a property with a FMV of £325,000 but can qualify for a property with a FVM of £275,000 *Baldev Dhanda*",
      dateOfReferral: "2022-03-11T17:28:21.0897447",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T21:51:27.5158193",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 750,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 132,
      closedDate: "2022-03-18T09:30:16.6810634",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Constantinos Anastasiou",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 193,
      caseRef: "SAG193",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "15&14",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "LIVES WITH HIS PARENTS CURRENTLY\nFIRST TIME BUYER\nBUYING ON HIS OWN\n\nClient already has a Mortgage in principle.\n\nClient did not qualify through HCA calculator *Baldev Dhanda*",
      dateOfReferral: "2022-03-12T09:34:07.6981575",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T14:49:05.379306",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 127,
      closedDate: "2022-03-14T14:49:10.6424812",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Pink St Clair",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 194,
      caseRef: "SAG194",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "open to any 1 beds, no pets children have now moved out. FTB, sometimes hard for her to answer the phone so please keep trying\n\nTried calling on 15/3/22, 16/3/22, 17/3/22 and 18/3/22 with an email sent on 16/3/22. No response to Voicemails or email. *Baldev Dhanda*",
      dateOfReferral: "2022-03-12T10:13:01.1781817",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T10:13:28.6193516",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-18T10:13:36.6395676",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kirsty Thatcher",
      advisor: "Peter Hill",
      referralUser: "Mark Shynn",
      id: 195,
      caseRef: "SAG195",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has spoken with Chris Nya via offer sub\nWas buying via our office but was outbid \nFirst Time Buyer\nWorks for the Met Police in London ",
      dateOfReferral: "2022-03-12T10:56:05.5920734",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T09:32:06.9514805",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 27000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-14T15:46:30.982888",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emma Baker",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 196,
      caseRef: "SAG196",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 177500,
      plotNumber: "209",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Emma is a student nurse & Harold is employed\n\nThey are unsure as to how much they can borrow so after some great advice. \n\nIf affordability does not fit at 50% please ask as they may go lower. \n\nLegals Sold and quoted",
      dateOfReferral: "2022-03-12T12:01:17.1354241",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T09:08:47.9561831",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-15T09:22:14.274163",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Christina Patston",
      advisor: "Christopher Taylor",
      referralUser: "Mark Shynn",
      id: 197,
      caseRef: "SAG197",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "She is part time\nHe is full time",
      dateOfReferral: "2022-03-12T12:14:44.7880598",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T16:28:20.3368756",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 131,
      closedDate: "2022-06-27T09:30:26.1567956",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Omolade Animashaun",
      advisor: "Paul Parker",
      referralUser: "Ellis Gamon",
      id: 198,
      caseRef: "SAG198",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 185000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called and spoke to client on 22/3.\n\nRequested documents to get DIP.\n\nSent follow-up email on 1/4 on update for documents and scheduling appointment.\n\nReplied on 1/4 - decided to put process on hold whilst they save more funds for deposit/moving costs. ",
      dateOfReferral: "2022-03-12T15:28:17.4439983",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T14:08:28.8360795",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 138,
      closedDate: "2022-04-01T14:08:43.650313",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lucy Evans",
      advisor: "Ian Parker",
      referralUser: "Charlotte Tomlinson",
      id: 199,
      caseRef: "SAG199",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Interested in Kingsboure  \nlives with parents ",
      dateOfReferral: "2022-03-14T11:21:02.4926317",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T17:09:31.6652486",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 130000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 151,
      closedDate: "2022-04-05T14:33:29.2748351",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Hannah Knowles ",
      advisor: "Arjun Dhunna",
      referralUser: "Charlotte Tomlinson",
      id: 200,
      caseRef: "SAG200",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 889570,
      plotNumber: "plot 202",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-14T11:31:45.4250573",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-14T12:27:43.4334643",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-03-16T12:22:34.3975481",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Scott Simmonds",
      advisor: "Rachel Davies",
      referralUser: "Lauren Ruff",
      id: 201,
      caseRef: "SAG201",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently renting, interested in both the three beds and the two beds(when available).",
      dateOfReferral: "2022-03-14T11:52:48.5786984",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T14:14:31.5895074",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 126,
      closedDate: "2022-06-27T15:27:02.3962798",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sian Wickins",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 202,
      caseRef: "SAG202",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Partner has house to sell, both in full time employment.\n\nCan not qualify as house not up for sale or SSTC. Also deposit amount is £5000 and not £12000. *baldev dhanda*",
      dateOfReferral: "2022-03-14T11:58:57.2358172",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T11:24:53.6901566",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 129,
      closedDate: "2022-03-15T11:24:58.7894827",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jura Savage",
      advisor: "Peter Hill",
      referralUser: "Irina Pinto Coutinho",
      id: 203,
      caseRef: "SAG203",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 132500,
      plotNumber: "63",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Head housekeeper. Getting divorced & buying by herself. Looking to buy 75%. \n\n\nPeter Hill qualifying\n\nvoicemail left 14/3 @ 15:16\ntried 10:37 on 15/3\n\nQualifies for 75% \n\nHas her own advisor with DIP",
      dateOfReferral: "2022-03-14T13:16:39.0423282",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T12:12:14.4473821",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-27T09:10:26.0405769",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ruth Ferrari",
      advisor: "Baldev Dhanda",
      referralUser: "Eleanor Forbes",
      id: 204,
      caseRef: "SAG204",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit level can increase to up to £15,000 with gift from relative.\n\nClient does not qualify based on her actual deposit of £4,000 for a property with a full market value of £225,000. She could potentially qualify if she can confirm her deposit of £12,000. *Baldev Dhanda*",
      dateOfReferral: "2022-03-14T13:19:44.7822884",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T22:03:46.8963248",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 4000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 144,
      closedDate: "2022-03-16T22:03:55.8364562",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ashleigh Evans",
      advisor: "Deonne Samuels",
      referralUser: "Irina Pinto Coutinho",
      id: 205,
      caseRef: "SAG205",
      referredById: 25,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Supervisor/Team leader at a heating company.",
      dateOfReferral: "2022-03-14T15:49:38.0958098",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T13:14:32.2769248",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 128,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tadas Sumskis",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 206,
      caseRef: "SAG206",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "nothing to sell, just him looking at 2 beds.\n\nDid not qualify for a 50% share of a property with a FVM of £267,500 *Baldev Dhanda*",
      dateOfReferral: "2022-03-14T15:58:02.8831096",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T11:38:38.8431167",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 137,
      closedDate: "2022-03-16T11:39:23.0542148",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MISS LEONIE FITZHENRY",
      advisor: "Peter Hill",
      referralUser: "Joe Evans",
      id: 207,
      caseRef: "SAG207",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "85",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE CALL LEONIE WITHIN NEXT 24 HOURS TO DO FULL SAGE CHECKS AND MORTGAGE ADVICE - SHE IS FTB AND HAS SPOKEN TO OWN IFA. SHE IS LOOKING AT PLOT 85 STAFFORD ROAD, PENKRIDGE WHICH IS MIN OF 50% SHARE. JO\n\nMedihya already qualified in the white box",
      dateOfReferral: "2022-03-14T16:23:48.1253716",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T10:30:01.868142",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-15T10:34:39.1096908",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Olufemi Oloyy",
      advisor: "Rachel Davies",
      referralUser: "Mark Shynn",
      id: 208,
      caseRef: "SAG208",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-14T17:03:59.1138208",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T09:54:47.4544177",
      isDeleted: 1,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-30T09:54:53.3690088",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Diana Webb",
      advisor: "Arjun Dhunna",
      referralUser: "Spencer Bartley ",
      id: 209,
      caseRef: "SAG209",
      referredById: 73,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Selling matrimonial home in Grays, will be clearing some personal debts with sale proceeds and should be left with approx £100,000 deposit. Needs three beds as Diane has 2 children. ",
      dateOfReferral: "2022-03-14T17:21:31.5946234",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T09:05:30.3788733",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-03-15T16:51:15.4228248",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jacqui Phillips",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 210,
      caseRef: "SAG210",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "will be using cash from her sale \n\nWould qualifies for a 50% share in a property with a FVM of £160,000 however, she has not begun the sale process on her existing property so could not be qualified. *Baldev Dhanda*",
      dateOfReferral: "2022-03-15T11:52:19.2669141",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T11:29:50.9436248",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 135,
      closedDate: "2022-03-16T11:33:00.4724064",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Oluwasdamilola (Dammy) Ayisire",
      advisor: "Paul Parker",
      referralUser: "Spencer Bartley ",
      id: 211,
      caseRef: "SAG211",
      referredById: 73,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works full time but currently on maternity leave \n\nQualified for 50% Share of property with a FVM of £405,000 *Baldev Dhanda*\n\nContacted on 23/3 - awaiting documents. 1st appointment scheduled w/c 4th April due to partner's availability (teacher and its Easter break)\n\nSent follow-up email on 1/4 on update for documents and scheduling appointment.\n\nGot DIP but have decided not to go ahead at this time",
      dateOfReferral: "2022-03-15T12:44:40.4054346",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-05T08:36:17.4817433",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: 139,
      closedDate: "2022-04-05T08:36:30.609105",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Whitson",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 212,
      caseRef: "SAG212",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Full time employment- First Time Buyer- Currently Renting  ",
      dateOfReferral: "2022-03-15T12:55:48.2091618",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T14:27:53.2446174",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-15T15:21:52.1728974",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rebecca Allpress",
      advisor: "Rachel Davies",
      referralUser: "Nicola Pike",
      id: 213,
      caseRef: "SAG213",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "Plot 209",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call between -2 or after 4pm please\n\nLegal Sold & quoted emailed",
      dateOfReferral: "2022-03-15T13:23:45.5752849",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T15:44:12.8588348",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: 141,
      closedDate: "2022-06-30T09:52:19.3323859",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jodie Willis",
      advisor: "Arjun Dhunna",
      referralUser: "Irina Pinto Coutinho",
      id: 214,
      caseRef: "SAG214",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 133750,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Has recently had a job promotion & salary has gone up ",
      dateOfReferral: "2022-03-15T13:41:50.0991371",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T10:28:24.4743242",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 134,
      closedDate: "2022-07-13T10:10:27.6792745",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Liam Moss",
      advisor: "Joanna Halliday",
      referralUser: "Lauren Ruff",
      id: 215,
      caseRef: "SAG215",
      referredById: 66,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit level is aprox. as he hasnt sold his flat yet, looking for new build/shared ownership, have a 7 week old baby girl.\n\nemail chaser sent 7.4.22 jh",
      dateOfReferral: "2022-03-15T13:57:29.9616887",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T06:57:46.594121",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 133,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Anthony Ackermann",
      advisor: "Peter Hill",
      referralUser: "Mark Shynn",
      id: 216,
      caseRef: "SAG216",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently lives in a shared ownership property.\nPut deposit as £0 - said his wife will confirm the exact amount as they might use some equity on other bits \n\n\nArjun qualified the wife - doubled up",
      dateOfReferral: "2022-03-15T14:38:08.623689",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T16:37:15.8495804",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 136,
      closedDate: "2022-03-18T16:37:19.3285631",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lauren Clarke",
      advisor: "Rachel Davies",
      referralUser: "Laura Jones",
      id: 217,
      caseRef: "SAG217",
      referredById: 54,
      caseStatusId: 35,
      developmentId: 2,
      purchasePrice: 80000,
      plotNumber: "204",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-15T15:06:28.7674496",
      offerExpiryDate: "2022-12-25T00:00:00",
      updatedDate: "2022-06-30T09:57:03.022504",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 140,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Wilfred Chitembwe",
      advisor: "Christopher Taylor",
      referralUser: "Laura Jones",
      id: 218,
      caseRef: "SAG218",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 225000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "please call after 2pm on 16/03",
      dateOfReferral: "2022-03-15T15:35:02.0827019",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T10:57:59.9760448",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 142,
      closedDate: "2022-06-27T09:51:40.4648635",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Darren Thomas",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 219,
      caseRef: "SAG219",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sold subject to contract on his property in Norfolk, 50% share- will have approx- £20,000-£30,000 deposit. ",
      dateOfReferral: "2022-03-15T16:20:44.5814021",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-15T17:07:00.4395911",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-16T10:18:50.8063831",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Leanne Russon",
      advisor: "Peter Hill",
      referralUser: "Laura Jones",
      id: 220,
      caseRef: "SAG220",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "gone through a break up - sold her house and is currently living in late mums flat - will look to also sell that \n\n\nPeter Hill spoke to Leanne - decided against this property so didnt want to be qualified",
      dateOfReferral: "2022-03-15T17:27:09.7404118",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T12:46:10.3964091",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-16T12:47:18.8008447",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Charlotte Brant",
      advisor: "Arjun Dhunna",
      referralUser: "Ellis Gamon",
      id: 221,
      caseRef: "SAG221",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 185000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-15T18:23:36.7224806",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T09:14:25.3454989",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-17T13:06:39.9065573",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sherisse McFarlane & Gamma Cauwembergh",
      advisor: "Kelly Powers",
      referralUser: "Lauren Ruff",
      id: 222,
      caseRef: "SAG222",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has been looking in the surrounding areas for a while loves the area, has a baby on the way, deposit she said 10% of the £202,500 both her and her partner are full time employed.  \n\ncalled left v/m sent email on 16/3 at 4pm.\n\nHCA passed - using owner advisor (was a broker herself)",
      dateOfReferral: "2022-03-16T11:22:16.8658195",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T15:09:56.5649257",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 143,
      closedDate: "2022-07-21T15:28:32.2461218",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Johnathan Vaughan",
      advisor: "Mark Ross",
      referralUser: "Laura Jones",
      id: 223,
      caseRef: "SAG223",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 160000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-16T11:56:20.3681235",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T13:56:41.759926",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 145,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "MR ALEX WIXON",
      advisor: "Arjun Dhunna",
      referralUser: "Joe Evans",
      id: 224,
      caseRef: "SAG224",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "204 OR 205",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE CALL ALEX WITHIN NEXT 24 HOURS - HE IS FTB AND LOOKING INTO THE SAGE % APARTMENTS AT THE FAIRWAYS - WE HAVE 2 X PLOTS LEFT (204 & 205) WHICH ARE BOTH 2 BED 1ST FLOOR. 100% VALUE @ £160,000. MIN SHARE IS 50%. SERVICE CHARGE IS £114.99 PCM. LET ME KNOW. THANKS, JO",
      dateOfReferral: "2022-03-16T12:02:12.954371",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-16T13:01:15.3071894",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 115,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-16T13:01:35.2684992",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rachel Wagstaff",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 225,
      caseRef: "SAG225",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 112500,
      plotNumber: "75",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Rachel is currently on Mat leave but returning soon. Would have to sell her property. Is unsure as to how much she would be able to borrow. \n\nLegals Sold & quote emailed\n\n\nPeter Hill Taken on - going to go back in a month to check on progress of sale",
      dateOfReferral: "2022-03-16T12:10:19.294035",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T14:18:33.8306904",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 146,
      closedDate: "2022-07-07T09:21:54.1918271",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gina Ugwu & Caur Obeta",
      advisor: "Adam Faulkner",
      referralUser: "Lauren Ruff",
      id: 226,
      caseRef: "SAG226",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can you double check if she has a property to sell she had to run off before I could ask again as the line was pretty poor, she is currently on Visa to this country from Nigeria has 3 years left both are full time employed. \n\nQualified 17/3/22 *Baldev Dhanda*",
      dateOfReferral: "2022-03-16T14:51:11.3854869",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T13:27:44.2422943",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 21000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 148,
      closedDate: "2022-04-02T08:25:19.8998436",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Shannon Prawl",
      advisor: "Arjun Dhunna",
      referralUser: "Eleanor Forbes",
      id: 227,
      caseRef: "SAG227",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-16T17:13:16.7568525",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T11:29:54.2780701",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-03-21T09:59:37.3305093",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Whitson",
      advisor: "Phillip Nutter",
      referralUser: "Emily Balloch",
      id: 228,
      caseRef: "SAG228",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill Qualifying\n\nCall arranged for 10am 18th feb",
      dateOfReferral: "2022-03-17T10:24:18.8925413",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T14:21:48.7818132",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 156,
      closedDate: "2022-03-28T14:23:32.8408315",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Dedre Ackermann ",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Emily Balloch",
      id: 229,
      caseRef: "SAG229",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Now looking at Kelvedon site - Ayletts Green as her first choice \nSC is roughly 850 \n14&15 Plots are on the market - 3 bedroom\nFull Price £405,000\n50% shared ",
      dateOfReferral: "2022-03-17T10:25:54.3897681",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T12:16:45.6520074",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 41000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 149,
      closedDate: "2022-07-12T12:23:48.2268277",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kelly lee",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 230,
      caseRef: "SAG230",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-17T10:27:22.8203692",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T11:31:16.5390691",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-17T12:58:21.0651224",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Marlene Munyanyi",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 231,
      caseRef: "SAG231",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Client decided not to pursue property. * Baldev Dhanda*",
      dateOfReferral: "2022-03-17T10:28:26.7662072",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T09:56:09.19765",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-21T09:56:20.0280066",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mike JARVIS",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 232,
      caseRef: "SAG232",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "116",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "qualified by Peter Hill\n\nDid not fir HCA calculator - mortgage too expensive due to age.",
      dateOfReferral: "2022-03-17T10:30:48.7414042",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T10:30:50.786176",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-22T10:30:54.4845625",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ahmad Bilal",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 233,
      caseRef: "SAG233",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "116",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-17T11:04:44.4341836",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-17T13:11:40.0844512",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-21T10:03:00.9183552",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Helen Symonds",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 234,
      caseRef: "SAG234",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "116",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client did not qualify for property with a FMV of £410,000. She could potentially qualify for a property worth £330,000. *Baldev Dhanda*",
      dateOfReferral: "2022-03-17T11:34:48.8566541",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T18:53:38.2122422",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 161,
      closedDate: "2022-03-21T18:55:08.5902168",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sebastian Frost ",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Emily Balloch",
      id: 235,
      caseRef: "SAG235",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "116",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-17T11:36:02.090321",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T12:17:27.8320813",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 147,
      closedDate: "2022-06-25T11:37:57.8986014",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Helen Symonds",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 236,
      caseRef: "SAG236",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Lovely lady, has nothing to sell, full time employed.\n\nClient did not qualify for a property with a FVM of £405,000. Client could potentially qualify for a property with a FVM of £330,000.",
      dateOfReferral: "2022-03-17T12:18:24.6139131",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T18:57:42.5216034",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 162,
      closedDate: "2022-03-21T18:58:35.3640833",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alida Chacin",
      advisor: "Phillip Nutter",
      referralUser: "Emily Balloch",
      id: 237,
      caseRef: "SAG237",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-17T15:04:14.8726845",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T09:27:08.7633192",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 152,
      closedDate: "2022-06-27T10:00:44.4357451",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Allison Gooch",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 238,
      caseRef: "SAG238",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "peter hill qualified\n\nno mortgage as buying all of her share with funds from sale of property",
      dateOfReferral: "2022-03-17T15:05:28.8222359",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-18T12:27:58.8475048",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 1,
      serviceCharge: 1,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 150,
      closedDate: "2022-03-18T12:28:08.9271223",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kinneh",
      advisor: "Baldev Dhanda",
      referralUser: "Claire Jenks",
      id: 239,
      caseRef: "SAG239",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "Plot 212, 6 Thomas Aston Place",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Kinneh is living with her friend Amanda Burrows, she currently works in Nantwich so wants a prop close to work, Amanda said for you to contact her but did advise you are likely to need to speak to Kinneh directly. ",
      dateOfReferral: "2022-03-17T15:14:13.1364362",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T10:23:57.7137975",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-29T10:29:40.2016899",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kinneh Jarju",
      advisor: "Baldev Dhanda",
      referralUser: "Claire Jenks",
      id: 240,
      caseRef: "SAG240",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "Plot 121, 6 Thomas Aston Place",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "friend called on Kinneh's behalf and asked if you can call her, did say sure you need to speak to Kinneh directly so have added both numbers on there, friend is Amanda Burrows, Kinneh works in Nantwich and wants to buy close so can walk to work ",
      dateOfReferral: "2022-03-17T15:28:19.5892391",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T10:24:42.5074068",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-29T10:30:14.858755",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lewis Blanchett & Paige Chesterman",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 241,
      caseRef: "SAG241",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently Renting, bad phone line as he was driving but was very keen for some more information on what he needs to do to get a shared ownership with his partner. Could you ask him to clarify his email address, please. \nThank you. \n**18/03/2022- won't be available to answer the phone til at least 3pm today** \n\n\nPeter Hill Qualifying\n\nVery tight on HCA so requested payslips and waiting for these to come through\n\n5th April 22 - enquired on the 2 bedrooms we now have... emailed Peter Hill to get clarity on the above before anything is emailed to the client. \n\n6.4.22 - Sent email for client to make contact to proceed next steps.\n\nsecond email sent on 11.4. No reply - closing lead",
      dateOfReferral: "2022-03-17T16:33:57.4440865",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T13:18:51.4899912",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 198,
      closedDate: "2022-04-19T13:21:13.7451342",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Arlow Farncombe",
      advisor: "Phillip Nutter",
      referralUser: "Laura Jones",
      id: 242,
      caseRef: "SAG242",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "77",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-18T11:42:50.6289585",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T09:36:45.6111116",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 10350,
      serviceCharge: 70,
      minPercShareAvailable: "45",
      housingAssociation: "sage",
      financialDetailsId: 153,
      closedDate: "2022-06-27T10:01:34.2275553",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sara Udi",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 243,
      caseRef: "SAG243",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "wants a 2 bed, will be purchasing with partner \n\nDid not qualify for the 50% share. Would qualify for a property with a FMV of £230,000. *Baldev Dhanda*",
      dateOfReferral: "2022-03-18T12:00:56.5717348",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-19T13:08:49.4584252",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 154,
      closedDate: "2022-03-19T13:10:22.0963147",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Anthony Pepper",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 245,
      caseRef: "SAG245",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**friend**\n\nShane burgess referral \n\nshane.burgess@haart.co.uk ",
      dateOfReferral: "2022-03-18T16:25:00.866228",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T09:48:11.5637885",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-21T12:57:58.1363681",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rizwan Ashraf",
      advisor: "Baldev Dhanda",
      referralUser: "Irina Pinto Coutinho",
      id: 246,
      caseRef: "SAG246",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 131250,
      plotNumber: "42",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Self employed - boxing business & chauffer ",
      dateOfReferral: "2022-03-19T11:57:41.7180628",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T11:51:41.1942177",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-28T11:34:03.5005104",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chris Cutler",
      advisor: "Phillip Nutter",
      referralUser: "Charlotte Tomlinson",
      id: 247,
      caseRef: "SAG247",
      referredById: 32,
      caseStatusId: 35,
      developmentId: 1,
      purchasePrice: 118000,
      plotNumber: "plot 207/206/205",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-19T15:07:21.193758",
      offerExpiryDate: "2022-06-29T23:00:00",
      updatedDate: "2022-06-27T10:04:42.9102815",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage housing ",
      financialDetailsId: 155,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Charlotte Colbridge",
      advisor: "Rachel Davies",
      referralUser: "Charlotte Tomlinson",
      id: 248,
      caseRef: "SAG248",
      referredById: 32,
      caseStatusId: 35,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "plot  212 /213/209",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Leeds looks do able based on affordability and also client's circumstances in regards to having no payslip and only contract. ",
      dateOfReferral: "2022-03-19T15:10:31.8985202",
      offerExpiryDate: "2022-12-21T00:00:00",
      updatedDate: "2022-06-27T15:41:46.2035967",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 163,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Charlie Dalton",
      advisor: "Phillip Nutter",
      referralUser: "Lia Wilkerson                                   ",
      id: 249,
      caseRef: "SAG249",
      referredById: 23,
      caseStatusId: 28,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "needs a 2 bed as has a little boy, him and his partner hannah \n\n\n**Note from Mark at Colchester**\nEnq'd on Ayletts Green two bedrooms - £162,500 50% shared full price £325k. \nEmailed Phillip Nutter to advise and obtain HCA",
      dateOfReferral: "2022-03-19T15:32:24.4782551",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T09:43:48.2948276",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 158,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Matthew Critchell",
      advisor: "Ian Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 250,
      caseRef: "SAG250",
      referredById: 23,
      caseStatusId: 35,
      developmentId: 5,
      purchasePrice: 207500,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ftb, 1 bed, just him purchasing, has a help to buy savings account but said cant do help to buy on these properties\n\nPeter Hill Qualifying\n\nRyan Currently doesnt fit the HCA calculator - his UC household figure cant be used so i have asked him to speak with UC to work out his own entitlement and will re-assess",
      dateOfReferral: "2022-03-21T09:49:11.8751359",
      offerExpiryDate: "2022-12-18T00:00:00",
      updatedDate: "2022-06-21T13:49:16.4191808",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 169,
      closedDate: "2022-03-21T11:39:42.2624946",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Charley Ewetuga",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 251,
      caseRef: "SAG251",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 217000,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Civil Servant\n\nClient qualifies for a property of £217,000. he has the potential to increase his deposit to £20,000 if required. Service charge maybe less than that stated as origianl property was for a FVM of £267,500 *Baldev Dhanda*\n\nContacted on 22/3 - awaiting documents to be sent to do DIP.\n\nSent follow-up email on 1/4 on update for documents and scheduling appointment.\n\nNo response since last update. Closing lead.",
      dateOfReferral: "2022-03-21T12:38:53.3615532",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T14:36:18.3012963",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 157,
      closedDate: "2022-04-14T14:36:22.0509418",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Dean Allix",
      advisor: "Arjun Dhunna",
      referralUser: "Ellis Gamon",
      id: 252,
      caseRef: "SAG252",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 270000,
      plotNumber: "105",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-21T13:19:50.6560021",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T14:38:24.2252226",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-01T09:20:43.4186946",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Gemma Campbell",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 253,
      caseRef: "SAG253",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Gemma works full time for the NHS, has 2 kids is a first time buyer and is currently renting.\n\nPeter Hill Qualified.\n\nScheduled a call on wednesday 23/3. Didn't answer.\n\nleft voicemail to rescehdule/calll me back - no reply \n\nLeft 2nd voicemail on 1/4  ",
      dateOfReferral: "2022-03-21T13:46:05.0699223",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T10:40:46.5444199",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 159,
      closedDate: "2022-04-05T08:39:32.1610646",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Samantha Flindall",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 254,
      caseRef: "SAG254",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wants to pay the full £202,500 in cash, full time worker, has 2 kids, selling the family home due to divorce. ",
      dateOfReferral: "2022-03-21T14:06:13.6847661",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-21T15:10:11.3833604",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-22T12:13:21.0963598",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Maria Odufuye",
      advisor: "Baldev Dhanda",
      referralUser: "Ellis Gamon",
      id: 255,
      caseRef: "SAG255",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 185000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-21T16:13:08.4575173",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T11:54:12.4531619",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-28T11:38:50.6929934",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Liam Grant",
      advisor: "Ian Parker",
      referralUser: "Claire Jenks",
      id: 256,
      caseRef: "SAG256",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "205, Thomas Aston Place",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "please call today if poss ",
      dateOfReferral: "2022-03-22T09:51:20.1939492",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T16:44:22.4626026",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 58,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 178,
      closedDate: "2022-03-29T16:57:34.3726205",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sian Wickins",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 257,
      caseRef: "SAG257",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has a property they do need to sell.\nReally likes the location of Kelvedon\nAware they need to sell\nDeposit level is what they will have and there is equity to come out of the property also.\nWill be with her partner also Robbie Waymouth\n\nDo not qualify as property is yet to be sold. They currently have £5000 as a deposit and can not confirm exact deposit amount once sale has been agreed. Client has been advised that they need to have to property on the market and SSTC. *Baldev Dhanda*",
      dateOfReferral: "2022-03-22T11:23:08.6690641",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T09:48:24.6423494",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 165,
      closedDate: "2022-03-23T09:52:09.8681644",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Richard Francis",
      advisor: "Ian Parker",
      referralUser: "Nicola Pike",
      id: 258,
      caseRef: "SAG258",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "Plot 207 - 3 bed or Plot 212 - 2 bed ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Ideally Richard would like a 3 bed but if unaffordable would look at at 2 bed.\n\nIf 50% is unaffordable on the 3 try 40% but we would need to get approval from Sage.\n\nPlot 212 - 2 Bed £88750 \n\nLegals Sold & Quote emailed\n\nQualify for 3 bed house with a FVM of £225,000 *Baldev Dhanda*",
      dateOfReferral: "2022-03-22T12:29:21.8132816",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T17:52:23.5091733",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 164,
      closedDate: "2022-04-04T16:08:07.0670498",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Taulora Papazi",
      advisor: "Peter Hill",
      referralUser: "Irina Pinto Coutinho",
      id: 259,
      caseRef: "SAG259",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "105",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works for Amazon\n\nPeter Hill Qualifying\n\nDoes not fit HCA calc",
      dateOfReferral: "2022-03-22T12:47:18.8949081",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T11:41:08.4432668",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-23T11:41:13.2315698",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ashley Legg",
      advisor: "Arjun Dhunna",
      referralUser: "Irina Pinto Coutinho",
      id: 260,
      caseRef: "SAG260",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 101250,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Corporate Security. He was about to complete on a Shared Ownership property in Dagenham but it fell through. ",
      dateOfReferral: "2022-03-22T14:24:03.3064231",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T15:05:05.8718482",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 3000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-29T14:59:09.8436721",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chloe Campbell",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 261,
      caseRef: "SAG261",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "JUST PURCHASING ON HER OWN\nFIRST TIME BUYER \nLIVING WITH HER MUM ",
      dateOfReferral: "2022-03-22T15:54:07.8096827",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-22T16:07:54.5337457",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-23T10:46:29.1401832",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lauren Dobinson ",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 262,
      caseRef: "SAG262",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "not spoken to anyone about the mortgage so far - looking for advice - has £10,000 debt atm - will be £5000 in May\n\nPeter Hill Qualifying\n\nTried 23/3 @ 11:13 left vm ",
      dateOfReferral: "2022-03-22T17:50:48.5807829",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-25T14:45:45.2705483",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 174,
      closedDate: "2022-07-07T13:25:25.6513661",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rachael Cowden",
      advisor: "Baldev Dhanda",
      referralUser: "Nicola Pike",
      id: 263,
      caseRef: "SAG263",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "205",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Rob works in Kuwait as a teacher.\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-03-22T18:23:04.4408969",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T11:33:25.549831",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-24T12:17:40.1952672",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Douglas Morgan",
      advisor: "Ian Parker",
      referralUser: "Nicola Pike",
      id: 264,
      caseRef: "SAG264",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & quote emailed",
      dateOfReferral: "2022-03-22T21:40:06.6694704",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T12:48:20.5665858",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 168,
      closedDate: "2022-04-06T12:24:03.2239289",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Holly Wilcockson",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 265,
      caseRef: "SAG265",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Primary number which is Taylor Northcote, he deals with the finances can you call after half 1pm as he is working til then. Both full time employed, looking for more information on shared ownership and help to buy as well, also interested in the two beds that are coming on. Mum lives in Kelvedon and they've seen the site and love the area.    ",
      dateOfReferral: "2022-03-23T10:32:46.4707868",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-25T12:33:05.446363",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 20250,
      serviceCharge: 850,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 170,
      closedDate: "2022-04-20T09:21:42.6749389",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Touqeer Alam",
      advisor: "Ian Parker",
      referralUser: "Laura Jones",
      id: 266,
      caseRef: "SAG266",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 160000,
      plotNumber: "205",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Qualified by Charlotte Innes.\n\nCouldn't save on portal, so email me for notes an HCA.",
      dateOfReferral: "2022-03-23T10:32:47.5937773",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-23T17:53:21.4373391",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 114.99,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-29T16:01:34.7318749",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "John Gamble",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 267,
      caseRef: "SAG267",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14+15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with his wife\nPrivate renting\nKid goes to school in the village\nBoth have their own business\n\nQualified on the HCA calculator but was unable to qualify on a lenders affordability calculator. *Baldev Dhanda & Phil Nutter*",
      dateOfReferral: "2022-03-23T10:41:56.4585791",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T21:48:22.1805926",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing",
      financialDetailsId: null,
      closedDate: "2022-03-24T21:48:27.1476702",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Laffar & Charlotte Chompson",
      advisor: "Peter Hill",
      referralUser: "Lauren Ruff",
      id: 268,
      caseRef: "SAG268",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "David called said he's got a shared ownership property up for sale at the moment needs 3 bed house due to children, both self employed and employed says he has dealt with sage on a previous property but didn't get it because his place wasn't on the market it is now. Can you call 24/03 after 9:30am please.\n\nPeter Hill Qualifying\n\nTried 11:15am on 24th left voicemail",
      dateOfReferral: "2022-03-23T15:09:01.1052259",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T11:15:32.1971325",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-07T13:24:57.0259538",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Matthew Gleaves",
      advisor: "Peter Hill",
      referralUser: "Lia Wilkerson                                   ",
      id: 269,
      caseRef: "SAG269",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "his splitting from his partner so they are buying him out o the property early stages, but would be cash from the property. open to 1 beds as well as 2 beds but 2 would be preferred\n\n\nCash buyer so no need to proceed to the advisors\n",
      dateOfReferral: "2022-03-23T15:38:03.1311841",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-25T10:27:02.8922142",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-03-25T10:27:06.5927813",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Holly Dodd",
      advisor: "Arjun Dhunna",
      referralUser: "Eleanor Forbes",
      id: 270,
      caseRef: "SAG270",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 117500,
      plotNumber: "Plot 9 Thomas aston place",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-23T15:56:59.0522308",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T09:46:59.2650571",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-03-28T08:34:46.5876217",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Charlotte Wright",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 271,
      caseRef: "SAG271",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14/15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with her mum & sister\nDebbie Franklin\nSamantha Wright\n£20k deposit \nAll live at the same address",
      dateOfReferral: "2022-03-23T16:34:18.2607055",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-24T10:12:19.2866204",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-24T17:15:51.1246702",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Danni Holloway",
      advisor: "Peter Hill",
      referralUser: "Ellis Gamon",
      id: 272,
      caseRef: "SAG272",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 192500,
      plotNumber: "91",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-24T09:33:00.524804",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T12:37:18.2578153",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 171,
      closedDate: "2022-07-07T09:19:44.7292203",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Idrissia Majid",
      advisor: "Zeeshan Ashraf",
      referralUser: "Lia Wilkerson                                   ",
      id: 273,
      caseRef: "SAG273",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 133500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Mohammed Rassmi is her son, she doesnt speak a lot of English so he will be dealing with it. she's interested in the 2 beds so put the most expensive one still available down so they can choose if they pass. FTB\n\nPeter Hill Qualified\n\nDid not fit the calc just on her own but does with husband",
      dateOfReferral: "2022-03-24T09:42:38.2697592",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T15:15:50.525769",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 176,
      closedDate: "2022-07-15T06:36:52.1801536",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Hannah Jenkins",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 274,
      caseRef: "SAG274",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "15&14",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Call tomorrow 25th - anytime before 3pm\nShe also had another job with David Lloyd - only 3 hours a week contracted but treated as self-employed\nPartner is Harvey Daley - FTB \n\nClient did not respond to any attempts made to contact her. Voicemails and Emails were sent to client. *Baldev Dhanda*",
      dateOfReferral: "2022-03-24T13:19:01.2600516",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-30T11:40:22.9087707",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-30T11:40:28.4007424",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Samantha Liston",
      advisor: "Christopher Taylor",
      referralUser: "Eleanor Forbes",
      id: 275,
      caseRef: "SAG275",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 177500,
      plotNumber: "212",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-24T13:39:06.5012445",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T08:29:58.221305",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 173,
      closedDate: "2022-06-27T10:02:16.8927656",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Aminat Lawal ",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 277,
      caseRef: "SAG277",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "spoken to quite a few brokers - has AIP with Halifax still open to advice \n\nClient does not wish to proceed. *Baldev Dhanda*",
      dateOfReferral: "2022-03-25T11:54:42.2583922",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-25T16:59:36.3289653",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-25T16:59:39.7658844",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Zena Lodge ",
      advisor: "Jamie Bowley",
      referralUser: "Emily Balloch",
      id: 278,
      caseRef: "SAG278",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "18",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "MIP with Natwest - speaking to a broker but sees the benefit in keeping all in house so open to more advice \n\nQualifies for a 60% share in the property. She is keen to take the next steps and speak to an advisor. Unsure whether her MIP is for a shared ownership scheme, *Baldev Dhanda*",
      dateOfReferral: "2022-03-25T16:53:11.2154946",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T11:47:32.7247256",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 125000,
      serviceCharge: 750,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 175,
      closedDate: "2022-04-04T10:46:37.1331196",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Anthony Smith",
      advisor: "Peter Hill",
      referralUser: "Ellis Gamon",
      id: 279,
      caseRef: "SAG279",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 270000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Peter Hill Qualifying\n\nHad a chat with Anthony about shared ownership and he wants to buy outright. He didnt realise he would have to pay rent as well as mortgage.",
      dateOfReferral: "2022-03-25T16:57:09.0640396",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T09:15:02.3540644",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-04T09:20:55.9407642",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Eric Ahiagbede",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 280,
      caseRef: "SAG280",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SSTC - Beresfords - sold to a company - has MIP with Flagstones - would take more advice  \n\nClient did not qualify for a 50% Share of a £410,000 property. *Baldev Dhanda*",
      dateOfReferral: "2022-03-25T17:17:36.0859875",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T12:20:33.536928",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 150000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 192,
      closedDate: "2022-04-04T12:20:38.703391",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Brandon Gill",
      advisor: "Peter Hill",
      referralUser: "Ellis Gamon",
      id: 281,
      caseRef: "SAG281",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 267500,
      plotNumber: "86",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill qualifying\n\nArranged call for 1530 on 28/3",
      dateOfReferral: "2022-03-25T17:25:41.7631736",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T10:43:35.3564599",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-06T14:09:27.7865258",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Abbie Marshall",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Emily Balloch",
      id: 282,
      caseRef: "SAG282",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Selling a shared ownership property - has haart coming out Monday - not spoken to anyone about the mortgage - deposit could be higher depending on sale \n\n\nPeter Hill Qualifying\n\nTired 28/3 @ 11:49 left vm",
      dateOfReferral: "2022-03-25T17:34:01.2665158",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T19:10:44.3400506",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-22T08:17:22.3283752",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Owen Williams ",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 283,
      caseRef: "SAG283",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "will use FS - not spoken to anyone before about it - FTB \n",
      dateOfReferral: "2022-03-26T14:23:51.0297172",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T10:45:12.8299399",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 750,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-04T08:17:40.879147",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Umut Unal",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 284,
      caseRef: "SAG284",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SSTC - completing in a week - speaking to a friend and to HSBC - would like mortgage advice from us as well to compare - will be chain free\n",
      dateOfReferral: "2022-03-26T14:26:22.6361595",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T11:25:10.7830434",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-27T10:19:16.5411867",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tommy green ",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 285,
      caseRef: "SAG285",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SSTC - Beresford's - been sold about 12 weeks - would like further advice on the mortgage \n\n\nTried 28/3 @16:47",
      dateOfReferral: "2022-03-26T14:28:19.868393",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T15:47:17.7698522",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 175000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-04T10:02:44.6451875",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Laffar",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 286,
      caseRef: "SAG286",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 410000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Employed and Self Employed - said he is complicated - has a broker but open to more advice - has a property to sell - going OTM with his shared ownership company \nAlready been qualified via Peter Hill on the 23rd - Referred by Lauren at Colchester",
      dateOfReferral: "2022-03-26T14:30:40.1862091",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T10:54:17.5536525",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-01T10:18:43.8003051",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Katie Gleaves",
      advisor: "Peter Hill",
      referralUser: "Ellis Gamon",
      id: 287,
      caseRef: "SAG287",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 262500,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Is looking to purchase entirely cash ",
      dateOfReferral: "2022-03-28T09:04:32.3583385",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-28T13:08:26.0813038",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 131250,
      serviceCharge: 1200.6,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-03-28T13:22:31.1415113",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jasmine Mattacks",
      advisor: "Rachel Davies",
      referralUser: "Mark Shynn",
      id: 288,
      caseRef: "SAG288",
      referredById: 71,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14/15/28/29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with her partner Charlie \nFirst time buyers \nBoth employed.\nWill look at two beds... advised we are getting two beds on Ayletts Green soon.... details below for this as she wants to be qualified on this one as well. \nrough market price £325k\nrough rent charge £372.50\n\nClients have been qualified for a 3 bedroom with a FMV of £405,000. they are interested in a 2 bed at £325.000. *Baldev Dhanda*",
      dateOfReferral: "2022-03-28T10:59:25.3309723",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T12:07:07.2158313",
      isDeleted: 1,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 180,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rayna Stoyanova",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 289,
      caseRef: "SAG289",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-28T13:27:15.5031584",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T08:56:43.4095868",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 130000,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-03-29T13:16:28.112302",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Taulora Papazi",
      advisor: "Arjun Dhunna",
      referralUser: "Ellis Gamon",
      id: 291,
      caseRef: "SAG291",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 270000,
      plotNumber: "105",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-28T15:13:24.2923512",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T08:47:24.6842611",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-03-29T14:47:46.4914673",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Adeyemi Badru",
      advisor: "Paul Parker",
      referralUser: "Ellis Gamon",
      id: 292,
      caseRef: "SAG292",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 192500,
      plotNumber: "91",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sent email on 1/4 to have initial chat - no response.\n\nSent 2nd email on 5/4 - will close lead on 8/4 if not heard from client\n\nNot heard from client. - closing lead.",
      dateOfReferral: "2022-03-28T15:48:38.3418076",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-11T10:17:04.4437405",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 179,
      closedDate: "2022-04-11T10:17:19.5353989",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ash Keyte",
      advisor: "Rachel Davies",
      referralUser: "Nicola Pike",
      id: 294,
      caseRef: "SAG294",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legal Sold & quote emailed",
      dateOfReferral: "2022-03-29T09:06:49.6506735",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-03-29T11:10:12.7395376",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 177,
      closedDate: "2022-06-30T09:51:40.0959125",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Scott Seabridge",
      advisor: "Paul Parker",
      referralUser: "Eleanor Forbes",
      id: 295,
      caseRef: "SAG295",
      referredById: 31,
      caseStatusId: 28,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "80",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Available on the phone after 3:30.\n\nSent email on 4/4 - got reply to call on 5/4 in the morning.\n\nSpoke on the phone on 5/4 - sent follow up email with doc request.\n\n\nPP: 26/4\nDue to affordability and criteria on the clients' other/old bank account. He is not going to proceed at this time. \n\n08/08/22\nRe-opened as affordability and criteria changed",
      dateOfReferral: "2022-03-29T10:18:17.9864473",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T11:09:12.2454797",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 27000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 186,
      closedDate: "2022-04-26T09:42:28.4397643",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nick Hutchings",
      advisor: "Peter Hill",
      referralUser: "Ellis Gamon",
      id: 296,
      caseRef: "SAG296",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 207500,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "has 110k deposit FTE\n\nPeter Hill Qualifying\n\nTried 10:40 4/4 left voicemail",
      dateOfReferral: "2022-03-29T12:53:46.7734395",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T14:58:42.083255",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 110000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 199,
      closedDate: "2022-04-08T15:01:54.0286675",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Stacey Wilson",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 297,
      caseRef: "SAG297",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "94 or 101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - she may have already spoken to someone regarding shared but putting her through again for a check \n\n",
      dateOfReferral: "2022-03-29T15:24:48.7350902",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T12:31:44.712632",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 226,
      closedDate: "2022-04-19T13:25:10.1792144",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Isha Baldwin ",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 298,
      caseRef: "SAG298",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28/29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - AIP with Lloyds and Natwest went direct so looking for more advice.\n\n\nPP:\nSent email on 1/4.\n\nSpoke on Phone on 4/4 - awaiting documents to proceed.\n\nChanged property interest due to availability. Now wants to proceed wit Ayletts Green 2 beds. Awaiting docs.\n\nQualified and DIp'd. Sage chose another applicant.",
      dateOfReferral: "2022-03-30T08:56:13.4175855",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-17T15:41:32.8317107",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 184,
      closedDate: "2022-06-17T15:41:44.7188601",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Belinda Peacock ",
      advisor: "Ian Parker",
      referralUser: "Emily Balloch",
      id: 299,
      caseRef: "SAG299",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - her partner has a friend who is a broker but would be looking for more advice as well \n\nBelinda will be doing a single application as her partner has been self employed for less than 12 months. She has also been advised by another broker but would like to have a chat. *Baldev Dhanda*",
      dateOfReferral: "2022-03-30T09:04:42.211994",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T16:03:44.6680972",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 182,
      closedDate: "2022-05-05T09:58:07.5901872",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alzira Peres",
      advisor: "Deonne Samuels",
      referralUser: "Emily Balloch",
      id: 300,
      caseRef: "SAG300",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB - not spoken to anyone about the mortgage before ",
      dateOfReferral: "2022-03-30T09:25:50.3962818",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T08:57:57.2800476",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15500,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 183,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mark Purser",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 301,
      caseRef: "SAG301",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15",
      htb: 1,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Currently rented\nJust purchasing in his name but partner and 3 kids will be moving in. \nCan purchase this full cash at the 50% share\nHappy to discuss the options of mortgage purchase ",
      dateOfReferral: "2022-03-30T10:15:35.2463248",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T12:54:46.5464105",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 202500,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 185,
      closedDate: "2022-04-01T14:45:50.7685111",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Joe Bonfiglio",
      advisor: "Arjun Dhunna",
      referralUser: "Charlotte Tomlinson",
      id: 302,
      caseRef: "SAG302",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "plot 175",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "need address confirming if possible x\n\nnot on the market yet understands will need to sell ",
      dateOfReferral: "2022-03-30T10:15:55.5912294",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T08:54:58.514215",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-04-01T14:46:23.7387497",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emma Gower & Joshua Ludlow",
      advisor: "Joanna Halliday",
      referralUser: "Lauren Ruff",
      id: 303,
      caseRef: "SAG303",
      referredById: 66,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Emma is self employed on a 0hour contract for a Care company partner works full time, they have a little girl also. \n\nPeter Hill To qualify\n\nTried 15:40 on 1st april - left vm\nemailed client doc request 5.4.22 also russel davies \n7.4.22 client said not putting prop on market yet as cost of living gone up",
      dateOfReferral: "2022-03-30T10:22:16.1620946",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T07:12:35.343384",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 195,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sacha Lawrence",
      advisor: "Rachel Davies",
      referralUser: "Mark Shynn",
      id: 304,
      caseRef: "SAG304",
      referredById: 71,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14@15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First time buyer\nLiving with her parents \nAdvised we are getting two bedrooms as well (£162,500) £372.40 share rent - approx",
      dateOfReferral: "2022-03-30T10:39:49.4865883",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T15:55:45.9127728",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 450000,
      serviceCharge: 464.06,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 193,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Felicity Calveley",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 305,
      caseRef: "SAG305",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 112500,
      plotNumber: "Plot 205",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB \n\nLegals Sold & quote emailed",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T09:09:39.4240417",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-06T08:48:16.0661001",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Samantha Henry",
      advisor: "Mark Ross",
      referralUser: "Lauren Ruff",
      id: 306,
      caseRef: "SAG306",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 &15 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Samantha has just lost out on a shared ownership property and looking to find another one, her shared ownership property in London is on the market is aware she has to be sold before she can progress. Has a mortgage in place has 5% deposit. Mother lives locally. \n\npeter hill qualifying\n\ntried 16:10 on 1st april  left vm",
      dateOfReferral: "2022-03-30T13:30:44.4525313",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T12:56:42.5683887",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 191,
      closedDate: "2022-04-05T16:24:11.2575739",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Georgie Foreman & Georgia May",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 307,
      caseRef: "SAG307",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First Time Buyer, Employed, call Friday morning if possible as it is their little boys 1st birthday!. \n",
      dateOfReferral: "2022-03-30T15:46:47.1061513",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T09:11:21.3941544",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-04T15:56:05.986399",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alzira Peres",
      advisor: "Deonne Samuels",
      referralUser: "Emily Balloch",
      id: 308,
      caseRef: "SAG308",
      referredById: 64,
      caseStatusId: 26,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - not spoken to anyone about the mortgege - looking for advice \n\nDuplicate of SAG300 *Baldev Dhanda*",
      dateOfReferral: "2022-03-30T16:32:23.2416821",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T11:08:15.5983034",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 439,
      lnhManagerId: null,
    },
    {
      applicant: "Suzanne Killin",
      advisor: "Christopher Taylor",
      referralUser: "Emily Balloch",
      id: 309,
      caseRef: "SAG309",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "NTS - spoken to a broker already - will discuss more ",
      dateOfReferral: "2022-03-30T16:34:18.75719",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T06:34:46.0540265",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 750000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 187,
      closedDate: "2022-06-27T09:31:15.8637266",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nick & Emma Bacon",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 310,
      caseRef: "SAG310",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15 also 28 &29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "They are interested in both the 2 beds (28&29) and 3 beds (14&15), wife owned property around 18 years ago they have a help to buy ref- HTB-93204-S7Y0M9. \nHe is available Friday 01/04/2022 between 2:30pm & 4pm.\n ",
      dateOfReferral: "2022-03-31T14:08:03.5082923",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-03T15:32:43.5504175",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 224,
      closedDate: "2022-05-16T08:46:09.3402148",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Luke Taylor",
      advisor: "Christopher Taylor",
      referralUser: "Emily Balloch",
      id: 311,
      caseRef: "SAG311",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-03-31T16:24:08.7865368",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:34:06.6703789",
      isDeleted: 1,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 188,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Christine Tokar",
      advisor: "Arjun Dhunna",
      referralUser: "Irina Pinto Coutinho",
      id: 312,
      caseRef: "SAG312",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Senior Project Manager",
      dateOfReferral: "2022-03-31T16:41:43.0082373",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T10:25:54.1374548",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-04T11:33:14.4973193",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Francesca Dooley",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lauren Ruff",
      id: 313,
      caseRef: "SAG313",
      referredById: 66,
      caseStatusId: 34,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "*Service charge is APROX*\nHer house in Manningtree is going up for sale today (01/04/2022) I have explained to her it must be sold before she can go any further on this, she understands wants to make sure she can afford it though. \ndeposit will be from the sale of her house. \n\nPeter Hill Qualifying\n\nTried 4/4 @1600 left vm\n",
      dateOfReferral: "2022-04-01T10:50:14.4346364",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T11:07:49.2505783",
      isDeleted: 1,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: null,
    },
    {
      applicant: "Kerryjane Curley",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 314,
      caseRef: "SAG314",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14&15 29&28",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Living in rented\nBuying and her daughter will be living with her. \nWants to run through the qualification for the 3 bedroom and 2 bedroom \n\n14&15 - 3 bedroom;s\n£405k full price \n£464.06 - rough rent figure\n£202,500 50% share price \n\n29&28 - 2 bedroom's \n£325k full price\n£162,500 50% share price\n£372.40 - rough rent figure",
      dateOfReferral: "2022-04-01T11:00:10.417359",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T10:27:53.3109003",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 0,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 196,
      closedDate: "2022-06-28T14:29:25.3812005",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ann O'Toole",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 315,
      caseRef: "SAG315",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 162500,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**Service charge is APROX**\nAnn is in full time employment, has a mortgage in principle for £176,000. \nHer elderly parents live that way and she has to travel there every few days to buy food or take them to hospital appointments so this would be ideal.",
      dateOfReferral: "2022-04-01T11:43:21.5246125",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-01T14:44:53.8373929",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-07T08:16:53.5890821",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Steve Ashby",
      advisor: "Peter Hill",
      referralUser: "Lauren Ruff",
      id: 316,
      caseRef: "SAG316",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**service charge is APROX**\nFirst time buyer, phone line was pretty poor and he had to go back to work so got what I could only thing I didn't get to ask was whether he was buying with someone.  \n\nPeter Hill Qualifying \n\nCall arranged 6pm 4/4",
      dateOfReferral: "2022-04-01T12:05:00.7475856",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T09:03:05.8711383",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-12T09:36:14.9452967",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alice Brooks",
      advisor: "Paul Parker",
      referralUser: "Claire Jenks",
      id: 317,
      caseRef: "SAG317",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "Plot 175, 9 Caviller Road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called and left voicemail on 16/5 at 11am. Followed up call with email. \n\nAwaiting reply....\n\nCalled again on 18/5 at 2:30pm. Left voicemail.",
      dateOfReferral: "2022-04-01T12:14:43.3453492",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T13:41:52.5072626",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-05-31T16:31:35.6923739",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Thomas Spence",
      advisor: "Ravneet Sokhi",
      referralUser: "Irina Pinto Coutinho",
      id: 318,
      caseRef: "SAG318",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Self employed barber\n\nPeter Hill Qualifying\n\nTried 9:55am on 4/4 - left voicemail\n\n26.04.2022- Ravneet Sokhi Qualifying. Left vm @17:16",
      dateOfReferral: "2022-04-01T12:31:28.0077868",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T16:19:04.2588154",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-28T11:24:43.5766303",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Casey Sharp & Tremayne Divers",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 319,
      caseRef: "SAG319",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 405000,
      plotNumber: "14 & 15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking at both the 2 bed & 3 bed for this estate:\nPlots 14 & 15\n28 & 29- £162,500.\nThey are selling their home in Clacton on the market at the moment. ",
      dateOfReferral: "2022-04-01T13:25:24.6518765",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T08:33:40.4574653",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-06T13:26:44.8548481",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Luke Bevis",
      advisor: "Peter Hill",
      referralUser: "Claire Jenks",
      id: 320,
      caseRef: "SAG320",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "plot 175, 9 Caviller Road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "call today if poss\n\n\nPeter Hill Qualyfying\n\nSpoke with Luke - he didnt think they were going to proceed but is passing on the information i gave him about the property to his partner and they will decide. \n\nTried again 11/4 \n\nWill close and re-open if Luke/Partner gets back in contact.",
      dateOfReferral: "2022-04-01T15:29:58.7291152",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T09:46:15.4634232",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-12T09:46:28.3749833",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Rebecca Bray & Robert Otter",
      advisor: "Christopher Taylor",
      referralUser: "Irina Pinto Coutinho",
      id: 321,
      caseRef: "SAG321",
      referredById: 25,
      caseStatusId: 33,
      developmentId: 5,
      purchasePrice: 93750,
      plotNumber: "64",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Rebecca is a Customer Service Advisor at Santander & Robert is a Recruitment Consultant ",
      dateOfReferral: "2022-04-01T15:38:38.6055375",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T11:07:33.5655378",
      isDeleted: 1,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 190,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ross Cooper",
      advisor: "Mark Ross",
      referralUser: "Claire Jenks",
      id: 322,
      caseRef: "SAG322",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "plot 175, 9 Caviller Rd",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "call asap",
      dateOfReferral: "2022-04-01T15:50:49.0588346",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-16T14:41:48.3863616",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-16T14:44:36.1814126",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David James Whitehead",
      advisor: "Ian Parker",
      referralUser: "Charlotte Tomlinson",
      id: 323,
      caseRef: "SAG323",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118750,
      plotNumber: "plot 175 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "04/04/2022- Ravneet Qualifying\n\n04/04/2022- Left vm\n05/04/2022- Left vm\n06/04/2022- Left vm and emailed advising to contact us if he is still interested. Leaving with him.\n\n20/04/2022- He has spoken to an adviser but is open to using JMNB instead. Please contact via email as he is not always available via phone- \n\naddress not found, \nself employed ",
      dateOfReferral: "2022-04-02T09:14:53.9160545",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-21T11:20:57.8297737",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 225,
      closedDate: "2022-06-21T08:59:49.2170838",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ryan Reece",
      advisor: "Phillip Nutter",
      referralUser: "Ellis Gamon",
      id: 324,
      caseRef: "SAG324",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 207500,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-02T09:18:41.0681708",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T09:37:24.9129537",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 189,
      closedDate: "2022-04-04T12:06:31.8224424",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lewis Hickton",
      advisor: "Baldev Dhanda",
      referralUser: "Charlotte Tomlinson",
      id: 325,
      caseRef: "SAG325",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 88750,
      plotNumber: "206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Rents a council house atm, he'll give me full details when hes ready\nhe doesn't know if he'd qualify as he has very little savings - for our shared ownership properties \n\nClient wanted to know monthly rent figures. Does not want to proceed with a property on the Kingsbourne Development. *Baldev Dhanda*",
      dateOfReferral: "2022-04-02T10:52:55.1422352",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-06T15:44:55.8073944",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-04-06T15:45:00.4008413",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Erin Wilkinson ",
      advisor: "Joanna Halliday",
      referralUser: "Emily Balloch",
      id: 326,
      caseRef: "SAG326",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nMIP - has a broker - £166,925\nwould be open to more mortgage advice \nspoke to her and updated Emily, only will use own broker. ",
      dateOfReferral: "2022-04-02T15:34:37.3745752",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T07:13:58.9977726",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 47000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 194,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Hannah Jenkins",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 327,
      caseRef: "SAG327",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - spoken to broker and bank - wants more advice - no AIP \n\nTried calling on 4 separate occasions with 2 emails also to client. No response from any attempt made to contact her. *Baldev Dhanda*",
      dateOfReferral: "2022-04-02T15:39:47.4759911",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T12:04:28.8544334",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-08T12:07:20.5609962",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Joshua ",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 328,
      caseRef: "SAG328",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - looking for advice \n\nSpoke to the client, he was advised that all the properties have gone so no longer wishes to proceed. He would like to find another property that is available before going through the qualification process. *Baldev Dhanda*",
      dateOfReferral: "2022-04-02T15:45:54.8949404",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T10:36:16.3620788",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-04T10:36:25.4246874",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Abbey Mount",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 329,
      caseRef: "SAG329",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client has been unresponsive to calls and  voicemails. There has been some email communication but nothing to secure an appointment or show an interest in the property. *Baldev Dhanda*",
      dateOfReferral: "2022-04-04T08:24:57.5018105",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T09:21:19.10257",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 750,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-04-07T09:21:23.8462008",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Luke Taylor",
      advisor: "Christopher Taylor",
      referralUser: "Emily Balloch",
      id: 330,
      caseRef: "SAG330",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-04T08:32:52.6789024",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-04T11:57:06.0447476",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-27T09:34:14.4886356",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jack Ely",
      advisor: "Mark Ross",
      referralUser: "Lauren Ruff",
      id: 331,
      caseRef: "SAG331",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "25 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Jack is currently renting, his deposit is a gift from dad around the £6000 mark. Had to go back to work so got the basics- can you call him after 2pm please , thank you. ",
      dateOfReferral: "2022-04-04T09:39:21.2377479",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-16T14:11:02.508762",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 197,
      closedDate: "2022-04-16T14:46:45.3989442",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Craig Humphreyson",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 333,
      caseRef: "SAG333",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 115000,
      plotNumber: "77",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals Sold & Email quoted",
      dateOfReferral: "2022-04-05T12:32:23.0659739",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-05T12:51:12.0781289",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-05T14:51:32.8849276",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chris Buckland",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 335,
      caseRef: "SAG335",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Roughly £5k deposit \nLives locally to the development \nFirst Time Buyer\nEnq'd on the two bedroom's\n\nClient does not qualify for a property of £325,000. He will qualify for a 50% Share of a £240,000 property. *Baldev Dhanda*",
      dateOfReferral: "2022-04-05T14:56:44.3811641",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-06T13:01:47.1829542",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 372.4,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 200,
      closedDate: "2022-04-06T13:03:02.7308959",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Anthony Hardy",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 336,
      caseRef: "SAG336",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 225000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client has been called on multiple occasions from 5th to the 8th April with 2 follow up emails also sent. No response received from emails or voicemails. *Baldev Dhanda*",
      dateOfReferral: "2022-04-05T15:06:06.5239755",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T12:17:44.843592",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-08T12:17:52.3378131",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jemma Smith",
      advisor: "Paul Parker",
      referralUser: "Claire Jenks",
      id: 337,
      caseRef: "SAG337",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "175, 9 Caviller Road, Nantwich ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "can you call asap please to check eligability.\n\n7/4/22\nAfter further conversations with Jemma, unfortunately I won’t be able to proceed on this due to criteria around shared ownership scheme and affordability. \n\nHer partner already owns a property which he is not selling and, whilst he wasn’t going to be an applicant with Jemma, it became clear that this was a property they were to live in together as both had contributed towards the deposit in a joint account. This also made it unaffordable for Jemma in her own right, due to her partner then being classed as a “dependent”.\n",
      dateOfReferral: "2022-04-05T15:21:17.0698029",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T13:34:55.6135045",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 58,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 201,
      closedDate: "2022-04-07T13:35:01.8294466",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ella Spears",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 338,
      caseRef: "SAG338",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 225000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call after 4pm.\n\nSpoke on phone - but they've decided to put the process on hold for the time being due to personal reasons.",
      dateOfReferral: "2022-04-05T15:36:22.7473258",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T08:11:58.4870516",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 202,
      closedDate: "2022-04-25T08:12:07.5617132",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "James Gillingham",
      advisor: "Peter Hill",
      referralUser: "Charlotte Tomlinson",
      id: 339,
      caseRef: "SAG339",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118000,
      plotNumber: "PLOT 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill Qualifiying\n\n\nTried 12:40 on 6/4\n",
      dateOfReferral: "2022-04-06T10:16:50.8981986",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T10:41:16.3270424",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage housing ",
      financialDetailsId: 215,
      closedDate: "2022-06-27T10:30:45.7758888",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Elizabeth Ward",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 340,
      caseRef: "SAG340",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Nothing to sell - currently in rented ",
      dateOfReferral: "2022-04-06T10:47:14.7198159",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T08:57:23.9993063",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-13T15:46:00.2321273",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Megan Richardson",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 341,
      caseRef: "SAG341",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spoken to Laura Tilbury at just mortgages, buying alone, lost out on other shared ownership properties in the area. Very keen to get going.",
      dateOfReferral: "2022-04-06T11:28:02.3756055",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-06T11:54:30.6290898",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-06T13:22:19.8455865",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Graham Eaton",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 342,
      caseRef: "SAG342",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "Plot 206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Please Note: Legals sold & email quoted please do not resend ",
      dateOfReferral: "2022-04-06T12:31:40.1900767",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T09:15:36.5447061",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-07T10:17:57.8643232",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Beth Anthony",
      advisor: "Arjun Dhunna",
      referralUser: "Laura Jones",
      id: 343,
      caseRef: "SAG343",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "103",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "current property is on the market and she has viewings so will hopefully be SSTC soon ",
      dateOfReferral: "2022-04-06T12:52:52.2554605",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T09:16:27.0011941",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-08T09:00:15.6860318",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Laura Steele",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 344,
      caseRef: "SAG344",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "4 attempts made to contact client from the 7th to the 12th April. No voicemail facility but 2 emails sent with no response. *Baldev Dhanda*",
      dateOfReferral: "2022-04-07T10:52:49.280192",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T09:00:18.1401189",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 150000,
      serviceCharge: 372.4,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-12T09:00:27.1429982",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jason Leadbeater",
      advisor: "Ravneet Sokhi",
      referralUser: "Lauren Ruff",
      id: 345,
      caseRef: "SAG345",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**Service charge is aprox**\n\nCurrently renting, London Based, can you call after 3:30pm as he is in meetings. (Can you confirm address the one he gave doesn't show up on our system strangely. \n\n07.04.2022- Ravneet Qualifying\nDidn't qualify. He is going to look to increase his deposit over the next 6 months or so. Updated EA",
      dateOfReferral: "2022-04-07T11:46:25.901113",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T15:30:32.550814",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-07T15:30:39.6947397",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Michelle Hutchins",
      advisor: "Laura Turner",
      referralUser: "Lauren Ruff",
      id: 346,
      caseRef: "SAG346",
      referredById: 66,
      caseStatusId: 27,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28/29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**Service charge is APROX**\nShe is buying by herself, loves the area and has visited a few times. ",
      dateOfReferral: "2022-04-07T13:00:15.9127708",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T16:12:05.3704178",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 65000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 203,
      closedDate: "2022-04-07T14:32:03.5102314",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ella Wratten ",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 347,
      caseRef: "SAG347",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "haart Witham going out to it, works in london, not in excess of £80,000. \n\nDid not qualify as she is a current homeowner. Client will get back in touch once she is SSTC. To qualify she needs to increase her deposit to £35000 or clear her Credit Cards. *Baldev Dhanda*",
      dateOfReferral: "2022-04-07T13:22:49.9281075",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T15:49:11.7622121",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 204,
      closedDate: "2022-04-07T15:49:47.9683182",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Henry Donell",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 348,
      caseRef: "SAG348",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**service charge is APOX**\nSold subject to contract, divorcing and looking for his own home. ",
      dateOfReferral: "2022-04-07T13:31:58.1173441",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T13:56:40.5199124",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-07T14:30:25.9293143",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Isha & Russell Baldwin",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 349,
      caseRef: "SAG349",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**service charge is APROX**\nFirst time buyers, tried for Hatfield Peveral and qualified.\n\nDuplicate lead to SAG349. Will qualify for this property and are currently dealing with Paul Parker. *Baldev Dhanda*",
      dateOfReferral: "2022-04-07T13:45:35.1973283",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T12:51:01.8520525",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-08T12:55:01.2587017",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Katie Wilshire & Bradley Martin",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 350,
      caseRef: "SAG350",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**Service charge is APROX**\nLooking to buy with partner, property to sell shared ownership, both work full time Katie is a police officer.\n\nPlease call Bradley- secondary number as Katie is at work.\n\nPeter Hill Qualifying\n\nTried 10:45 on 8/4",
      dateOfReferral: "2022-04-07T14:24:42.166133",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T08:26:24.158145",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 211,
      closedDate: "2022-04-29T10:30:24.7724259",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Connor Chambers",
      advisor: "Arjun Dhunna",
      referralUser: "Lauren Ruff",
      id: 351,
      caseRef: "SAG351",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**Service charge is APROX**\nonly going in his name- First time buyer",
      dateOfReferral: "2022-04-07T14:39:03.0749689",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-07T15:00:26.0543744",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-07T15:53:35.7083388",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Paul Rennocks",
      advisor: "Deonne Samuels",
      referralUser: "Mark Shynn",
      id: 352,
      caseRef: "SAG352",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Just buying on his own\nRecently divorced\nMoney due within a week",
      dateOfReferral: "2022-04-07T14:54:29.049065",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-11T16:42:13.8333568",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 372.4,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 206,
      closedDate: "2022-04-11T16:40:56.121189",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "David Edwards",
      advisor: "Arjun Dhunna",
      referralUser: "Charlotte Tomlinson",
      id: 353,
      caseRef: "SAG353",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 118000,
      plotNumber: "plots 176",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Angie Dutton - partner \nspeak to her \n45% ",
      dateOfReferral: "2022-04-08T09:15:04.4780888",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T09:37:01.7935232",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing ",
      financialDetailsId: null,
      closedDate: "2022-04-08T15:40:15.6855949",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Stacey Jewitt",
      advisor: "Arjun Dhunna",
      referralUser: "Mark Shynn",
      id: 355,
      caseRef: "SAG355",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit amount is roughly from the sale \nService charge is approx also ",
      dateOfReferral: "2022-04-08T10:34:44.8174687",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T12:36:19.9607232",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-12T10:36:12.6131659",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "James Hodson",
      advisor: "Baldev Dhanda",
      referralUser: "Nicola Pike",
      id: 356,
      caseRef: "SAG356",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 120000,
      plotNumber: "147",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Legals Sold - Quote emailed\n\nIf Plot 147 @ £120k is unaffordable use Plot 175 @ £111,250 please\n\nClient has not responded to calls, voicemails, or emails that have been made since 8th April to 14th April. *Baldev Dhanda*",
      dateOfReferral: "2022-04-08T10:38:19.2673329",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T10:48:06.3575025",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-14T10:48:11.5394559",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Igor Nistor",
      advisor: "Peter Hill",
      referralUser: "Mark Shynn",
      id: 357,
      caseRef: "SAG357",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Partner is employed full time \ndeposit is between 15 - 25k \n\nPeter Hill Qualifying\n\nIgor would rather fill out the form himself as he isnt the best at english over the phone so i am awaiting him to return the completed form before being able to fill out the HCA",
      dateOfReferral: "2022-04-08T10:51:46.1226875",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-11T12:59:25.8959965",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-27T10:20:25.8066317",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nooruz Zaman",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 358,
      caseRef: "SAG358",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "His deposit is from the sale of a house, he shared the equity with his ex partner. Has a mortgage approved through halifax. \n\nWill qualify for a 40% share in the property. Awaiting response from EA to confirm if this will be acceptable. *Baldev Dhanda*",
      dateOfReferral: "2022-04-08T11:34:12.5150514",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T15:38:16.5590695",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-20T11:22:00.5206623",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chukka Prasad",
      advisor: "Joanna Halliday",
      referralUser: "Russell Davis",
      id: 359,
      caseRef: "SAG359",
      referredById: 19,
      caseStatusId: 27,
      developmentId: 7,
      purchasePrice: 360000,
      plotNumber: "8",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "PLEASE NOTE:\n\nApplicant has enquired about a site we havent yet launched but will be selling later this year. 2 bedrooms will be 250K  3 beds will be from 300K up to 375K . The site in in Rope Walk Ipswich. These will NOT be ready in time for HTB. \n\nPlease call the client SAT PM ",
      dateOfReferral: "2022-04-08T12:26:26.884497",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T15:57:54.4271242",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Amy Stone",
      advisor: "Paul Parker",
      referralUser: "Mark Shynn",
      id: 360,
      caseRef: "SAG360",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with her partner Harry \nboth FTB \nBoth full time employed\nWill consider any shared ownership in their area right up to Colchester.\n\nPP:\nSent email on 11/4 at 11:30.\n\nPP: \nSent 2nd email on 19/4 at 2pm\n\nPP: Plots now reserved but wants to a DIP and documents checked to help with their hunt. may be interested in a flat but wants a house.",
      dateOfReferral: "2022-04-08T12:50:29.4890565",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T16:39:35.9057368",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 381,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 208,
      closedDate: "2022-04-25T17:41:23.0573624",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nick Rowles",
      advisor: "Arjun Dhunna",
      referralUser: "Charlotte Tomlinson",
      id: 361,
      caseRef: "SAG361",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 81000,
      plotNumber: "plot 214 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "would sell own apartment, offered valuation on it understands would need to be sold ",
      dateOfReferral: "2022-04-08T12:54:30.8544375",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T13:12:15.8379198",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage housing",
      financialDetailsId: null,
      closedDate: "2022-04-08T13:44:01.7749656",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Yasmin Sailsman",
      advisor: "Ravneet Sokhi",
      referralUser: "Laura Jones",
      id: 362,
      caseRef: "SAG362",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "77",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "available anytime over the weekend and after 1:30PM weekdays \n08/04/2022- Ravneet Qualifying\n08/04/2022- Yasmin Didn't qualify, advised to look at cheaper properties/increase deposit. She will also be starting regular overtime in the next few months",
      dateOfReferral: "2022-04-08T13:15:21.6192588",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-08T14:57:49.7626907",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-08T15:10:42.2638401",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Emma Taylor",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 363,
      caseRef: "SAG363",
      referredById: 54,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "77",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Emma has qualified for a 50% share on a property with a FMV of £230,000 based on the guarantee she clears her CC and Creation Finance with the funds from the sale of her property which should complete within the next few weeks. *Baldev Dhanda*",
      dateOfReferral: "2022-04-08T13:22:41.7232774",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-09T07:52:00.6430828",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 207,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Phoebe Walden & Alex Cutts",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 364,
      caseRef: "SAG364",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28 & 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently lives with dad, wants to buy with partner, FTB, £20,000 deposit. ",
      dateOfReferral: "2022-04-08T16:26:57.277442",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T11:21:47.0041574",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 213,
      closedDate: "2022-06-06T13:30:21.0687689",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Melissa Clutton",
      advisor: "Paul Parker",
      referralUser: "Eleanor Forbes",
      id: 365,
      caseRef: "SAG365",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "205",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "PP:\nSent email on 11/4 at 11:30.",
      dateOfReferral: "2022-04-09T08:57:31.0762041",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-11T10:30:53.8085767",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 209,
      closedDate: "2022-04-14T14:35:43.0022711",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ryan Clay",
      advisor: "Peter Hill",
      referralUser: "Lia Wilkerson                                   ",
      id: 366,
      caseRef: "SAG366",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking at a 2 bed if cant afford it please look at 1 beds with him :)\n\n\nRyan doesnt currently qualify - however he is going to apply for UC on his own (currently household with partner but they are splitting so cannot be used) - will reassess HCA once he applies.",
      dateOfReferral: "2022-04-09T15:50:49.4819696",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-12T09:39:47.1391699",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 2000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-27T10:33:18.8220558",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "William Gray",
      advisor: "Rachel Davies",
      referralUser: "Lia Wilkerson                                   ",
      id: 367,
      caseRef: "SAG367",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "likes to be called Billy, only him buying, wants a 2 bed, FTB\n\n11.04.2022- Ravneet Qualifying. Qualified for 50% share. Emailed HCA to EA.",
      dateOfReferral: "2022-04-09T16:00:01.6136974",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-11T17:05:00.4740712",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 210,
      closedDate: "2022-06-30T09:56:33.0162578",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Laura Edwards",
      advisor: "Deonne Samuels",
      referralUser: "Laura Jones",
      id: 368,
      caseRef: "SAG368",
      referredById: 54,
      caseStatusId: 28,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "please call between 1pm and 2pm weekdays ",
      dateOfReferral: "2022-04-11T09:49:41.4714073",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T12:24:30.9035027",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 212,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Adam Burgess",
      advisor: "Ian Parker",
      referralUser: "Laura Jones",
      id: 369,
      caseRef: "SAG369",
      referredById: 54,
      caseStatusId: 35,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client qualifies for a 50% Share. If he raises his deposit to £25k then he will qualify for 60%. *Baldev Dhanda*",
      dateOfReferral: "2022-04-11T11:41:19.2594884",
      offerExpiryDate: "2022-11-28T00:00:00",
      updatedDate: "2022-08-15T10:22:31.5144908",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 840,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 214,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Miss Catherine Rice",
      advisor: "Ian Parker",
      referralUser: "Ellie Tomlinson",
      id: 370,
      caseRef: "SAG370",
      referredById: 20,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "2 bedroom houses",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill qualifying\n",
      dateOfReferral: "2022-04-12T14:36:27.3839339",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-13T16:29:45.7822186",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 216,
      closedDate: "2022-06-21T08:53:16.7539205",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Summer Brushette",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lia Wilkerson                                   ",
      id: 372,
      caseRef: "SAG372",
      referredById: 23,
      caseStatusId: 34,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking at 1 beds as we dont have any 2 beds left, ftb, put down the highest price 1 bed",
      dateOfReferral: "2022-04-13T09:47:39.253272",
      offerExpiryDate: "2022-12-21T00:00:00",
      updatedDate: "2022-06-27T08:52:23.1539397",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 217,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: null,
    },
    {
      applicant: "Aman Sood",
      advisor: "Mark Ross",
      referralUser: "Lia Wilkerson                                   ",
      id: 373,
      caseRef: "SAG373",
      referredById: 23,
      caseStatusId: 27,
      developmentId: 5,
      purchasePrice: 207500,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ideally wats 2 bed but none left, doesnt seem to understand that if he qualifies for ore than 50% he needs to proceed with what ever percentage he can afford.\nDidn't give me much info apart from he earns around 35k a year didn't give me deposit amount\n\nQualified 14/4/22 *Baldev Dhanda*",
      dateOfReferral: "2022-04-13T10:35:36.8331183",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T15:51:22.5543694",
      isDeleted: 1,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 5500,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 220,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jamie Conway",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 375,
      caseRef: "SAG375",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client does not qualify, he will qualify for a 50% share in a property with a FMV of £240,000 *Baldev Dhanda*",
      dateOfReferral: "2022-04-14T12:17:21.4467858",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T16:20:26.828072",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-04-20T11:45:18.6823402",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lucy Robbins",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Emily Balloch",
      id: 376,
      caseRef: "SAG376",
      referredById: 64,
      caseStatusId: 32,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "220",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "14.04.2022- Ravneet Qualifying. Qualified for 50% on Leeds. Emailed HCA to EA",
      dateOfReferral: "2022-04-14T12:19:21.517535",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-16T09:34:18.0880222",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 218,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: null,
    },
    {
      applicant: "John Thurlbeck ",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 377,
      caseRef: "SAG377",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "220",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-14T12:22:16.6310005",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T10:29:37.2359073",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 219,
      closedDate: "2022-07-13T10:12:59.9151727",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sid Broderick",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 378,
      caseRef: "SAG378",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "220",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client will qualify for a 45% Share of a property with a FMV of £210,000. *Baldev Dhanda*",
      dateOfReferral: "2022-04-14T12:23:29.567892",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-14T15:06:48.5789528",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-14T15:06:58.2027482",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Charlie Dalton",
      advisor: "Mark Ross",
      referralUser: "Emily Balloch",
      id: 379,
      caseRef: "SAG379",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "220",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "has spoken to phillip nutter before in regards to kelvedon shared ownership",
      dateOfReferral: "2022-04-14T12:25:43.7337962",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-16T15:03:32.7213681",
      isDeleted: 0,
      advisorId: 59,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 221,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Dominic Hoare",
      advisor: "Ian Parker",
      referralUser: "Laura Jones",
      id: 380,
      caseRef: "SAG380",
      referredById: 54,
      caseStatusId: 35,
      developmentId: 3,
      purchasePrice: 260000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Free for a call anytime Tuesday 19/04 as he is off work \nRavneet Qualifying \n19.04.2022- Emailed outstanding queries\n21.04.2022- Qualified. They are also looking at a 2 bed at £224,000",
      dateOfReferral: "2022-04-16T14:10:30.5681977",
      offerExpiryDate: "2023-01-06T00:00:00",
      updatedDate: "2022-07-21T11:40:08.7962669",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 229,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ravi Srivastava",
      advisor: "Ravneet Sokhi",
      referralUser: "Irina Pinto Coutinho",
      id: 381,
      caseRef: "SAG381",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 102500,
      plotNumber: "87",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "18.04.2022- Ravneet Qualifying. Booked call for 19.04.2022- currently owns a property abroad. He is going to look at the possibility of selling it and will contact us if he does decide to sell it. Informed EA",
      dateOfReferral: "2022-04-18T10:19:02.0624306",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T14:32:16.2883728",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-19T14:32:47.7441338",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sally Page",
      advisor: "Paul Parker",
      referralUser: "Mark Shynn",
      id: 382,
      caseRef: "SAG382",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "29&28",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Enq'd on the two bed rooms \nService charge - approx.\n\nPP:\n\n1st email sent on 19/4 at 2pm.\n\nPP: Spoke with client, however,  Both properties have now been reserved. No alternatives available through Sage / L&NH for her for at least 12-18 months. She will contact Spicerhaart/other EAs for other options and has saved my number.\nLead closed",
      dateOfReferral: "2022-04-19T08:18:12.6233638",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T16:38:24.065749",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 222,
      closedDate: "2022-04-19T16:38:30.0347231",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Laura Mason",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 383,
      caseRef: "SAG383",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Her partner is self employed - Aramis Mason\nService charge is approx\n\nDid not qualify with lender affordability criteria *Baldev Dhanda*",
      dateOfReferral: "2022-04-19T08:24:14.5944064",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-22T11:01:06.0439936",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-22T11:01:11.8989529",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Michael Boulton",
      advisor: "Paul Parker",
      referralUser: "Laura Jones",
      id: 384,
      caseRef: "SAG384",
      referredById: 54,
      caseStatusId: 34,
      developmentId: 3,
      purchasePrice: 130000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-19T09:25:20.3364399",
      offerExpiryDate: "2023-01-20T00:00:00",
      updatedDate: "2022-06-27T08:59:24.8713492",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 223,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: null,
    },
    {
      applicant: "Glebs Borisovs",
      advisor: "Baldev Dhanda",
      referralUser: "Mark Shynn",
      id: 385,
      caseRef: "SAG385",
      referredById: 71,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "service charge is approx\nClient sent there enq asking if sage would accept less than 50% share \nAdvise it is highly unlikely \n\nClient does not wish to proceed with the property unless the lease could be extended and is not keen to get involved with any difficulties with the HA. *Baldev Dhanda*",
      dateOfReferral: "2022-04-19T09:25:28.6482645",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-19T12:40:52.3151306",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 74000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-19T12:41:19.2269638",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Irfan Rauf",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 386,
      caseRef: "SAG386",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 130000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "property is going on the market and looking to use equity to be a cash buyer for 50% share - has mentioned he doesn't have the best credit score however \n\nDid not qualify. *Baldev Dhanda*",
      dateOfReferral: "2022-04-19T10:08:34.9439575",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-20T09:04:34.219288",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 130000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-20T09:07:48.3502936",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mourelle Josiah-wong",
      advisor: "Ian Parker",
      referralUser: "Mark Shynn",
      id: 387,
      caseRef: "SAG387",
      referredById: 71,
      caseStatusId: 33,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28&29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "his partner is part time employed ",
      dateOfReferral: "2022-04-19T13:03:00.2188112",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T15:47:18.5720603",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 380,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 228,
      closedDate: "2022-05-17T17:09:44.6425797",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kerri-Anne Hughes",
      advisor: "Rachel Davies",
      referralUser: "Lia Wilkerson                                   ",
      id: 388,
      caseRef: "SAG388",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "open to one beds as wel as 2, put he in or or only 2 bed left try her on 103,750 if 2 bed doesnt work\n\n20.04.2022- Ravneet Qualified",
      dateOfReferral: "2022-04-20T10:00:53.3271503",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-21T15:06:24.8066942",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 227,
      closedDate: "2022-06-27T15:30:02.6450328",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Luke Wholey",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 389,
      caseRef: "SAG389",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "just for him, wants a 2 bed if possible but only 1 left, if doesnt qualify for the 2 bed try 103,750 which is the most expensive  bed we have. \nHe works monday to friday till 5:30 so please try and call after that or weekends as wont be able to answer his phone at work\n\n*Client did not wish to proceed on a larger deposit* Baldev Dhanda",
      dateOfReferral: "2022-04-21T09:10:32.5755532",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T18:12:08.3792884",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-25T18:12:16.5286195",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Oliver Cole",
      advisor: "Baldev Dhanda",
      referralUser: "Lauren Ruff",
      id: 390,
      caseRef: "SAG390",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "28",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Hi, we know these are no longer available but Oliver was asking if he could pick your brains abit about how the shared ownership process works, how he can purchase more later on and how much he can afford he was interested in the 2 beds and he would really like Eylett's Green but for now he would like just some general information if possible using the 2 bed as an example. Can you call tomorrow (22/04/2022) please. \nThank you.\n\nSpoke to Oliver about shared ownership and affordability. He will potentially qualify for a property with a FMV of £340,000.  *Baldev Dhanda*",
      dateOfReferral: "2022-04-21T11:37:09.9789542",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-22T11:40:38.2087364",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 380,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-22T11:48:52.1288462",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Alice Boot",
      advisor: "Arjun Dhunna",
      referralUser: "Laura Jones",
      id: 391,
      caseRef: "SAG391",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "94",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-22T09:24:42.1164188",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-22T09:29:03.740554",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 115000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-22T10:04:57.4416602",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Karl Prince",
      advisor: "Paul Parker",
      referralUser: "Charlotte Tomlinson",
      id: 392,
      caseRef: "SAG392",
      referredById: 32,
      caseStatusId: 29,
      developmentId: 1,
      purchasePrice: 115000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "22.04.2022- Ravneet Qualified\n\n3/5/22\nAfter speaking with Karl, I've not heard back ref: document request, and follow up calls/emails.\n\nClosing lead. - re-opened now interested in plot 203 Kingsbourne",
      dateOfReferral: "2022-04-22T09:56:16.6909347",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-16T08:41:17.4805928",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 230,
      closedDate: "2022-05-03T12:19:38.1694508",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Darcie Reeve",
      advisor: "Arjun Dhunna",
      referralUser: "Ellis Gamon",
      id: 393,
      caseRef: "SAG393",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 207500,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-22T09:58:43.1669911",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-22T10:30:00.7962483",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-26T10:27:24.9655586",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Louise Carrigan",
      advisor: "Rachel Davies",
      referralUser: "Laura Jones",
      id: 394,
      caseRef: "SAG394",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 245000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-22T10:00:28.8063897",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-23T10:19:07.3518094",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 63.38,
      minPercShareAvailable: "47",
      housingAssociation: "sage",
      financialDetailsId: 231,
      closedDate: "2022-06-30T09:50:48.5362303",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Ben Mulvaney",
      advisor: "Steven Sanderson",
      referralUser: "Emily Balloch",
      id: 395,
      caseRef: "SAG395",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 310000,
      plotNumber: "Plot 1 ",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        'NOT MORTIMER PLACE \nNOT SAGE \nNOT SHARED OWNERSHIP \n\n35" Moulsham Street \n\nLooking for mortgage advice as well as being qualified- I think this will be a sign up as looking to keep all in house.  \n\nThey are FTB with a £30,000 deposit. have a DIP for £290,000 with L&C. \n\nThey would like to reserve today so please could this be called ASAP. \n\nLooking into HTB as well, would like to compare both. ',
      dateOfReferral: "2022-04-22T10:20:09.684971",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T14:53:14.2067373",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 1103.89,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-22T10:25:59.8823413",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lesley Golding",
      advisor: "Steven Sanderson",
      referralUser: "Emily Balloch",
      id: 396,
      caseRef: "SAG396",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "our vendor\n22.04.2022- Ravneet Sokhi Qualified",
      dateOfReferral: "2022-04-22T11:14:38.6024294",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T15:27:46.0544537",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 232,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nabeel Arshad",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Laura Jones",
      id: 397,
      caseRef: "SAG397",
      referredById: 54,
      caseStatusId: 35,
      developmentId: 2,
      purchasePrice: 260000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - was on his parents mortgage for a very short time but has had his name removed\n\nQualified Lead *Baldev Dhanda*",
      dateOfReferral: "2022-04-22T11:24:01.3043131",
      offerExpiryDate: "2023-01-15T00:00:00",
      updatedDate: "2022-07-20T14:29:14.0501905",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 63.38,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 233,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: null,
    },
    {
      applicant: "Georgina Fulford",
      advisor: "Baldev Dhanda",
      referralUser: "Laura Jones",
      id: 398,
      caseRef: "SAG398",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 245000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Does not qualify for the property as a sole applicant. *Baldev Dhanda*",
      dateOfReferral: "2022-04-22T11:36:23.2525228",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-22T15:11:46.567719",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 63.38,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-22T15:22:16.2023614",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Chloe West ",
      advisor: "Phillip Nutter",
      referralUser: "Emily Balloch",
      id: 399,
      caseRef: "SAG399",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please confirm deposit before proceeding. Clients have said the deposit will be available at the end of April 2022 as well as funds for solicitors and advice fees *Baldev Dhanda*",
      dateOfReferral: "2022-04-22T11:59:27.2231308",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-28T08:20:31.8673234",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 7500,
      serviceCharge: 850,
      minPercShareAvailable: "45",
      housingAssociation: "SAGE",
      financialDetailsId: 238,
      closedDate: "2022-06-27T09:59:23.8535528",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Maria Hennessy",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 400,
      caseRef: "SAG400",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nnot spoken to anyone about the mortgage yet so looking for advice as well. \n\n25.04.2022- Ravneet Sokhi Qualifying. Left vm @ 9:50",
      dateOfReferral: "2022-04-23T11:07:56.6340361",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T09:30:43.1129796",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-04-25T10:04:42.2401451",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Wofai Ofem",
      advisor: "Ravneet Sokhi",
      referralUser: "Eleanor Forbes",
      id: 401,
      caseRef: "SAG401",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 240000,
      plotNumber: "142",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "25.04.2022- Ravneet Qualifying. Qualified for 50% but the monthly payments are out of their budget so no longer interested",
      dateOfReferral: "2022-04-23T14:14:26.6098874",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T09:32:12.7915961",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 3500,
      serviceCharge: 49,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-04-25T09:32:18.7391823",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Kelly Weatherill",
      advisor: "Paul Parker",
      referralUser: "Eleanor Forbes",
      id: 402,
      caseRef: "SAG402",
      referredById: 31,
      caseStatusId: 32,
      developmentId: 1,
      purchasePrice: 225000,
      plotNumber: "142",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has Help to Buy ISA and the deposit monies would come from this - she is not sure if she can use this on shared ownership properties.\n\n3/5.\n\nAfter having got everything ready for Sage and getting her a DIP. she and her partner went to view the property and unfortunately it did not meet their needs (size).\n\nLead will remain open for branch to keep in touch with client to find alternative property.  ",
      dateOfReferral: "2022-04-23T14:24:30.4217528",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T10:36:41.5427626",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 4000,
      serviceCharge: 50,
      minPercShareAvailable: "35",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 239,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Charlie Clark",
      advisor: "Steven Sanderson",
      referralUser: "Irina Pinto Coutinho",
      id: 403,
      caseRef: "SAG403",
      referredById: 25,
      caseStatusId: 35,
      developmentId: 5,
      purchasePrice: 195000,
      plotNumber: "127",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works as Trainee Accountant - please call between 1pm-2pm as will be on lunch break\n\nQualified Lead *Baldev Dhanda* 25/04/22\n\nFMV 195k\n50% buy 97500\ndep 20k \nloan 77500\n\nCharlie Anthony Richard Clark \nlived at home 21 years parents address ",
      dateOfReferral: "2022-04-23T14:41:28.3755339",
      offerExpiryDate: "2022-11-30T00:00:00",
      updatedDate: "2022-07-22T10:31:03.3732456",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 234,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Lindsay Clark",
      advisor: "Zeeshan Ashraf",
      referralUser: "Emily Balloch",
      id: 404,
      caseRef: "SAG404",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 300000,
      plotNumber: "Plot 3 & 4 ",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        'NOT MORTIMER PLACE \nNOT SAGE \nNOT SHARED OWNERSHIP \n\n35" Moulsham Street \n\nLooking for mortgage advice as well as being qualified-would like to look into HTB as well, would like to compare both. \n\nShe has a property to sell and on the market atm. \n\nLikes Plot 3 & 4 \n\nPlot 3 - 1 bed - £220,000 - Service £671.28\nPlot 4 - 2 bed - £300,000 - Service - £1014.38 - HTB \n\nShe is quite interested in reserving. \n\n',
      dateOfReferral: "2022-04-25T08:53:36.325609",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T09:12:48.1763688",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 1014.38,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-28T12:20:15.9483618",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Renan Olisco",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Ellis Gamon",
      id: 405,
      caseRef: "SAG405",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "25.04.2022- Ravneet Sokhi Qualified",
      dateOfReferral: "2022-04-25T09:39:26.6897275",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T14:50:34.2925305",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 13500,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 237,
      closedDate: "2022-04-28T09:14:30.5151438",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Karmenan Kanakasabapathy",
      advisor: "Ian Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 406,
      caseRef: "SAG406",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "his employed but has another job which is self-employed. looking at 1 beds",
      dateOfReferral: "2022-04-25T10:47:13.3032352",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-25T15:26:50.5757562",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 235,
      closedDate: "2022-05-05T09:26:48.7710349",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Carol Palmer",
      advisor: "Baldev Dhanda",
      referralUser: "Lia Wilkerson                                   ",
      id: 407,
      caseRef: "SAG407",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 103750,
      plotNumber: "108",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "both retired, her and husband, looking at 1 beds, sstc and know it needs to be sold before they can complete\n\nDidi not qualify as they came in at 12% on the affordability calculator. *Baldev Dhanda*",
      dateOfReferral: "2022-04-25T10:49:40.8442478",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-28T13:45:44.4578742",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 1200,
      minPercShareAvailable: "505",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-04-28T13:45:50.3211106",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Frank Whieldon",
      advisor: "Ian Parker",
      referralUser: "Laura Jones",
      id: 408,
      caseRef: "SAG408",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 245000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "25.04.2022- Ravneet Qualified",
      dateOfReferral: "2022-04-25T12:46:04.3846297",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T15:53:59.214093",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 40,
      depositLevel: 6500,
      serviceCharge: 68.38,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 236,
      closedDate: "2022-06-27T16:43:11.2089142",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Graeme Shannon",
      advisor: "Phillip Nutter",
      referralUser: "Charlotte Tomlinson",
      id: 409,
      caseRef: "SAG409",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "plot 206 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "need to take address down, line was bad ",
      dateOfReferral: "2022-04-25T14:54:29.5431929",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-28T14:36:34.7718247",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 1000000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-06-27T10:02:17.0908896",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sorrelle Koch",
      advisor: "Baldev Dhanda",
      referralUser: "Ellis Gamon",
      id: 410,
      caseRef: "SAG410",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 100000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "is employed and has self employment to - please ask her for more details about this.",
      dateOfReferral: "2022-04-26T09:07:55.5673715",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T09:34:32.8359651",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 160000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-09T12:03:06.5985683",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Tanya gear",
      advisor: "Eri Nani",
      referralUser: "Laura Jones",
      id: 411,
      caseRef: "SAG411",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 245000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - currently on maternity leave \nonly has a couple of grand for a deposit however has been advised her father in law will gift around £6,000 if needed ",
      dateOfReferral: "2022-04-26T09:31:22.1606675",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T09:48:04.1122972",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 63.38,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-28T15:12:36.9575816",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Jack Savvides",
      advisor: "Ravneet Sokhi",
      referralUser: "Laura Jones",
      id: 412,
      caseRef: "SAG412",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 2,
      purchasePrice: 245000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "26.04.2022- Ravneet Sokhi Qualifying. Left vm\n27.04.22- vm @ 14:32",
      dateOfReferral: "2022-04-26T10:23:17.1904855",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-27T13:36:35.9204548",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 63.38,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-04-29T13:09:03.6030898",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Mary Burgess",
      advisor: "Eri Nani",
      referralUser: "Eleanor Forbes",
      id: 413,
      caseRef: "SAG413",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 240000,
      plotNumber: "142",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "Sold property \nRetired \nMoney coming from sale proceeds",
      dateOfReferral: "2022-04-26T10:52:14.679407",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-26T10:57:01.7352604",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 48,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-04-28T15:28:30.6313805",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Abbie Buckley",
      advisor: "Rachel Davies",
      referralUser: "Nicola Pike",
      id: 415,
      caseRef: "SAG415",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "Plot 206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "qualified\n\nLegals quoted & emailed ",
      dateOfReferral: "2022-04-26T15:54:21.0890841",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-28T14:27:18.7661447",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 240,
      closedDate: "2022-06-27T15:28:16.2887303",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Daniel Bio",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 416,
      caseRef: "SAG416",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-04-26T16:35:29.5963863",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-04-27T08:29:57.6388672",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-04-27T10:08:38.5483354",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Nowaz Romel",
      advisor: "Jamie Bowley",
      referralUser: "Emily Balloch",
      id: 417,
      caseRef: "SAG417",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "fully qualified ",
      dateOfReferral: "2022-04-28T11:20:23.1169172",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-16T16:12:57.398256",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 242,
      closedDate: "2022-05-24T14:29:34.648245",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Sian Corbett",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 419,
      caseRef: "SAG419",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nLegals Sold & quote emailed\n\n12:50 - tried contacting customer, left vm and sent an email, will try again later.\n\n02/05/22 Third attempt to contact customer - went straight to answerphone. Left a message and will email again.",
      dateOfReferral: "2022-04-29T10:16:12.0274078",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-02T13:39:09.6405614",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-05-04T14:17:09.6056002",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: null,
    },
    {
      applicant: "Shakia Hawthorne",
      advisor: "Nadia Bandula ",
      referralUser: "Lia Wilkerson                                   ",
      id: 421,
      caseRef: "SAG421",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 100000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "her and fiance, shes a students his full time employed, FTBs, 15-18k deposit\n\n13:59 VM left and email sent\n\nrequested documents from Shakia to ensure the HCA is correct and I have still not heard from her. Will contact her again today.",
      dateOfReferral: "2022-04-29T10:39:12.1472303",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-03T10:43:16.451242",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "SAGE",
      financialDetailsId: 241,
      closedDate: "2022-05-05T09:04:49.8634955",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Lorraine Clarke",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Eleanor Forbes",
      id: 422,
      caseRef: "SAG422",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 230000,
      plotNumber: "204",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "Deposit will come from sale proceeds\nNot employed ",
      dateOfReferral: "2022-05-02T09:10:51.3232626",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-02T14:07:02.7181045",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-07T16:33:43.0993709",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Daisy Hawks",
      advisor: "Nadia Bandula ",
      referralUser: "Eleanor Forbes",
      id: 423,
      caseRef: "SAG423",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 230000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Deposit will be gifted from grandparents ",
      dateOfReferral: "2022-05-03T09:53:44.5765109",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-03T16:20:22.0507954",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 244,
      closedDate: "2022-05-03T16:21:58.0594864",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Stephen Flynn",
      advisor: "Adam Faulkner",
      referralUser: "Laura Jones",
      id: 424,
      caseRef: "SAG424",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 290000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "fully qualified ",
      dateOfReferral: "2022-05-03T10:13:34.0777445",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-03T14:56:02.9779412",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 40,
      depositLevel: 29000,
      serviceCharge: 70,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 243,
      closedDate: "2022-05-03T15:40:14.8815531",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Shaniece walker",
      advisor: "Eri Nani",
      referralUser: "Laura Jones",
      id: 426,
      caseRef: "SAG426",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 4,
      purchasePrice: 290000,
      plotNumber: "27",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call either wednesday 04/05 or thursday 05/05 before 2pm",
      dateOfReferral: "2022-05-03T10:40:47.7009159",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-03T10:45:19.3424983",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 70,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-05-11T14:10:42.4787902",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Thomas Whitehouse",
      advisor: "Nadia Bandula ",
      referralUser: "Laura Jones",
      id: 427,
      caseRef: "SAG427",
      referredById: 54,
      caseStatusId: 79,
      developmentId: 3,
      purchasePrice: 230000,
      plotNumber: "94",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "qualified, and have requested AML documents \n\n09/05/22 AML Documents sent to Laura Jones",
      dateOfReferral: "2022-05-03T12:18:24.4458097",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-18T12:00:44.0732755",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 70,
      minPercShareAvailable: "47",
      housingAssociation: "sage",
      financialDetailsId: 246,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 28,
    },
    {
      applicant: "Kevin Danson",
      advisor: "Nadia Bandula ",
      referralUser: "Ellis Gamon",
      id: 428,
      caseRef: "SAG428",
      referredById: 79,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "fully qualified\n\n06/05/22 CUSTOMER IS NOT QUALIFIED - WAS QUALIFIED AT THE WRONG AMOUNT. \n\nTRIED CALLING HIM BUT NO VM FACILITY, HAVE SENT HIM AN EMAIL\n\n06/05/22 using own advisor, is porting his mortgage from santander, has already been told he will get an interest rate of 2.19",
      dateOfReferral: "2022-05-03T13:15:38.6465703",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-06T15:43:39.8323746",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 248,
      closedDate: "2022-05-06T15:44:43.2367919",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 20,
    },
    {
      applicant: "Laurel Griffiths",
      advisor: "Kelly Powers",
      referralUser: "Eleanor Forbes",
      id: 429,
      caseRef: "SAG429",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 230000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "18/05 Development has no plots left - customer would like me to assist and is now looking at a standard purchase route - discussed affordability on 10% deposit and awaiting payslips to verify income for dip",
      dateOfReferral: "2022-05-03T13:44:32.9723879",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T12:25:57.2142517",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 245,
      closedDate: "2022-06-24T10:36:37.5494087",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Matthew Simpson",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 430,
      caseRef: "SAG430",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 125000,
      plotNumber: "210",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**SERVICE CHARGE IS APROX**\n\nMatthew is a FTB Works full time and is interested in the flat plot 210. \nThank you ",
      dateOfReferral: "2022-05-04T10:26:19.5355447",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-04T10:32:42.7807162",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-10T11:48:36.8148225",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Miss Niamh Georgia Gough ",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lauren Ruff",
      id: 431,
      caseRef: "SAG431",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 202500,
      plotNumber: "Plot 14",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First Time Buyers- They are aware these homes have gone want to be prepared for when the next lot come up so would like to have a chat about what they can afford they ideally want 3 bed for a growing family but are happy to know details about 2 beds as well. \nThank you \n\n\nAH - attempted to call at 13:40 04/05 - left voicemail",
      dateOfReferral: "2022-05-04T10:37:29.4090338",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-20T15:49:41.3205822",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 247,
      closedDate: "2022-06-22T08:26:48.0913983",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Emma Goodsell",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 432,
      caseRef: "SAG432",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 125000,
      plotNumber: "210",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**SERVICE CHARGE IS WORST CASE APROX**\nPart time employed, £7000-£8000 deposit- Used to work in Kelvedon wants to start fresh not a first time buyer but has nothing to sell.  \n\n\n\n04/05/22 - Attempted to call at 16:30 - left voicemail",
      dateOfReferral: "2022-05-04T14:44:09.3212038",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-05T08:50:33.2258147",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 249,
      closedDate: "2022-05-10T14:22:03.8712454",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Gareth Temmen",
      advisor: "Paul Parker",
      referralUser: "Charlotte Tomlinson",
      id: 433,
      caseRef: "SAG433",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "plot 206 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-04T15:24:19.0053709",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-04T17:21:42.4816356",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-05-11T13:05:33.3183151",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Melissa Jordan",
      advisor: "Paul Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 434,
      caseRef: "SAG434",
      referredById: 23,
      caseStatusId: 32,
      developmentId: 5,
      purchasePrice: 97500,
      plotNumber: "127",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "just her purchasing ftb.\n\n5/5\n\nCalled @ 11:45am. Re-scheduled to call 12pm on 6/5 ",
      dateOfReferral: "2022-05-04T15:53:36.4471085",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T17:24:43.1986907",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Ricardo Pereira",
      advisor: "Kelly Powers",
      referralUser: "Emily Balloch",
      id: 435,
      caseRef: "SAG435",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 8,
      purchasePrice: 315000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        'NOT MORTIMER PLACE \nNOT SAGE \nNOT SHARED OWNERSHIP \n\n35" Moulsham Street \n\nLooking for mortgage advice as well as being qualified \n\nThey are FTB with a 10% deposit. does not have a AIP yet - looking into it atm so happy for more advice.\n\nThey are viewing this weekend with us. \n\nLooking into HTB as well, would like to compare both. \n\n18/05 Customer refused a call to discuss next steps, using another broker. Kelly Powers',
      dateOfReferral: "2022-05-04T16:14:55.8712659",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T12:43:10.2884843",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 1000,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 251,
      closedDate: "2022-06-24T10:35:42.2213445",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Anthony Carter",
      advisor: "Eri Nani",
      referralUser: "Lia Wilkerson                                   ",
      id: 436,
      caseRef: "SAG436",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 97500,
      plotNumber: "127",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "he would be cash from sale. his proprty is sstc. \n\n\n\n\nTHIS LEAD WANTS TO PY CASH 100% SHARE",
      dateOfReferral: "2022-05-04T16:19:53.4543731",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-09T16:40:02.0317864",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 260,
      closedDate: "2022-05-24T13:23:35.1134977",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Elizabeth Burnet",
      advisor: "Aaron Heer",
      referralUser: "Emily Balloch",
      id: 437,
      caseRef: "SAG437",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Clients qualify on 45% share \nThey have their own broker who is a family friend which they are set on using\nThey currently have an AIP with nationwide through him but this is for a standard purchase - they will need a new/amended one for S/O property ",
      dateOfReferral: "2022-05-04T16:23:08.3800719",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-05T10:29:45.2604794",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 250,
      closedDate: "2022-06-24T16:34:15.858739",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Alexander Manyakin ",
      advisor: "Aaron Heer",
      referralUser: "Emily Balloch",
      id: 438,
      caseRef: "SAG438",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client doesn't fit affordability on HCA \nClient is looking to change jobs towards end of this year once he has gained extra qualification at end of summer \nExplained that OT is taken at 50% on HCA so it is base salary that has main impact and informed them of what base they would need to qualify\nThey have agreed to get back in contact with me if they find an alternative cheaper property and when their income circumstances change for me to reassess affordability",
      dateOfReferral: "2022-05-04T16:25:34.6702974",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-05T12:13:31.2397738",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 252,
      closedDate: "2022-05-09T10:41:02.6409286",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Amanda Turner",
      advisor: "Paul Parker",
      referralUser: "Lia Wilkerson                                   ",
      id: 439,
      caseRef: "SAG439",
      referredById: 23,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 97500,
      plotNumber: "127",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spoke on the phone on 6/5. Client agreed to move forward and sent follow-up email with document request.\n\nHeard nothing since and closed lead on 13/5 and passed back to branch.",
      dateOfReferral: "2022-05-05T12:29:45.9103209",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-13T12:29:25.6619731",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 1200,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 255,
      closedDate: "2022-05-13T12:29:41.5036397",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Malcolm Bourne ",
      advisor: "Aaron Heer",
      referralUser: "Claire Jenks",
      id: 440,
      caseRef: "SAG440",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 228000,
      plotNumber: "plot 206, Thomas Aston Place ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "has 80k deposit from cash from sale and is on disability income\n\n\n\n\nQualified client however does not fit on HCA due to income and age - HCA sitting at 77%",
      dateOfReferral: "2022-05-05T13:22:39.1418437",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-05T15:37:21.3944807",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 253,
      closedDate: "2022-05-09T10:31:08.9982422",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Yusuf Tokgoz",
      advisor: "Aaron Heer",
      referralUser: "Lauren Ruff",
      id: 441,
      caseRef: "SAG441",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210 & 211 & 212",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Yusuf is looking at both the one bed and two bed apartments. \none bed details are- \n- £190,000 full price - Service charge- 646\nHe has a mortgage in principle with Just mortgages- Ruy-Felipe De Carvalho- Chelmsford. \n\nAH 06/05 - Qualified client however due to their income being £90,000 with an increase in the near future they do not qualify for shared ownership as per income cap - Asked client to get back to me as soon as they find a suitable property on standard purchase\n\nWorth having a conversation with client to see if we have any other properties they are interested in",
      dateOfReferral: "2022-05-05T15:46:48.747975",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-06T10:12:05.5715577",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 254,
      closedDate: "2022-05-09T10:41:55.1326213",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Robert Bailey",
      advisor: "Laura Turner",
      referralUser: "Eleanor Forbes",
      id: 442,
      caseRef: "SAG442",
      referredById: 31,
      caseStatusId: 27,
      developmentId: 1,
      purchasePrice: 230000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Large deposit came from sale of house - currently living with parents ",
      dateOfReferral: "2022-05-06T09:16:47.9238334",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-09T16:42:54.807162",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 256,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Samantha Morgan",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lauren Ruff",
      id: 443,
      caseRef: "SAG443",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "**service charge is estimated**\n\nSammy works for Met police- Living with family, first time buyer, could you give her call this afternoon over the weekend or Monday before 10am she works shifts. \nAlso has a dog going to message the new homes manager Russell to see if that will be allowed. \nThank you ",
      dateOfReferral: "2022-05-06T15:31:55.4006805",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-17T15:04:18.4032261",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 262,
      closedDate: "2022-06-22T08:38:15.5381283",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Adele Perrone",
      advisor: "Eri Nani",
      referralUser: "Charlotte Tomlinson",
      id: 444,
      caseRef: "SAG444",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 1150000,
      plotNumber: "206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "in rented early days\njust thinking about it for now \n\n\nNO ANSWER",
      dateOfReferral: "2022-05-06T16:04:18.1344318",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-24T13:25:35.0248989",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-05-24T13:25:42.7986395",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Amelia Shackleton",
      advisor: "Steven Sanderson",
      referralUser: "Nicola Pike",
      id: 445,
      caseRef: "SAG445",
      referredById: 29,
      caseStatusId: 81,
      developmentId: 1,
      purchasePrice: 115000,
      plotNumber: "Plot 204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call after 4pm as Amelia is a teacher.\nLegals sold and quote emailed.\n\nSpoke to Client will call after 4pm when she has finished work and reception on the phone is better. ",
      dateOfReferral: "2022-05-07T09:52:30.7839932",
      offerExpiryDate: "2022-12-11T00:00:00",
      updatedDate: "2022-07-26T15:33:09.2123679",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 259,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 53,
      lnhManagerId: 29,
    },
    {
      applicant: "Pia Smith",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 446,
      caseRef: "SAG446",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210 211 212",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Pia is buying by herself, is a first time buyer, currently living with family, looking at both the 1 bed and 2 bed \n1 bed info- £95,000 at 50% share- SC- (aprox) £646\n\n\nAH 09/05 - Qualified on 2 bed fits affordability for 50% share",
      dateOfReferral: "2022-05-09T09:01:43.8744858",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-17T12:14:11.5706493",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 257,
      closedDate: "2022-06-27T16:36:11.8811985",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sarah Giles ",
      advisor: "Nadia Bandula ",
      referralUser: "Lauren Ruff",
      id: 447,
      caseRef: "SAG447",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210 211 212",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sarah is buying by herself, First time buyer, living with family.\nShe is also intrested in the 1 and 2 bed flats \n1 bed- £95,000 at 50% share SC- (Aprox) £646\n\n09/05/22 spoke to sarah, has another adviser, however is open to speaking to me, awaiting floor plans from EA in order to decide which prperty she wants to go for. \n\ntried contacting client several times - closing down case.",
      dateOfReferral: "2022-05-09T09:10:07.0635584",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-17T16:59:38.9285236",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 32000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 258,
      closedDate: "2022-05-17T16:59:47.0837118",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Diane Bonito",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 448,
      caseRef: "SAG448",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210 211 212",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Joe called up for his mother Diane the number provided is for the mother, she is going through divorce and the deposit is from the sale of that looking for a ground floor flat as she is disabled so I'm finding that out for them she would like to know figures on both the 1 bed and two bed. She is currently living eith the son Joe.  \n1 bed- £95,000 at 50% share and SC- (Aprox) £646. \n\n\n\nCASH BUYER FOR 50% -QUALIFIED",
      dateOfReferral: "2022-05-09T09:47:18.6733452",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-09T16:45:29.4978789",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 261,
      closedDate: "2022-05-24T13:26:54.190771",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Hayley Robinson",
      advisor: "Nadia Bandula ",
      referralUser: "Irina Pinto Coutinho",
      id: 449,
      caseRef: "SAG449",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 96250,
      plotNumber: "91",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works as engineer. Please call after 4pm any day.\n\n12/05/22 VM left and email sent \n\n12/5/22 Spoke to Hayley, she has her own broker who has been dealing with shared ownership and she said she would like to  continue using them. \n\n",
      dateOfReferral: "2022-05-09T12:51:18.2890794",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-12T15:58:02.8752344",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 267,
      closedDate: "2022-05-12T16:08:08.0114021",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 20,
    },
    {
      applicant: "Olivier De Pina",
      advisor: "Kelly Powers",
      referralUser: "Emily Balloch",
      id: 450,
      caseRef: "SAG450",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nnot spoken to anyone about the mortgage before so looking for advice as well as being qualified. \n\nthinks he can go up to £160,000 \n\nwants 2 bed flats in Chelmsford  \n\n10% deposit \n\n\nClients income is £80k so exactly on income cap - probably best for adviser to speak to them to make sure they are eligible for shared ownership - have made client aware of this and they also are open to go down standard purchase for a property if required\n\n11/05/22 tried contacting customer - could not leave voicemail, so sent an email. Customer texted me back that he will call me when he is free. \n\n12/05/22 had a missed call from customer at 08:06 this morning, tried calling him back, but he did not answer. \n\n17/05/22 customer not eligible for shared ownership. Passed on to a colleague for standard mortgages.\n\n18/05 Reviewed details and requested further information to qualify (default details and whether satisfied and visa status not clear) - customer is only available by email today and tomorrow so awaiting a reply. Kelly Powers",
      dateOfReferral: "2022-05-09T15:52:00.6278863",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T12:41:55.2296236",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 263,
      closedDate: "2022-07-05T17:00:44.9597024",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Ashley Williams",
      advisor: "Steven Sanderson",
      referralUser: "Laura Jones",
      id: 451,
      caseRef: "SAG451",
      referredById: 54,
      caseStatusId: 35,
      developmentId: 3,
      purchasePrice: 225000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "client qualifies for at least 55% (should be able to purchase more depending on lender)",
      dateOfReferral: "2022-05-09T16:08:03.747799",
      offerExpiryDate: "2022-11-30T00:00:00",
      updatedDate: "2022-08-05T11:06:37.3432725",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 265,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 28,
    },
    {
      applicant: "Areej Fatima",
      advisor: "Eri Nani",
      referralUser: "Irina Pinto Coutinho",
      id: 452,
      caseRef: "SAG452",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 96250,
      plotNumber: "91",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works in Real Estate - call between 2pm-3pm",
      dateOfReferral: "2022-05-10T10:04:05.8770869",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-10T17:56:03.8844337",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-11T09:58:37.1400493",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 20,
    },
    {
      applicant: "Nicky Van Der Westhuizen",
      advisor: "Medihya Akram",
      referralUser: "Lauren Ruff",
      id: 453,
      caseRef: "SAG453",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 250000,
      plotNumber: "210, 211",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Nicky has a mortgage in principle from his bank for £144,000, currently living with parents, don't think he has a broker, he is very keen and wants to reserve quickly if qualifies. \nCan you call after 5pm as he is working. \nThank you \n\n11/5/22\nAwaiting payslips to assess affordability\nM.Akram \n\n16/5/22\ni have received his payslips and property price of £250,000 is still unaffordable.  £235,000 could be ok.  customer would like to know what properties are avialable upto that price.  Emailed EA and awaiting response ",
      dateOfReferral: "2022-05-10T14:29:46.6849812",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-16T10:56:57.6138199",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 269,
      closedDate: "2022-07-04T15:32:10.6269262",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Tim Sullivan",
      advisor: "Steven Sanderson",
      referralUser: "Charlotte Tomlinson",
      id: 454,
      caseRef: "SAG454",
      referredById: 32,
      caseStatusId: 27,
      developmentId: 1,
      purchasePrice: 115000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Restricted on share due to deposit\n\nemail sent to client as all homes have now gone on Kingsbourne",
      dateOfReferral: "2022-05-11T08:45:28.233585",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-24T14:50:06.5628686",
      isDeleted: 1,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 266,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Dominik Rewer",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 455,
      caseRef: "SAG455",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "Plot 206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nLegals Sold & quote emailed\n\n\n\n\n\n\nContact after 3pm\n\nPLOT HAS ALREADY BEEN RESERVED, UNABLE TO SEND IN AML - AWAITING MORE PLOTS TOB E RELEASED.",
      dateOfReferral: "2022-05-11T08:49:41.8122571",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-23T09:31:16.6235223",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 270,
      closedDate: "2022-05-23T09:31:37.2882073",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Constantin Gruia Vulgaris",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 456,
      caseRef: "SAG456",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "Plot 206",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nLegals Sold & Quote Emailed\n\nqualified.\n\n13/5/22.\nSpoke on the phone and, whilst the Kingsbourne development is now sold out, he is potentially interested in the Cherry Tree Park development, once announced. \n\nI've emailed him to send me the documents to move forward and to arrange a 1st appointment.",
      dateOfReferral: "2022-05-11T09:05:45.9196142",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-13T12:17:51.1619669",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 271,
      closedDate: "2022-06-22T17:24:56.3244247",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Sophie Woodall",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 457,
      caseRef: "SAG457",
      referredById: 29,
      caseStatusId: 79,
      developmentId: 3,
      purchasePrice: 111250,
      plotNumber: "Plot 75",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nLegals Sold & Emailed\n\nqualified\n\n12/05/22 spoke to sophie - not sure about using JM due to the higher fee that her current advisor will charge. Explained that we work with sage on a daily basis and ensure prompt reservation, and said there is a risk she might lose the property. Waiting for her to get back to me on this.\n12/05/22 AML documents sent at 12:45",
      dateOfReferral: "2022-05-11T12:15:21.8961758",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T11:23:40.7384809",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 268,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 28,
    },
    {
      applicant: "Paul Mitty",
      advisor: "Aidan Pearce ",
      referralUser: "Emily Balloch",
      id: 458,
      caseRef: "SAG458",
      referredById: 64,
      caseStatusId: 28,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-11T13:54:57.3005841",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T11:41:33.5224478",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 600,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Anjelika Annable",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Emily Balloch",
      id: 459,
      caseRef: "SAG459",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "unsure whether she will be buying in her name or her daughters name, she is using cash for the purchase for her daughter. anjelika is retired but daughter is employed.\n\nAH - call arranged for 13/05",
      dateOfReferral: "2022-05-11T16:28:01.5332565",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-17T09:27:39.0829696",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 39,
      depositLevel: 162500,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-03T09:37:09.4699412",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Hannah Youngs & Josh Leavett",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 460,
      caseRef: "SAG460",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN Development name is Wyvern Farm (Hampton Park) in Colchester. \nService charge is approx. \nHannah & Josh both work for British transport Police. (Southend and London). \nhas a Mortgage in Principle for £280,000 apparently. \n\nhave their own mortgage advisor.\n",
      dateOfReferral: "2022-05-12T15:58:10.9865241",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-23T15:30:12.7509713",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1152,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-24T13:26:16.969873",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Scott Wheeler",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 461,
      caseRef: "SAG461",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN Development name is Wyvern Farm (Hampton Park) in Colchester. Service charge is aprox.\nScott has a mortgage in principle for £290,000 apparently. \nHe is going on holiday tomorrow- 13/05/2022 so can he have a call today 12/05/2022 or morning of the 13th, thank you. \n\n\nAH - Attempted to call 13/05 9:50am - Voicemail left\n\nComes back from holiday on friday 20th will be able to chat from the 21st. \n\n\nFULLY QUALIFIED-50% share ",
      dateOfReferral: "2022-05-12T16:02:29.2090824",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-24T12:54:04.3474014",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1152,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 280,
      closedDate: "2022-06-21T08:54:57.3658632",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Chloe Lacey",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 462,
      caseRef: "SAG462",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Duplicate lead - Chris Taylor assigned other and has since made contact with the client",
      dateOfReferral: "2022-05-12T16:53:11.8896341",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-16T08:32:58.1582033",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-16T08:34:06.0483626",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Karis Finck",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 463,
      caseRef: "SAG463",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "not qualified lead. \nneed to look for property of no more than £250000 based on the income ",
      dateOfReferral: "2022-05-12T16:55:02.624058",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T15:31:31.1298254",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-18T15:32:14.4578815",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Shakira Hawthorne",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 464,
      caseRef: "SAG464",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "student but partner is full time employed.\n\nSpoke with Shakira and qualified, but failed to reply with the documents needed to reserve.\n\nI've closed the lead after several attempts.",
      dateOfReferral: "2022-05-12T16:56:41.6717444",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-14T14:27:13.1062427",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 277,
      closedDate: "2022-06-14T14:27:20.0723898",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Laura Crimmin",
      advisor: "Aaron Heer",
      referralUser: "Lauren Ruff",
      id: 465,
      caseRef: "SAG465",
      referredById: 66,
      caseStatusId: 26,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm , Colchester. \n\nLaura recently separated with her partner and has a mip of £230,000 apparently. \nMany thanks \n\n\n\nAH - Awaiting sale of Lauras current property",
      dateOfReferral: "2022-05-13T08:30:21.8423677",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T09:48:34.7339621",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 272,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Chloe Lacey ",
      advisor: "Christopher Taylor",
      referralUser: "Lauren Ruff",
      id: 466,
      caseRef: "SAG466",
      referredById: 66,
      caseStatusId: 28,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm, Colchester.\nChloe and sam have spoken to Chris Naya at just mortgages can apparently get a mortgage in principle for £160,000\n",
      dateOfReferral: "2022-05-13T08:41:51.7047777",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:39:53.2611348",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 273,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Alex Michie & Lydia Pearmain",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 467,
      caseRef: "SAG467",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm Colchester. \nAlex and Lydia would also like to discuss the 3 bed which details are:\n\n£335,000 \nPlot 15\nService charge: £1250\n",
      dateOfReferral: "2022-05-13T09:00:56.9071957",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-13T12:25:12.2535415",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-24T13:27:50.5091921",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Abul Chowdhury",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 468,
      caseRef: "SAG468",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm Colchester. \nThey are currently a council tenant, 5 of them in household. \n\nnot qualified",
      dateOfReferral: "2022-05-13T09:54:36.0557552",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-13T15:21:43.0965222",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-13T15:22:27.6835709",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Gabriela Karaulanova ",
      advisor: "Nadia Bandula ",
      referralUser: "Lauren Ruff",
      id: 469,
      caseRef: "SAG469",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm Colchester (Tiger Way)\nGabriela & Mike currently live at home and are First time buyers.\n\n\nqualified \n\n13/05/22 contacted - they want to view the property or a showhome and will get back to me after the weekend if they want to proceed. \nAlso enquired about broker fee, which I explained is £595.\nClient will get back to me after the weekend.\n\n17/05/22 Spoke to Mike, sending AML documents over. ",
      dateOfReferral: "2022-05-13T10:33:58.0483752",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-17T17:16:35.0316167",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 23000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 274,
      closedDate: "2022-05-26T16:48:51.2978482",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Martyn Collins",
      advisor: "Eri Nani",
      referralUser: "Laura Jones",
      id: 470,
      caseRef: "SAG470",
      referredById: 54,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 225000,
      plotNumber: "75",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-13T11:08:18.0122417",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-13T11:23:50.0836773",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-05-24T13:28:30.7653666",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Cristian Bora ",
      advisor: "Nadia Bandula ",
      referralUser: "Lauren Ruff",
      id: 471,
      caseRef: "SAG471",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm, Colchester.\nFirst time buyers, looking at the two and three bed- \n3 bed is \nFull market price- £335,000\nPlot- 15\nService charge- £1250\nBoth work in transport and have two kids. \n\n\n\n18/05/22 AML DOCS SENT \n\n06/06/22 customer has been notified that the property he is interested in has been pulled. there is a 2 bed property left, however a few applicants are quite far in applying, awaiting customer to send me 12 months savings statements if not too late to reserve. ",
      dateOfReferral: "2022-05-13T11:36:03.6340398",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-06T14:26:11.2288777",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 275,
      closedDate: "2022-06-09T11:40:07.9446336",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Phillipa Makanza",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 473,
      caseRef: "SAG473",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- Wyvern Farm, Colchester. \n2 in household 1 child she is a NHS nurse. \nalso interested in the 3 bed which is- \nFull market price- £335,000\nPlot- 15\nService charge- £1250\n\n\n\nDOES NOT QUALIFY/ VERY LITTLE DEPOSIT \n",
      dateOfReferral: "2022-05-13T13:16:55.0828237",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T15:02:05.8692203",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "sage homes",
      financialDetailsId: null,
      closedDate: "2022-05-18T15:03:05.1752309",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Harry Turner & Mateo Romero",
      advisor: "Paul Parker",
      referralUser: "Irina Pinto Coutinho",
      id: 474,
      caseRef: "SAG474",
      referredById: 25,
      caseStatusId: 65,
      developmentId: 5,
      purchasePrice: 135000,
      plotNumber: "107",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Harry works in building insurance\nMateo works in hospitality\n\nCalled on 16/5 and left voicemail - sent follow-up email.\n\nCall scheduled on 18/5 at 1:30pm.\nQualified on HCA - awaiting docs to reserve.\n\nHas decided not to move forward due to pet dog not allowed in property.",
      dateOfReferral: "2022-05-14T11:02:49.7973963",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-03T09:38:42.4211169",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200.6,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOUSING",
      financialDetailsId: null,
      closedDate: "2022-06-03T09:38:47.9432878",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 20,
    },
    {
      applicant: "Eryk Sawicki ",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 475,
      caseRef: "SAG475",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "does not qualify , will need more deposit or a maximum property price of £290000 on a 45 % share ",
      dateOfReferral: "2022-05-16T15:56:22.4653406",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T15:46:27.5502095",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 16500,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-18T15:47:17.0680006",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nicky van der Westhuizen ",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 476,
      caseRef: "SAG476",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "spoken to Medihya Akram before",
      dateOfReferral: "2022-05-16T16:11:15.0798321",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T09:05:11.4647015",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-18T16:37:52.0144145",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Connor Bott",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 477,
      caseRef: "SAG477",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "i spoke to this client and i took some details , as did not have all of them , requested to be called on Monday the 23/05. but since then did not answer ",
      dateOfReferral: "2022-05-16T16:22:09.3458",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-27T09:16:08.7450087",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-27T09:23:36.9888992",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sophie Miller",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 478,
      caseRef: "SAG478",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-17T11:17:06.9037866",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T09:05:58.1546619",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-18T16:48:20.7930349",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Dami Agboola",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 479,
      caseRef: "SAG479",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-17T16:11:50.4896965",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T09:06:05.7504566",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-20T09:26:48.1550152",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nadine",
      advisor: "Eri Nani",
      referralUser: "Nicola Pike",
      id: 480,
      caseRef: "SAG480",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 3,
      purchasePrice: 112500,
      plotNumber: "Plot 75",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "Legals sold & Quote emailed",
      dateOfReferral: "2022-05-18T10:01:12.8016817",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T21:57:21.4386021",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 112500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 278,
      closedDate: "2022-05-24T13:20:46.4314783",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kieron Barry & Leah Lawson",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 481,
      caseRef: "SAG481",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER. 2 BED. \n\nLeah works for the NHS Colchester hospital, First time buyers. \nLiving with family at the moment. \n\nDocuments requested on 19/5\n\nFollow up sent on 26/5 as received nothing.\n\nHave decided not to move forward on home ownership due to personal reasons.",
      dateOfReferral: "2022-05-18T14:14:14.4460087",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-03T09:35:09.9547763",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 279,
      closedDate: "2022-06-03T09:37:50.1988082",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Annaliza Gilbert & Ferdinand Eandelaria",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 482,
      caseRef: "SAG482",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- WYVERN FARM COLCHESTER 3 BED \nFerdinand lives in the Philippines. \nAnnaliza works as a staff nurse for the NHS. \n4 Children\nRelocating to COLCHESTER hospital. \nFirst Time Buyer\n",
      dateOfReferral: "2022-05-18T14:42:45.4859868",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-18T16:39:05.5095265",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-23T13:46:23.1307225",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Kate Evans",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 483,
      caseRef: "SAG483",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FUNDS INHERITANCE WAITING ON PROBATE \n\ndoes not qualify / even on 20% share\n",
      dateOfReferral: "2022-05-19T11:22:58.257685",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-19T14:52:20.165354",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-19T14:53:25.8609117",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Philipa Makanza",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 484,
      caseRef: "SAG484",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-05-19T14:30:14.6097866",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-19T14:57:27.0335459",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-24T13:11:33.5047666",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Victor Siska",
      advisor: "Nadia Bandula ",
      referralUser: "Emily Balloch",
      id: 485,
      caseRef: "SAG485",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "20/05/22 qualified, however is looking at another property with a different estate agent as he would like to purchase a 3 bed property.\n\nAML docs sent ",
      dateOfReferral: "2022-05-19T16:29:07.571601",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-20T16:22:28.0237489",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-06T14:24:26.359828",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Laura Fowler ",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 486,
      caseRef: "SAG486",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking for her daughter who is dyslexic, has financial details to hand.\n\nemily pearson \n\ndoes not qualify. \nnot enough income or deposit for a lender to lend the total necessary amount ",
      dateOfReferral: "2022-05-19T16:30:54.4523149",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-23T09:17:27.487759",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-23T09:28:23.547596",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jack Ely",
      advisor: "Eri Nani",
      referralUser: "Emily Balloch",
      id: 487,
      caseRef: "SAG487",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "227",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "fully qualified.\nthey want to use their own mortgage advisor ",
      dateOfReferral: "2022-05-19T16:32:08.8150244",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-20T14:15:48.6448712",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-05-24T13:09:40.7891387",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Alan Amirtharaj",
      advisor: "Christopher Taylor",
      referralUser: "Lauren Ruff",
      id: 488,
      caseRef: "SAG488",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYRVEN FARM COLCHESTER. \nSERVICE CHARGE IS APROX. \nAlan is currently renting with his wife, has a help to buy. \nhe is also interested in the 2 bed which is...\nfull market value- £297,500\nservice charge £1050 \nplot 17. \nThanks\n\n\n\n",
      dateOfReferral: "2022-05-20T11:00:58.8321235",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-24T14:37:08.9163557",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 282,
      closedDate: "2022-06-27T09:40:41.003281",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "James Martin",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 490,
      caseRef: "SAG490",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "James has a mortgage in principle for £120,000 apparently gifted deposit just him purchasing. \nNO LESS THAN 50% SHARE.\n2 bed as well please so- \n\nFull market value- \n£297,500\nService charge- \n£1050\nPlot- \n17\nThanks \n\n\nNO LONGER INTERSTED / FOUND ANOTHER  PROPERTY  ",
      dateOfReferral: "2022-05-20T12:08:10.4890218",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-23T10:12:46.100009",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 55000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-23T10:13:43.9812056",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Andrew Clark",
      advisor: "Jamie Bowley",
      referralUser: "Lauren Ruff",
      id: 491,
      caseRef: "SAG491",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 325000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN-WYVERN FARM COLCHESTER \nSERVICEW CHARGE APPROX\n2 in household, living with family. \n\n\n\n\nqualified lead/ have loans which is very happy to pay if needed.",
      dateOfReferral: "2022-05-20T15:03:56.5388893",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-24T14:25:58.5422007",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOMES",
      financialDetailsId: 283,
      closedDate: "2022-06-13T16:47:52.4802351",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Daniel Rowley & Miriam Rowley",
      advisor: "Nadia Bandula ",
      referralUser: "Lauren Ruff",
      id: 493,
      caseRef: "SAG493",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- WYVERN FARM COLCHESTER!\nNO LESS THAN 50% SHARE\nSERVICE CHARGE IS APPROX. \n\nFirst time buyers, 2 kids (4&7), Mr works full time Mrs works part time. \n",
      dateOfReferral: "2022-05-23T09:16:34.17814",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-23T13:22:24.0886811",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-05-23T13:24:52.6899028",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Elise Harris",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 494,
      caseRef: "SAG494",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\nSERVICE CHARGE APPROX\n50% SHARE OR ABOVE ONLY\n\nUsing money from the sale of her house to purchase £140,000 selling to a developer, just her and her daughter who is at uni. looking at both the 2 bed and 3. \n\n2 bed details- \nfull market price- £297,500.00\nservice charge- £1050\nPlot- 17\nCall between 2pm-3pm due to working. \n\nfully qualified for 2 bed at 65% or 3 bed at 50%",
      dateOfReferral: "2022-05-23T14:24:22.9542548",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-25T11:40:40.2972037",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOMES",
      financialDetailsId: 284,
      closedDate: "2022-05-26T10:16:14.0854588",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Autumn Kent",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 495,
      caseRef: "SAG495",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\n50% SHARE MINIMUM\nSERVICE CHARGE APPROX\n\nAutumn is buying by herself although her boyfriend will be living with her. Has a broker but is open to speaking to Just mortgages for the ease of the purchase. \n\n\n\nFULLY QUALIFIED LEAD/ VERY HAPPY TO PROCEED AND WAITING FOR YOUR CALL",
      dateOfReferral: "2022-05-24T14:45:02.0329229",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-09T13:09:57.3116246",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "sage homes",
      financialDetailsId: 285,
      closedDate: "2022-06-09T13:10:07.1634639",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Leanne Cummins",
      advisor: "Eri Nani",
      referralUser: "Lauren Ruff",
      id: 496,
      caseRef: "SAG496",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 335000,
      plotNumber: "16",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\n50% SHARE NO LESS\nSERVICE CHARGE IS APPROX.\n\nLeanne is buying by herself, deposit is a family gift, she is a teacher has a mortgage in principle of £152,000 apparently. \ncould you call at lunch or after 3:30 due to her working hours. \n\n\ndoes not qualify on hca",
      dateOfReferral: "2022-05-24T15:39:18.4428609",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-26T09:34:17.658528",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1250,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOMES",
      financialDetailsId: null,
      closedDate: "2022-05-26T09:35:12.5427283",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Lauren Hughes ",
      advisor: "Eri Nani",
      referralUser: "Eleanor Forbes",
      id: 497,
      caseRef: "SAG497",
      referredById: 31,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 195000,
      plotNumber: "Plot 156 Littler Lane ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Referral for Winsford ",
      dateOfReferral: "2022-05-25T11:49:59.4551533",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-25T12:10:17.8057372",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Chloe Nunn & Lewis Gardener",
      advisor: "Christopher Taylor",
      referralUser: "Lauren Ruff",
      id: 498,
      caseRef: "SAG498",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\nNO LESS THAN 50% SHARE\nSERVICE CHARGE IS APPROX\nChloe isn't currently working although she has had a job offer and tarts soon Lewis has been working for the same company for the last 2 years, First time buyers. \n\nfully qualified ",
      dateOfReferral: "2022-05-25T12:13:01.3735415",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-27T10:13:45.9825177",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE Homes",
      financialDetailsId: 288,
      closedDate: "2022-06-27T09:42:09.7188432",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Thomas Lee",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 499,
      caseRef: "SAG499",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 295700,
      plotNumber: "plot 17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\n50% SHARE MIN\nSERVICE CHARGE APPROX.\n\nPolice officer in Colchester, just him purchasing, in rented at the moment. \n\n\nAH - 26/05 Left VM and sent email.\n\nSpoke on phone and sent email on 27/5. Asked to send documents.\n\nSent follow up email on 7/6 for update.\n\nReplied on 17/6 but missed out on property.\nOn the list for any future announcements as there's currently nothing available locally for him",
      dateOfReferral: "2022-05-25T15:11:41.298073",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-17T15:40:01.0110902",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOMES",
      financialDetailsId: 286,
      closedDate: "2022-06-17T15:40:10.0384648",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Stephen Bland",
      advisor: "Paul Parker",
      referralUser: "Lauren Ruff",
      id: 500,
      caseRef: "SAG500",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\n50% SHARE ONLY\nSERVICE CHARGE IS APPROX.\n\nJust him purchasing, applied and approved for Peabody homes, works full time, sold subject to contract on his home £30,000 is from equity. Moving into mums while trying to find. \n\n27/5\n\nClient informed me that he is using his own broker. Lead closed",
      dateOfReferral: "2022-05-25T15:26:35.8134766",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-27T20:58:59.0302174",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 287,
      closedDate: "2022-05-27T20:59:05.3230639",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Daniel Ross Chambers",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lauren Ruff",
      id: 501,
      caseRef: "SAG501",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM COLCHESTER\n50% SHARE MIN\nSERVICE CHARGE IS APPROX\n\nPenguin Parade - Stanway \n\n",
      dateOfReferral: "2022-05-26T09:30:04.0669148",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-10T08:53:35.7911798",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 290,
      closedDate: "2022-06-22T08:24:53.9419172",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Lee Kehoe",
      advisor: "Aaron Heer",
      referralUser: "Lauren Ruff",
      id: 502,
      caseRef: "SAG502",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETTS GREEN- WYVERN FARM COLCHESTER\nSERVICE CHARGE IS APPROX\nNO LESS THAN 50% SHARE\n\nJust him, key worker, no dependants, First time buyer. ",
      dateOfReferral: "2022-05-27T16:14:04.1608362",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-05-30T10:17:50.404402",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1050,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 289,
      closedDate: "2022-05-30T10:18:57.8993051",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Gary Pepper ",
      advisor: "Paul Parker",
      referralUser: "Eleanor Forbes",
      id: 503,
      caseRef: "SAG503",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 230000,
      plotNumber: "Plot 203 Thomas Aston Place ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit money is coming from consent order - will be complete in a few weeks.\nInterested in Shared Ownership in Shavington as we do not have any available in Nantwich \n\nSpoke on phone on 1/6.\n\nDevelopment not yet announced, but have asked for him to provide documents to put him in a position to reserve asap.\n\nFollowed up on development announcement (22nd June). No reply.\n\nFinal call and voicemail made on 4th July. Will close lead if not heard back",
      dateOfReferral: "2022-05-30T16:23:18.8642757",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T10:31:51.2474006",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 291,
      closedDate: "2022-08-01T12:19:14.1538928",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lauren Hamblion",
      advisor: "Ravneet Sokhi",
      referralUser: "Shannay Jarvis",
      id: 504,
      caseRef: "SAG504",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Applicant 1 works for Spicerhaart.\n\n£30k joint deposit.\n\nMiss has deposit of £25,000\nMr has deposit of £5,000\n\nBoth using HTB ISA \n\n01/06/2022- Waiting for further details on car loan from Lauren and waiting for EA to confirm min share and service charge\n\n01/06/2022- Passed onto James Peters as he is already the advisor. Haven't filled out details on portal as sent to him and already being dealt with",
      dateOfReferral: "2022-06-01T10:58:58.6662929",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-01T12:55:10.3678091",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 300000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-01T12:55:28.4914992",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Rachael Allen",
      advisor: "Paul Parker",
      referralUser: "Shannay Jarvis",
      id: 505,
      caseRef: "SAG505",
      referredById: 126,
      caseStatusId: 35,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "First Time Buyers. \n\n\nfully qualified\n",
      dateOfReferral: "2022-06-01T11:07:54.1662006",
      offerExpiryDate: "2023-01-27T00:00:00",
      updatedDate: "2022-07-29T13:53:34.9809064",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 11000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 292,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 19,
    },
    {
      applicant: "Sarah Kirby",
      advisor: "Eri Nani",
      referralUser: "Shannay Jarvis",
      id: 506,
      caseRef: "SAG506",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 3650000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Miss employed part time - 23 hours per week.\n\nDeposit coming from sale of another house - completion 17th June. Exchanged contracts on sale. \n\nSole applicant. \n\nNo children. ",
      dateOfReferral: "2022-06-01T11:15:43.8518134",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-01T15:13:52.8164542",
      isDeleted: 0,
      advisorId: 96,
      propertyStatusId: 40,
      depositLevel: 165000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 293,
      closedDate: "2022-06-01T15:25:43.7560509",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Marc McGrath",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Shannay Jarvis",
      id: 507,
      caseRef: "SAG507",
      referredById: 126,
      caseStatusId: 35,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit is £25,000 - £30,000\n\nBeing gifted from father. \n\n\nfully qualified \n\n",
      dateOfReferral: "2022-06-01T11:18:33.0570805",
      offerExpiryDate: "2023-01-09T00:00:00",
      updatedDate: "2022-07-20T14:17:06.2888414",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 294,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 19,
    },
    {
      applicant: "Charlotte Bell",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Shannay Jarvis",
      id: 508,
      caseRef: "SAG508",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Current property is SSTC.\n\nMiss works part time.\n\nMr works full time.\n\n\nAH 01/06 - Attempted to call both Charlotte and Daniel - no answer left VM for both and emailed charlotte ",
      dateOfReferral: "2022-06-01T11:37:43.9310225",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-03T09:32:30.2834427",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 70000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-06T08:26:05.5338038",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Lucy O'Hanlon",
      advisor: "Nadia Bandula ",
      referralUser: "Shannay Jarvis",
      id: 509,
      caseRef: "SAG509",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Both Mr and Mrs employed Fulltime ",
      dateOfReferral: "2022-06-04T10:31:56.33878",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-04T11:45:14.1004654",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 17000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-09T11:35:48.4650002",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Christine Ankin",
      advisor: "Peter Hill",
      referralUser: "Shannay Jarvis",
      id: 510,
      caseRef: "SAG510",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Miss works 29.5 hours per week\n\nCurrent property is SSTC - Pestells and Co. ",
      dateOfReferral: "2022-06-06T09:45:59.3871674",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-06T10:05:51.7284148",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-06T11:02:55.5170797",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jordan Knight",
      advisor: "Ian Parker",
      referralUser: "Lauren Ruff",
      id: 511,
      caseRef: "SAG511",
      referredById: 66,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: 297500,
      plotNumber: "17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NOT AYLETT'S GREEN- WYVERN FARM\n50% SHARE ONLY\nSERVICE CHARGE APPROX.\n\nDon't have the deposit amount to hand called in on the 26th and didn't load to the portal unfortunately. Should have been notified that the three beds have been pulled and only the two bed is still going but there is a few people quite a way through the process, so may be worth setting some expectations if possible. \nThank you :)   \n\nFULLY QUALIFIED   ",
      dateOfReferral: "2022-06-06T10:23:36.0789632",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-06T13:28:41.0770427",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 850,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 295,
      closedDate: "2022-06-27T16:39:51.6011802",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Megan Pickard",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 513,
      caseRef: "SAG513",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: null,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "does not have a MIP yet - spoken to a broker \n\nlooking for more advice \n\nHCA qualified on 11/6.\n\nAwaiting documents to proceed with reservation application.",
      dateOfReferral: "2022-06-10T16:34:18.3741851",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-11T14:13:35.9402452",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1200,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-20T14:00:16.4643035",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Debbie Phillips ",
      advisor: "Paul Parker",
      referralUser: "Emily Balloch",
      id: 514,
      caseRef: "SAG514",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 375000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NTS \nspoken to a broker \nlooking into a MIP atm \nlooking for more advice as well\n\n\nCall booked for 4pm on 14/6.\n\nDidn't answer phone at agreed time. Tried again following day and sent email. Waiting for reply.\n",
      dateOfReferral: "2022-06-10T16:36:29.8966308",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-15T16:28:28.7725575",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1200,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-20T13:59:34.8482476",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Caroline Affakereh",
      advisor: "Nadia Bandula ",
      referralUser: "Eleanor Forbes",
      id: 515,
      caseRef: "SAG515",
      referredById: 31,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 205000,
      plotNumber: "130",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client only qualifies for 42%, need to check with sage if they agree, may e=be hard on the affordability side.",
      dateOfReferral: "2022-06-13T08:06:17.3798532",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-13T10:24:05.1115183",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-06-20T14:03:22.5909014",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Holly Norris",
      advisor: "Paul Parker",
      referralUser: "Shannay Jarvis",
      id: 516,
      caseRef: "SAG516",
      referredById: 126,
      caseStatusId: 78,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Miss - Employed with Essex County Council - FT\n\nMr - Kebble Environmental - FT\n\nFTB.\n\nPaul Parker - 14/6:\nMade contact and qualified on HCA at 40% - just.\n\nWaiting for confirmation that Sage will go for it. ",
      dateOfReferral: "2022-06-14T10:09:46.4983333",
      offerExpiryDate: "2022-12-29T00:00:00",
      updatedDate: "2022-08-03T08:30:48.5151986",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 19,
    },
    {
      applicant: "Hayden Dackombe",
      advisor: "Nadia Bandula ",
      referralUser: "Shannay Jarvis",
      id: 517,
      caseRef: "SAG517",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Sole Applicant. ",
      dateOfReferral: "2022-06-14T10:19:04.5516314",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-14T12:53:28.5009959",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-16T10:31:38.7270197",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nathan Williams",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 518,
      caseRef: "SAG518",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 111250,
      plotNumber: "175",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "14/06/22 vm lef and email sent",
      dateOfReferral: "2022-06-14T10:24:34.4839309",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-20T13:18:18.8668307",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-06-28T07:42:48.4006598",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Michael Jones",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 519,
      caseRef: "SAG519",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 205000,
      plotNumber: "130",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Legals sold and quote emailed\n\n16/06/22 tried calling, could not leave a voicemail, so have sent an email. ",
      dateOfReferral: "2022-06-14T11:24:05.9013228",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-16T10:07:33.8617231",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 5500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-18T09:26:28.2205765",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nelko Yordanov",
      advisor: "Steven Sanderson",
      referralUser: "Nicola Pike",
      id: 520,
      caseRef: "SAG520",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "151",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Legals Sold & quote emailed\n\nAIp done with Santander and accepted",
      dateOfReferral: "2022-06-14T12:22:31.9288324",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T10:47:02.8122333",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 298,
      closedDate: "2022-06-27T09:50:33.5728534",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Elle Jones",
      advisor: "Steven Sanderson",
      referralUser: "Nicola Pike",
      id: 521,
      caseRef: "SAG521",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 42,
      purchasePrice: 197500,
      plotNumber: "156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & quote emailed",
      dateOfReferral: "2022-06-14T12:38:47.6294713",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-14T12:52:58.7463937",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-27T09:59:57.1865731",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nicky Durnan",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 522,
      caseRef: "SAG522",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 222500,
      plotNumber: "175",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Legals Sold & Quote emailed\n\n14/06/22. Appointment made for Saturday to go through qualification when husband is home. ",
      dateOfReferral: "2022-06-14T14:47:36.0822657",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:19:28.5884896",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-06T10:57:01.4484349",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Alex White-Miller",
      advisor: "Jamie Bowley",
      referralUser: "Shannay Jarvis",
      id: 523,
      caseRef: "SAG523",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has four children\n\nMr employed FT\nMrs - Universal Credit and Child Benefit\n\nSaved £9000",
      dateOfReferral: "2022-06-15T11:39:27.5592689",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-15T14:35:42.7337837",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 297,
      closedDate: "2022-06-21T16:23:47.4699277",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Georgina Stewart ",
      advisor: "Aaron Heer",
      referralUser: "Eleanor Forbes",
      id: 524,
      caseRef: "SAG524",
      referredById: 31,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 205000,
      plotNumber: "Plot 130 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Not employed at the moment - starting new job next month \nPartner is selling property - sale proceeds will be used for purchase \n\n\n\nAH - Client qualifies for property - waiting for Mr property to be SSTC (currently on market)",
      dateOfReferral: "2022-06-15T12:11:26.6255594",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T09:51:05.7826333",
      isDeleted: 1,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 296,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Anthony Wood",
      advisor: "Steven Sanderson",
      referralUser: "Bryony Collett",
      id: 525,
      caseRef: "SAG525",
      referredById: 128,
      caseStatusId: 28,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "General manager for a plumbing and heating company, has a 20 year old daughter spends time with dad when she is back from uni, shared guardianship of his other daughter. \nSold a property 4 years ago when separating from his ex, deposit has come from the sale of his previous property.\n\nCase on hold until he finds  anew home. ",
      dateOfReferral: "2022-06-15T13:28:56.2285412",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:52:27.8638261",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 299,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nadine Tunstall ",
      advisor: "Steven Sanderson",
      referralUser: "Eleanor Forbes",
      id: 526,
      caseRef: "SAG526",
      referredById: 31,
      caseStatusId: 35,
      developmentId: 1,
      purchasePrice: 205000,
      plotNumber: "Plot 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-15T13:52:10.9697927",
      offerExpiryDate: "2023-02-01T00:00:00",
      updatedDate: "2022-08-09T13:54:35.5300467",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 307,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 28,
    },
    {
      applicant: "Chris Telfer",
      advisor: "Christopher Taylor",
      referralUser: "Nicola Pike",
      id: 527,
      caseRef: "SAG527",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "151",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & emailed",
      dateOfReferral: "2022-06-15T14:22:32.2226589",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-15T15:57:11.8026025",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-27T10:07:07.2610521",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Richard Ternent",
      advisor: "Baldev Dhanda",
      referralUser: "Nicola Pike",
      id: 529,
      caseRef: "SAG528",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 102500,
      plotNumber: "Plot 130 or 132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals Sold & quote emailed",
      dateOfReferral: "2022-06-16T13:07:06.0999099",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-16T13:43:22.7727752",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-22T15:29:30.8420715",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Emily Marr",
      advisor: "Phillip Nutter",
      referralUser: "Nicola Pike",
      id: 531,
      caseRef: "SAG529",
      referredById: 29,
      caseStatusId: 29,
      developmentId: 42,
      purchasePrice: 200000,
      plotNumber: "157 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & quoted",
      dateOfReferral: "2022-06-17T10:15:44.2839023",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T08:24:06.4695546",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 300,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "David Spibey",
      advisor: "Christopher Taylor",
      referralUser: "Nicola Pike",
      id: 532,
      caseRef: "SAG530",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 210000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legal Sold & quote emailed",
      dateOfReferral: "2022-06-17T11:03:11.2648004",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-17T11:45:16.3546299",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T07:19:23.1745688",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Dean Latham",
      advisor: "Paul Parker",
      referralUser: "Nicola Pike",
      id: 533,
      caseRef: "SAG531",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 42,
      purchasePrice: 98750,
      plotNumber: "156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spoke on phone on 17/6.\n\nQualified - using own (JM) adviser - Neil Ormsby.\n\nWill now use me and awaiting documents",
      dateOfReferral: "2022-06-17T11:37:03.8895771",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T12:09:17.5507331",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-05T11:53:01.6963654",
      isClosed: 1,
      administratorId: 52,
      lnhManagerId: 28,
    },
    {
      applicant: "Keith MIllington",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Claire Jenks",
      id: 534,
      caseRef: "SAG532",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 102500,
      plotNumber: "Plot 130, Langport Road ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-17T14:59:46.9791113",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-20T10:26:49.6888238",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-20T10:41:29.5798742",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jessica Gunsman",
      advisor: "Nadia Bandula ",
      referralUser: "Bryony Collett",
      id: 535,
      caseRef: "SAG533",
      referredById: 128,
      caseStatusId: 32,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Full time - Legal Secretary, £40,000 deposit from the sale of a previous home, currently going through a divorce, she has a 3 year old son.\n\nChecking to see if she passes the criteria for when our next two bedroom properties launch.",
      dateOfReferral: "2022-06-17T15:03:44.6100316",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T10:59:25.4121687",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 19,
    },
    {
      applicant: "Keith Millington",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Claire Jenks",
      id: 536,
      caseRef: "SAG534",
      referredById: 33,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 102500,
      plotNumber: "Plot 132, Lanport Road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-17T15:04:55.8689875",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-20T10:20:38.0409725",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: 58,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-22T08:40:15.9496385",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kat Dunbobbin",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 537,
      caseRef: "SAG535",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legal Sols & quote emailed",
      dateOfReferral: "2022-06-18T09:45:49.47163",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-18T10:26:03.0975821",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-30T09:43:20.273922",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Carla O'Rourke",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Jamie Bodle",
      id: 541,
      caseRef: "SAG536",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "37",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "On housing benefit & carers allowance\nWill be getting a gifted deposit of £8,000",
      dateOfReferral: "2022-06-20T14:05:42.1760652",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-20T14:26:52.30205",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-06-20T15:48:36.7862889",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Toni Ellis",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Jamie Bodle",
      id: 542,
      caseRef: "SAG537",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "37",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Will be her and her partner",
      dateOfReferral: "2022-06-20T14:56:47.0121978",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T14:52:56.0972152",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing",
      financialDetailsId: 301,
      closedDate: "2022-06-21T14:53:08.0407447",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Neeranjan Ganowry",
      advisor: "Nadia Bandula ",
      referralUser: "Boyd Kelly",
      id: 543,
      caseRef: "SAG538",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 132500,
      plotNumber: "31 22 Nova Close, Overstone Northampton NN6 0SH",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Had said that he has already filled this out before but happy to do it again. ",
      dateOfReferral: "2022-06-21T09:30:29.6064894",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T09:35:08.0290297",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-06-27T12:46:38.8451596",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Louise Spacek",
      advisor: "Steven Sanderson",
      referralUser: "Boyd Kelly",
      id: 546,
      caseRef: "SAG539",
      referredById: 172,
      caseStatusId: 28,
      developmentId: 25,
      purchasePrice: 130,
      plotNumber: "32 20 Nova Close, OverstoneNorthampton NN6 0SH",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Been to see someone before.  ",
      dateOfReferral: "2022-06-21T10:49:24.7920877",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T15:47:40.8034818",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 331,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Charlie Jeynes",
      advisor: "Laura Turner",
      referralUser: "Boyd Kelly",
      id: 547,
      caseRef: "SAG540",
      referredById: 172,
      caseStatusId: 26,
      developmentId: 25,
      purchasePrice: 13000,
      plotNumber: "32 20 Nova Close, OverstoneNorthampton NN6 0SH",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Tony enquired on behalf of brother Charlie - trying to arrange a call with Charlie to discuss further.",
      dateOfReferral: "2022-06-21T11:06:47.9444071",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T11:54:40.7817971",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Ruchika bhambu",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Jas Sagoo",
      id: 548,
      caseRef: "SAG541",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 415000,
      plotNumber: "13",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "deposit \n10k\nincome 32=12k overtime \n2 bed parking",
      dateOfReferral: "2022-06-21T11:26:49.0921619",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T16:01:38.1325243",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 303,
      closedDate: "2022-07-11T09:52:29.8641761",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Zainab Mahomed Patel",
      advisor: "Laura Turner",
      referralUser: "Jamie Bodle",
      id: 549,
      caseRef: "SAG542",
      referredById: 111,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "34",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-21T11:48:04.6762969",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T08:18:49.7430345",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 75000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 310,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Matthew Herbert ",
      advisor: "Rachel Davies",
      referralUser: "Boyd Kelly",
      id: 550,
      caseRef: "SAG543",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 132500,
      plotNumber: "plot 31 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-21T12:15:34.9807896",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T12:18:18.5156556",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 75000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-07-21T09:57:37.4647423",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Christine Reid",
      advisor: "Laura Turner",
      referralUser: "Emilio Williams",
      id: 552,
      caseRef: "SAG544",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-21T12:32:27.8047837",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T12:57:07.7918449",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-22T16:39:40.532489",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jennifer Mallorie ",
      advisor: "Steven Sanderson",
      referralUser: "Bryony Collett",
      id: 554,
      caseRef: "SAG546",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Prefers to be called Jenny\nShe will be living with her partner Steve however the mortgage will only be in her name.\nThey both work at estate agents, she works for Daniel Brewer and he works at Howick and Brooker\nJoint income is just under £80,000\nFirst time buyers\n07714167174 - Steve ",
      dateOfReferral: "2022-06-21T12:38:52.3624772",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T14:08:40.5224677",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 215000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-21T15:12:42.8322395",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Banureka Sivakumar",
      advisor: "Baldev Dhanda",
      referralUser: "Emilio Williams",
      id: 555,
      caseRef: "SAG547",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "please see case notes for updates.",
      dateOfReferral: "2022-06-21T12:40:15.5922124",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T13:11:24.3675619",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 141.34,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-01T13:14:01.1705564",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Nisha Kabir Khan",
      advisor: "Medihya Akram",
      referralUser: "Jas Sagoo",
      id: 556,
      caseRef: "SAG548",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Depo - 10K \n2 bedrooms \nRequired parking \nWorking full time / Housing benefit ",
      dateOfReferral: "2022-06-21T12:41:33.3361513",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T11:43:04.7123228",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 141.35,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-04T08:41:50.2740063",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "oluwatoyin odudimu",
      advisor: "Baldev Dhanda",
      referralUser: "Boyd Kelly",
      id: 559,
      caseRef: "SAG549",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 132500,
      plotNumber: "31 22 Nova Close, Overstone Northampton NN6 0SH",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client has decided not to proceed as he does not currently have enough funds to cover his fees and deposit. He will get back in touch once he has been able to secure a larger fund/pot to proceed.\n\n*Baldev Dhanda*",
      dateOfReferral: "2022-06-21T13:21:13.8024326",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T12:55:36.5881954",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-06-23T12:55:56.357885",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Adam McDonnell",
      advisor: "Aaron Heer",
      referralUser: "Shannay Jarvis",
      id: 560,
      caseRef: "SAG550",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Both employed FT\n\n1 Child",
      dateOfReferral: "2022-06-21T13:24:58.1452086",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T09:06:08.4397235",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 19000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 302,
      closedDate: "2022-06-23T12:56:29.6646927",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Dace Sebre",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Boyd Kelly",
      id: 561,
      caseRef: "SAG551",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 132500,
      plotNumber: "32 20 Nova Close, OverstoneNorthampton NN6 0SH",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-21T15:03:41.1081143",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T12:40:46.3789001",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "Sage House. ",
      financialDetailsId: 308,
      closedDate: "2022-08-18T13:54:15.0698086",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Alarna Ruscoe",
      advisor: "Joanna Halliday",
      referralUser: "Nicola Pike",
      id: 562,
      caseRef: "SAG552",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 175000,
      plotNumber: "103",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Site name is Cherry Tree Park not Kingsbourne but not on the list yet.\n\nLegals sold & quote emailed\n\nPlease call after 6pm",
      dateOfReferral: "2022-06-21T22:08:41.7382158",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-21T22:29:59.5706299",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T07:37:29.2355359",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kian Woulfe",
      advisor: "Adam Faulkner",
      referralUser: "Alex Honeywood",
      id: 563,
      caseRef: "SAG553",
      referredById: 173,
      caseStatusId: 34,
      developmentId: 25,
      purchasePrice: 132500,
      plotNumber: "33",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T08:20:25.715004",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T15:27:09.4197105",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 6625,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Dena Kee Rose",
      advisor: "Zeeshan Ashraf",
      referralUser: "Shannay Jarvis",
      id: 564,
      caseRef: "SAG554",
      referredById: 126,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Miss salary £52,500\n\nMr salary £25,000\n\n2 children",
      dateOfReferral: "2022-06-22T08:37:52.0327724",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T09:25:05.0457265",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "David Spengler",
      advisor: "Zeeshan Ashraf",
      referralUser: "Steven Field",
      id: 566,
      caseRef: "SAG556",
      referredById: 302,
      caseStatusId: 28,
      developmentId: 27,
      purchasePrice: 126000,
      plotNumber: "20 or 17",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This guy is 71, had assumed cash as retired, but says needs a mortgage... says repayments and rent well within his budget, and has fond a specialist broker who can do mortgage, so assume must have decent pension; It's a lifetime / interest only mortgage; can you do that on shared ownership?",
      dateOfReferral: "2022-06-22T09:57:05.2418082",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T12:19:06.3945933",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 32000,
      serviceCharge: 354.13,
      minPercShareAvailable: "45%",
      housingAssociation: "Paradigm",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: " Conor Joseph Fleming",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Jas Sagoo",
      id: 567,
      caseRef: "SAG557",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please do not call betwean 1230 - 2\n\n\ndeposit 15\nincome 25k+ \n2 bed ",
      dateOfReferral: "2022-06-22T10:06:56.6479174",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T10:11:13.6571406",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-23T10:36:55.5804839",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Paul Laker Jones",
      advisor: "Zeeshan Ashraf",
      referralUser: "Charlotte Smith",
      id: 568,
      caseRef: "SAG558",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511 15 Atchison AvenueNorwich NR4 7WJ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T10:10:11.6606516",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T10:12:23.0390608",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-07-15T06:35:30.5737893",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Justice Magombo",
      advisor: "Adam Faulkner",
      referralUser: "Alex Honeywood",
      id: 570,
      caseRef: "SAG559",
      referredById: 173,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 130000,
      plotNumber: "32",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T11:03:34.1513476",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T08:12:23.9050001",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE ",
      financialDetailsId: 306,
      closedDate: "2022-07-14T10:29:25.041915",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Jessica Griggs",
      advisor: "Laura Turner",
      referralUser: "Bethany Moret",
      id: 571,
      caseRef: "SAG560",
      referredById: 145,
      caseStatusId: 27,
      developmentId: 27,
      purchasePrice: 315000,
      plotNumber: "7,8,9,10,11,12",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can you please call her today? shes off all day \n\nTHIS ISN'T OAK FARM MEADOW, ITS ACTUALLY SHARED OWNERSHIP IN LONG MELFORD BLOOR HOMES. (not released yet) \n\nFull Market Value £315,000.",
      dateOfReferral: "2022-06-22T11:07:48.6476408",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T11:51:47.8053926",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 7875,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 305,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Jerrod Daileg",
      advisor: "Jamie Bowley",
      referralUser: "Imogen Bradley",
      id: 572,
      caseRef: "SAG561",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 400000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T11:19:51.4947124",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T11:26:14.8312808",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: null,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-22T15:46:21.688776",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lewis Green",
      advisor: "Rachel Davies",
      referralUser: "Praveena Sharma",
      id: 573,
      caseRef: "SAG562",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285500,
      plotNumber: "155/93 Marshall Way",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works night shift - Interested in 3 beds ",
      dateOfReferral: "2022-06-22T11:23:14.5061827",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T11:39:31.0853493",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-14T12:08:26.5077287",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jerrod Daileg",
      advisor: "Rachel Davies",
      referralUser: "Imogen Bradley",
      id: 574,
      caseRef: "SAG563",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 400000,
      plotNumber: "B10204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T12:43:10.8760793",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-27T14:37:52.4453759",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Candice Weekes-Lionel",
      advisor: "Christopher Taylor",
      referralUser: "Lauren Ruff",
      id: 576,
      caseRef: "SAG565",
      referredById: 66,
      caseStatusId: 26,
      developmentId: 47,
      purchasePrice: 335000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Candice is looking to purchase a shared ownership property but is in the early stages and would like to get some more information on what she needs to do in order to be able to purchase as she is on her own earns roughly £26,000 a year and is currently renting. She is interested in the WYVERN farm 3 beds and is aware that they are currently unavailable.  ",
      dateOfReferral: "2022-06-22T12:14:30.8287011",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T13:04:52.3425082",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE HOMES",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jibi Job",
      advisor: "Nadia Bandula ",
      referralUser: "Alex Honeywood",
      id: 577,
      caseRef: "SAG566",
      referredById: 173,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 130000,
      plotNumber: "32",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Only been in the country for 6 months ",
      dateOfReferral: "2022-06-22T12:31:55.2988628",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T13:52:32.479845",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-29T19:48:32.7023528",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Claire Henson",
      advisor: "Rachel Davies",
      referralUser: "Boyd Kelly",
      id: 579,
      caseRef: "SAG567",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: null,
      plotNumber: "",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Wanted a 3 bed if possible due to medical needs.  ",
      dateOfReferral: "2022-06-22T13:06:32.7260883",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T13:23:40.138575",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 140000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-06-27T14:53:57.8906528",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Louise Ball ",
      advisor: "Nadia Bandula ",
      referralUser: "Shannay Jarvis",
      id: 580,
      caseRef: "SAG568",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Miss - universal credit\nMr - self employed\n\nUnsure of deposit level. ",
      dateOfReferral: "2022-06-22T13:37:09.0294549",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T12:48:42.8311976",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-27T12:50:00.4817216",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sadira Abdulla ",
      advisor: "Diane Cogan",
      referralUser: "Jamie Bodle",
      id: 581,
      caseRef: "SAG569",
      referredById: 111,
      caseStatusId: 26,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "69",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wants to purchase with Sister who is working.\nSadira isn't currently employed, however is using her savings for the deposit.",
      dateOfReferral: "2022-06-22T14:33:17.9192353",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T10:23:40.2654324",
      isDeleted: 0,
      advisorId: 18,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Jessica Lucas",
      advisor: "Diane Cogan",
      referralUser: "Shannay Jarvis",
      id: 582,
      caseRef: "SAG570",
      referredById: 126,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "1 Child ",
      dateOfReferral: "2022-06-22T14:37:17.7432621",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T14:45:05.8027188",
      isDeleted: 0,
      advisorId: 18,
      propertyStatusId: 40,
      depositLevel: 17000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Roque Agnelo Fernandes",
      advisor: "Aaron Heer",
      referralUser: "Imogen Bradley",
      id: 583,
      caseRef: "SAG571",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T15:04:44.3333955",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T16:09:56.0086234",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 309,
      closedDate: "2022-06-24T16:32:52.3241676",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jasbir Salh",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Emily Balloch",
      id: 584,
      caseRef: "SAG572",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-22T16:09:57.29332",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T16:56:25.8746791",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 311,
      closedDate: "2022-06-25T11:03:57.162308",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nancy Eldridge",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 585,
      caseRef: "SAG573",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Client did not qualify for a 50% share in the property. \n\n*Baldev Dhanda*",
      dateOfReferral: "2022-06-22T16:13:27.9854523",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T11:43:17.0601403",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-23T12:03:06.2647008",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "James Sturge",
      advisor: "Laura Turner",
      referralUser: "Sam Bowyer",
      id: 586,
      caseRef: "SAG574",
      referredById: 28,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 175000,
      plotNumber: "Plot 103 or 104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in Plot 103 or 104 @ Cherry Tree Park\n\nWorking away on 22/6 but if he could be called after 1pm please.\n\nA lot of interest, aware what docs he needs - keen to move forward.",
      dateOfReferral: "2022-06-22T20:19:13.5429998",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-22T21:27:18.0243614",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Opinna Udeh-paul",
      advisor: "Matthew Laws",
      referralUser: "Jas Sagoo",
      id: 590,
      caseRef: "SAG575",
      referredById: 299,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-23T10:36:18.3482173",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T10:37:56.886816",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Kelsey Godfrey",
      advisor: "Nadia Bandula ",
      referralUser: "Bryony Collett",
      id: 591,
      caseRef: "SAG576",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Kelsey - is a payroll controller, Cameron is a yard foreman.\n\nFTB - £26000 - income is under £80,000\n\nCurrently in rented. ",
      dateOfReferral: "2022-06-23T11:47:50.1821833",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T13:16:14.1824182",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 26000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-30T13:31:10.9181512",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Hollie Anne Baker",
      advisor: "Ian Parker",
      referralUser: "Karen Duke",
      id: 592,
      caseRef: "SAG577",
      referredById: 252,
      caseStatusId: 35,
      developmentId: 51,
      purchasePrice: 400000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Billy who is Hollys partner\n\n\nThis lead has been picked up by Charlotte Fay for qualification\n\nAs a household they are very close to the 80k income.  Billy has a default, registered in 2017. He is going to check this date with Experian to make sure definitely over 3 years.  It is settled.\n\nThey have a little boy, Frankie, two and a half, likes swimming.   They said no childcare fees but also mentioned a nursery so worth checking. ",
      dateOfReferral: "2022-06-23T12:26:20.3851735",
      offerExpiryDate: "2023-01-05T00:00:00",
      updatedDate: "2022-07-26T14:00:21.9839512",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 316,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 121,
    },
    {
      applicant: "Glen Rule",
      advisor: "Charlotte Fay",
      referralUser: "Bryony Collett",
      id: 593,
      caseRef: "SAG578",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying with partner, Glen is bus driver at Stansted, Susan is Senior carer. Been in rented for 9 years.\n\nThis has been taken on by Charlotte Fay for qualification.\n\n2 children 11 and 12\nBoth birthdays in September \n1 boy, 1 girl\n\nLived in their current house since 2013 and looking to own somewhere again. Both have owned properties in previous relationships and now looking to buy somewhere together. \n",
      dateOfReferral: "2022-06-23T12:28:11.8213117",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T11:45:20.388149",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE ",
      financialDetailsId: 325,
      closedDate: "2022-06-27T11:51:26.0869425",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Tayla-Louise Walker",
      advisor: "Laura Turner",
      referralUser: "Karen Duke",
      id: 594,
      caseRef: "SAG579",
      referredById: 252,
      caseStatusId: 27,
      developmentId: 51,
      purchasePrice: 400000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "first time buyer",
      dateOfReferral: "2022-06-23T12:43:17.8955425",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T16:45:21.733062",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "sAGE",
      financialDetailsId: 313,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Callum Tyrrell",
      advisor: "Laura Turner",
      referralUser: "Emilio Williams",
      id: 595,
      caseRef: "SAG580",
      referredById: 300,
      caseStatusId: 27,
      developmentId: 39,
      purchasePrice: 490000,
      plotNumber: "15",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-06-23T12:44:51.0946657",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T15:27:04.9490913",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 197,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 314,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Brandon Czapla",
      advisor: "Matthew Laws",
      referralUser: "Bryony Collett",
      id: 596,
      caseRef: "SAG581",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Brandon is an account manager, Alice is part time as a student nurse and then will be a full time nurse from 17th July\n\nThey are first time buyers currently in private renting\n\nDeposit is ~£32000 all from savings. ",
      dateOfReferral: "2022-06-23T12:46:38.5255262",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T12:49:03.3361677",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 32000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-23T16:29:28.6120809",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Scott McNeil",
      advisor: "Aidan Pearce ",
      referralUser: "Ryan Cheetham",
      id: 597,
      caseRef: "SAG582",
      referredById: 228,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "80",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "V. Keen to reserve a 3 bed semi detached. Good deposit level. Himself and Mrs buying - FTB's. Mrs currently on Mat leave from PT job\n\nUPDATE\nClient doesn't initially qualify based on lender affordability but is getting some additional paper work over to evidence exact income. Will update again when we have what we need. Has own broker within the family but may look to use is because of New Build. Awaiting outcome.",
      dateOfReferral: "2022-06-23T13:05:55.3562906",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T08:03:39.0799905",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 65,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-28T10:17:37.5261463",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Becy Downie",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 598,
      caseRef: "SAG583",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 149",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call Monday to Wednesday next week\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-06-23T14:36:03.6726273",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T16:16:05.7598831",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-24T13:38:50.1096086",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Agnelo Dcosta",
      advisor: "Ian Parker",
      referralUser: "Jas Sagoo",
      id: 601,
      caseRef: "SAG584",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "2 bed parking\ndeposit 40k\nincome 49k combined ",
      dateOfReferral: "2022-06-23T15:31:59.2446943",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-23T16:25:13.7593003",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 315,
      closedDate: "2022-07-20T16:23:11.7226706",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sharma Khan",
      advisor: "Charlotte Fay",
      referralUser: "Imogen Bradley",
      id: 603,
      caseRef: "SAG585",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "B10205 / b10304",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "This lead has been taken on for qualifying by Charlotte Fay \n\nSharma has just moved to the UK from India and she is heading a new division of the company that she works for here.  She is married and her husband will be back and forth between India and the UK.  She has confirmed that it is only Sharma on the application.\n\nAfter speaking to Sharma she has disclosed that she has a property in India that she owns and so is not eligible for shared ownership. ",
      dateOfReferral: "2022-06-23T16:03:03.9147802",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T14:23:39.4014046",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 4500,
      serviceCharge: 451,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-06-24T14:44:03.2496059",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Brenda Paterson",
      advisor: "Alison Cathcart",
      referralUser: "Sam Bowyer",
      id: 604,
      caseRef: "SAG586",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 175000,
      plotNumber: "103",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Cash buyer, please call after 3.30 on 24th June",
      dateOfReferral: "2022-06-23T20:48:46.6776573",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-26T08:30:59.6605023",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 131250,
      serviceCharge: 55,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 320,
      closedDate: "2022-08-10T09:15:40.643511",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Conor Porter",
      advisor: "Alison Cathcart",
      referralUser: "Nicola Pike",
      id: 605,
      caseRef: "SAG587",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 175000,
      plotNumber: "103",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Appointment booked for 1pm on 25/06 for HCA calc and affordability check.",
      dateOfReferral: "2022-06-23T21:52:51.9823651",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-26T08:28:05.6397049",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 8750,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 322,
      closedDate: "2022-08-10T09:16:50.2689959",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Emma Goodsell",
      advisor: "Baldev Dhanda",
      referralUser: "Emily Balloch",
      id: 608,
      caseRef: "SAG588",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called client 11:15am, VM left and Email sent 24/06/22 *Baldev Dhanda*\n\nClient has so far not responded to multiple attempts to be qualified. appointment was confirmed with the client  but she DNA. Left VM and Email informing client to get in touch if she wants to proceed. *Baldev Dhanda* 28/06/22",
      dateOfReferral: "2022-06-24T09:45:02.3093422",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T15:21:34.0825719",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 8500,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-30T08:40:28.4167018",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Elise Harris",
      advisor: "Jamie Bowley",
      referralUser: "Emily Balloch",
      id: 609,
      caseRef: "SAG589",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "please call between 1-3pm if today, if Saturday then call anytime.\n\ncalled arranged for 2pm * BD*",
      dateOfReferral: "2022-06-24T09:46:10.7089908",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T14:56:29.7223818",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 140000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-24T17:37:21.2308133",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Matthew phillips",
      advisor: "Matthew Laws",
      referralUser: "Emily Balloch",
      id: 610,
      caseRef: "SAG590",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-24T11:08:47.9728189",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T11:10:05.3254592",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-24T13:34:58.5139282",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Rachel O'Mahoney",
      advisor: "Shanaz Parbin",
      referralUser: "Emily Balloch",
      id: 611,
      caseRef: "SAG591",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 49,
      purchasePrice: 410000,
      plotNumber: "125",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "has local own to sell will come on with us",
      dateOfReferral: "2022-06-24T11:11:11.4489507",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T11:02:41.4415843",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T14:43:47.1183502",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sian Murray",
      advisor: "Laura Turner",
      referralUser: "Jamie Bodle",
      id: 612,
      caseRef: "SAG592",
      referredById: 111,
      caseStatusId: 27,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "61",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sian's property is under offer and just at signing of contracts stage.",
      dateOfReferral: "2022-06-24T11:36:48.9449781",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T13:10:19.9246454",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 317,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Lewis Buckley - Mead",
      advisor: "Matthew Laws",
      referralUser: "Shannay Jarvis",
      id: 613,
      caseRef: "SAG593",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "1 child",
      dateOfReferral: "2022-06-24T11:53:37.371105",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T11:57:04.8294435",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-24T14:47:50.2301564",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Daniel James Meany",
      advisor: "Alison Cathcart",
      referralUser: "Bryony Collett",
      id: 614,
      caseRef: "SAG594",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Daniel is full time employed in project management \nNicola is part time - Retail supervisor\n\nThey have a young girl together, Sadie who is 20 months old.  Their parents look after Sadie when they are at work. \n\nDaniel has works from home 4 days a week since covid which is one of the main reasons they want to move out and buy somewhere of their own with more space. ",
      dateOfReferral: "2022-06-24T12:17:37.6131749",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T09:33:32.2896514",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 337,
      closedDate: "2022-08-10T09:17:36.5648583",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Catriona Wareham",
      advisor: "Alison Cathcart",
      referralUser: "Jas Sagoo",
      id: 615,
      caseRef: "SAG595",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "income 67k\n2 bed with parking ",
      dateOfReferral: "2022-06-24T12:25:03.0099627",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T14:05:19.3728007",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 67000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 318,
      closedDate: "2022-08-10T09:18:51.9576234",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Rose Mason",
      advisor: "Alison Cathcart",
      referralUser: "Praveena Sharma",
      id: 618,
      caseRef: "SAG596",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Appt booked for 6pm on 27/06",
      dateOfReferral: "2022-06-24T15:07:19.5332467",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-26T08:35:26.2074674",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T09:20:15.4530506",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Zoe Fish ",
      advisor: "Rachel Davies",
      referralUser: "Bryony Collett",
      id: 621,
      caseRef: "SAG598",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Secretary - full time.\nDeposit - will be coming from the sale of her property she believes her equity is £180,000\nBuying alone - 2 children living with her - 24 year old he is moving out son, 18 year old who has special needs. \nIncome is under £80,000\nQuerying if she eligible for shared ownership. \nShe is selling her property and has an open day booked \n\nWe don't currently have a 2 bedroom but need to see if passes the qualification.",
      dateOfReferral: "2022-06-24T16:00:55.9885713",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-24T20:51:15.3975309",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 170000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 319,
      closedDate: "2022-07-21T09:59:05.2267057",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nick Weaver",
      advisor: "Agne Slepetyte",
      referralUser: "Sam Bowyer",
      id: 623,
      caseRef: "SAG600",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 175000,
      plotNumber: "104",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This is the last 2 bed plot available, there is other interest in it.\n\nCould you please make contact ASAP.",
      dateOfReferral: "2022-06-25T09:12:54.4375863",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-25T11:46:53.2235116",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 1,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 321,
      closedDate: "2022-06-30T10:31:49.4905974",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lucy Mason",
      advisor: "Agne Slepetyte",
      referralUser: "Shannay Jarvis",
      id: 624,
      caseRef: "SAG601",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Miss Maternity Leave \n\nSole Application \n\nIncome under £80,000",
      dateOfReferral: "2022-06-25T09:49:40.6917617",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-25T11:26:42.5377502",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 40,
      depositLevel: 200000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-08T10:08:39.0083104",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Scott",
      advisor: "Alison Cathcart",
      referralUser: "Bryony Collett",
      id: 625,
      caseRef: "SAG602",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Full time - Primary School Teacher - \nNicola is coming off of maternity leave next week - delivery driver for Sainsbury's\nThey have a 2.5 year old and an 8 month old\n\nCurrently in a shared ownership property but they need to upsize will sell if eligible for the three bedroom. \n\nThey would like to know if there is a electric charging point for his car on the driveway. \n",
      dateOfReferral: "2022-06-25T13:27:10.794671",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-26T08:18:49.9768875",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-08-10T09:21:01.9311125",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Joel Fielding",
      advisor: "Matthew Laws",
      referralUser: "Bethany Moret",
      id: 629,
      caseRef: "SAG603",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 315000,
      plotNumber: "tbc",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "call anytime on 28th tuesday \nnot sapphire fields, its for a long melford site but i dont know the name of the site.\nFMV : 315,000.",
      dateOfReferral: "2022-06-27T08:56:20.3433683",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:28:50.4114239",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 7857,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 333,
      closedDate: "2022-06-28T14:30:56.3384764",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Elise Harris",
      advisor: "Ian Parker",
      referralUser: "Bethany Moret",
      id: 630,
      caseRef: "SAG604",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 315000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FMV - £315,000 \nNot oak farm meadow, jsut dont know the name of long melford site we have\n\n27/06/2022 Picked up for qualifying by Charlotte Fay \n\n2 children, one at university and one moved out.\n\nShe has received a AIP from another provider but happy to look at options if needed. ",
      dateOfReferral: "2022-06-27T09:20:04.2485922",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T12:00:47.0691013",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 7875,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: null,
      financialDetailsId: 349,
      closedDate: "2022-07-22T13:37:46.1285525",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Kim Chambers",
      advisor: "Nadia Bandula ",
      referralUser: "Melanie Mills ",
      id: 631,
      caseRef: "SAG605",
      referredById: 143,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 315000,
      plotNumber: "hasn't decided yet",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This is the new oLng Melford site, she is sstc and is seperating from her husband, looking to buy with her son.\nHas £25k not sure if she can afford these.\nKurt said there may be flexibility on price and share.\nWould really like a call before 1pm today as working over the next couple of days\nKind Regards Mel\n\n27/06/2022 Picked up by Charlotte Fay for qualifying \n\n1 son, Owen, 4 years old. Starting school in September, looking forward to starting, lots of energy! \n",
      dateOfReferral: "2022-06-27T09:32:38.613779",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:07:17.4972953",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "flexible according to Kurt",
      housingAssociation: "Sage",
      financialDetailsId: 324,
      closedDate: "2022-07-06T11:02:16.1512252",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Maria Gerald",
      advisor: "Steven Sanderson",
      referralUser: "Bethany Moret",
      id: 634,
      caseRef: "SAG606",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 315000,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "long melford site\nfull market value 315,000\nafter 4.00 please call ",
      dateOfReferral: "2022-06-27T09:52:24.2058562",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T09:55:25.1487087",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 7857,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-29T16:34:15.9630933",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Natalie Davies",
      advisor: "Steven Sanderson",
      referralUser: "Praveena Sharma",
      id: 635,
      caseRef: "SAG607",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T09:54:18.9932216",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T12:49:50.6250663",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 354,
      closedDate: "2022-07-25T13:46:37.7493677",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Magdalena Oparaeche",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 637,
      caseRef: "SAG608",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-06-27T10:08:47.0524007",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T10:10:12.9317665",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-27T10:31:04.1217454",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Collette Stubbs",
      advisor: "Zeeshan Ashraf",
      referralUser: "Sam Bowyer",
      id: 639,
      caseRef: "SAG609",
      referredById: 28,
      caseStatusId: 32,
      developmentId: 88,
      purchasePrice: 210000,
      plotNumber: "92",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wants a 3 bed shared ownership\n\nPlease look at £210,000 FMV & £235,000 FMV\n\nPlease call today 27/6, keen to progress\n\n27/06/2022 Taken on for qualifying by Charlotte Fay ",
      dateOfReferral: "2022-06-27T12:33:53.0651616",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T06:29:17.7443098",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 326,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Maisam Azizi",
      advisor: "Matthew Laws",
      referralUser: "Jas Sagoo",
      id: 640,
      caseRef: "SAG610",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Zuvair (relative): 07944 449 493\n\nTaken by Matthew Laws for qualifying \n\nSpoken to Zuvair - Wasn't fully aware of how shared ownership worked. I explained and he now wants a chat with the person he will be moving in with. He will call back once that discussion has been made.",
      dateOfReferral: "2022-06-27T13:26:19.507563",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T09:14:24.1198735",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-16T14:27:10.609497",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Alison",
      advisor: "Nadia Bandula ",
      referralUser: "Lewis Ward",
      id: 641,
      caseRef: "SAG611",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "112",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T13:29:52.8970563",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T15:54:01.8798326",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 300,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing",
      financialDetailsId: 327,
      closedDate: "2022-06-29T19:54:30.5435847",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Robert Jones",
      advisor: "Rachel Davies",
      referralUser: "Lewis Ward",
      id: 642,
      caseRef: "SAG612",
      referredById: 232,
      caseStatusId: 78,
      developmentId: 88,
      purchasePrice: 87500,
      plotNumber: "104",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T13:58:53.9613521",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T09:32:20.4137474",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: null,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 28,
    },
    {
      applicant: "Moumen Boutari",
      advisor: "Ian Parker",
      referralUser: "Jas Sagoo",
      id: 643,
      caseRef: "SAG613",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 1,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-06-27T14:22:49.8458504",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T14:29:17.2403275",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: 176.79,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-28T08:48:44.1675935",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Geraldine Diaz",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 644,
      caseRef: "SAG614",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: " 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "2 bed flat w/ parking\nIncome: £85k\nDep: £6-£10k\nHave a property in Scotland, do not need to sell, may rent out.\nNeeds to know if she and her partner can qualify for Shared Ownership",
      dateOfReferral: "2022-06-27T15:05:31.4364953",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T15:11:05.4682011",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-06-28T10:02:05.8760427",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Declan McCormick",
      advisor: "Nadia Bandula ",
      referralUser: "Praveena Sharma",
      id: 645,
      caseRef: "SAG615",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Property is plot 111 or 112\n\nFMV is £232,500",
      dateOfReferral: "2022-06-27T15:06:23.3306749",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T11:08:14.3404052",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 330,
      closedDate: "2022-07-06T11:03:07.1822572",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ujal Marway",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 646,
      caseRef: "SAG616",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 425000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on for qualifying by Charlotte Fay \n\nWorks at Healthrow airport, loves her job. Been renting for a few years and now would like to own somewhere of her own. ",
      dateOfReferral: "2022-06-27T15:21:16.8988658",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T09:42:22.3835566",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 158.36,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 329,
      closedDate: "2022-06-28T09:45:37.1152196",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "calum rooney",
      advisor: "Ciaran Wilkinson",
      referralUser: "Lewis Ward",
      id: 647,
      caseRef: "SAG617",
      referredById: 232,
      caseStatusId: 26,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "80",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T15:39:41.4118145",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T15:26:24.3677652",
      isDeleted: 1,
      advisorId: 62,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 200,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Shaun Behan",
      advisor: "Nadia Bandula ",
      referralUser: "Jamie Bodle",
      id: 648,
      caseRef: "SAG618",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T15:50:09.8177379",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T16:33:12.2785922",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 37000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-06T11:04:04.8543206",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Claire Myatt",
      advisor: "Jamie Bowley",
      referralUser: "Lewis Ward",
      id: 649,
      caseRef: "SAG619",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 78500,
      plotNumber: "103",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-27T16:04:19.5171721",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-27T16:30:26.0992228",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 300,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-08T15:27:57.2614236",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Tomasz Nisciur",
      advisor: "Nadia Bandula ",
      referralUser: "Lewis Ward",
      id: 650,
      caseRef: "SAG620",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "80",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T09:12:43.5834286",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:00:24.234629",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 600,
      minPercShareAvailable: "45%",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-28T14:03:40.2205575",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Magdalena Janiga",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 651,
      caseRef: "SAG621",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB \nLegals sold & quote emailed",
      dateOfReferral: "2022-06-28T09:15:24.1412251",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T09:21:12.5877583",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-08T13:32:37.868301",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kelly Blanchard",
      advisor: "Nadia Bandula ",
      referralUser: "Nicola Pike",
      id: 652,
      caseRef: "SAG622",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "80",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & quote emailed",
      dateOfReferral: "2022-06-28T09:19:39.8517576",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T09:20:58.4944379",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-06-30T15:47:01.2602823",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Linda Demelo",
      advisor: "Nadia Bandula ",
      referralUser: "Emilio Williams",
      id: 653,
      caseRef: "SAG623",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 400000,
      plotNumber: "78",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on for qualifying by Charlotte Fay \n\nThey have their own mortgage broker and insurances already in place. \n\nQualified but deposit needs confirming - she confirmed 80k but this was a much bigger figure than what she had originally given to Haart.",
      dateOfReferral: "2022-06-28T09:31:49.5424165",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T12:45:50.7888078",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 80000,
      serviceCharge: 136.68,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 334,
      closedDate: "2022-07-05T10:19:08.7094734",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Julie Clayton",
      advisor: "Matthew Laws",
      referralUser: "Jamie Bodle",
      id: 654,
      caseRef: "SAG624",
      referredById: 111,
      caseStatusId: 27,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "62",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Will be cash buyer - Has funds for 50%\n\nTaken by Matthew Laws for qualification\n\nQualified for 50% share as a cash buyer ",
      dateOfReferral: "2022-06-28T09:41:32.7477798",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T12:32:24.9031321",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 95000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 332,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Megan Richardson",
      advisor: "Peter Hill",
      referralUser: "Emilio Williams",
      id: 655,
      caseRef: "SAG625",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Call after 3pm please\n\nPeter Hill Qualifying",
      dateOfReferral: "2022-06-28T10:36:17.2222067",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T15:28:57.8233392",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-28T16:30:54.3926446",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "David Obaretin ",
      advisor: "Paul Parker",
      referralUser: "Bryony Collett",
      id: 656,
      caseRef: "SAG626",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "David - Full time - System analyst \nSonia - Full time - Social worker\n\nTaken on for qualifying by Charlotte Fay \n\nCurrently living in a 3 bed rented property, happy with where they are living so will only move if the space is really worth it.  They are looking at 3 different properties this weekend including this one (2nd/3rd July).\n\nPicked up by Paul Parker as adviser\n",
      dateOfReferral: "2022-06-28T11:47:10.4284924",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T11:09:34.5071226",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 341,
      closedDate: "2022-07-01T17:19:44.1011444",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Anusha Selvaratnam",
      advisor: "Paul Parker",
      referralUser: "Ali Abbas",
      id: 657,
      caseRef: "SAG627",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 495000,
      plotNumber: "B10.04.07",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "work for the NHS, looking for parking which is an extra 30k has not been added to the property value. Have given the minimum price for a 2 bedroom. If you could see the maximum she would be able to afford up to at 25% share as well please.\n\npicked up by Paul Parker to qualify and take on as advisor.\n\nQualified - requested documents to proceed.\n\nDecided not to go ahead with Colindale plot but will still send documents to get them qualified to view others.",
      dateOfReferral: "2022-06-28T12:17:03.136597",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T11:14:22.109015",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 1016.02,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-11T10:40:21.7573744",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Wojciech Lalak",
      advisor: "Matthew Laws",
      referralUser: "Shannay Jarvis",
      id: 658,
      caseRef: "SAG628",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wrong property. \n\nWas looking more around £350,000\n\nMust be a 3 bed and not a flat\n\nQualified for FMV £360,000 @50% Share",
      dateOfReferral: "2022-06-28T12:28:09.4152123",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T15:52:33.8523471",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-06-28T16:20:25.4875481",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Janet Leyland",
      advisor: "Baldev Dhanda",
      referralUser: "Jamie Bodle",
      id: 659,
      caseRef: "SAG629",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "61",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on Baldev Dhanda 28/06/22\n\n*Qualified 30/06/22* Baldev Dhanda",
      dateOfReferral: "2022-06-28T12:36:48.3843567",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T13:48:18.6392094",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-07T10:29:37.1834146",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Kelly Weaire",
      advisor: "Deonne Samuels",
      referralUser: "Nicola Pike",
      id: 661,
      caseRef: "SAG630",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "368",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Plot is at Norton Hall Meadows, this site is not on the drop down list, have used Bilbrook instead  - Please call me if you need any further info\n\nLegals sold & emailed",
      dateOfReferral: "2022-06-28T12:51:26.3640657",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T13:06:33.9586875",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T13:54:55.6011693",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Julie Aloy",
      advisor: "Peter Hill",
      referralUser: "Jamie Bodle",
      id: 662,
      caseRef: "SAG631",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill Qualifying",
      dateOfReferral: "2022-06-28T13:18:36.2723921",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T15:33:08.2733975",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-04T13:36:58.6566531",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Faye Cresswell",
      advisor: "Zeeshan Ashraf",
      referralUser: "Praveena Sharma",
      id: 663,
      caseRef: "SAG632",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T13:36:41.1445022",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T14:45:45.2965838",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-15T06:26:25.8304138",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Divyesh Depala",
      advisor: "Ravneet Sokhi",
      referralUser: "Imogen Bradley",
      id: 665,
      caseRef: "SAG634",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 445000,
      plotNumber: "B10203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Divyesh currently lives with his parents and will be a first time buyer. \n\nHas his own IFA that would like to use already, someone their family has used in the past. \n\n04.07.2022- Left vm and emailed. Leaving with him and closing.\n\n05.07.22- Divyesh is sending his payslips and benefit statements so I can look at his affordability while he's receiving sick pay. He said he will be receiving sick pay for another year or so- RS\n\n07.07.2022- Left vm to say that while he's on sick pay and receiving benefits he won't qualify as he doesn't meet affordability.",
      dateOfReferral: "2022-06-28T14:17:51.6964642",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T14:32:28.7794189",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 206.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 343,
      closedDate: "2022-07-07T15:06:47.9964219",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Kyle Mayol",
      advisor: "Rachel Davies",
      referralUser: "Imogen Bradley",
      id: 666,
      caseRef: "SAG635",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 472500,
      plotNumber: "B10607",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T14:20:59.6025581",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:25:43.9847071",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T09:11:58.1093967",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Mahamadou Sylla",
      advisor: "Matthew Laws",
      referralUser: "Imogen Bradley",
      id: 668,
      caseRef: "SAG636",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 455000,
      plotNumber: "B10207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T14:24:43.2251401",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T17:17:17.5291347",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 336,
      closedDate: "2022-06-28T17:19:42.0629226",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "MUGUREL CHIRLACOFSCHI",
      advisor: "Deonne Samuels",
      referralUser: "Imogen Bradley",
      id: 669,
      caseRef: "SAG637",
      referredById: 301,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 375000,
      plotNumber: "B10502",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T14:27:26.5978478",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T11:55:09.1843166",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 173.31,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 338,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Nasir Kunwar",
      advisor: "Deonne Samuels",
      referralUser: "Imogen Bradley",
      id: 670,
      caseRef: "SAG638",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 480000,
      plotNumber: "B10708",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T14:29:29.7413316",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T14:40:26.3016506",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 220.96,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-01T13:42:02.0213732",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Alice Munday",
      advisor: "Ian Parker",
      referralUser: "Benjamin Starr",
      id: 674,
      caseRef: "SAG639",
      referredById: 168,
      caseStatusId: 65,
      developmentId: 35,
      purchasePrice: 392500,
      plotNumber: "97",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-28T16:52:06.6633868",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-28T17:10:20.3142335",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-20T16:30:27.5313167",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Tara Cartwright",
      advisor: "Alison Cathcart",
      referralUser: "Nicola Pike",
      id: 675,
      caseRef: "SAG640",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 245000,
      plotNumber: "368",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "*** Added as Bilbrook but the site is Norton Hall Meadows and not in the drop down***\n\nTara is separating from her husband and want to buy on, property is not yet on the market, discussed that she needs to be sstc before she could apply., she thinks it will sell really quickly. Agreed to get the initial affordability check done to make sure she is affordable and then if there is a plot available when she is sold she will be able to proceed asap.\n\nLegals sold & quote emailed ",
      dateOfReferral: "2022-06-29T08:11:11.3172599",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T08:13:55.2850664",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 120000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T09:44:24.736502",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Essie Bental ",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Praveena Sharma",
      id: 678,
      caseRef: "SAG641",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 230000,
      plotNumber: "-",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "minimum 2 bed - looking to purchase it for December. ",
      dateOfReferral: "2022-06-29T10:11:21.2643945",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T11:54:04.3914743",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 342,
      closedDate: "2022-07-20T14:51:12.9680617",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Thomas James Martin",
      advisor: "Peter Hill",
      referralUser: "Ryan Cheetham",
      id: 680,
      caseRef: "SAG642",
      referredById: 228,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on for qualifying by Charlotte Fay\n\nTom and Kayleigh have been renting but their landlord is now selling the property and they need to move out by November. Had been planning to move in about a year anyway and buy their own place so moving it forwards. \n\nThey have already spoken to a mortgage adviser but would speak to a NB  specialist - Tom has adverse credit history and would be keen to speak to someone with a good knowledge around this. ",
      dateOfReferral: "2022-06-29T10:36:46.2020776",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T10:58:16.4248317",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 350,
      closedDate: "2022-07-04T13:36:45.0336985",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Abbey Ann Simmons",
      advisor: "Nadia Bandula ",
      referralUser: "Karen Duke",
      id: 681,
      caseRef: "SAG643",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "83 3 Stacksteads Place, Maidstone, Kent",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FIRST TIME BUYER\n\nTaken on for qualifying by Charlotte Fay \n\nCurrently both living with parents and looking to buy first property. ",
      dateOfReferral: "2022-06-29T10:42:06.5772133",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T08:12:50.7415236",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 346,
      closedDate: "2022-06-30T12:34:11.3204892",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Gabriel-Daniel Despina",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Karen Duke",
      id: 684,
      caseRef: "SAG644",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "plot 84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "first time buyers",
      dateOfReferral: "2022-06-29T11:17:24.9272214",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T11:20:00.2967685",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-06T14:45:21.7289889",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Taranjeet Kaur",
      advisor: "Matthew Laws",
      referralUser: "Jamie Bodle",
      id: 687,
      caseRef: "SAG645",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If doesn't qualify for £320,000 plot, would like to be assessed for a 2 bedroom plot at £275,000 FMV.\n\nWill be getting a gifted deposit from her mother.\n\nShe is married, but didn't want her husband applying with her - I have told her that Sage would not allow her to apply on her own if she is married.",
      dateOfReferral: "2022-06-29T12:28:55.1790475",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T12:30:14.9713829",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-06-30T12:33:20.828819",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Anastasia Taylor",
      advisor: "Matthew Laws",
      referralUser: "Abhishek Joshi",
      id: 688,
      caseRef: "SAG646",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Her income: £22k - Works w/ Children\nHusband income: £42k - Ex-Army, works in Prison.\nPlease text or e-mail before calling, if not, PLEASE CALL ON WEEKEND (SAT). As they work full time, can be hard to reach.\n\nTaken by Matthew Laws for qualification \n\nEmail sent to verify a suitable time to call\n\nSpoken to Neville - They qualified for the property but decided they want to find something for more around 350k FMV\n\nNeville is 65\n\nDeposit can go up to 15k",
      dateOfReferral: "2022-06-29T12:45:18.2662655",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T18:20:37.2234438",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 176,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: 347,
      closedDate: "2022-06-29T18:25:47.8865383",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Danny Eccles",
      advisor: "Deonne Samuels",
      referralUser: "Jamie Bodle",
      id: 691,
      caseRef: "SAG647",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-29T13:13:21.8378324",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T15:40:23.2784817",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-07T12:08:28.3472736",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Olly Tucker-Barnett",
      advisor: "Deonne Samuels",
      referralUser: "Ben Greentree",
      id: 693,
      caseRef: "SAG649",
      referredById: 140,
      caseStatusId: 28,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "51",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Closer to work in Kings Lynn - works as manager at a leisure centre\n\nWANTS MORTGAGE APPOINTMENT",
      dateOfReferral: "2022-06-29T13:22:09.329443",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T15:33:32.3764699",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: 345,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Roche",
      advisor: "Deonne Samuels",
      referralUser: "Abhishek Joshi",
      id: 694,
      caseRef: "SAG650",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 425000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Dep: £5k\nIncome: £61800\nFTB? Y\nPlease e-mail if you cannot get through and he WILL call back.",
      dateOfReferral: "2022-06-29T13:22:36.2209234",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T13:15:57.2613396",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 158.36,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-07T11:36:07.4017535",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sofia Manfredi",
      advisor: "Christopher Taylor",
      referralUser: "Jamie Bodle",
      id: 695,
      caseRef: "SAG651",
      referredById: 111,
      caseStatusId: 26,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-29T13:45:49.4430565",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T10:40:41.2451828",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Shazeina Czareina ",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 699,
      caseRef: "SAG652",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "interested in 3 bed",
      dateOfReferral: "2022-06-29T15:43:31.4729983",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T15:44:28.0820069",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-06-29T18:27:12.4902247",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Cherelle Nunes",
      advisor: "Matthew Laws",
      referralUser: "Emily Balloch",
      id: 700,
      caseRef: "SAG653",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "29/06/22 Taken by Matthew Laws for qualifying\n\n30/06/22 Qualified from information given but very vague. Waiting for confirmation on a few bits - Once received I will send it through\n\n04/07/22 - Left V/M to chase up confirmation of info\n\n07/07/22 Left V/M and sent email",
      dateOfReferral: "2022-06-29T15:53:20.0997525",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T16:14:42.5128689",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-07T17:04:56.2981736",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sherisse Alicia Mcfarlane ",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Emily Balloch",
      id: 701,
      caseRef: "SAG654",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sherisse & Gamma have a little boy, 11 weeks old. They currently live separately and this will be their first house together. \n\nSherisse is on maternity leave and going back to work in October.  ",
      dateOfReferral: "2022-06-29T15:55:04.9188238",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T16:19:16.2247286",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 351,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Luke Sidney John Mitchell ",
      advisor: "Charlotte Fay",
      referralUser: "Emily Balloch",
      id: 702,
      caseRef: "SAG655",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently living with parents after breaking up with partner. Was self employed pre covid but now works in special effects, employed. ",
      dateOfReferral: "2022-06-29T15:56:53.114052",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T09:18:35.3072238",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 364,
      closedDate: "2022-07-04T09:20:45.978216",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Billy Wall",
      advisor: "Medihya Akram",
      referralUser: "Bryony Collett",
      id: 704,
      caseRef: "SAG656",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 430000,
      plotNumber: "290",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Full time - plumber at a private boarding school - Billy\n\nFull time - Dog groomer - Holly \n\nIncome is under £80,000\n\nWould like to be assessed for both 2 and 3 bedroom properties as they aren't sure if they will pass the 3 bedroom but want to try.\n\nIf they pass the 2 bedroom assessment then the properties are off plan. \n\n\n",
      dateOfReferral: "2022-06-29T16:16:37.7168251",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-29T18:58:01.8558303",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 348,
      closedDate: "2022-07-07T10:35:41.1717205",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sian Swinhoe",
      advisor: "Laura Turner",
      referralUser: "Jamie Bodle",
      id: 705,
      caseRef: "SAG657",
      referredById: 111,
      caseStatusId: 26,
      developmentId: 63,
      purchasePrice: 245000,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-30T07:57:30.3716743",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T07:58:15.7662661",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Barbara Cochrane",
      advisor: "Baldev Dhanda",
      referralUser: "Jamie Bodle",
      id: 707,
      caseRef: "SAG658",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please case notes for updates *Baldev Dhanda*\n\nCase closed as unresponsive.",
      dateOfReferral: "2022-06-30T09:06:35.2888594",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T15:03:30.65356",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-05T15:03:44.3167608",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Kaira Hayhurst ",
      advisor: "Laura Turner",
      referralUser: "Jamie Bodle",
      id: 708,
      caseRef: "SAG659",
      referredById: 111,
      caseStatusId: 26,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-30T09:13:21.0521937",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T09:18:22.0363312",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Felicio Menezes",
      advisor: "Baldev Dhanda",
      referralUser: "Abhishek Joshi",
      id: 710,
      caseRef: "SAG660",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Buying/Helping (for) Niece (Firmineh) she is a FTB; the uncle Felicio would be helping her.\nFM Income: £24k\nFirmineh Income: £22k\nDeposit: £25k\n3 bedroom flat \n\nSee case notes for update *Baldev Dhanda*",
      dateOfReferral: "2022-06-30T09:26:09.7067597",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T13:37:18.1538969",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-01T13:38:59.2785271",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sian Haughton",
      advisor: "Alison Cathcart",
      referralUser: "Ben Greentree",
      id: 711,
      caseRef: "SAG661",
      referredById: 140,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "51",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "WOULD LIKE MORTGAGE APPOINTMENT!!! NOT CASH",
      dateOfReferral: "2022-06-30T09:29:57.7082733",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T13:03:44.6203007",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T13:50:04.3620235",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Helen Fagan",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 712,
      caseRef: "SAG662",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Helen is currently being bought out by her ex partner\n\nLegal sold & emailed",
      dateOfReferral: "2022-06-30T09:36:10.5538223",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T09:40:36.8616629",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-06T13:15:14.1462243",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Elvis Kimathi",
      advisor: "Ravneet Sokhi",
      referralUser: "Boyd Kelly",
      id: 713,
      caseRef: "SAG663",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 130000,
      plotNumber: "Plot 29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "30.06.2022- Tried to call (couldn't leave vm). 01.07.2022- Tried to call (couldn't leave vm) and emailed\n04.07.2022- 01.07.2022- Tried to call (couldn't leave vm) and emailed. Updated Boyd and Mark and closing on the portal.",
      dateOfReferral: "2022-06-30T09:50:27.5108914",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T13:21:23.5696488",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-04T13:22:05.7987598",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Joe Reading",
      advisor: "Jamie Bowley",
      referralUser: "Nicola Pike",
      id: 715,
      caseRef: "SAG664",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegal sold & quote emailed",
      dateOfReferral: "2022-06-30T10:09:56.7449127",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T10:19:17.2401649",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-06T15:28:39.131454",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Claire Blunstone",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 716,
      caseRef: "SAG665",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\n\nLegals sold & quote emailed\n\n30/06/22 - Taken by Matthew Laws for Qualifying \n                - Voicemail left \n\n04/07/22 - Voicemail left \n\n06/07/22  - Email sent to confirm interest and convenient time to call \n\n06/07/22  - Email confirmed she is no longer interested ",
      dateOfReferral: "2022-06-30T10:24:14.7757401",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T10:03:48.4280395",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-06T10:03:23.8871211",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Aurelia Jorja",
      advisor: "Peter Hill",
      referralUser: "Imogen Bradley",
      id: 719,
      caseRef: "SAG666",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 455000,
      plotNumber: "B10506",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-30T11:00:54.0316041",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T11:02:42.5399462",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 208.36,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-01T14:33:37.5800456",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Alison Jane Ryder",
      advisor: "Peter Hill",
      referralUser: "Jamie Bodle",
      id: 720,
      caseRef: "SAG667",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "61",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on for qualifying by Charlie Fay \n\nAlison & Alan both have children but they are all over 18 and not at home. \n\nThey are really keen on this particular plot. ",
      dateOfReferral: "2022-06-30T11:35:48.4611707",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T08:44:50.7690102",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 361,
      closedDate: "2022-07-05T10:20:22.7302561",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Dr Miriam Dyberg",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 721,
      caseRef: "SAG668",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 81 £280k & Plot 158 £300k FMV",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nLegals sold & quote emailed\n\nThere are 2 plots available\n\nPlot  149 @ fmv £280,000\nPlot 158 @ fmv £300,000",
      dateOfReferral: "2022-06-30T12:02:54.0244403",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T14:32:22.9479141",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 358,
      closedDate: "2022-07-11T16:28:37.3508436",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Aimee Gellie",
      advisor: "Charlotte Fay",
      referralUser: "Steven Field",
      id: 722,
      caseRef: "SAG669",
      referredById: 302,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 126000,
      plotNumber: "15,16,17,18,20",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This lady has own broker, who she is wanting to use and already in talks; don't know if you'll be able to turn this beyond vetting for affordability",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T13:44:08.9919914",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 354.13,
      minPercShareAvailable: "45%",
      housingAssociation: "Paradigm",
      financialDetailsId: 356,
      closedDate: "2022-07-04T08:50:58.9751378",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Dominic Brindle",
      advisor: "Agne Slepetyte",
      referralUser: "Bryony Collett",
      id: 723,
      caseRef: "SAG670",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Self employed - roof - full time\nEmployed - Care home - in Thaxted - Part time\n\nBoth FTB \n\nCan't afford to get onto the open market due to the house prices.\n",
      dateOfReferral: "2022-06-30T13:01:38.1939039",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-06-30T16:11:16.565987",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 1000,
      minPercShareAvailable: "50 ",
      housingAssociation: "SAGE",
      financialDetailsId: 352,
      closedDate: "2022-08-13T12:08:16.393785",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Abbi Carr",
      advisor: "Agne Slepetyte",
      referralUser: "Jamie Bodle",
      id: 725,
      caseRef: "SAG671",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-06-30T14:49:11.7125077",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-02T09:36:29.9415629",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 357,
      closedDate: "2022-07-15T11:52:49.6496529",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Drew Alexander Aitken",
      advisor: "Ravneet Sokhi",
      referralUser: "Benjamin Starr",
      id: 727,
      caseRef: "SAG672",
      referredById: 168,
      caseStatusId: 65,
      developmentId: 35,
      purchasePrice: 392500,
      plotNumber: "97",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Drew & Shannon have looked at a new build previously but just missed out. They had a broker for that but are keen to speak to someone from JM now, they are keen to get things in place quickly and have bank statements/payslips/ID ready to go. \n\nThey are living together at their parents house at the moment, this will be their first property. They met whilst working together at B & Q - aisle 33!!\n\n04.07.2022- Spoke to Drew and requested documents. Have asked Ellen from Stevenage branch to send across the plans for Lavender Grange as clients have not yet received them- RS\n\n06.07.2022- Drew and Shannon are hoping to get documents across to me this week- RS\n\n08.07.2022- Emailed Drew to chase docs. The property on Lavender Grange has now gone but they are looking at https://www.rightmove.co.uk/properties/121008584#/?channel=RES_NEW- RS\n\n11.07.2022- Drew emailed to say that he has Covid and will contact me when he's feeling better. Closing for now- RS",
      dateOfReferral: "2022-06-30T15:19:48.6185038",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T15:48:55.4725382",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: 359,
      closedDate: "2022-07-11T15:51:07.2822362",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Jonathan Beadle",
      advisor: "Matthew Laws",
      referralUser: "Karen Duke",
      id: 728,
      caseRef: "SAG673",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "plot 84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sold \n\n30/06/22 - With Matthew Laws for qualification\n\n01/07/22 - Doesn't qualify for Monchelsea Park, Plot 84\n               - Interested in another plot on site FMV £325000\n               - Waiting for proof of overtime and confirmation of plot before proceeding ",
      dateOfReferral: "2022-06-30T15:39:10.3427045",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T14:59:01.3018998",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 56000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-09T10:06:58.0533678",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Lucy Lee Waterfield",
      advisor: "Ravneet Sokhi",
      referralUser: "Jamie Bodle",
      id: 730,
      caseRef: "SAG674",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "68",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Applying with partner who is self employed.\n\n01/07/22- left vm and emailed\n05/07/22- emailed outstanding queries\n08/07/22- Qualified Lucy and sent HCA to EA. She has her own IFA.- RS",
      dateOfReferral: "2022-06-30T16:24:34.4370628",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T14:00:09.6507022",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-08T14:24:20.4539153",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Miss Shahida Raza",
      advisor: "Baldev Dhanda",
      referralUser: "Joe Evans",
      id: 733,
      caseRef: "SAG675",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 200000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "PLEASE CALL CLIENT ON MONDAY 4TH JULY 2022.\nSHE HAS A PROPERTY TO SELL IN WALSALL WHICH IS NOT ON THE MARKET YET. LOOKING TO MOVE TO STAFFORD FOR 2+ BED HOUSE UPTO £200,000. (NOT SHARED OWNERSHIP ETC) HAD SOME ADVICE BUT HAPPY FOR 2ND OPINION. JE (1908770)",
      dateOfReferral: "2022-07-01T10:02:55.6921063",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T10:03:56.3600646",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-11T10:21:37.8642308",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Jessica Goodwin",
      advisor: "Rachel Davies",
      referralUser: "Shannay Jarvis",
      id: 738,
      caseRef: "SAG676",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-01T13:09:09.3800354",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T13:20:13.0996336",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-21T10:00:23.8490185",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Rebekah Williams",
      advisor: "Paul Parker",
      referralUser: "Shannay Jarvis",
      id: 739,
      caseRef: "SAG677",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Picked up by Paul Parker.\n\nQualified at 35%. Unfortunately does not meet the minimum 50% required.",
      dateOfReferral: "2022-07-01T13:22:42.3336323",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T10:52:51.4496023",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-11T10:54:59.3648178",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Shannon Anema",
      advisor: "Paul Parker",
      referralUser: "Roxanne Samuels",
      id: 740,
      caseRef: "SAG678",
      referredById: 141,
      caseStatusId: 29,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "any",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB's partner is called Tyler Eral also employed. \n\nPicked up by Paul Parker",
      dateOfReferral: "2022-07-01T13:23:14.485255",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T14:37:34.145051",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Zara Khan",
      advisor: "Matthew Laws",
      referralUser: "Emilio Williams",
      id: 743,
      caseRef: "SAG679",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-01T14:57:15.9607276",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T09:02:19.8788939",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 5500,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage housing",
      financialDetailsId: 362,
      closedDate: "2022-07-04T09:02:52.6902919",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Shelby Leigh Fullex",
      advisor: "Medihya Akram",
      referralUser: "Karen Duke",
      id: 744,
      caseRef: "SAG680",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "They have previously spoken with an adviser outside of JM and have an AIP (likely to have expired now). They would be willing to have a call with someone from JM but they are also pursuing the adviser they are already connected with. \n\nShelby and Brandon have sold their house SSTC, likely to be completed by mid July. They know that these properties will not be ready until early next year. \n\nThey have 2 children, 2 and 5, eldest is in first year of school and loving it. ",
      dateOfReferral: "2022-07-01T15:36:36.6535922",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T16:34:08.2618648",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 60,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 367,
      closedDate: "2022-07-04T17:41:43.0811152",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Lauren Welton",
      advisor: "Peter Hill",
      referralUser: "Jamie Bodle",
      id: 746,
      caseRef: "SAG682",
      referredById: 111,
      caseStatusId: 28,
      developmentId: 63,
      purchasePrice: 190000,
      plotNumber: "69",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "May be able to qualify for a 3 bed @ £245,000 FMV\n\nPeter Hill to qualify - no plots left at Bracebridge Heath\n\nQualifying for Waddington - £200k FMV",
      dateOfReferral: "2022-07-01T16:11:12.7561008",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T08:43:42.410921",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Donna Lee",
      advisor: "Medihya Akram",
      referralUser: "Jamie Bodle",
      id: 747,
      caseRef: "SAG683",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 245000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-01T16:42:46.0601072",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-01T17:18:29.008728",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 160000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-04T15:33:23.6762395",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Feninda Williams",
      advisor: "Kelly Powers",
      referralUser: "Imogen Bradley",
      id: 748,
      caseRef: "SAG684",
      referredById: 301,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 462.5,
      plotNumber: "B10207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-02T09:18:17.643459",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T11:29:39.2752375",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Luke edwards",
      advisor: "Nadia Bandula ",
      referralUser: "Nadia Bandula ",
      id: 753,
      caseRef: "SAG686",
      referredById: 44,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "already has IFA, but happy to go through details with me. Last AIP from january but in constant touch with his advisor. \n\nappt monday 6pm to have a chat",
      dateOfReferral: "2022-07-02T13:55:15.6914976",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-02T13:55:33.7787139",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-13T08:41:12.282875",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 112,
    },
    {
      applicant: "Saray dacosta Sobole",
      advisor: "Agne Slepetyte",
      referralUser: "Karen Duke",
      id: 754,
      caseRef: "SAG687",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "first time buyer",
      dateOfReferral: "2022-07-02T14:40:31.1227224",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T11:13:17.9072567",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 366,
      closedDate: "2022-07-04T11:13:24.9790873",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Tom James Norton",
      advisor: "Ravneet Sokhi",
      referralUser: "Matthew Prentice ",
      id: 755,
      caseRef: "SAG688",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "97",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If you can call today Tom is off all day - otherwise he may need to call back depending on work.\n\nWas buying a second hand shared ownership on site but seller pulled out at last min.\n\nHas own IFA\n\n04/07/2022- Left vm and emailed. Leaving with him and closing- RS",
      dateOfReferral: "2022-07-04T09:18:50.255353",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T14:19:41.7964511",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 365,
      closedDate: "2022-07-04T14:20:08.9791506",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 119,
    },
    {
      applicant: "Janet Thomas",
      advisor: "Charlotte Fay",
      referralUser: "Elliot Piper",
      id: 756,
      caseRef: "SAG689",
      referredById: 144,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157500,
      plotNumber: "9 18 Skylark Way",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This is not Oak farm meadow but is actully Long Melford. \n\nJanet works full time for the UK Power Networks as an area manager. She was working from home during covid but now back in the office.  She has children but they are all over 18 and dont live at home. ",
      dateOfReferral: "2022-07-04T09:58:38.9220573",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T13:53:35.797897",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: null,
      financialDetailsId: 368,
      closedDate: "2022-07-12T13:58:23.1771289",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Sophie Youles",
      advisor: "Matthew Laws",
      referralUser: "Ben Greentree",
      id: 758,
      caseRef: "SAG690",
      referredById: 140,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "51",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "WANTS MORTGAGE APPOINTMENT\n\n04/07/22 - Taken by Matthew for Qualifying \n\n- Booked a call with Sophie on Friday @ 11am for qualifying \n\n08/07/22 - No answer \n\n09/07/22 - No answer (email sent)",
      dateOfReferral: "2022-07-04T11:14:41.370828",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T10:07:31.0763309",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "75",
      financialDetailsId: 442,
      closedDate: "2022-07-18T10:08:47.1108742",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Kadir Oketokoun ",
      advisor: "Charlotte Fay",
      referralUser: "Thomas Barker",
      id: 759,
      caseRef: "SAG691",
      referredById: 163,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 300000,
      plotNumber: "608 Cresta HOuse",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB< Offered £300,000 on Flat 608 Cresta House, Alma Street Luton\nWill be using HTB\n\nTaken on for qualifying by Charlotte Fay \n\nQualified for HTB - have an AIP in place with their own adviser and have insurances/will through their work place, asked not to be contacted about mortgages for this property. ",
      dateOfReferral: "2022-07-04T11:16:53.6731122",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T08:53:09.4563104",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 370,
      closedDate: "2022-07-05T08:53:15.9162024",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 161,
    },
    {
      applicant: "BRUNO BREGAJ",
      advisor: "Alison Cathcart",
      referralUser: "Thomas Barker",
      id: 760,
      caseRef: "SAG692",
      referredById: 163,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 265000,
      plotNumber: "208",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Offered £265,000 on 208 Cresta House, Alma Street, Luton\nHelp to buy\nFirst time buyer",
      dateOfReferral: "2022-07-04T11:19:37.7025672",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T06:15:53.0010802",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T13:50:36.5451935",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 161,
    },
    {
      applicant: "Alice Hamilton ",
      advisor: "Rachel Davies",
      referralUser: "Charlotte Smith",
      id: 761,
      caseRef: "SAG693",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511, 15 Atchison Avenue Norwich NR4 7WJ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She hasn't spoken to a mortgage advisor at all, so would like a full appointment also please :)",
      dateOfReferral: "2022-07-04T11:25:15.6797045",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-04T11:26:52.3852721",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-17T14:58:43.9392851",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Mr Nathan Jonathon Nicholas Wilson ",
      advisor: "Kelly Powers",
      referralUser: "Karen Duke",
      id: 762,
      caseRef: "SAG694",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "IN RENTED\n\nTaken on for qualifying by Charlotte Fay \n\nGoing on holiday to Rhodes next week. \n\nNathan doesn't qualify for a 3 bed property at 395k but he had originally been looking at the 2 beds which he would qualify for (now all reserved).  He will still be looking for another property at around 340k or will get on a waiting list for the 2 bedroom properties. ",
      dateOfReferral: "2022-07-04T11:32:56.4358617",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T09:55:27.666066",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 371,
      closedDate: "2022-08-04T09:35:34.8815766",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Ismail Patel",
      advisor: "Alison Cathcart",
      referralUser: "Jamie Bodle",
      id: 763,
      caseRef: "SAG695",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-04T11:50:58.6063494",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T06:41:09.7597188",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 369,
      closedDate: "2022-08-18T17:06:48.8721106",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Momir Milosavljevic",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 764,
      caseRef: "SAG696",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 480000,
      plotNumber: "b1.07.09",
      htb: 1,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "looking to use funds from parents to buy 25% share. \n\n04/07/22 - with Matthew Laws for qualifying \n                - Waiting for confirmation of benefits received \n\n",
      dateOfReferral: "2022-07-04T12:10:47.3915152",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T10:11:15.1750142",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: 1042.55,
      minPercShareAvailable: "25%",
      housingAssociation: null,
      financialDetailsId: 373,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Sally Ann Jones",
      advisor: "Kelly Powers",
      referralUser: "Praveena Sharma",
      id: 765,
      caseRef: "SAG697",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Renting at the moment, looking for a 3 bed. \ncontact her partner if she doesnt pick up the call\n\nLewis and Sally live really near by this plot at the moment.  This will be their first property together. ",
      dateOfReferral: "2022-07-04T12:41:26.6309058",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T14:10:44.5153412",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 7200,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 372,
      closedDate: "2022-07-23T14:32:18.2754343",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Rohit Vashisht",
      advisor: "Matthew Laws",
      referralUser: "Emilio Williams",
      id: 766,
      caseRef: "SAG698",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "04/07/22 - Taken by Matthew Laws for Qual'\n\n                - No answer voicemail left \n\n06-07-22 -  Voicemail left",
      dateOfReferral: "2022-07-04T13:36:22.1606721",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T09:21:37.5238635",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing ",
      financialDetailsId: null,
      closedDate: "2022-07-08T10:15:31.7481297",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Julie Leany",
      advisor: "Peter Hill",
      referralUser: "Bryony Collett",
      id: 767,
      caseRef: "SAG699",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Full time, works in London, Legal PA\nIncome is under £80,000\nDivorced with her husband and sold their property which is where the deposit comes from.\nShe has a daughter who is at uni and comes to visit often. \n\nPeter Hill Qualifying",
      dateOfReferral: "2022-07-04T13:36:26.1966063",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T14:08:27.0672388",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 120000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-11T16:30:40.3697168",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Mehdi Minaji Moghaddam",
      advisor: "Charlotte Fay",
      referralUser: "Emilio Williams",
      id: 768,
      caseRef: "SAG700",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-04T14:14:53.4700975",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T11:27:01.5801654",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing ",
      financialDetailsId: 375,
      closedDate: "2022-07-05T11:42:32.2053916",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lisa Bhanu",
      advisor: "Paul Parker",
      referralUser: "Steven Field",
      id: 769,
      caseRef: "SAG701",
      referredById: 302,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 126000,
      plotNumber: "15-20",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Lisa's house is currently sold subject to contract following divorce. Lisa will be buying cash from proceeds of sale.\n\nWent through affordability. Whilst she does pass this, unfortunately, she does not any of the nominations criteria to be able to purchase.",
      dateOfReferral: "2022-07-04T15:03:57.5550175",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T10:51:00.4350757",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 126000,
      serviceCharge: 354,
      minPercShareAvailable: "45",
      housingAssociation: "paradigm",
      financialDetailsId: null,
      closedDate: "2022-07-11T10:51:41.7981867",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Emma Pennells",
      advisor: "Medihya Akram",
      referralUser: "Cassie Tovell",
      id: 773,
      caseRef: "SAG702",
      referredById: 373,
      caseStatusId: 28,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "In rented accommodation\n2 children\n\nDeposit 10k could stretch to £15,000\n\nIdeally would like a three bedroom \n\nLooking to purchase maximum they can afford. ",
      dateOfReferral: "2022-07-04T17:36:42.374574",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T17:22:34.9154757",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 85,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 376,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Ali Jalba",
      advisor: "Charlotte Fay",
      referralUser: "Emilio Williams",
      id: 774,
      caseRef: "SAG703",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T08:29:00.4995798",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T10:25:47.7957475",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 120000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage housing",
      financialDetailsId: 379,
      closedDate: "2022-07-07T10:45:31.5931549",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: " Joe William Mallison",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 775,
      caseRef: "SAG704",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "12k dep\nincome 31=bonus 6k\n2 bed with parking\n\nkeen to view today \n\nTaken on for qualifying by Charlotte Fay ",
      dateOfReferral: "2022-07-05T08:50:57.8963016",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T10:55:15.7788726",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 374,
      closedDate: "2022-07-05T10:56:45.5513114",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Laura Murphy",
      advisor: "Peter Hill",
      referralUser: "Emilio Williams",
      id: 777,
      caseRef: "SAG705",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call between 12-2pm\n\nPeter Hill tried 5/7 and 6/7 left voicemail",
      dateOfReferral: "2022-07-05T08:59:47.7692003",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T12:14:10.6627549",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "2022-07-07T14:23:48.7033323",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Shruti Patel",
      advisor: "Nadia Bandula ",
      referralUser: "Imogen Bradley",
      id: 778,
      caseRef: "SAG706",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 452500,
      plotNumber: "B10506",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T09:59:45.1665328",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T14:06:14.0576786",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 208.36,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-14T10:59:46.0735939",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Daniel Botwe",
      advisor: "Peter Hill",
      referralUser: "Emilio Williams",
      id: 780,
      caseRef: "SAG707",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T10:34:33.8696457",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T10:35:08.5963983",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "SAGE HOUSING",
      financialDetailsId: null,
      closedDate: "2022-07-05T15:27:38.9385909",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Andrea Price",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 781,
      caseRef: "SAG708",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Andrea is buying with her partner who is selling his property, they have offers they are considering. Will be purchasing cash from sale.\n\nLegal sold & quote emailed.\n\n05/07/22 - Taken by Matthew Laws for qualifying \n                - Andrea currently has Covid and would like a call back in two days.\n\n08/07/22 - No answer \n\n09/07/22 - No answer (email sent)\n                - Still unwell with Covid so she will call me once she is feeling better\n27/07/22 - Email sent for an update on covid and proceeding \n",
      dateOfReferral: "2022-07-05T10:45:55.4444074",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T10:15:35.1553878",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 117500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Steven Wicks",
      advisor: "Matthew Laws",
      referralUser: "Matthew Prentice ",
      id: 782,
      caseRef: "SAG709",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "98",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T10:50:02.3341847",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T17:03:48.0362208",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 378,
      closedDate: "2022-07-05T17:07:33.0869536",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 119,
    },
    {
      applicant: "Isaiah Oketola",
      advisor: "Medihya Akram",
      referralUser: "Imogen Bradley",
      id: 784,
      caseRef: "SAG710",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 385000,
      plotNumber: "43",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "wife is in Nigeria",
      dateOfReferral: "2022-07-05T11:02:03.1439455",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T13:33:03.8593865",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 149.64,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 386,
      closedDate: "2022-08-05T14:46:24.2049935",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Sam Shevyn",
      advisor: "Medihya Akram",
      referralUser: "Praveena Sharma",
      id: 786,
      caseRef: "SAG711",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "3 bed ",
      dateOfReferral: "2022-07-05T11:09:41.3081501",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T11:12:47.7904945",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 51,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-20T11:33:37.8005573",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kastanraj Kandiah",
      advisor: "Diane Cogan",
      referralUser: "Emilio Williams",
      id: 788,
      caseRef: "SAG712",
      referredById: 300,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T11:57:50.0884429",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T12:03:03.862896",
      isDeleted: 0,
      advisorId: 18,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Elizibeth Blackburn",
      advisor: "Steven Sanderson",
      referralUser: "Emilio Williams",
      id: 789,
      caseRef: "SAG713",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "elizabeth p/t asda 7352 pa \nabigail p/t restuarant 5200 pa. ",
      dateOfReferral: "2022-07-05T12:55:21.7901206",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T15:43:18.8068067",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 141.34,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing ",
      financialDetailsId: null,
      closedDate: "2022-07-06T15:44:11.6238898",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Miss Jade Ashleigh Smith ",
      advisor: "Charlotte Fay",
      referralUser: "Bryony Collett",
      id: 793,
      caseRef: "SAG714",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Self employed - Cake baker - Full time\n\nBuying alone, thinking of getting a dog (guard dog) nervous to live alone, likes the idea of a rescue dog.\n\nLiving with family atm.",
      dateOfReferral: "2022-07-05T14:22:00.0757528",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T16:09:49.0553692",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 377,
      closedDate: "2022-07-06T08:39:39.1817584",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Leonardo Paolini",
      advisor: "Matthew Laws",
      referralUser: "Matthew Prentice ",
      id: 794,
      caseRef: "SAG715",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "99",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-05T15:19:07.5230934",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T17:09:33.7787776",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-05T17:13:14.9983042",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 119,
    },
    {
      applicant: "Bethany Dewey-Fox ",
      advisor: "Rachel Davies",
      referralUser: "Matthew Prentice ",
      id: 795,
      caseRef: "SAG716",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "99",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Bethany is a School Teacher so please call after 4PM",
      dateOfReferral: "2022-07-05T15:24:40.3851382",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T15:25:24.3155078",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-21T10:16:44.5742469",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 114,
    },
    {
      applicant: "Ashleigh Jackson-Lake",
      advisor: "Nadia Bandula ",
      referralUser: "Bethany Moret",
      id: 797,
      caseRef: "SAG717",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: -3,
      plotNumber: "7/8",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "long melford site (not oak farm) \nfull market value : 315,000 ",
      dateOfReferral: "2022-07-05T16:27:31.776668",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-05T16:28:22.8916442",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 7857,
      serviceCharge: 50,
      minPercShareAvailable: "40%",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-13T08:30:33.4233587",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Andrew Sharpes",
      advisor: "Jamie Bowley",
      referralUser: "Nicola Pike",
      id: 800,
      caseRef: "SAG718",
      referredById: 29,
      caseStatusId: 35,
      developmentId: 88,
      purchasePrice: 205000,
      plotNumber: "132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \n\n06/07/22 - Taken by Matthew Laws for qualifying\n                - Call booked for 18:30\n\n\n\ncontact number on file is for mum (Debbie). Client doesn't get signal at work and will have mum present when discussing things",
      dateOfReferral: "2022-07-05T17:37:45.4026026",
      offerExpiryDate: "2023-01-31T00:00:00",
      updatedDate: "2022-08-04T10:26:19.0063594",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 7500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 383,
      closedDate: "2022-07-07T09:20:26.4552584",
      isClosed: 0,
      administratorId: 53,
      lnhManagerId: 28,
    },
    {
      applicant: "Toby Newcomb",
      advisor: "Laura Turner",
      referralUser: "Karen Duke",
      id: 803,
      caseRef: "SAG719",
      referredById: 252,
      caseStatusId: 27,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "pROPERTY SOLD\n\n06/07/22 -Taken by Matthew Laws for qual' \n                - Voicemail left \n                - Didn't qualify with current situation. Discussed another option and he will get back to me tomorrow with an answer\n07/07/22 - Qualified subject to paying off 14k on credit cards with money from proceeds from sale of property. \n\n\n\n\n",
      dateOfReferral: "2022-07-06T09:23:47.8991805",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T16:00:02.8891603",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 200000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 389,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Georgia Emily Reynolds ",
      advisor: "Charlotte Fay",
      referralUser: "Matthew Prentice ",
      id: 805,
      caseRef: "SAG720",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "98",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Georgia is off on thursday 7th so maybe easier to call her then.\n\nAlso, can i please ask - if Georgia fails on 25% could you let me know what percentage she would be okay with? Sage are staring to consider lower if required",
      dateOfReferral: "2022-07-06T11:23:26.6598553",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T14:58:11.1821239",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 65,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 387,
      closedDate: "2022-07-07T15:02:59.76156",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 119,
    },
    {
      applicant: "Kevin Crotch ",
      advisor: "Matthew Laws",
      referralUser: "Charlotte Smith",
      id: 809,
      caseRef: "SAG721",
      referredById: 305,
      caseStatusId: 26,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511 15 Atchison Avenue, Norwich NR4 7WJ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "06/07/22 - Taken by Matthew for Qualifying \n                - Wasn't aware of his self employed income. He will will confirm with me when home\n\n09/07/22 - No response from email, called and left V/M\n\n13/07/22 - VM left ",
      dateOfReferral: "2022-07-06T12:39:34.4300755",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T15:27:32.0477968",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Josh Brambley",
      advisor: "Baldev Dhanda",
      referralUser: "Karen Duke",
      id: 810,
      caseRef: "SAG722",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 325000,
      plotNumber: "PLOT 73 6 Westfield Drive",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "WILL BE COMING OFF THIS MORTAGE END OF AUGUST\n\n",
      dateOfReferral: "2022-07-06T12:48:25.3794566",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T09:58:09.6141984",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 88,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 393,
      closedDate: "2022-07-21T09:14:14.8916314",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Dhreeraj Soni",
      advisor: "Nadia Bandula ",
      referralUser: "Imogen Bradley",
      id: 811,
      caseRef: "SAG723",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 475000,
      plotNumber: "B10508",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "doesnt live or work in the area of Barnet, but would like to be qualified when this opens up to everyone in September",
      dateOfReferral: "2022-07-06T13:25:34.4296806",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T06:35:03.7568869",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 220.044,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 380,
      closedDate: "2022-07-19T14:07:10.3644485",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Milo Steggles",
      advisor: "Baldev Dhanda",
      referralUser: "Charlotte Smith",
      id: 812,
      caseRef: "SAG724",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking to buy first home together. They have been speaking to a mortgage adviser already but happy to have a call from us. \n\nCan go up to 60% on shared ownership and are keen to own as much as possible. \n\nUsing his own Advisor for now. *Baldev Dhanda*",
      dateOfReferral: "2022-07-06T14:02:24.7500162",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T10:51:46.402307",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 382,
      closedDate: "2022-07-07T10:56:38.5014335",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Louise Price",
      advisor: "Steven Sanderson",
      referralUser: "Madison Emery-Hyson",
      id: 813,
      caseRef: "SAG725",
      referredById: 231,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "Plot 81 / 11 Martin Ray Drive",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-06T14:03:40.4392549",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-06T14:04:29.765934",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "sage housing",
      financialDetailsId: null,
      closedDate: "2022-07-11T14:54:44.0024051",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Kimberley Eade",
      advisor: "Peter Hill",
      referralUser: "Imogen Bradley",
      id: 814,
      caseRef: "SAG726",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 480000,
      plotNumber: "B10709",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Matthew Laws Qualified\n\nPeter Hill Broker\n\nDocuments asked for - they are viewing Tuesday - hope to reserve straight away",
      dateOfReferral: "2022-07-06T14:10:53.927283",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T12:54:17.2761263",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 220.44,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 381,
      closedDate: "2022-07-11T14:38:48.8318819",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Krishan Shura",
      advisor: "Peter Hill",
      referralUser: "Imogen Bradley",
      id: 815,
      caseRef: "SAG727",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 510000,
      plotNumber: "B10708",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Peter Hill Qualified \n\nRequested Docs",
      dateOfReferral: "2022-07-06T14:16:22.4394811",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T08:35:35.6092987",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 95000,
      serviceCharge: 217,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-11T16:27:23.06513",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Martyn Booton",
      advisor: "Ravneet Sokhi",
      referralUser: "Charlotte Smith",
      id: 816,
      caseRef: "SAG728",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: null,
      plotNumber: "511 15 Atchison Avenue, Norwich",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "7.7.22- Left vm and emailed- RS\n8.7.22- Martyn emailed to say he is no longer interested in this property. Emailed to see if there is anything else he is interested in and closing on the portal.",
      dateOfReferral: "2022-07-06T14:19:23.3754691",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T15:31:30.7120795",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-08T15:32:19.4883874",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Chung Kwan Li",
      advisor: "Ravneet Sokhi",
      referralUser: "Imogen Bradley",
      id: 817,
      caseRef: "SAG729",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 475000,
      plotNumber: "B10508",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "07/07/2022- left vm and emailed- RS\n08/07/2022- left vm - RS\n\n13.7.22- left vm and leaving with them- RS",
      dateOfReferral: "2022-07-06T14:22:41.2996623",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T16:01:26.2043451",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 180000,
      serviceCharge: 220.44,
      minPercShareAvailable: "75",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-13T16:02:09.7833008",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Holly Shakespeare",
      advisor: "Charlotte Fay",
      referralUser: "Shannay Jarvis",
      id: 819,
      caseRef: "SAG730",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Decided not to go ahead as this is right at the top of their budget and they dont feel they will be able to afford the monthly costs. ",
      dateOfReferral: "2022-07-06T15:10:50.6722951",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T13:42:07.9670286",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 23000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-07T13:45:52.2567796",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Leanne Robinson",
      advisor: "Jamie Bowley",
      referralUser: "Bethany Moret",
      id: 821,
      caseRef: "SAG731",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157500,
      plotNumber: "7,8,9,10",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "full market value : 315,000 \nnot oak farm meadow - long melford instead \n\ncall asap please ",
      dateOfReferral: "2022-07-06T15:26:07.6184092",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T09:19:12.9438039",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 7857,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 384,
      closedDate: "2022-07-19T09:50:47.803319",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Abs martin ",
      advisor: "Ian Parker",
      referralUser: "Shannay Jarvis",
      id: 823,
      caseRef: "SAG732",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Grace Sykes, 07753 166458, gracee.sykes@hotmail.co.uk 2 Wentworth Drive, CM23 2PB",
      dateOfReferral: "2022-07-06T16:19:34.5430899",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T09:57:31.2233267",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-07T10:14:15.3164643",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Danni Game",
      advisor: "Peter Hill",
      referralUser: "Shannay Jarvis",
      id: 824,
      caseRef: "SAG733",
      referredById: 126,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "294",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "No children.\n\nno contact for 2-3 weeks so i have closed the case and left final voice mail and email., if client contacts i will be",
      dateOfReferral: "2022-07-06T16:23:20.9192559",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T13:05:33.9648701",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1000,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-08-15T13:06:32.2391036",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Glen Banyard",
      advisor: "Peter Hill",
      referralUser: "Callum Morton",
      id: 825,
      caseRef: "SAG734",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 32,
      purchasePrice: 317500,
      plotNumber: "50",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-07T07:33:59.3367247",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T10:25:13.1623825",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 650,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-07T10:30:58.2365011",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Alex Bright",
      advisor: "Matthew Laws",
      referralUser: "Bethany Moret",
      id: 826,
      caseRef: "SAG735",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157000,
      plotNumber: "7,8,9,10 ",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "full market value £315,000\nplease call anytime tomorrow\nnot oak farm meadow - its actually long melford ",
      dateOfReferral: "2022-07-07T09:03:10.0695988",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T10:23:36.7347457",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 5857,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: 395,
      closedDate: "2022-07-08T10:25:15.4276328",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Alexander Bartlett",
      advisor: "Peter Hill",
      referralUser: "Ryan Laurence",
      id: 828,
      caseRef: "SAG736",
      referredById: 142,
      caseStatusId: 27,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "47",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Needs to speak to a mortgage advisor.\n\nAlex is having problems with his phone at the moment, please contact by email in the first instance. ",
      dateOfReferral: "2022-07-07T10:06:12.4867514",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T08:44:50.9668684",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing",
      financialDetailsId: 392,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "karen Theobald",
      advisor: "Matthew Laws",
      referralUser: "Benjamin Starr",
      id: 830,
      caseRef: "SAG737",
      referredById: 168,
      caseStatusId: 27,
      developmentId: 53,
      purchasePrice: 340000,
      plotNumber: "67",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "07/07/22 - Qualified by Matthew Laws",
      dateOfReferral: "2022-07-07T11:23:19.6573187",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T12:52:54.928345",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: 385,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Luke Davies",
      advisor: "Jamie Bowley",
      referralUser: "Madison Emery-Hyson",
      id: 833,
      caseRef: "SAG738",
      referredById: 231,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "plot 81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-07T12:12:45.0644596",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T18:54:43.3736705",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 390,
      closedDate: "2022-07-18T19:19:14.54472",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Aimee Foss",
      advisor: "Charlotte Fay",
      referralUser: "Benjamin Starr",
      id: 834,
      caseRef: "SAG739",
      referredById: 168,
      caseStatusId: 65,
      developmentId: 53,
      purchasePrice: 340000,
      plotNumber: "67",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-07T12:42:36.6006214",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T12:44:31.2106748",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-11T07:56:03.9107712",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Mary Margaret Taylor",
      advisor: "Peter Hill",
      referralUser: "Praveena Sharma",
      id: 836,
      caseRef: "SAG740",
      referredById: 235,
      caseStatusId: 27,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Taken on for qualifying by Charlie Fay \nLooking for 3 bed - has a small son, aged 3 Magnus (husband is Shetlandic). Getting married in September, this is first house together. \n\nMary & Richard qualify for 50% re shared ownership but lender affordability is just out.  Sam Boyers has confirmed that 45% will be possible in which case eligibility and lender affordability both fit.  The figures Mary has given are conservative in terms of salary and she thinks this may be slightly more so 50% may be possible once spoken to an adviser. \n",
      dateOfReferral: "2022-07-07T13:56:01.4930662",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T11:57:41.0419658",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 394,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nicole Hammans",
      advisor: "Jamie Bowley",
      referralUser: "Ryan Laurence",
      id: 837,
      caseRef: "SAG741",
      referredById: 142,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "47, 46",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Happy to talk to mortgage advisor. \n\nLegal's instructed with QSD following discussion with client",
      dateOfReferral: "2022-07-07T13:57:04.5871391",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T15:42:25.6551109",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing",
      financialDetailsId: 391,
      closedDate: "2022-08-01T13:24:08.7959601",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "James Ball",
      advisor: "Charlotte Fay",
      referralUser: "Bryony Collett",
      id: 839,
      caseRef: "SAG742",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "James is a FTB, currently lives around the corner from the plots with his family\n\nFull time Plumber ",
      dateOfReferral: "2022-07-07T14:21:10.7371861",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T15:38:00.0890453",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 388,
      closedDate: "2022-07-10T13:50:22.7583953",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Nicole Brooks",
      advisor: "Jamie Bowley",
      referralUser: "Benjamin Starr",
      id: 840,
      caseRef: "SAG743",
      referredById: 168,
      caseStatusId: 65,
      developmentId: 53,
      purchasePrice: 340000,
      plotNumber: "67",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-07T14:38:04.5199896",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T14:47:03.4616571",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 60,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-08T09:44:24.3922312",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Maxine Cleveland",
      advisor: "Baldev Dhanda",
      referralUser: "Bethany Moret",
      id: 841,
      caseRef: "SAG744",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157000,
      plotNumber: "7,8,9,10 ",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "315,000 fmv \nnot oak farm, its long meflord \nanyday at 5.30pm",
      dateOfReferral: "2022-07-07T15:03:20.5227804",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T16:16:19.1240289",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 5785,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T13:17:10.1598086",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Becky Warwick",
      advisor: "Alison Cathcart",
      referralUser: "Cassie Tovell",
      id: 843,
      caseRef: "SAG745",
      referredById: 373,
      caseStatusId: 33,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "Plot 1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "looking for Shared Ownership \nI have a few plots available \n2 and 3 bedrooms\n\n",
      dateOfReferral: "2022-07-07T15:37:47.73332",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T07:56:29.7184762",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 996,
      minPercShareAvailable: "35",
      housingAssociation: "Sage",
      financialDetailsId: 398,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 19,
    },
    {
      applicant: "Rain India  Riley",
      advisor: "Adam Faulkner",
      referralUser: "Bryony Collett",
      id: 844,
      caseRef: "SAG746",
      referredById: 128,
      caseStatusId: 28,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Information and governance for the local authority - Full time\n\nGrounds worker - Full time \n\nLiving with family - \n\nShe has an 18 month old daughter, currently pregnant due in October. \n\nRain's parents are gifting the deposit - up to the value of 10%\n\n",
      dateOfReferral: "2022-07-07T16:14:55.2069612",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T07:52:51.6563056",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 402,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Chloe Mozley",
      advisor: "Laura Turner",
      referralUser: "Ali Abbas",
      id: 845,
      caseRef: "SAG747",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Best to call after 2:30pm. \n\nhas got a 20k deposit but would like to put down the least possible. ",
      dateOfReferral: "2022-07-07T16:20:04.6865365",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-07T16:21:36.9685484",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1016.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Adele O'Connor",
      advisor: "Baldev Dhanda",
      referralUser: "Ben Greentree",
      id: 848,
      caseRef: "SAG748",
      referredById: 140,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "82",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "REQUIRES MORTGAGE APPOINTMENT",
      dateOfReferral: "2022-07-08T08:40:54.6169663",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T20:45:39.3204461",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-21T12:13:47.344773",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Anka Gug",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Jas Sagoo",
      id: 854,
      caseRef: "SAG749",
      referredById: 299,
      caseStatusId: 32,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Dep: £50k\nIncome: £24\nTakes Universal Credit - has checked that they will pay for Service Charges and Rent not the Mortgage\n2 bed \nno parking ",
      dateOfReferral: "2022-07-08T12:00:19.716154",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T13:24:11.850755",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 399,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 108,
    },
    {
      applicant: "Lucy Freedman",
      advisor: "Matthew Laws",
      referralUser: "Karen Duke",
      id: 856,
      caseRef: "SAG750",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 325000,
      plotNumber: "73",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "very motivated\n\n08/07/22 - Taken by Matthew Laws for qualifying\n                - Spoken to Lucy but a lot of information was missing so currently waiting for that to be confirmed.\n\n11/07/22 - Boyfriend now doesn't want to move. ",
      dateOfReferral: "2022-07-08T12:19:30.8407246",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T09:34:43.6461289",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-13T09:36:12.0236414",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Joao Vicente",
      advisor: "Nadia Bandula ",
      referralUser: "Jas Sagoo",
      id: 857,
      caseRef: "SAG751",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ftb\ndeposit 10k\nincome 29 = wife 37\n2 bed \nparking \n\n08/07/22 - Taken by Matthew Laws for qualifying \n                - VM left\n11/07/22 - VM left / Email sent\n12/07/22 - Spoken to Joae, some details missing for qualifying so waiting for confirmation on that. \n15/07/22 - VM left",
      dateOfReferral: "2022-07-08T12:21:59.2914509",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-16T07:59:44.7076868",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 440,
      closedDate: "2022-07-26T14:18:31.0598988",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Hairat Oyemade Sobowale ",
      advisor: "Arjun Dhunna",
      referralUser: "Gareth Harmer",
      id: 858,
      caseRef: "SAG752",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 175000,
      plotNumber: "82",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Current property sold subject to contract\n\nEnglish name = Tara Martins",
      dateOfReferral: "2022-07-08T12:36:13.8411497",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T10:25:42.2442966",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 17500,
      serviceCharge: 88,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 400,
      closedDate: "2022-07-25T08:41:36.452591",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Alice Olyaie",
      advisor: "Alison Cathcart",
      referralUser: "Ali Abbas",
      id: 859,
      caseRef: "SAG753",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 370000,
      plotNumber: "b10310",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Alice has a 20 year old daughter who lives in America. She goes out to see her a couple of times a year and vice versa. She is studying and working out there. ",
      dateOfReferral: "2022-07-08T12:46:06.7366616",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T07:28:03.4917019",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 807.34,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 397,
      closedDate: "2022-08-10T13:52:59.9302452",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Massimiliano Cardillo",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 860,
      caseRef: "SAG754",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b10509",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-08T12:54:52.3918564",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T21:28:10.5532048",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 1025.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 407,
      closedDate: "2022-07-11T22:00:32.5266944",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Laura Harwood",
      advisor: "Baldev Dhanda",
      referralUser: "Cassie Tovell",
      id: 861,
      caseRef: "SAG755",
      referredById: 373,
      caseStatusId: 29,
      developmentId: 69,
      purchasePrice: 300000,
      plotNumber: "219",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can get a gift if needed \n\nMrs self employed 8 years - got tax returns \n\nlooking for two bedroom flat at 300 fmv \nor if can 2 bed house 365/370 max fmv\n\ni have not been issued the service charge information yet. \n\nMiss self employed \nMr employed \n\n08/07/22 - Taken by Matthew Laws \n                - Spoken to Laura. A lot of information missing. Email sent to confirm missing info before qualification\n\n11/07/22 - Qualified",
      dateOfReferral: "2022-07-08T13:23:46.8252586",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T13:18:18.5400179",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1200,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 403,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "ellie shea",
      advisor: "Matthew Laws",
      referralUser: "Madison Emery-Hyson",
      id: 862,
      caseRef: "SAG756",
      referredById: 231,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "plot 81",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "08/07/22 - Taken by Matthew Laws for qualifying\n                \n09/08/22 - No answer, V/M left \n\n11/07/22 - No answer, V/M left, email left\n\n13/07/22 - No answer",
      dateOfReferral: "2022-07-08T13:28:54.9304585",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T09:28:19.2222501",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 500,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-13T09:30:06.2724796",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Robert Bates",
      advisor: "Charlotte Fay",
      referralUser: "Melanie Mills ",
      id: 864,
      caseRef: "SAG757",
      referredById: 143,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: null,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Needs to see how much he can afford, interested in the Long Melford properties",
      dateOfReferral: "2022-07-08T13:51:17.9833705",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-08T15:55:29.1660455",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 49,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 396,
      closedDate: "2022-07-08T15:57:46.9442883",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Ben Clifford",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 865,
      caseRef: "SAG758",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "interested in 3 bed but if he doesn't qualify for the 3 bed then he would be happy with 2 bed \n\n08/07/22 - Taken by Matthew Laws for qualifying \n\n09/07/22 - No answer \n\n11/07/22 - No answer / Email sent\n\n12/07/22 - Spoken to Ben. Doesn't qualify for 3 or 2 bed with current circumstances but have given him an option to move forward by paying off a loan and reducing deposit. He will contact me in the next two days with an answer. ",
      dateOfReferral: "2022-07-08T14:11:57.276249",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T17:10:20.3494185",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 414,
      closedDate: "2022-07-15T14:05:21.8895188",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Emma Lindop",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 866,
      caseRef: "SAG759",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 102500,
      plotNumber: "132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegals sold and quote emailed",
      dateOfReferral: "2022-07-08T14:29:16.628068",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T16:26:04.0921683",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 5500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T08:49:50.6518703",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "sharn simmons",
      advisor: "Laura Turner",
      referralUser: "Lewis Ward",
      id: 872,
      caseRef: "SAG760",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "113",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-09T09:50:07.162228",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-09T10:22:36.5388484",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 8500,
      serviceCharge: 51,
      minPercShareAvailable: "50%",
      housingAssociation: "sage housing",
      financialDetailsId: null,
      closedDate: "2022-07-14T09:41:43.8725712",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Magdalena Oparaeche",
      advisor: "Alison Cathcart",
      referralUser: "Praveena Sharma",
      id: 873,
      caseRef: "SAG761",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "113",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "3 bed ",
      dateOfReferral: "2022-07-09T10:37:27.7173616",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-09T11:29:52.8706497",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T13:53:33.0436164",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Holly Maskell",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Bryony Collett",
      id: 876,
      caseRef: "SAG762",
      referredById: 128,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 365000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Part time - Payroll administrator\n\nSold a property to get her deposit - completed in last year. Has a partner but has a bad credit score so wants to see if she can do it alone. \n\nLooking at a 2 bedroom property :)\n",
      dateOfReferral: "2022-07-09T12:38:50.3053163",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-09T14:35:37.5441083",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-13T08:59:17.1020528",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Steven Bond",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Ben Greentree",
      id: 877,
      caseRef: "SAG763",
      referredById: 140,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "84",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "REQUIRE MORTGAGE APPOINTMENTS",
      dateOfReferral: "2022-07-09T12:39:47.8294689",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-09T15:03:27.444223",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-20T14:35:27.8797049",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Gui Ying Cen",
      advisor: "Ashleigh Wakenshaw",
      referralUser: "Nicola Pike",
      id: 879,
      caseRef: "SAG764",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 1,
      purchasePrice: 102500,
      plotNumber: "132",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals sold & quote emailed\n\n",
      dateOfReferral: "2022-07-09T13:55:43.4120431",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-09T16:04:11.2198642",
      isDeleted: 0,
      advisorId: 89,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-09T16:07:57.5125375",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Daniellea Dee",
      advisor: "Adam Faulkner",
      referralUser: "Cassie Tovell",
      id: 880,
      caseRef: "SAG765",
      referredById: 373,
      caseStatusId: 34,
      developmentId: 69,
      purchasePrice: 225000,
      plotNumber: "218",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "I dont have the correct service charge information. ",
      dateOfReferral: "2022-07-09T14:21:16.2368638",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T11:10:04.7399157",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 1140,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 51,
      lnhManagerId: 19,
    },
    {
      applicant: "neha sharma",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 883,
      caseRef: "SAG766",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-11T10:51:58.6585022",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T09:18:30.6008534",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 408,
      closedDate: "2022-07-12T09:28:51.9448669",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Thomas Butler",
      advisor: "Peter Hill",
      referralUser: "Sam Bowyer",
      id: 885,
      caseRef: "SAG767",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112 or 113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Expecting his first baby imminently, private rented on a rolling month contract.\n\n£11,000 deposit\n\n11/07/22 Taken on for qualifying by Charlie Fay. Waiting for information to be sent over. ",
      dateOfReferral: "2022-07-11T11:20:01.4601202",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T10:47:26.556548",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-15T13:07:58.2508981",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Tina Anne Wilson",
      advisor: "Laura Turner",
      referralUser: "Steven Merralls",
      id: 886,
      caseRef: "SAG768",
      referredById: 243,
      caseStatusId: 28,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "79,81,82,83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Wants to talk directly to Laura Turner ",
      dateOfReferral: "2022-07-11T12:12:10.8273232",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T07:49:35.0533175",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "Sage homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Rebecca Boultwood",
      advisor: "Shanaz Parbin",
      referralUser: "Cassie Tovell",
      id: 887,
      caseRef: "SAG769",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 300000,
      plotNumber: "217",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Single applicant\n10k deposit but can be more\nEmployeed \n\nlooking at 1 bedroom r two bedroom \n\none bedroom prices are £225,000\ntwo bedroom prices are 300,000\n\n11/07/22 - VM left ",
      dateOfReferral: "2022-07-11T12:41:05.288474",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T19:32:20.6836956",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 100,
      minPercShareAvailable: "30",
      housingAssociation: "Sage",
      financialDetailsId: 406,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Neelu Sharma",
      advisor: "Shanaz Parbin",
      referralUser: "Imogen Bradley",
      id: 890,
      caseRef: "SAG770",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 455000,
      plotNumber: "B10207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Unemployed since moving to UK from India in March 2021",
      dateOfReferral: "2022-07-11T13:45:43.1245592",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T19:36:03.6164122",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 404,
      closedDate: "2022-08-10T14:50:16.530451",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Alistair Curran",
      advisor: "Steven Sanderson",
      referralUser: "Jamie Bodle",
      id: 893,
      caseRef: "SAG771",
      referredById: 111,
      caseStatusId: 29,
      developmentId: 63,
      purchasePrice: 245000,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-11T13:58:48.4754445",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T12:59:17.6612803",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 413,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Joe Donnor",
      advisor: "Jamie Bowley",
      referralUser: "Jamie Bodle",
      id: 894,
      caseRef: "SAG772",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 63,
      purchasePrice: 245000,
      plotNumber: "66",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-11T14:15:27.7947502",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T17:26:13.0942398",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 34000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 405,
      closedDate: "2022-07-21T16:50:25.1846383",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Olesja Petriv",
      advisor: "Charlotte Fay",
      referralUser: "Sam Bowyer",
      id: 897,
      caseRef: "SAG773",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 300000,
      plotNumber: "158",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Mrs is self employed for 1 year\nMr S/E for 3 years",
      dateOfReferral: "2022-07-11T14:38:48.3832298",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T14:40:09.4513545",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 55,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-18T08:09:13.7646981",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Shauna Considina",
      advisor: "Steven Sanderson",
      referralUser: "Ali Abbas",
      id: 898,
      caseRef: "SAG774",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "b1.02.05",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "she is self employed but also employed. ",
      dateOfReferral: "2022-07-11T14:53:02.2298795",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T14:55:07.116923",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 833.14,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-21T09:25:28.0883612",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "sarjit bhogal",
      advisor: "Arjun Dhunna",
      referralUser: "Praveena Sharma",
      id: 899,
      caseRef: "SAG775",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Best day to call Tuesday or Thursday, Interested in 3 bed ",
      dateOfReferral: "2022-07-11T15:13:12.3148933",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T15:20:11.8148103",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-05T15:41:00.5382593",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ahmed Jaafar",
      advisor: "Matthew Laws",
      referralUser: "Emilio Williams",
      id: 900,
      caseRef: "SAG776",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-11T15:14:57.4209626",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-11T15:23:09.6202186",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing",
      financialDetailsId: null,
      closedDate: "2022-08-16T14:16:12.6635647",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Leanne Copstick",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Tomlinson",
      id: 902,
      caseRef: "SAG777",
      referredById: 32,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 105000,
      plotNumber: "unsure yet",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Cherry tree park ",
      dateOfReferral: "2022-07-12T07:52:07.5089446",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T08:07:29.0043828",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage housing ",
      financialDetailsId: null,
      closedDate: "2022-07-25T13:18:51.6321062",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Sophie Goodban",
      advisor: "Charlotte Fay",
      referralUser: "Steven Merralls",
      id: 903,
      caseRef: "SAG778",
      referredById: 243,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "would like a call at 1pm at lunch or after 5pm",
      dateOfReferral: "2022-07-12T08:18:47.7989945",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T14:52:15.8277838",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 70,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 410,
      closedDate: "2022-07-12T14:53:40.4941506",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Joe Kendall",
      advisor: "Agne Slepetyte",
      referralUser: "Ben Greentree",
      id: 905,
      caseRef: "SAG779",
      referredById: 140,
      caseStatusId: 65,
      developmentId: 31,
      purchasePrice: 210000,
      plotNumber: "46",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wishes to have mortgage appointment, is looking into options with an IFA but will compare",
      dateOfReferral: "2022-07-12T09:03:21.9563148",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T09:05:55.5601589",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-13T12:55:42.6523131",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Holly Judge",
      advisor: "Nadia Bandula ",
      referralUser: "Ali Abbas",
      id: 909,
      caseRef: "SAG780",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "b1.02.05",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-12T09:59:26.26345",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T12:16:26.3735554",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 833.14,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 417,
      closedDate: "2022-07-26T13:43:40.2469784",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Mary Carvelle",
      advisor: "Charlotte Fay",
      referralUser: "Bethany Moret",
      id: 910,
      caseRef: "SAG781",
      referredById: 145,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157500,
      plotNumber: "7,8,9,10",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "anytime after 12.30 friday or anytime after 4.30 in week.\nfull market value is £315,000 \ncash buyer",
      dateOfReferral: "2022-07-12T10:00:33.0581577",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T09:25:43.9055472",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 157500,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: 452,
      closedDate: "2022-07-20T09:29:36.9942952",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Manal Chemlal",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 913,
      caseRef: "SAG782",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 390000,
      plotNumber: "B1.04.04",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-12T10:27:12.8223384",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T17:40:18.8300193",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 873.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 416,
      closedDate: "2022-07-12T17:42:56.9486673",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Naiha Bhogal",
      advisor: "Laura Turner",
      referralUser: "Sam Bowyer",
      id: 916,
      caseRef: "SAG783",
      referredById: 28,
      caseStatusId: 27,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "110/113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-12T11:06:15.7801507",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T21:01:55.7449195",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 412,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Aaron Fernandes",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 917,
      caseRef: "SAG784",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "He has cash, would like to pay the share amount as deposit - £92.5k depo - 25% of the full property price \n\nHe is purchasing for son, is interested in buying/putting deposit down for him, son's income is roughly £35k pa.\n\nI am on the ropes with this one; it was a long conversation that I had w/ him - I just need this checked over please, I remain unconvinced with the information provided - thanks in advance for qualifying. \n\nCall booked 14/07/22 14:00",
      dateOfReferral: "2022-07-12T11:11:15.5754661",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T13:01:21.5063399",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 92500,
      serviceCharge: 141.34,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-15T08:29:18.6366261",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Penaki Das",
      advisor: "Peter Hill",
      referralUser: "Cassie Tovell",
      id: 919,
      caseRef: "SAG785",
      referredById: 373,
      caseStatusId: 79,
      developmentId: 69,
      purchasePrice: 365000,
      plotNumber: "195",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "He has spoken to our inhouse adviser but we are not able to get him a house on his income for outright purchase. \n\nHe would like to consider SO \n\nWe have looked at it could be doable on a two bedroom house. \n\nI have a couple to offer him which i will send in due course. \n\n12/07/22 - Taken by Matthew for qualifying\n13/07/22 - Spoken to Penaki. Waiting on proof of income.",
      dateOfReferral: "2022-07-12T11:30:47.2989908",
      offerExpiryDate: "2023-02-07T00:00:00",
      updatedDate: "2022-08-11T14:32:03.7606191",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 93,
      minPercShareAvailable: "25",
      housingAssociation: "Ssage",
      financialDetailsId: 419,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 50,
      lnhManagerId: 19,
    },
    {
      applicant: "Joseph Dentith",
      advisor: "Rachel Davies",
      referralUser: "Sam Bowyer",
      id: 924,
      caseRef: "SAG786",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 300000,
      plotNumber: "158",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call on Friday, contact details are for Louise but will just be in Josephs name.",
      dateOfReferral: "2022-07-12T12:25:13.5856494",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T12:27:55.1352036",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-17T15:02:16.0393831",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Daniela Badea",
      advisor: "Aidan Pearce ",
      referralUser: "Dominka Zych",
      id: 925,
      caseRef: "SAG787",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 185000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-12T12:42:48.199382",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T12:44:15.9502181",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-14T09:58:20.146138",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Holly Groombridge",
      advisor: "Ian Parker",
      referralUser: "Steven Merralls",
      id: 926,
      caseRef: "SAG788",
      referredById: 243,
      caseStatusId: 32,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "82,81,79, 83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NHS WORKER\nWould like a call asap really interested in these property's",
      dateOfReferral: "2022-07-12T12:52:25.3028241",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T08:29:49.3223364",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-07-12T13:02:53.7968978",
      isClosed: 1,
      administratorId: 52,
      lnhManagerId: 121,
    },
    {
      applicant: "Vipul Gada",
      advisor: "Nadia Bandula ",
      referralUser: "Ali Abbas",
      id: 932,
      caseRef: "SAG790",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 462500,
      plotNumber: "b1.03.09",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If they don't qualify for a 2 bedroom, would be interested in a 1 bedroom. Send me an email and I can send you over the price list for 1 and 2 bedrooms.",
      dateOfReferral: "2022-07-12T14:01:57.6934998",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T09:29:56.7916015",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 1012.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 418,
      closedDate: "2022-07-14T11:39:18.5252713",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jamil Etareri",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 934,
      caseRef: "SAG791",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 472500,
      plotNumber: "B1.04.08",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-12T14:24:55.2711964",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T15:01:38.8780873",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 1032.44,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-15T15:52:35.9197059",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Marius Zemetis",
      advisor: "Rachel Davies",
      referralUser: "Matthew Prentice ",
      id: 935,
      caseRef: "SAG792",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "98",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Hello - If Marius fails on 25% can you please let me know what percentage he would pass on? as Sage are considering lower",
      dateOfReferral: "2022-07-12T14:31:10.9207829",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-12T15:02:51.676669",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 345000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T09:08:40.9931392",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 119,
    },
    {
      applicant: "Miles Clayton",
      advisor: "Nadia Bandula ",
      referralUser: "Katie Rigden",
      id: 938,
      caseRef: "SAG793",
      referredById: 244,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "Plot 83 and 81",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Help to Buy: HTB-127108-N5L7J3",
      dateOfReferral: "2022-07-12T15:57:43.5468709",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T10:59:39.02976",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-16T08:36:30.2644514",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Chloe Love-Allotey",
      advisor: "Matthew Laws",
      referralUser: "Cassie Tovell",
      id: 939,
      caseRef: "SAG794",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can you give her advise on if she can buy or not. She is leaving her job tomorrow to work abroad for 6 months but has a job to go to. \nCan she still buy? \nreally keen on shared ownership\n\nGoing away in Aug to work in Caribbean - job secured \n1 years contract \nVeterinary company\n\nWould be able to go back to previous employment when returned.\n\n\n",
      dateOfReferral: "2022-07-12T16:19:21.4271586",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T14:17:50.2191646",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-14T14:19:28.520372",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jake Charlie Barnes",
      advisor: "Peter Hill",
      referralUser: "Karen Duke",
      id: 942,
      caseRef: "SAG795",
      referredById: 252,
      caseStatusId: 32,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "PLOT 83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FIRST TIME BUYER\n\nJake & Beth currently live separately at their parents house and this will be their first property together.   \n\n",
      dateOfReferral: "2022-07-13T09:02:33.1774331",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T09:06:48.3664311",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "sAGE",
      financialDetailsId: 422,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 50,
      lnhManagerId: 121,
    },
    {
      applicant: "Frances Strubel",
      advisor: "Matthew Laws",
      referralUser: "Imogen Bradley",
      id: 944,
      caseRef: "SAG796",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 380000,
      plotNumber: "B10710",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "13/07/22 - Taken by Matthew Laws for qualifying \n                - Voicemail left\n15/07/22 - Voicemail left and email sent\n\n***Cash Buyer***",
      dateOfReferral: "2022-07-13T09:27:38.888091",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T13:42:49.1114767",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 100000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 443,
      closedDate: "2022-08-16T13:44:24.8541798",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Samantha Ward",
      advisor: "Laura Turner",
      referralUser: "Steven Merralls",
      id: 947,
      caseRef: "SAG797",
      referredById: 243,
      caseStatusId: 27,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "79,81,82,83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works for the nhs\nLives close to the site the lees Ashford",
      dateOfReferral: "2022-07-13T09:39:58.7927116",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T07:48:04.4537133",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Hima Allada",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 948,
      caseRef: "SAG798",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Not a FTB; sadly going through divorce, was on a joint mortgage and now looking for herself. \n\nI have a sneaking suspicion that she will no longer own it, following the divorce. \n\nIncome: £43k per year\n\nJust herself buying\n\n",
      dateOfReferral: "2022-07-13T09:40:26.7532187",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T09:44:33.2878736",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-18T10:19:27.0746814",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lee Hames",
      advisor: "Arjun Dhunna",
      referralUser: "Imogen Bradley",
      id: 950,
      caseRef: "SAG799",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 480000,
      plotNumber: "B10708",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T10:04:14.0849751",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T10:09:55.8906633",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 150000,
      serviceCharge: 220.96,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-03T14:52:43.7676947",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Iva Petrova",
      advisor: "Arjun Dhunna",
      referralUser: "Imogen Bradley",
      id: 952,
      caseRef: "SAG800",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 370000,
      plotNumber: "B10710",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T10:19:47.8229134",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T10:31:25.2815436",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 171.34,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-26T11:14:09.0749327",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Amy Harris",
      advisor: "Matthew Laws",
      referralUser: "Dominka Zych",
      id: 953,
      caseRef: "SAG801",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 185000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T10:33:07.8959265",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T10:35:19.710334",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-14T15:03:59.2761354",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Roshana Dodhy",
      advisor: "Charlotte Fay",
      referralUser: "Karen Duke",
      id: 955,
      caseRef: "SAG802",
      referredById: 252,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "PLOT 84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "WANTS TO MOVE TO MAIDSTONE TO BE CLOSE TO FAMILY\n\n3 children - ages 21, 20 and 8. Eldest has just graduated from university in Law. 20 year old just completed first year of university, studying criminology. ",
      dateOfReferral: "2022-07-13T10:46:31.1281342",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T13:49:19.1262063",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 800,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 424,
      closedDate: "2022-07-15T08:24:41.3732366",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Eloi Lee",
      advisor: "Arjun Dhunna",
      referralUser: "Abhishek Joshi",
      id: 956,
      caseRef: "SAG803",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nDep: £5000\nIncome: £20,000\n\nSadly being taken out of her current place, and needs to find something a little more permanent, may think about an equity release from parents' property to help her buy her own place.\n\nDoes not want a Section 21 served against her, needs something more permanent, has children - I think 2 or 3?",
      dateOfReferral: "2022-07-13T10:49:27.9525764",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T11:13:10.7377462",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-21T15:38:58.0033681",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Timothy Ishaku",
      advisor: "Peter Hill",
      referralUser: "Andrew Gibbs",
      id: 959,
      caseRef: "SAG804",
      referredById: 327,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 370000,
      plotNumber: "967",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Plot 967 Longford Park (Correct development)\n£30,000 deposit\nHad AIP before but it's expired.\n\n13/07/22 - Taken by Matthew Laws for qualifying\n                - VM left\n\nTried 3 times and left VM and email to call me when he can.",
      dateOfReferral: "2022-07-13T12:41:33.1145478",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T09:25:43.319606",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 25,
      minPercShareAvailable: "40",
      housingAssociation: null,
      financialDetailsId: 423,
      closedDate: "2022-07-27T14:40:30.8551999",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 124,
    },
    {
      applicant: "Navrita Sidhu",
      advisor: "Matthew Laws",
      referralUser: "Daisie Naughton",
      id: 961,
      caseRef: "SAG805",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 36500,
      plotNumber: "B1.02.01",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T12:58:55.3074763",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T13:01:40.9582622",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 171.87,
      minPercShareAvailable: "25%",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-13T13:54:31.8377589",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Mark Bernard",
      advisor: "Ravneet Sokhi",
      referralUser: "Abhishek Joshi",
      id: 962,
      caseRef: "SAG806",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Income: £22,512\nDeposit: £5k\nInterested in 2 bed apartments with parking\n\n20.7.22- Didn't qualify but i sent an email with my details in case he would like to use JM going forward- RS",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T15:09:21.6720479",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-20T15:11:18.5619017",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Tushar Shantilal",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 964,
      caseRef: "SAG807",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nDep: £25,000\nIncome: £30,000\nMum's Income: £24,000\nHim & Mum will buying and she will be living in the property with him.",
      dateOfReferral: "2022-07-13T13:55:01.6754915",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T14:01:03.6251147",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-19T08:01:54.2939379",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Pavithra Wickramasinghe",
      advisor: "Matthew Laws",
      referralUser: "Jas Sagoo",
      id: 968,
      caseRef: "SAG808",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "2 flat \nparking\ndeposit 18k\nincome 36 = partner 8500\n\n13/07/22 - Taken by Matthew Laws for qualifying \n                - Voicemail left \n15/07/22 - Voicemail left and email sent",
      dateOfReferral: "2022-07-13T14:33:47.7197964",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T10:13:03.2741415",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 18000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-19T09:34:36.1306324",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Imani Kolaru",
      advisor: "Matthew Laws",
      referralUser: "Daisie Naughton",
      id: 972,
      caseRef: "SAG809",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "B1.03.03",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "13/07/22 - Taken by Matthew for Qualifying\n14/07/22 - Busy at work calling back at 1800\n                - Voicemail left\n15/07/22 - Voicemail left \n19/07/22 - Voicemail left and email sent \n\n** Max calls reached**\n\n",
      dateOfReferral: "2022-07-13T15:01:45.1935674",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T13:47:11.6436159",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 225,
      minPercShareAvailable: "25%",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-27T10:18:17.5851472",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Rafiqul Selim Begum",
      advisor: "Adam Faulkner",
      referralUser: "Jas Sagoo",
      id: 974,
      caseRef: "SAG810",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T15:27:57.7173651",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T10:18:39.1720325",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 40,
      depositLevel: 16000,
      serviceCharge: 141.32,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-28T09:44:17.4591126",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Mark Shemilt",
      advisor: "Matthew Laws",
      referralUser: "Ryan Cheetham",
      id: 976,
      caseRef: "SAG811",
      referredById: 228,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "101",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Hi, Has Mark been spoken with ?",
      dateOfReferral: "2022-07-13T15:38:28.3036637",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T13:52:42.322167",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 462,
      closedDate: "2022-07-21T13:53:26.3137344",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Cassandra Hawthorne",
      advisor: "Arjun Dhunna",
      referralUser: "Abhishek Joshi",
      id: 977,
      caseRef: "SAG812",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 92500,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "2 bed no parking\nDep: £60K\nIncome: £30k\n\nPlease call between 1-2pm or after 4pm.\n\n",
      dateOfReferral: "2022-07-13T15:53:54.8346257",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T16:53:08.7570631",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 141.34,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-08T12:48:05.9681581",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Robyn Godfrey",
      advisor: "Rachel Davies",
      referralUser: "Daisie Naughton",
      id: 980,
      caseRef: "SAG813",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "B1.03.04",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-13T16:29:58.5434309",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-13T16:53:55.8317264",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 873,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-11T09:37:32.1493496",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Roisin Alice Concannon",
      advisor: "Zeeshan Ashraf",
      referralUser: "Katie Rigden",
      id: 986,
      caseRef: "SAG814",
      referredById: 244,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB",
      dateOfReferral: "2022-07-14T09:36:11.7192341",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T06:19:24.3957006",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 429,
      closedDate: "2022-07-25T07:16:59.728491",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Dominic Singun",
      advisor: "Adam Faulkner",
      referralUser: "Elle Halls",
      id: 987,
      caseRef: "SAG815",
      referredById: 147,
      caseStatusId: 27,
      developmentId: 27,
      purchasePrice: 157500,
      plotNumber: "7,8,9,10",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Not Oak Farm Meadow, it is the Long melford site",
      dateOfReferral: "2022-07-14T09:43:10.7424454",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T11:53:08.7147553",
      isDeleted: 1,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 14000,
      serviceCharge: 48,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Caitlin Ann Stephens",
      advisor: "Zeeshan Ashraf",
      referralUser: "Elle Halls",
      id: 990,
      caseRef: "SAG816",
      referredById: 147,
      caseStatusId: 27,
      developmentId: 27,
      purchasePrice: 250000,
      plotNumber: "",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "not oak farm, long Melford site. Needs to discuss affordability. Moving in with parents to save up money to have things for new house. \n\nCaitlin had her own baking business but has gone to full time employment now in order to be able to afford a house together.",
      dateOfReferral: "2022-07-14T09:57:28.2680408",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T06:40:29.0010813",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "tbc",
      housingAssociation: "sage",
      financialDetailsId: 432,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Ioannis  Spanos",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 991,
      caseRef: "SAG817",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 380000,
      plotNumber: "B1.07.02",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Would like a 2 bedroom but if he doesn't qualify would be interested in a 1 bedroom.\nIf you send me and email I can send over both the price list for 1 & 2 bedrooms.",
      dateOfReferral: "2022-07-14T10:05:44.5640326",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T13:27:02.5673044",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 427,
      closedDate: "2022-08-19T08:15:37.2478185",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "K Chin",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 997,
      caseRef: "SAG818",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 510000,
      plotNumber: "b1.07.08",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "The property FMV is 480k but because he is looking to purchase parking as well comes at an extra cost of 30k \n\nUnable to get hold of. ",
      dateOfReferral: "2022-07-14T11:17:58.2734839",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T08:39:36.6279248",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 250000,
      serviceCharge: 1042.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-20T08:40:24.686654",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Ben O'reilly",
      advisor: "Arjun Dhunna",
      referralUser: "Cassie Tovell",
      id: 998,
      caseRef: "SAG819",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 220000,
      plotNumber: "214",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-14T11:27:50.5490404",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T11:35:04.0717681",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 5500,
      serviceCharge: null,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T08:50:31.8420489",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "K Chin",
      advisor: "Matthew Laws",
      referralUser: "Daisie Naughton",
      id: 999,
      caseRef: "SAG820",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 465000,
      plotNumber: "B1.07.06",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Same lead with Charlotte Fay\nDaisie made aware.",
      dateOfReferral: "2022-07-14T11:43:26.9740416",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T09:37:40.2535546",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 300000,
      serviceCharge: 790,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-15T09:40:23.7366292",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "megan hawkes",
      advisor: "Matthew Laws",
      referralUser: "Matthew Prentice ",
      id: 1000,
      caseRef: "SAG821",
      referredById: 309,
      caseStatusId: 65,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "99",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If Megan fails on 25% can you let me know what percentage she would pass on or what price home she can afford please? Sage are looking at other options for those that fail.\nIt would be handy to have the HCA calculator emailed to me as well as Sage keep asking to see them!\nThanks\nMatt\n\n14/07/22 - Taken by Matthew Laws for qualifying \n                - Voicemail left ",
      dateOfReferral: "2022-07-14T11:46:43.5295289",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T09:59:50.7504297",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 433,
      closedDate: "2022-07-15T10:03:52.7423446",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Veronica Florentina Groza ",
      advisor: "Medihya Akram",
      referralUser: "Daisie Naughton",
      id: 1001,
      caseRef: "SAG822",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 445000,
      plotNumber: "B10203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Herself, her husband and son are all employed ",
      dateOfReferral: "2022-07-14T11:52:56.1659411",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T12:13:44.787232",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 763,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-05T14:57:36.2031192",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Caroline Walker",
      advisor: "Medihya Akram",
      referralUser: "Imogen Bradley",
      id: 1002,
      caseRef: "SAG823",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 400000,
      plotNumber: "B10204",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-14T11:57:51.2872899",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T12:16:05.9687394",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-05T14:34:49.5632426",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Sashon Leacock",
      advisor: "Charlotte Innes",
      referralUser: "Abhishek Joshi",
      id: 1003,
      caseRef: "SAG824",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Dep: £5k\nIncome: £15k\n2 bed flat w/ parking\nPlease do feel free to call today; seemed quite interested.. ",
      dateOfReferral: "2022-07-14T12:00:35.5541026",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T11:43:30.9628926",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-15T11:53:37.991983",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Kirsty Watson",
      advisor: "Charlotte Innes",
      referralUser: "Sam Bowyer",
      id: 1004,
      caseRef: "SAG825",
      referredById: 28,
      caseStatusId: 32,
      developmentId: 41,
      purchasePrice: 300000,
      plotNumber: "158",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has an AIP up to £200k, been looking for a year.\n\nPicked up by Charlotte Innes 13:40 on 14/07/2022.\n\nClient qualifies for a 40% share.  Sam Bowyer has said this is fine.  Client will send her documents.\n\nBasic salary is £40,000 + £4500 car allowance.  Then based on last 3 months her average commission is £13,687.  This is paid to her as a monthly bonus.  Calculator done with Kent reliance.",
      dateOfReferral: "2022-07-14T12:31:42.5593845",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T08:04:20.2268581",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 55,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 428,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 50,
      lnhManagerId: 28,
    },
    {
      applicant: "Taylor Lengden",
      advisor: "Charlotte Fay",
      referralUser: "Lewis Ward",
      id: 1005,
      caseRef: "SAG826",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 117500,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Taylor is part time 30 hrs a week\n",
      dateOfReferral: "2022-07-14T12:44:51.9856638",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T12:51:11.9444342",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "45%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-18T10:09:02.760223",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Esther kelechi Azubike",
      advisor: "Baldev Dhanda",
      referralUser: "Baldev Dhanda",
      id: 1006,
      caseRef: "SAG827",
      referredById: 75,
      caseStatusId: 28,
      developmentId: 30,
      purchasePrice: 0,
      plotNumber: "Unknown",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-14T13:04:19.9635875",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T09:17:56.3391",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 0,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Mathew William brown",
      advisor: "Peter Hill",
      referralUser: "Steven Field",
      id: 1008,
      caseRef: "SAG828",
      referredById: 302,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 153000,
      plotNumber: "19 & 31",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Mat is in the army, earns £48,000 PA\n\nTried 5 calls and 3 emails\n\nClosed for now but will open up if Matthew reaches out.",
      dateOfReferral: "2022-07-14T13:16:09.4053805",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T14:33:40.6130467",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 430,
      minPercShareAvailable: "45",
      housingAssociation: "Paradigm",
      financialDetailsId: null,
      closedDate: "2022-07-21T14:34:14.0283671",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Jodie Lawrence",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 1009,
      caseRef: "SAG829",
      referredById: 235,
      caseStatusId: 25,
      developmentId: 46,
      purchasePrice: 232500,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in 2 bed - looking to buy it herself\n\n14/07/22 - Taken by Matthew Laws for qualifying \n                - Call booked for 1815",
      dateOfReferral: "2022-07-14T13:16:39.5273434",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T17:34:37.4462082",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 5500,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-14T17:31:50.0056754",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Laura Murphy",
      advisor: "Rachel Davies",
      referralUser: "Jas Sagoo",
      id: 1010,
      caseRef: "SAG830",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 385000,
      plotNumber: "43",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "income 33 k\nif it does not fit their is flexibility on price up to 5 %",
      dateOfReferral: "2022-07-14T13:19:30.9381569",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-14T13:52:26.8907725",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 13000,
      serviceCharge: 149.64,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-17T15:03:36.5240252",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Emily West",
      advisor: "Nadia Bandula ",
      referralUser: "Katie Rigden",
      id: 1013,
      caseRef: "SAG831",
      referredById: 244,
      caseStatusId: 28,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "79,81,82,83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Going through a separation- property on market and will be taking the proceeds for deposit",
      dateOfReferral: "2022-07-14T13:52:56.1565529",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T14:52:03.6731681",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Elise Wheatley",
      advisor: "Zeeshan Ashraf",
      referralUser: "Jas Sagoo",
      id: 1014,
      caseRef: "SAG832",
      referredById: 299,
      caseStatusId: 28,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "if it does fit affordability , the asking price can be reduced up to 5%",
      dateOfReferral: "2022-07-14T13:59:08.6178664",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T16:14:24.7936964",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 430,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Karl Bardsley",
      advisor: "Nadia Bandula ",
      referralUser: "Steven Field",
      id: 1018,
      caseRef: "SAG833",
      referredById: 302,
      caseStatusId: 32,
      developmentId: 27,
      purchasePrice: 153000,
      plotNumber: "19 or 31",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "in military, criteria for site wavered\n\n14/07/22 - Taken by Matthew Laws for qualifying \n15/07/22 - Voicemail left ",
      dateOfReferral: "2022-07-14T16:50:26.0032451",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T13:03:34.8062141",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 430,
      minPercShareAvailable: "45",
      housingAssociation: "paradigm",
      financialDetailsId: 438,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 48,
      lnhManagerId: 107,
    },
    {
      applicant: "Tony Chohan",
      advisor: "Nadia Bandula ",
      referralUser: "Cassie Tovell",
      id: 1021,
      caseRef: "SAG834",
      referredById: 373,
      caseStatusId: 32,
      developmentId: 69,
      purchasePrice: 470000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Tony & Deanna have one child who would be living in the property with them. Tony also has 2 children from a previous relationship, all under 17.",
      dateOfReferral: "2022-07-15T08:54:37.3657558",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T10:40:24.4078008",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 435,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Victoria Hooton",
      advisor: "Peter Hill",
      referralUser: "Boyd Kelly",
      id: 1023,
      caseRef: "SAG835",
      referredById: 172,
      caseStatusId: 65,
      developmentId: 25,
      purchasePrice: 160000,
      plotNumber: "288",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Hi Guys,\n\nVikki is a vendor of ours - so please can we get on this asap and look after her as best we can :)\n\nthank you,\nBoyd ",
      dateOfReferral: "2022-07-15T09:06:34.6679222",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T11:56:32.2909324",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 600,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: 434,
      closedDate: "2022-07-19T15:26:25.8163776",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "ROBERT MCGAVIN",
      advisor: "Adam Davis",
      referralUser: "Joe Evans",
      id: 1026,
      caseRef: "SAG836",
      referredById: 35,
      caseStatusId: 32,
      developmentId: 23,
      purchasePrice: 180000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT NEW BUILD LEAD - JUST NORMAL FS FIRST APPOINTMENT PLEASE - Currently in forces accommodation - looking to buy house in stafford for his partner to live in as he will be going to colchester soon with army. she works at aston marina and her parents live in burntwood. stafford is furthest north they want to go. looking for large 2 bed thru to 4 bed house upto £180k max. spoken to own bank (HSBC) for mortgage,booked for JM. PLEASE CALL IN NEXT 24 HOURS. JE",
      dateOfReferral: "2022-07-15T10:21:49.742744",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T14:34:32.7287594",
      isDeleted: 0,
      advisorId: 80,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ayola Beckford",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 1027,
      caseRef: "SAG837",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "155",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Interested in 3 bed",
      dateOfReferral: "2022-07-15T10:40:32.7140322",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T13:14:46.3344075",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 437,
      closedDate: "2022-07-15T13:16:43.6910223",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Valentina Petri",
      advisor: "Charlotte Fay",
      referralUser: "Gareth Harmer",
      id: 1028,
      caseRef: "SAG838",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "£15k deposit\n£53k joint income\nCurrently in rented accommodation\n\nMinimum 50% share on £395,000 = £197,500",
      dateOfReferral: "2022-07-15T10:48:27.5731291",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T11:29:12.8189825",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-18T13:10:36.5660162",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Ebony Mills ",
      advisor: "Aidan Pearce ",
      referralUser: "Charlotte Smith",
      id: 1029,
      caseRef: "SAG839",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-15T11:26:59.3603699",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T11:37:12.9243609",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 75,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-07-29T11:17:18.5958153",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Shaun Hughes",
      advisor: "Laura Turner",
      referralUser: "Sam Bowyer",
      id: 1030,
      caseRef: "SAG840",
      referredById: 28,
      caseStatusId: 26,
      developmentId: 41,
      purchasePrice: 300000,
      plotNumber: "158",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-15T11:32:04.4627556",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T11:37:16.2422113",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 11500,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Rob Lyons",
      advisor: "Aidan Pearce ",
      referralUser: "Sam Bowyer",
      id: 1031,
      caseRef: "SAG841",
      referredById: 28,
      caseStatusId: 27,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Please call after 5pm",
      dateOfReferral: "2022-07-15T11:40:26.5281854",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T15:49:31.0055987",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 55,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ana Ortigosa",
      advisor: "Matthew Laws",
      referralUser: "Gareth Harmer",
      id: 1034,
      caseRef: "SAG842",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 197500,
      plotNumber: "84",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently in rented\n5% deposit\nmin 50% share on this site full market value £395k = £197,500\n\n15/07/22 - Taken by Matthew Laws for qualifying\n                - No answer, email sent\n19/07/22 - No answer ",
      dateOfReferral: "2022-07-15T12:13:58.0921601",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T10:39:58.4894674",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 80,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 454,
      closedDate: "2022-07-20T10:42:01.3036772",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Florin Ghimici",
      advisor: "Steven Sanderson",
      referralUser: "Ali Abbas",
      id: 1037,
      caseRef: "SAG843",
      referredById: 312,
      caseStatusId: 28,
      developmentId: 38,
      purchasePrice: 370000,
      plotNumber: "b1.03.01",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "15/07/22 - Taken by Matthew Laws for qualifying \n      ",
      dateOfReferral: "2022-07-15T14:15:00.1103313",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T10:10:38.1079469",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 807.87,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 441,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jozsef Hasznosi",
      advisor: "Charlotte Fay",
      referralUser: "Praveena Sharma",
      id: 1038,
      caseRef: "SAG844",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "2 Bed \nhas 10% deposit available. ",
      dateOfReferral: "2022-07-15T14:33:34.2643736",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T15:08:46.5745538",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 10002,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-20T09:54:42.7638385",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jade Gamage ",
      advisor: "Charlotte Fay",
      referralUser: "Cassie Tovell",
      id: 1039,
      caseRef: "SAG845",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "partner is self-employed \nJade not working as on maternity leave\n\nOn one persons income \nI have a number of plots available \n\nIdeally a three bedroom £450,000 maximum\n \nI have other cheaper plots that could be offered. \n\nService charge is a rough estimate as i dont have the correct figures. \n\nLook at max affordability. ",
      dateOfReferral: "2022-07-15T15:07:03.0747672",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T08:18:11.3047271",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 472,
      closedDate: "2022-07-25T08:20:07.9011001",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Darshika Relwani",
      advisor: "Arjun Dhunna",
      referralUser: "Ali Abbas",
      id: 1040,
      caseRef: "SAG846",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 465000,
      plotNumber: "b1.04.09",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-15T15:20:24.0724674",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T15:25:09.3663704",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 27000,
      serviceCharge: 1016,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-08T12:53:54.6784918",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Rea Bexheti",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 1043,
      caseRef: "SAG847",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 447500,
      plotNumber: "b1.03.06",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking for a 2 bedroom, if she's not qualified would go for a 1 bedroom. So if you send me an email I can send your price list for both of them.",
      dateOfReferral: "2022-07-15T16:30:21.9619468",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-15T16:35:15.2053603",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-18T15:14:01.7833558",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Max Dale",
      advisor: "Nadia Bandula ",
      referralUser: "Elle Halls",
      id: 1047,
      caseRef: "SAG848",
      referredById: 147,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 130000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "not oak farm, Long Melford site. Has a mortgage advisor however nothing written up. Interested in the plots and his affordability. ",
      dateOfReferral: "2022-07-16T10:01:34.3360525",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-16T11:27:52.6917116",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 29000,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-18T15:43:52.5788743",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Ashna Mathur",
      advisor: "Nadia Bandula ",
      referralUser: "Ali Abbas",
      id: 1049,
      caseRef: "SAG849",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "b1.03.04",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-18T07:57:14.5848816",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T15:08:00.5032028",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-18T15:45:19.8070955",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Belinda King",
      advisor: "Steven Sanderson",
      referralUser: "Katie Rigden",
      id: 1050,
      caseRef: "SAG850",
      referredById: 244,
      caseStatusId: 26,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79,81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "needs a deposit of 14k to buy a 25% share - she will speak to her family about seeing if this is available as she has 10k at the min. \n\nonly available to buy 25% with her eligibility so will see is sage will allow her to buy as low as 25% or it will be a no go. ",
      dateOfReferral: "2022-07-18T08:25:53.2660558",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T09:50:29.2588531",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 80,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 467,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Karena Kyriacou",
      advisor: "Peter Hill",
      referralUser: "Katie Rigden",
      id: 1051,
      caseRef: "SAG851",
      referredById: 244,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 240000,
      plotNumber: "79,81,82,83",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First time buyer\n\nPeter Hill qualified\n\nKarena just emailed:\nI’m sorry for the radio silence! I was having a think about how to proceed as my situation has slightly changed so I think I might put a pin in the house hunt process for now until I’m more certain.\n\nSorry for not updating you sooner!\n\n\n",
      dateOfReferral: "2022-07-18T08:47:34.3817344",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T12:32:15.571704",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 80,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 444,
      closedDate: "2022-07-22T12:34:26.6240074",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Elizabeth barker",
      advisor: "Fiona Wilson",
      referralUser: "Praveena Sharma",
      id: 1052,
      caseRef: "SAG852",
      referredById: 235,
      caseStatusId: 27,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She's currently living in a shared ownership property. She is looking to sell her share before purchasing a new one. \n\nInterested 3 but two bed wouldn't be a problem as its cheaper",
      dateOfReferral: "2022-07-18T08:53:06.0765128",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T07:40:58.5518209",
      isDeleted: 0,
      advisorId: 86,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jenny Williams",
      advisor: "Charlotte Fay",
      referralUser: "Praveena Sharma",
      id: 1053,
      caseRef: "SAG853",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Interested in 2 or 3 bed",
      dateOfReferral: "2022-07-18T09:19:31.4675293",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T09:22:20.6075269",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-20T17:53:22.6947281",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Miss Rumbidzai Matambo ",
      advisor: "Aaron Heer",
      referralUser: "Praveena Sharma",
      id: 1057,
      caseRef: "SAG854",
      referredById: 235,
      caseStatusId: 28,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Min 2 bed",
      dateOfReferral: "2022-07-18T10:26:04.7755851",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T16:20:39.9524884",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 466,
      closedDate: "2022-07-21T15:03:23.4465447",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Joanna Helen Jarvis",
      advisor: "Matthew Laws",
      referralUser: "Matthew Prentice ",
      id: 1061,
      caseRef: "SAG855",
      referredById: 309,
      caseStatusId: 27,
      developmentId: 37,
      purchasePrice: 345000,
      plotNumber: "99",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Joanna is hopeful of buying the 25% share and then renting from sage - she is retired and has pensions - her husband passed  away earlier this year. If Joanna cant purchase the 25% please let me know at what percentage or what price she can afford as Sage are considering options...",
      dateOfReferral: "2022-07-18T11:04:01.5839253",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T17:06:19.5993992",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 86250,
      serviceCharge: 65,
      minPercShareAvailable: "25",
      housingAssociation: "sag",
      financialDetailsId: 447,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 110,
    },
    {
      applicant: "Ketan ambasana",
      advisor: "Aaron Heer",
      referralUser: "Jas Sagoo",
      id: 1068,
      caseRef: "SAG856",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-18T12:20:14.8772718",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T15:06:03.3779334",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "SAGE ",
      financialDetailsId: 445,
      closedDate: "2022-07-29T09:53:00.7391259",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sadia Shirzad",
      advisor: "Matthew Laws",
      referralUser: "Imogen Bradley",
      id: 1075,
      caseRef: "SAG857",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 382500,
      plotNumber: "B10703",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "18/07/22 - Taken by Matthew for qualifying \n                - The number is for her brother who is trying anyway possible to get her a mortgage. Sadia doesn't qualify on her own. She has her partner coming over in 3 months but he has no work confirmed for when he does. Her brother is now trying to find someone else to go on the mortgage with her to meet affordability. ",
      dateOfReferral: "2022-07-18T13:25:55.9834093",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-18T16:14:00.35474",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 225.95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T09:55:45.0238854",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "DENIS RONALDO TRAVASSO",
      advisor: "Steven Sanderson",
      referralUser: "Emilio Williams",
      id: 1077,
      caseRef: "SAG858",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 420000,
      plotNumber: "75",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "PREFERS A CALL AFTER 6PM",
      dateOfReferral: "2022-07-18T14:09:42.8186713",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T10:48:05.4049753",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 13000,
      serviceCharge: 156.23,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing ",
      financialDetailsId: 498,
      closedDate: "2022-07-28T10:50:28.7540074",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Bethany Potts",
      advisor: "Charlotte Innes",
      referralUser: "Sam Bowyer",
      id: 1091,
      caseRef: "SAG859",
      referredById: 28,
      caseStatusId: 27,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "80",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Due to complete on hers on 28th July, moving back in with parents in the interim. Please call anytime on 19/7, thank you!",
      dateOfReferral: "2022-07-19T08:31:17.3279489",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T11:43:03.1909658",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 17500,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 455,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Gayle Fernandez ",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 1096,
      caseRef: "SAG860",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-19T09:53:08.9295886",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T14:38:38.6738967",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T14:36:09.2952221",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Gbubemi Obioru",
      advisor: "Laura Turner",
      referralUser: "Kirsty Nunn",
      id: 1097,
      caseRef: "SAG861",
      referredById: 249,
      caseStatusId: 26,
      developmentId: 171,
      purchasePrice: 525000,
      plotNumber: "Unit 3",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-07-19T09:55:33.4282481",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T10:14:36.4594832",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 52500,
      serviceCharge: 300,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 118,
    },
    {
      applicant: "Mufarrah Sikander",
      advisor: "Ravneet Sokhi",
      referralUser: "Abhishek Joshi",
      id: 1103,
      caseRef: "SAG862",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "2 bed/ w parking\nIncome: £55k combined\nDep: £5k \nHerself plus partner",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T10:06:21.3535332",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-29T09:31:29.4733308",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Faye Nicholls",
      advisor: "Simon Dyer",
      referralUser: "Johnathan Bone ",
      id: 1104,
      caseRef: "SAG863",
      referredById: 399,
      caseStatusId: 65,
      developmentId: 171,
      purchasePrice: 545000,
      plotNumber: "Unit 1",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Sold subject to contract\nWill move in with father until she can purchase\nHas MIP of 452,000 and equity from sale 148,000\n\nSpoke to her and she said they have a mortgage advisor but happy to talk, just need to find a lender that will be able to use her husbands bonus. Simon Dyer 20/07/22  10:55\n\nSpoke to Faye again today, she had already done a DIP last week and doesn't want to do anymore at the moment, will keep in touch as may come back once offer has been accepted. 21/07 13:15",
      dateOfReferral: "2022-07-19T12:21:01.8727092",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T13:01:28.6802369",
      isDeleted: 0,
      advisorId: 99,
      propertyStatusId: 39,
      depositLevel: 148000,
      serviceCharge: 300,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-25T07:28:00.2045836",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 118,
    },
    {
      applicant: "Tudor Marculesdu",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 1105,
      caseRef: "SAG864",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b1.05.09",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "They are also interested in getting parking with the apartment and they are an extra 30k, which is not included in the price.\n\n",
      dateOfReferral: "2022-07-19T12:45:30.3908302",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T22:29:40.4059819",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 449,
      closedDate: "2022-07-21T22:36:25.626956",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jilna Solanki",
      advisor: "Matthew Laws",
      referralUser: "Imogen Bradley",
      id: 1109,
      caseRef: "SAG865",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 472500,
      plotNumber: "b10607",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-19T13:13:02.2773653",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T13:14:45.0433192",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 350000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-19T15:53:34.7453127",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jilna Solanki",
      advisor: "Matthew Laws",
      referralUser: "Imogen Bradley",
      id: 1110,
      caseRef: "SAG866",
      referredById: 301,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 472500,
      plotNumber: "b10607",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Cash buyer",
      dateOfReferral: "2022-07-19T13:16:01.1675859",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T15:51:15.857865",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 354375,
      serviceCharge: 217.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 450,
      closedDate: "2022-08-16T13:48:02.7212204",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Joseph Poole",
      advisor: "Laura Turner",
      referralUser: "Praveena Sharma",
      id: 1112,
      caseRef: "SAG867",
      referredById: 235,
      caseStatusId: 78,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "2 or 3 depending on the affordability \n\n19/07/22 - Taken by Matthew Laws for qualifying\n                \n",
      dateOfReferral: "2022-07-19T14:20:38.0789417",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T13:52:40.9560402",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 451,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 28,
    },
    {
      applicant: "Lauren Roberts",
      advisor: "Matthew Laws",
      referralUser: "Paul Roscoe",
      id: 1116,
      caseRef: "SAG868",
      referredById: 224,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 94000,
      plotNumber: "TBC",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She has seen our site being advertised but was limited on deposit, now a smaller share can be bought she may be eligible.\n\n19/07/22 - Taken by Matthew Laws for qualifying \n20/07/22 - Left VM\n",
      dateOfReferral: "2022-07-19T15:52:51.8826548",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T09:27:48.3222658",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 3000,
      serviceCharge: 0,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-22T09:44:14.2443012",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Hayley Deacon",
      advisor: "Matthew Laws",
      referralUser: "Jamie Bodle",
      id: 1117,
      caseRef: "SAG869",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "38",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "May want to look at a 3 bedroom house at £320,000 FMV - But not sure on affordability for one of these.\n\n19/07/22 - Taken by Matthew Laws for qualifying \n20/07/22 - Doesn't qualify for 40% confirming if there is a possibility of dropping to 35%",
      dateOfReferral: "2022-07-19T16:30:19.7818088",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T13:23:38.7905113",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 456,
      closedDate: "2022-07-20T13:24:25.0358001",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Sophie Tyrrell",
      advisor: "Medihya Akram",
      referralUser: "Jamie Bodle",
      id: 1118,
      caseRef: "SAG870",
      referredById: 111,
      caseStatusId: 26,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "36",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - Wants to also know if will qualify for 3 bed @ £320,000 FMV",
      dateOfReferral: "2022-07-19T17:13:53.7850163",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-19T18:19:38.7729723",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Alev Shevki",
      advisor: "Matthew Laws",
      referralUser: "Josh Taylor",
      id: 1126,
      caseRef: "SAG871",
      referredById: 114,
      caseStatusId: 26,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Hi Alev has already seen JMNB for qualification on a Sage property. A HCA was produced however she used her own mortgage advisor. Now her mortgage advisor is saying he can't find a suitable lender so can someone get in touch and see what we do for Alev?",
      dateOfReferral: "2022-07-20T10:35:40.2155837",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T10:42:27.54913",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 750,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 114,
    },
    {
      applicant: "Victoria Speers",
      advisor: "Charlotte Fay",
      referralUser: "Dominka Zych",
      id: 1128,
      caseRef: "SAG872",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 1850000,
      plotNumber:
        "82 Morpheth Crescent, Houghton Regis, Dunstable, Central Bedfordshire, LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-20T10:54:40.2091851",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T11:00:57.6596332",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 90000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-27T12:04:00.3016314",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: " Hayley Joanna Chick",
      advisor: "Aaron Heer",
      referralUser: "Cassie Tovell",
      id: 1129,
      caseRef: "SAG873",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "Plot 1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Partner is employed \n\nHayley self employed since April 2016 - has her tax returns - dont have her prediction for this current year. Has last 3 \n",
      dateOfReferral: "2022-07-20T11:09:33.8157162",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T10:19:27.2556476",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 16000,
      serviceCharge: 95,
      minPercShareAvailable: "50%",
      housingAssociation: null,
      financialDetailsId: 460,
      closedDate: "2022-08-15T13:18:45.3171467",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Tosin Adeniyi-Brown",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 1130,
      caseRef: "SAG874",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 370000,
      plotNumber: "B1.03.10",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Qualifies with 6% discount on FMV - 348,000",
      dateOfReferral: "2022-07-20T11:20:25.1758922",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T09:50:09.44544",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: 171.34,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 458,
      closedDate: "2022-08-18T07:51:25.9923072",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Mahamadou Sylla",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 1131,
      caseRef: "SAG875",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b1.05.09",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "also interested in parking which is an extra 30k, I have not added that to the property purchase price.\n\nPeter Hill Qualified.\n\nQualifies for 25% ownership, HCA sent to Ali",
      dateOfReferral: "2022-07-20T12:06:09.7103874",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T13:40:14.1407223",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Safina  Chandler",
      advisor: "Arjun Dhunna",
      referralUser: "Ali Abbas",
      id: 1133,
      caseRef: "SAG876",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b1.05.07",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "She is a key worker and works for NHS.",
      dateOfReferral: "2022-07-20T13:16:53.6963112",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-20T15:30:22.8419428",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 90000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 457,
      closedDate: "2022-07-28T14:32:41.9303445",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Jordan Waite",
      advisor: "Nadia Bandula ",
      referralUser: "Roger Jackson",
      id: 1134,
      caseRef: "SAG877",
      referredById: 351,
      caseStatusId: 27,
      developmentId: 37,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB. Had a MIP before covid. Has £10k deposit, family might be able to lend to help. ",
      dateOfReferral: "2022-07-20T13:55:29.4356904",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T10:32:33.4905572",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: 100000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Matt Lemon",
      advisor: "Peter Hill",
      referralUser: "Gareth Harmer",
      id: 1136,
      caseRef: "SAG878",
      referredById: 385,
      caseStatusId: 78,
      developmentId: 51,
      purchasePrice: 197500,
      plotNumber: "3 Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Three beds only\nFull price £395k 50% shre min = £197,500\n\nFirst HCA for 50%\n\nvery tight on lender affordability calculators at 50%, asking sage if it can go to 47% ",
      dateOfReferral: "2022-07-20T14:01:44.0690045",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T14:49:34.0927602",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 88,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 397,
      lnhManagerId: 121,
    },
    {
      applicant: "Ama Wiafe",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 1141,
      caseRef: "SAG879",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "B1.05.07",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Would qualify at a lower FMV - waiting for confirmation of discount from Ali. ",
      dateOfReferral: "2022-07-20T14:38:48.6145647",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T10:10:52.3839097",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 474,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Roxana Geana",
      advisor: "Jamie Bowley",
      referralUser: "Ali Abbas",
      id: 1142,
      caseRef: "SAG880",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 472500,
      plotNumber: "B1.06.09",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Will be joint application with herself and her partner who are both employed.\n\nWill be putting down a deposit of 5% \n\nAlso want parking which 30k extra and not included in the property price. ",
      dateOfReferral: "2022-07-20T14:59:04.947815",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T12:42:27.6678295",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 23625,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 459,
      closedDate: "2022-08-02T10:32:52.3702603",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Hannah Ibrahim",
      advisor: "Aaron Heer",
      referralUser: "Emily Balloch",
      id: 1143,
      caseRef: "SAG881",
      referredById: 64,
      caseStatusId: 26,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "unable to contact Hannah - made 3 attempts and email also sent",
      dateOfReferral: "2022-07-20T16:07:16.3794524",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T15:06:00.0966029",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Gavin Fennell",
      advisor: "Laura Turner",
      referralUser: "Emily Balloch",
      id: 1144,
      caseRef: "SAG882",
      referredById: 64,
      caseStatusId: 27,
      developmentId: 6,
      purchasePrice: 325000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-20T16:16:18.293131",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T07:43:28.3290948",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Ali Abusin",
      advisor: "Nadia Bandula ",
      referralUser: "Jamie Bodle",
      id: 1145,
      caseRef: "SAG883",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 45,
      purchasePrice: 275000,
      plotNumber: "36",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-20T17:08:53.9149453",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T16:29:26.9552966",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-26T14:20:08.3027922",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Tashi",
      advisor: "Peter Hill",
      referralUser: "Steven Field",
      id: 1147,
      caseRef: "SAG884",
      referredById: 302,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 153000,
      plotNumber: "19 or 31",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "THIS SITE IS OAK FARM DRIVE, MILCOMBE, not oak farm meadow Sage, but here is no listing in the pre set developments; employed and tax credits re children, spoke to Mortgage Light, who Tashi says confired his affordability. Basically 5K income, 19K tax credits, 80K deposit \n\nTried 3 times and left VM on 27/7\n\nWill email and update if i hear response",
      dateOfReferral: "2022-07-21T07:44:05.9256141",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T10:33:53.2221674",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 430.01,
      minPercShareAvailable: "45%",
      housingAssociation: "aradigm",
      financialDetailsId: null,
      closedDate: "2022-07-27T11:05:11.9790394",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Richard Humm",
      advisor: "Charlotte Innes",
      referralUser: "Gareth Harmer",
      id: 1151,
      caseRef: "SAG885",
      referredById: 385,
      caseStatusId: 27,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "3 Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "50% share on £395 = £197,500",
      dateOfReferral: "2022-07-21T08:57:02.6162678",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T17:43:05.5179839",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 88,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Sue Brindley",
      advisor: "Steven Sanderson",
      referralUser: "Roger Jackson",
      id: 1152,
      caseRef: "SAG886",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 200000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Sue is looking for mortgage advise first please. Please not, there is no onward purchase found. A MIP will be enough to start the search process ",
      dateOfReferral: "2022-07-21T09:05:04.6519632",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T09:05:39.4336626",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: -1,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-23T12:26:31.2824722",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Will Matthews ",
      advisor: "Aaron Heer",
      referralUser: "Jas Sagoo",
      id: 1154,
      caseRef: "SAG887",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T09:15:36.096381",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T09:02:03.4409696",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 478,
      closedDate: "2022-07-29T09:46:14.4831209",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Gemma Hare",
      advisor: "Peter Hill",
      referralUser: "Dominka Zych",
      id: 1156,
      caseRef: "SAG888",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "321 88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She has property previously , but her ex Partner bought it of her. She will be buying with her new partner and he will be FTB",
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T14:39:25.2100298",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 22500,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 463,
      closedDate: "2022-08-15T13:10:30.2114015",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Agata Karpinska",
      advisor: "Peter Hill",
      referralUser: "Dominka Zych",
      id: 1159,
      caseRef: "SAG889",
      referredById: 165,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "322 90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T10:00:09.4106169",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T09:26:51.771697",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Lorraine Gooch",
      advisor: "Ravneet Sokhi",
      referralUser: "Roger Jackson",
      id: 1160,
      caseRef: "SAG890",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "No onward purchase agreed. Will need a MIP please",
      dateOfReferral: "2022-07-21T10:03:06.175071",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T10:04:34.9582143",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-27T14:34:27.9231474",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Matthew Ellingham",
      advisor: "Ravneet Sokhi",
      referralUser: "Gareth Harmer",
      id: 1161,
      caseRef: "SAG891",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three bedrooms",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "395000 at 50% = £197500",
      dateOfReferral: "2022-07-21T10:03:57.9188165",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T10:05:21.3644808",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 88,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-27T14:44:12.0912541",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Shaheriyar Mohiuddin",
      advisor: "Jamie Bowley",
      referralUser: "Emilio Williams",
      id: 1162,
      caseRef: "SAG892",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 370000,
      plotNumber: "45",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T10:11:00.9344526",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T11:34:55.1851826",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 32000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing",
      financialDetailsId: 475,
      closedDate: "2022-07-26T16:25:02.4605314",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lara George",
      advisor: "Deonne Samuels",
      referralUser: "Gareth Harmer",
      id: 1163,
      caseRef: "SAG893",
      referredById: 385,
      caseStatusId: 26,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "3 Bedrooms",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FAP £395 at 50% share = £197,500",
      dateOfReferral: "2022-07-21T10:21:21.9162383",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T10:25:21.3973562",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Jade Lauren Barber",
      advisor: "Steven Sanderson",
      referralUser: "Steven Sanderson",
      id: 1165,
      caseRef: "SAG894",
      referredById: 57,
      caseStatusId: 28,
      developmentId: 30,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "RAF and spoke to jade about h2b and SO homes. she is now house hunting. ",
      dateOfReferral: "2022-07-21T10:46:51.1796319",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T11:27:44.9449651",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 17000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 461,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Malwina Cabanek",
      advisor: "Ian Parker",
      referralUser: "Dominka Zych",
      id: 1166,
      caseRef: "SAG895",
      referredById: 165,
      caseStatusId: 78,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "318 82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "21/07/22 - Taken by Matthew Laws for qualifying \n                - Waiting for confirmation of bonuses and O/T from pay slips. Should receive this tomorrow from Malwina. ",
      dateOfReferral: "2022-07-21T10:48:14.8568858",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T12:59:06.414349",
      isDeleted: 0,
      advisorId: 10,
      propertyStatusId: 39,
      depositLevel: 9000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 464,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 52,
      lnhManagerId: 162,
    },
    {
      applicant: "Nicola Andrews ",
      advisor: "Ravneet Sokhi",
      referralUser: "Corrina Davie",
      id: 1167,
      caseRef: "SAG896",
      referredById: 180,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "323",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T10:48:37.5066294",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T18:02:43.6544589",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T09:41:26.1110362",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Ben Weinberg",
      advisor: "Deonne Samuels",
      referralUser: "Dominka Zych",
      id: 1169,
      caseRef: "SAG897",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "318 82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T11:02:21.8407689",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T11:50:41.0996841",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-25T14:06:03.2430018",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Bartłomiej Stoklosa",
      advisor: "Charlotte Fay",
      referralUser: "Dominka Zych",
      id: 1171,
      caseRef: "SAG898",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "322 90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If he doesn't pick up please call his wife Katarzyna 07809633991\n\nOn hold until the end of August. ",
      dateOfReferral: "2022-07-21T11:26:49.6305894",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T11:14:54.7447789",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T13:59:14.5711625",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Chanel Charles ",
      advisor: "Deonne Samuels",
      referralUser: "Dominka Zych",
      id: 1172,
      caseRef: "SAG899",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "320 86 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T12:03:37.7704989",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T12:55:48.2262134",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-21T12:55:53.7042218",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Iga Bielawska",
      advisor: "Deonne Samuels",
      referralUser: "Ali Abbas",
      id: 1173,
      caseRef: "SAG900",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 455000,
      plotNumber: "B1.02.07",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T12:07:56.3055166",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T13:32:46.9273352",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Yelenny Francis Sherman",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 1177,
      caseRef: "SAG901",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Divorced - sadly, owned a property before, but not right now.\n\nNot a FTB\n\n£22K Income yearly\n£50k deposit",
      dateOfReferral: "2022-07-21T13:13:38.3932096",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T14:53:57.4497922",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 494,
      closedDate: "2022-07-27T15:12:59.9734328",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sophie Leslie ",
      advisor: "Arjun Dhunna",
      referralUser: "Charlotte Smith",
      id: 1179,
      caseRef: "SAG902",
      referredById: 305,
      caseStatusId: 28,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "Plot 511     15 Atchison Avenue, Norwich",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T14:21:16.6538221",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T11:46:18.0088514",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: 468,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Sarah Bird ",
      advisor: "Deonne Samuels",
      referralUser: "Charlotte Smith",
      id: 1180,
      caseRef: "SAG903",
      referredById: 305,
      caseStatusId: 26,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "Plot 511 , 11 Atchinson ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-21T14:23:31.8735189",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-21T14:25:53.237441",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Lewis Burcham",
      advisor: "Peter Hill",
      referralUser: "Elliot Piper",
      id: 1188,
      caseRef: "SAG904",
      referredById: 144,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 157500,
      plotNumber: "plot 7-12",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please note this is not for Oak Farm Meadow but actually Sky Lark Meadow Long Melford\n\n21/07/22 - Taken by Matthew Laws for qualifying \n22/07/22 - Completed qualifying call and now waiting on pay slips prior to sending through as qualified.\n\n\nLewis messaged to say going to pull out of the putchase.",
      dateOfReferral: "2022-07-21T16:47:25.7280836",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T08:03:57.5011919",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "25%",
      housingAssociation: "sage",
      financialDetailsId: 469,
      closedDate: "2022-07-27T09:47:14.0158828",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Alex Abel",
      advisor: "Jamie Bowley",
      referralUser: "Ryan Cheetham",
      id: 1189,
      caseRef: "SAG905",
      referredById: 228,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "PLEASE CONTACT TODAY IF POSS - AFTER 2pm would be great",
      dateOfReferral: "2022-07-22T07:53:37.8320351",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T07:56:15.7042353",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-27T09:26:14.1961986",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Chloe Waterhouse",
      advisor: "Charlotte Fay",
      referralUser: "Elle Halls",
      id: 1192,
      caseRef: "SAG906",
      referredById: 147,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 120000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Wanting to be qualified for anything that may come up in Stowmarket shared ownership wise. Has spoken to a couple advisers previously.\n£120,000 borrow\n15% deposit\nneeds confirming,. ",
      dateOfReferral: "2022-07-22T08:41:30.192379",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T08:43:22.8619572",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: null,
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-07-27T15:52:54.2132916",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Anita Gonsalves",
      advisor: "Peter Hill",
      referralUser: "Emilio Williams",
      id: 1194,
      caseRef: "SAG907",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-22T08:55:45.7527708",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T08:58:21.4013238",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sAGE",
      financialDetailsId: null,
      closedDate: "2022-07-25T15:30:12.2710274",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Maria Riga",
      advisor: "Matthew Laws",
      referralUser: "Abhishek Joshi",
      id: 1199,
      caseRef: "SAG908",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Total Household Income: £50k \n\nDeposit: £5%-£10%\n\nIn renting, FTB\n\n22/07/22 - Taken by Matthew Laws for qualifying \n                - Tight on affordability. Waiting for proof of income before sending off as qualified. \n25/07/22 - Would like to confirm details of property with Abhishek before proceeding. ",
      dateOfReferral: "2022-07-22T11:02:08.0591615",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T13:39:18.5271063",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 484,
      closedDate: "2022-07-26T13:41:51.4015229",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Rhoannan Hartley-Downer",
      advisor: "Steven Sanderson",
      referralUser: "Katie Rigden",
      id: 1200,
      caseRef: "SAG909",
      referredById: 244,
      caseStatusId: 27,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "First time buyer looking to purchase on her own. ",
      dateOfReferral: "2022-07-22T11:23:58.1032487",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T16:11:09.2283176",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 473,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Kulvinder Kauldhar",
      advisor: "Deonne Samuels",
      referralUser: "Jamie Bodle",
      id: 1201,
      caseRef: "SAG910",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-22T13:04:56.8054687",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T13:28:39.2657347",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 39,
      depositLevel: 160000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-07-22T13:28:52.2929385",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "matthew tagg",
      advisor: "Aaron Heer",
      referralUser: "Emily Balloch",
      id: 1203,
      caseRef: "SAG911",
      referredById: 64,
      caseStatusId: 26,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "partner Charlotte Lee-Gough is self employed",
      dateOfReferral: "2022-07-22T14:23:34.2759368",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-22T14:24:49.8197677",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 1300,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Amanda Underwood",
      advisor: "Jamie Bowley",
      referralUser: "Roger Jackson",
      id: 1205,
      caseRef: "SAG912",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Needs a MIP please ",
      dateOfReferral: "2022-07-22T15:29:18.1428632",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T17:12:14.7143104",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T10:05:52.9518234",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Lydiea Hull",
      advisor: "Aaron Heer",
      referralUser: "Nicola Pike",
      id: 1209,
      caseRef: "SAG913",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 240000,
      plotNumber: "Plot 111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB currently in private rent\n\nLegals sold & quote emailed\n\n\n\nAH - 3 attempts made + email - unresponsive ",
      dateOfReferral: "2022-07-23T08:58:30.8939481",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T10:20:46.9636434",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 150000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-08T09:18:37.819998",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Claire Embrey",
      advisor: "Alison Cathcart",
      referralUser: "Nicola Pike",
      id: 1215,
      caseRef: "SAG914",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 240000,
      plotNumber: "Plot 111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Hoping to sell her flat to her tenant she is aware she needs to be sold before she can buy a shared ownership.\n\nLegals sold & quote mailed",
      dateOfReferral: "2022-07-23T11:45:44.6162721",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-23T13:41:54.5508167",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 55000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Mohammed Rehman",
      advisor: "Alison Cathcart",
      referralUser: "Jas Sagoo",
      id: 1216,
      caseRef: "SAG915",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-23T11:51:57.0601094",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-23T15:00:33.7253788",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-10T14:17:41.9854926",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lauren Bush",
      advisor: "Steven Sanderson",
      referralUser: "Daisie Naughton",
      id: 1217,
      caseRef: "SAG916",
      referredById: 311,
      caseStatusId: 29,
      developmentId: 38,
      purchasePrice: 455000,
      plotNumber: "B100207",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-25T08:37:45.6124374",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T08:22:53.1379865",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 479,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Rain Riley",
      advisor: "Adam Faulkner",
      referralUser: "Elle Halls",
      id: 1228,
      caseRef: "SAG917",
      referredById: 147,
      caseStatusId: 27,
      developmentId: 27,
      purchasePrice: 220000,
      plotNumber: "8,9,10",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Seriously interested in The Long Melford 2 bed's. Only 2 plots left. Has spoken to a mortgage advisor already, that is how she got to the £220,000 number. Wanting a bigger property so going down the shared ownership route. Currently living with parents.",
      dateOfReferral: "2022-07-25T12:10:38.5894696",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T12:34:47.3944233",
      isDeleted: 1,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Lorna Murie",
      advisor: "Charlotte Fay",
      referralUser: "Lewis Ward",
      id: 1231,
      caseRef: "SAG918",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 94000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "she is unemployed partner works full time",
      dateOfReferral: "2022-07-25T12:33:19.0531255",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T12:35:01.7020752",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 94000,
      serviceCharge: 50,
      minPercShareAvailable: "40%",
      housingAssociation: "SAGE ",
      financialDetailsId: null,
      closedDate: "2022-07-27T12:44:41.4778506",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Jason Boroughton",
      advisor: "Arjun Dhunna",
      referralUser: "Emilio Williams",
      id: 1233,
      caseRef: "SAG919",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 410000,
      plotNumber: "43",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-25T12:51:12.6031937",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T11:31:17.0997163",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 149.64,
      minPercShareAvailable: "25",
      housingAssociation: "Sage housing",
      financialDetailsId: 490,
      closedDate: "2022-08-01T14:09:19.7705187",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Kadie Beaumont ",
      advisor: "Matthew Laws",
      referralUser: "Emilio Williams",
      id: 1234,
      caseRef: "SAG920",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "25/07/22 - Taken by Matthew Laws for qualifying \n                - VM left \n26/07/22 - No answer, Email sent",
      dateOfReferral: "2022-07-25T13:39:15.0569187",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T12:04:59.2314902",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: 501,
      closedDate: "2022-07-28T17:06:28.1832915",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Dilawar Anwarzai",
      advisor: "Charlotte Fay",
      referralUser: "Emilio Williams",
      id: 1235,
      caseRef: "SAG921",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-25T14:02:37.258776",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T14:03:34.2109658",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 125000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-07-27T21:00:22.3097742",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Olivia White",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1237,
      caseRef: "SAG922",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Not a new build \nI'm selling this property as a second hand shared ownership but we need to qualify the buyer in the same way. \n\nThe development is Gilden Park. \n\nAddress is 19 Dunnock Road. offering 40% ownership at the value of £131,000 \nFMV is £327,500\n\n25/07/22 - Taken by Matthew Laws for qualifying \n                - VM left \n",
      dateOfReferral: "2022-07-25T14:05:51.2181193",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T17:45:43.5833215",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 11500,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 477,
      closedDate: "2022-08-02T14:47:35.0729163",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "ALEXANDER KARIM",
      advisor: "Christopher Taylor",
      referralUser: "Madison Emery-Hyson",
      id: 1238,
      caseRef: "SAG923",
      referredById: 231,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 1,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "This is for a 1st mortgage appointment not for a new build. We have a lack off staff so have been asked to refer some cases to here.  He is a first time buyer, has already got a MIP with NatWest and has been to see L&C. Is interested in seeing if he can get a better rate as he got his mortgage in principal a few months ago.",
      dateOfReferral: "2022-07-25T14:12:36.095139",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T16:50:17.0796587",
      isDeleted: 0,
      advisorId: 9,
      propertyStatusId: 40,
      depositLevel: 1,
      serviceCharge: 1,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-19T14:09:42.2811491",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "David Creagh",
      advisor: "Matthew Laws",
      referralUser: "Cassie Tovell",
      id: 1240,
      caseRef: "SAG924",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 380000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sold His Property - Still going through. \nsold for 350,000 no mortgage needed will be cash buy around 200,000\n\n",
      dateOfReferral: "2022-07-25T14:41:31.891577",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:45:41.5633161",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 200000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 571,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Adam CLiff ",
      advisor: "Kelly Powers",
      referralUser: "Cassie Tovell",
      id: 1241,
      caseRef: "SAG925",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 131000,
      plotNumber: "19 dunnock road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "property built and is a second Hand Sale that i am selling. \n\nIts with Sage Housing and assessment is carried out the same way as a new build sale. \n\n\n",
      dateOfReferral: "2022-07-25T14:52:45.0875976",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T15:58:50.8328705",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-25T16:01:35.6734284",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Ojuolape Forsythe",
      advisor: "Neil Waller ",
      referralUser: "Damian Herrelle",
      id: 1242,
      caseRef: "SAG926",
      referredById: 177,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 37000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-25T14:57:19.4096083",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T11:08:13.3126378",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 480,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Kabir Khan",
      advisor: "Rachel Davies",
      referralUser: "Ali Abbas",
      id: 1243,
      caseRef: "SAG927",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "b1.03.03",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-25T15:09:39.7517817",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T15:12:36.4596234",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 225.95,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-18T14:27:06.4233319",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Amy Hutchinson",
      advisor: "Steven Sanderson",
      referralUser: "Jamie Bodle",
      id: 1245,
      caseRef: "SAG928",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "40",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB",
      dateOfReferral: "2022-07-25T16:07:14.2767674",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T16:07:53.4442963",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 18000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-02T15:37:57.9570098",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Michael Murphy",
      advisor: "Matthew Laws",
      referralUser: "Sam Bowyer",
      id: 1247,
      caseRef: "SAG929",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works in the fire service\nSeperated from ex\n\n25/07/22 - Taken by Matthew Laws for qualifying \n26/07/22 - No answer, email sent \n27/07/22 - No answer and no reply from email\n08/08/22 - No answer \n***Max calls reached***",
      dateOfReferral: "2022-07-25T16:19:00.6079465",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T10:46:34.1247269",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 55,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-15T10:49:21.5716559",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Tyler Mckie",
      advisor: "Neil Waller ",
      referralUser: "Cassie Tovell",
      id: 1249,
      caseRef: "SAG930",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: "19 Dunnock Road, Harlow, Essex",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Single Applicant looking to purchase\ndeposit 29k \nFTB\n\nThis is a resale shared ownership property. \n\nFMV 327,500 seller is selling 40% (131,000) ",
      dateOfReferral: "2022-07-25T16:24:01.9100498",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-25T16:25:21.6780063",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 40,
      depositLevel: 29000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-26T17:19:24.0953024",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Lousie Berry ",
      advisor: "Baldev Dhanda",
      referralUser: "Kurt Williams",
      id: 1251,
      caseRef: "SAG931",
      referredById: 115,
      caseStatusId: 65,
      developmentId: 28,
      purchasePrice: 315000,
      plotNumber: "10",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Apologies for the missing details, it has been passed to my via branch and this is what i have \n\nLouise is working till 5:30pm today so ideally after then. \n\nInterested in the Long Melford site near Bury St Edmunds \n\nGood luck ",
      dateOfReferral: "2022-07-26T07:38:30.5665822",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T07:48:56.1865061",
      isDeleted: 0,
      advisorId: 75,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T13:25:34.7086513",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Mr Danny Baker",
      advisor: "Jamie Bowley",
      referralUser: "Gareth Harmer",
      id: 1253,
      caseRef: "SAG932",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "3 Beds",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\nFull market price £395k @ 50% share = £197,500",
      dateOfReferral: "2022-07-26T09:01:30.2669307",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T10:45:46.8999622",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-28T11:04:03.0729504",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Caroline Kingsnorth",
      advisor: "Arjun Dhunna",
      referralUser: "Gareth Harmer",
      id: 1255,
      caseRef: "SAG933",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "3 beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Ideally would like a call at the weekend when husband is also available\nFull market price £395,000 @ 50% = £197,500",
      dateOfReferral: "2022-07-26T09:10:37.0963866",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T09:11:23.9066775",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-08T13:22:30.5155961",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Joanne Finch",
      advisor: "Aaron Heer",
      referralUser: "Gareth Harmer",
      id: 1257,
      caseRef: "SAG934",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently selling property and sold subject to status as part of divorce with deposit coming from sale.\nFAP £395k @ 50% = £197,500",
      dateOfReferral: "2022-07-26T09:26:15.7486265",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T12:53:34.0863737",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 483,
      closedDate: "2022-07-26T12:55:29.6249961",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "kayleigh oliver",
      advisor: "Laura Turner",
      referralUser: "Steven Merralls",
      id: 1258,
      caseRef: "SAG935",
      referredById: 243,
      caseStatusId: 28,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79, 81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Available to call at 12 or after 4 today\n",
      dateOfReferral: "2022-07-26T09:31:57.1884253",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-31T11:29:30.7600112",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Olivia Manning",
      advisor: "Laura Turner",
      referralUser: "Gareth Harmer",
      id: 1259,
      caseRef: "SAG936",
      referredById: 385,
      caseStatusId: 27,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three Beds",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Best to call between 12-2\nCURRENTLY IN RENTED\nHelp to buy\nFull Price £395k @ 50% = £197500",
      dateOfReferral: "2022-07-26T09:33:52.6692513",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T07:03:21.4040402",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Zoe O'Keefe",
      advisor: "Matthew Laws",
      referralUser: "Dominka Zych",
      id: 1260,
      caseRef: "SAG937",
      referredById: 165,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 375000,
      plotNumber: "321 88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "26/07/22 - Taken by Matthew Laws for qualifying \n                - Arranged qualifying call for 17:15",
      dateOfReferral: "2022-07-26T09:55:25.0022019",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T09:24:35.9764268",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 488,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Muhammad Farhan Bhatti",
      advisor: "Aaron Heer",
      referralUser: "Dominka Zych",
      id: 1262,
      caseRef: "SAG938",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "321 88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-26T10:45:07.9021994",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T11:49:39.9291231",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 481,
      closedDate: "2022-07-26T11:50:10.3795517",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Ms Erica Dionne Lewis",
      advisor: "Aidan Pearce ",
      referralUser: "Dominka Zych",
      id: 1264,
      caseRef: "SAG939",
      referredById: 165,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "322 90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 1,
      so: 1,
      keyNotes: "I have her SOF and ID",
      dateOfReferral: "2022-07-26T11:04:40.8859965",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T07:58:32.2034427",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 493,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Callum Moroney",
      advisor: "Joanna Halliday",
      referralUser: "Charlotte Smith",
      id: 1268,
      caseRef: "SAG940",
      referredById: 305,
      caseStatusId: 26,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511, 15 Atchison Avenue, Norwich",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "26/07/22 - Taken by Matthew Laws for qualifying \n                - Booked qualifying call for tomorrow @1630",
      dateOfReferral: "2022-07-26T12:35:15.1438476",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T17:43:12.6863137",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 40,
      depositLevel: 13000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: 496,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Katie Evans",
      advisor: "Charlotte Fay",
      referralUser: "Praveena Sharma",
      id: 1270,
      caseRef: "SAG941",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Has a property and is looking to remove herself from the mortgage. She is in the process and the solicitors are able to provide the details/ evidence. \n\nShe is interested in 2 beds for her and her sister but she will be the main applicant and she will be the only on in the mortgage. \n\nHerself and her sister are in the process of getting new jobs and will wait until they have secured these before re-contacting for further information on properties. \n",
      dateOfReferral: "2022-07-26T12:43:36.9436811",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T10:50:48.3767993",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T10:53:27.2064057",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Erin Patel",
      advisor: "Peter Hill",
      referralUser: "Charlotte Smith",
      id: 1272,
      caseRef: "SAG942",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511, 15 Atchison Avenue, Norwich",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Erin qualifies for 50% ownership.\n\nHe has his own broker and wants to use them, ",
      dateOfReferral: "2022-07-26T14:04:28.4545779",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T10:10:53.0216513",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 486,
      closedDate: "2022-08-04T10:11:22.5588447",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Darren Brice",
      advisor: "Arjun Dhunna",
      referralUser: "Steven Merralls",
      id: 1273,
      caseRef: "SAG943",
      referredById: 243,
      caseStatusId: 26,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79,81",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "His house will be on the market this week, he will need to sell the property to buy this new build.\nSelf employed 4 month\ncash from sale £130,000\n",
      dateOfReferral: "2022-07-26T14:17:15.7667334",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T14:21:10.5583164",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 117.5,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Lynda Mahabir",
      advisor: "Charlotte Fay",
      referralUser: "Emilio Williams",
      id: 1276,
      caseRef: "SAG944",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-26T16:05:36.4642752",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-26T16:10:41.5606972",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-01T17:35:18.5991407",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jon Kenny ",
      advisor: "Kelly Powers",
      referralUser: "Daisy May Tait Davies",
      id: 1277,
      caseRef: "SAG945",
      referredById: 192,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 142500,
      plotNumber: "147",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Incorrect number on portal - waiting correct number to be sent ",
      dateOfReferral: "2022-07-26T16:10:03.9494001",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T07:38:44.9827527",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing ",
      financialDetailsId: 495,
      closedDate: "2022-08-04T09:42:45.809101",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: " Lovelyn Medrano Colcol ",
      advisor: "Aaron Heer",
      referralUser: "Ali Abbas",
      id: 1278,
      caseRef: "SAG946",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 477500,
      plotNumber: "b1.06.08",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works from 10am-9pm\nSaid she finishes work at 4pm tomorrow, so would be better to call her tomorrow after 4pm",
      dateOfReferral: "2022-07-27T07:59:18.6486058",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T09:44:48.4593071",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 17000,
      serviceCharge: 220.44,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 504,
      closedDate: "2022-08-16T11:16:02.4982682",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Shajid Sacranie",
      advisor: "Neil Waller ",
      referralUser: "Jamie Bodle",
      id: 1279,
      caseRef: "SAG947",
      referredById: 111,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "40",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-27T08:45:13.9722699",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T10:50:39.1221742",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 489,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Baser Bilurdagi",
      advisor: "Ravneet Sokhi",
      referralUser: "Jas Sagoo",
      id: 1281,
      caseRef: "SAG948",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-27T09:14:06.336105",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T09:15:25.4562499",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 747.66,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T12:14:46.7418995",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jodie Darville",
      advisor: "Ravneet Sokhi",
      referralUser: "Amrick Chattu",
      id: 1282,
      caseRef: "SB314",
      referredById: 381,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 240000,
      plotNumber: "111",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "First Appointment\nFirst time buyer \nLooking to buy a shared ownership property off plan ",
      dateOfReferral: "2022-07-27T09:20:34.8273528",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T16:20:56.5473777",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 600,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-02T15:11:53.3529392",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Phillip Cole",
      advisor: "Arjun Dhunna",
      referralUser: "Emilio Williams",
      id: 1283,
      caseRef: "SAG949",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Please call after 3:30pm",
      dateOfReferral: "2022-07-27T09:31:49.3728466",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T09:32:51.7965378",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 5000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-07-27T15:29:35.1787009",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Antony Mcmanus",
      advisor: "Neil Waller ",
      referralUser: "Cassie Tovell",
      id: 1289,
      caseRef: "SAG950",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "First Time Buyer \nSingle applicant \n\nThis is a second hand re sale. \n\nSellers full market value is 327500 and selling 40% only (131k)",
      dateOfReferral: "2022-07-27T10:25:06.5382562",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T16:11:43.8462562",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-11T09:40:06.6375945",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Debbie Stinson",
      advisor: "Arjun Dhunna",
      referralUser: "Emily Balloch",
      id: 1290,
      caseRef: "SAG951",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "NTS \nEmployed \nspoken to a broker but only initial chat so open to advice from us as well ",
      dateOfReferral: "2022-07-27T10:28:27.1325114",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T14:37:49.6161023",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 492,
      closedDate: "2022-08-16T11:41:51.3193796",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Hannah Stone",
      advisor: "Peter Hill",
      referralUser: "Emily Balloch",
      id: 1291,
      caseRef: "SAG952",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nno AIP \nspoken to a broker - looking for more advice and to compare rates \n\nHannah has not been in contact for over 3 weeks after first contact and hasnt sent any documents.,\n\nI have closed case until i hear from her.",
      dateOfReferral: "2022-07-27T10:36:09.641364",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T12:49:54.5426468",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 80000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-08-15T12:50:31.9359174",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Hannah Ibrahim",
      advisor: "Matthew Laws",
      referralUser: "Emily Balloch",
      id: 1293,
      caseRef: "SAG953",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \nspoken to one broker so far - no AIP yet - looking for more advice from us ",
      dateOfReferral: "2022-07-27T10:47:08.9838659",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T12:48:09.3635733",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 491,
      closedDate: "2022-07-27T14:25:13.2469915",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Liinaa Aubeeluck",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Jas Sagoo",
      id: 1295,
      caseRef: "SAG954",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-27T11:30:00.5619239",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T11:32:29.7083488",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: 747.66,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T08:34:09.0738685",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Lewis Eley",
      advisor: "Peter Hill",
      referralUser: "Cassie Tovell",
      id: 1296,
      caseRef: "SAG955",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 370000,
      plotNumber: "196",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "18k deposit\n\nlooking at off plan and would like a house. \nI don't have service charge info at the moment and giving worse case ",
      dateOfReferral: "2022-07-27T11:32:37.1877776",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T13:04:39.4284202",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 18000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Susan Bahaduri",
      advisor: "Matthew Laws",
      referralUser: "Daisie Naughton",
      id: 1298,
      caseRef: "SAG956",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 445000,
      plotNumber: "B10203",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "HAS CASH\n\n\n**Exceeds annual income limit. Susan earns 85k herself so with husband it would be well over limit**",
      dateOfReferral: "2022-07-27T13:04:46.2113735",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T14:53:33.5889817",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 120000,
      serviceCharge: 206.79,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-27T15:12:21.0171668",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Vladimir Prosel",
      advisor: "Ravneet Sokhi",
      referralUser: "Dominka Zych",
      id: 1299,
      caseRef: "SAG957",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "The number on the file is his partner as his English is not to good ",
      dateOfReferral: "2022-07-27T13:14:56.8634437",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T13:20:18.5426366",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 200000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-03T08:21:40.7497859",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Husneara Begun",
      advisor: "Peter Hill",
      referralUser: "Dominka Zych",
      id: 1300,
      caseRef: "SAG958",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Qualified but affordability relies on being able to use Shozel's self employed income of one year (paid by PAYE through his own company) -  possible with Pepper money.\n\n2 of these properties are sold, 2 available but with 2 people interested so Mark Alvis has asked if this can be moved quickly to see if possible please. \n\nNot happy with the increasing in FMV from £370k to £390k so doesnt want to purchase, i will re-open if she comes back on.",
      dateOfReferral: "2022-07-27T13:56:06.9907095",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T08:24:27.9556629",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 525,
      closedDate: "2022-08-18T08:25:40.241644",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Rachel Clarke",
      advisor: "Arjun Dhunna",
      referralUser: "Dominka Zych",
      id: 1302,
      caseRef: "SAG959",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 380000,
      plotNumber: "82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "27/07/22 - Taken by Matthew Laws for qualifying \n28/07/22 - VM left",
      dateOfReferral: "2022-07-27T14:22:34.322877",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T11:26:12.2448772",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 499,
      closedDate: "2022-08-08T13:38:32.3517059",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Maziar Azadi",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 1303,
      caseRef: "SAG960",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 480000,
      plotNumber: "b1.07.08",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "27/07/22 - Taken by Matthew Laws for qualifying \n28/07/22 - Not qualified, calling back to see if he can raise deposit. ",
      dateOfReferral: "2022-07-27T14:50:20.5940114",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T17:00:22.2621498",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 4781,
      serviceCharge: 220.96,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 502,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Daniel Goodyear",
      advisor: "Laura Turner",
      referralUser: "Charlotte Smith",
      id: 1304,
      caseRef: "SAG961",
      referredById: 305,
      caseStatusId: 26,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511 15 Atchison AvenueNorwich NR4 7RG",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-27T14:52:23.064225",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-27T14:55:55.0471695",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 12000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Zoe Holewinska",
      advisor: "Ravneet Sokhi",
      referralUser: "Dominka Zych",
      id: 1305,
      caseRef: "SAG962",
      referredById: 165,
      caseStatusId: 28,
      developmentId: 33,
      purchasePrice: 380000,
      plotNumber: "88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Affordability only works using Patryks new full time salary, started on August 1st. Has signed contract and previous payslips leading up to this with company when he was working with them part time.  ",
      dateOfReferral: "2022-07-27T15:09:51.9973573",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T09:46:02.768767",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 510,
      closedDate: "2022-08-01T08:34:49.9533792",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Lia McCarthy",
      advisor: "Aaron Heer",
      referralUser: "Dominka Zych",
      id: 1306,
      caseRef: "SAG963",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 380000,
      plotNumber: "88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She's not available to speak tomorrow. Can you call on Friday\n\nAH - Left VM + email 29/07",
      dateOfReferral: "2022-07-27T15:27:52.8215935",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T13:09:45.8581602",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 509,
      closedDate: "2022-07-29T15:33:35.928563",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Brian Morgan",
      advisor: "Charlotte Fay",
      referralUser: "Nicola Pike",
      id: 1308,
      caseRef: "SAG964",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Brian is an amputee and is on related benefits. He currently rents.\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-07-27T18:04:42.2333341",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T14:15:01.1348334",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: 511,
      closedDate: "2022-08-02T19:07:48.5556369",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Joseph Bartleton",
      advisor: "Arjun Dhunna",
      referralUser: "Nicola Pike",
      id: 1309,
      caseRef: "SAG965",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegal sold & quote emailed",
      dateOfReferral: "2022-07-27T18:37:07.0956859",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T12:00:23.3854404",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: 497,
      closedDate: "2022-08-11T10:39:41.1010194",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lucy Truman",
      advisor: "Jamie Bowley",
      referralUser: "Callum Morton",
      id: 1310,
      caseRef: "SAG966",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "28/07/22 - Taken by Matthew Laws for qualifying \n                - Waiting for confirmation of Income for her partner (as CIS and less than a year) before proceeding ",
      dateOfReferral: "2022-07-28T08:45:36.3505552",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T10:18:41.934783",
      isDeleted: 0,
      advisorId: 11,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 505,
      closedDate: "2022-08-01T13:13:46.1590225",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Safinat Emengo",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Gareth Harmer",
      id: 1311,
      caseRef: "SAG967",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Will be moving to Maidstone renting then buy - daughter going to Maidstone Grammer school\n£395k full price - 50% share £197,500\n\n1st attempt call - call back i 10 mins\n\n2nd attempt call - no answer ",
      dateOfReferral: "2022-07-28T08:46:44.4815937",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T09:03:34.2632361",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 39,
      depositLevel: 60000,
      serviceCharge: 88,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T08:22:04.5291325",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Bradley Bennett",
      advisor: "Neil Waller ",
      referralUser: "Callum Morton",
      id: 1313,
      caseRef: "SAG968",
      referredById: 152,
      caseStatusId: 26,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-28T09:10:33.3771869",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T09:12:14.9793248",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 39,
      depositLevel: 15,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Faith Ratcliff",
      advisor: "Matthew Laws",
      referralUser: "Callum Morton",
      id: 1316,
      caseRef: "SAG969",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "28/07/22 - Taken by Matthew Laws for qualifying\n                - Doesn't qualify from info from call. May be able to increase deposit but will have to discuss this when Faith has finished work. ",
      dateOfReferral: "2022-07-28T09:55:21.3560825",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T17:41:07.3768627",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: 503,
      closedDate: "2022-07-29T15:43:11.3011947",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Aimalohi Ehizoje",
      advisor: "Aidan Pearce ",
      referralUser: "Dominka Zych",
      id: 1317,
      caseRef: "SAG970",
      referredById: 165,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "321 88 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Work NHS",
      dateOfReferral: "2022-07-28T09:55:44.4066929",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T10:18:09.2556115",
      isDeleted: 0,
      advisorId: 16,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Carolyn Penny",
      advisor: "Ameliah Maio",
      referralUser: "Lewis Ward",
      id: 1320,
      caseRef: "SAG971",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 105,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Carolyn has divorce her partner an sold the house, she may buy up to 45% share in cash. however would consider a mortgage if the payments were goig to be similar to the rent",
      dateOfReferral: "2022-07-28T11:04:39.2143271",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T13:50:44.2640342",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 110000,
      serviceCharge: 50,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage ",
      financialDetailsId: 528,
      closedDate: "2022-08-11T16:37:22.7330514",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Matthew Jewell ",
      advisor: "Neil Waller ",
      referralUser: "Charlotte Smith",
      id: 1321,
      caseRef: "SAG972",
      referredById: 305,
      caseStatusId: 33,
      developmentId: 28,
      purchasePrice: 149950,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Help to buy registration number– htb-152216-k4v0l6 \n\nMatthews parents are happy to be guarantors on a mortgage if it is needed\n",
      dateOfReferral: "2022-07-28T12:37:04.5156912",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:53:45.1803931",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: 519,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: 53,
      lnhManagerId: 115,
    },
    {
      applicant: "Dusan Kaminsky",
      advisor: "Ravneet Sokhi",
      referralUser: "Ali Abbas",
      id: 1324,
      caseRef: "SAG973",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: "b1.06.07",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-28T13:18:29.9064116",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T13:20:17.2747829",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T14:38:12.133985",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Alex Saunders",
      advisor: "Ravneet Sokhi",
      referralUser: "Callum Morton",
      id: 1325,
      caseRef: "SAG974",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-28T13:25:35.5141273",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T13:32:50.0578503",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-02T15:17:54.9693858",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Syed Pasha",
      advisor: "Ravneet Sokhi",
      referralUser: "Abhishek Joshi",
      id: 1326,
      caseRef: "SAG975",
      referredById: 314,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Dep: £100k-£125k\nIncome: £38.5k (as of August 1st)\nBudget: £380K (40% HTB), does not know affordability for Shared Ownership + normal properties\nFTB\nNeed to vacate current place by Oct; needs to find asap",
      dateOfReferral: "2022-07-28T13:33:26.9585874",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T14:00:34.7657923",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 125000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jasmine Watson",
      advisor: "Arjun Dhunna",
      referralUser: "Dominka Zych",
      id: 1328,
      caseRef: "SAG976",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-28T14:38:15.0317064",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T14:41:48.349329",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-08T13:48:52.048196",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Oludoyin Obasa",
      advisor: "Ravneet Sokhi",
      referralUser: "Dominka Zych",
      id: 1329,
      caseRef: "SAG977",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 370000,
      plotNumber: "90 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-28T14:52:58.4943826",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-28T15:03:37.7144255",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 13500,
      serviceCharge: 597.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-15T10:40:00.661336",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Megan Glover",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Katie Rigden",
      id: 1332,
      caseRef: "SAG978",
      referredById: 244,
      caseStatusId: 28,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79,81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Property is close to exchange",
      dateOfReferral: "2022-07-28T15:04:31.433498",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T17:14:05.4439058",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 537,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Joy Prior",
      advisor: "Neil Waller ",
      referralUser: "Stephen Heath",
      id: 1333,
      caseRef: "SAG979",
      referredById: 194,
      caseStatusId: 27,
      developmentId: 41,
      purchasePrice: 150000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She is after a 3 bed end or semi detached, explained we don't have any left and she said that she knew as spoke with Sage and they said they have another phase coming soon.  She wants to be ready so when released can go for one, Figures are based upon 3 bed semi now which is under offer",
      dateOfReferral: "2022-07-28T15:11:14.8053895",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T16:09:33.8806352",
      isDeleted: 0,
      advisorId: 409,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: "Sage Homes",
      financialDetailsId: 522,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jack Leech",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Lewis Ward",
      id: 1334,
      caseRef: "SAG980",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "jack and friend looking to buy together\n\n",
      dateOfReferral: "2022-07-28T15:55:06.8594532",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-30T10:08:46.7427228",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "40%",
      housingAssociation: "SAGE",
      financialDetailsId: 514,
      closedDate: "2022-08-08T09:13:49.4926742",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jane Renkel-Clarke",
      advisor: "Charlotte Fay",
      referralUser: "Jessica Jinks",
      id: 1336,
      caseRef: "SAG981",
      referredById: 226,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 1,
      so: 0,
      keyNotes:
        "Jane is selling her home on Merlin Court, and would like to go into shared ownership. Please call to book mortgage advice. Not for a house.",
      dateOfReferral: "2022-07-29T08:26:14.6249661",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T08:29:03.0499983",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: -1,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-01T14:14:49.1811768",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 384,
    },
    {
      applicant: "Melissa Basquil",
      advisor: "Matthew Laws",
      referralUser: "Cassie Tovell",
      id: 1339,
      caseRef: "SAG982",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 380000,
      plotNumber: "Sawbridgeworth two bedroom coming up",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "called to view my second hand coach house 19 Dunnock Road - FMV £327,500\nselling 40% share (131,000) SC £534 per year \n\nAlso spoke to the client about 2 bedroom houses I have coming up in Sawbridgeworth. 2 bedroom off plan FMV 380,000\nNo service charge info just yet. Estimate £95 PCM\n\nI hope all the above makes sense. Please let me know if not. \n\nCassie. \n\n29/07/22 - Picked up by Matthew Laws for qualifying \n               - VM left",
      dateOfReferral: "2022-07-29T09:13:58.1404703",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T14:05:58.8396925",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 518,
      closedDate: "2022-08-01T14:13:11.7545342",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Obinna Udeh-Paul",
      advisor: "Ravneet Sokhi",
      referralUser: "Emilio Williams",
      id: 1341,
      caseRef: "SAG983",
      referredById: 300,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "free for a call between 12-2pm today ",
      dateOfReferral: "2022-07-29T09:26:56.4511321",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T16:29:29.1448901",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "sage housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Pheobe Hughes",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Sam Bowyer",
      id: 1342,
      caseRef: "SAG984",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Please call today! Off work for 6 weeks, works at a school.",
      dateOfReferral: "2022-07-29T09:40:12.3079594",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T13:01:56.3053472",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: 508,
      closedDate: "2022-08-01T13:34:14.9976967",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Diane Crowley",
      advisor: "Arjun Dhunna",
      referralUser: "Kathryn Gibb",
      id: 1343,
      caseRef: "SAG985",
      referredById: 191,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 140000,
      plotNumber: "50",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-29T10:32:38.8463552",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T16:09:49.1928424",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 140000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-03T16:08:05.4686516",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Charlotte Cain ",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1345,
      caseRef: "SAG986",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: "19 dunnock road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This is a second hand resale \n\nseller selling 40% share FMV £327,500 ",
      dateOfReferral: "2022-07-29T11:15:00.8755902",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T13:24:29.4494872",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 80000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-11T11:38:08.3692181",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Aneesa Majothi",
      advisor: "Aaron Heer",
      referralUser: "Jamie Bodle",
      id: 1346,
      caseRef: "SAG987",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "34",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-07-29T13:02:12.6012449",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T14:47:14.3288726",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Housing",
      financialDetailsId: 512,
      closedDate: "2022-08-08T11:30:46.9583774",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Scott Garbutt",
      advisor: "Medihya Akram",
      referralUser: "Roger Jackson",
      id: 1347,
      caseRef: "SAG988",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "FTB, needs a MIP. Not found anywhere to live ",
      dateOfReferral: "2022-07-29T13:02:15.5433141",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T14:38:48.5490502",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 39,
      depositLevel: 8000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 513,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Vivien smith",
      advisor: "Shanaz Parbin",
      referralUser: "Roger Jackson",
      id: 1349,
      caseRef: "SAG989",
      referredById: 351,
      caseStatusId: 27,
      developmentId: 23,
      purchasePrice: 205000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "185 cash in bank. Wants to buy a new build for about 205k. Retired, wants a little mortgage. Can we help??",
      dateOfReferral: "2022-07-29T14:02:32.9630121",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T11:51:27.4755885",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 185000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Khalib Zerrauk",
      advisor: "Kritika Dhain",
      referralUser: "Daisie Naughton",
      id: 1350,
      caseRef: "SAG990",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: null,
      plotNumber: "B10201",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Wanting to view tomorrow, please call ASAP",
      dateOfReferral: "2022-07-29T14:24:00.7098229",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T14:26:02.0463621",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 171.87,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-07-29T15:21:26.2572721",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Sharon Disney",
      advisor: "Peter Hill",
      referralUser: "Roger Jackson",
      id: 1352,
      caseRef: "SAG991",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 160000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB, looking for a MIP please. Not looking at new build, only existing ",
      dateOfReferral: "2022-07-29T14:45:59.713382",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T14:50:42.1410523",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-15T15:30:13.8861629",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Mohammed Tahir",
      advisor: "Medihya Akram",
      referralUser: "Roger Jackson",
      id: 1354,
      caseRef: "SAG992",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 160000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "First time buyer. Need a MIP for one of our properties that is on the market as offers over 160k ",
      dateOfReferral: "2022-07-29T15:43:37.0517594",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T16:19:06.8113931",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Lisa Cherry",
      advisor: "Matthew Laws",
      referralUser: "Cassie Tovell",
      id: 1355,
      caseRef: "SAG993",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: "19 dunnock road, harlow",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "29/07/22 - Taken by Matthew Laws for qualifying \n                - Travelling home and won't be back until 1930. Have agreed a time to call back Monday. ",
      dateOfReferral: "2022-07-29T15:49:44.126121",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-29T16:11:47.3713227",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-01T07:39:13.7403833",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Anila Minhas ",
      advisor: "Agne Slepetyte",
      referralUser: "Jade Thorne",
      id: 1356,
      caseRef: "SAG994",
      referredById: 248,
      caseStatusId: 26,
      developmentId: 171,
      purchasePrice: 525000,
      plotNumber: "30",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "First time buyers, interested in plot 3 forge Park at £525,000. \nPlot is NOT available on HTB or shared ownership so would be normal resi mortgage.\n£100,000 deposit \nPlease call on a Saturday or an evening as both work full time ",
      dateOfReferral: "2022-07-30T09:00:59.6750746",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-30T09:37:04.201036",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "David Pattison",
      advisor: "Ameliah Maio",
      referralUser: "Cassie Tovell",
      id: 1357,
      caseRef: "SAG995",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: "19 dunnock road, Harlow, Essex ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "gets paid weekly \n11.60 Per Hour \naround 30k per year. \n",
      dateOfReferral: "2022-07-30T11:03:40.124261",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T10:28:42.2160709",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 13000,
      serviceCharge: 534,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-02T15:37:45.9851419",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Mark Edwards",
      advisor: "Agne Slepetyte",
      referralUser: "Nicola Pike",
      id: 1359,
      caseRef: "SAG996",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can someone please call Mark asap \n\nLegals Sold & quote emailed",
      dateOfReferral: "2022-07-30T12:57:32.0186685",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-07-30T13:34:22.218948",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Roman Bernadowicz",
      advisor: "Agne Slepetyte",
      referralUser: "Roger Jackson",
      id: 1362,
      caseRef: "SAG997",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Needs a MIP please. Had one, total of £210k but had now ran out ",
      dateOfReferral: "2022-07-30T16:32:10.8492898",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T07:47:07.7163931",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-13T08:47:13.2852453",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Jake Le",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 1363,
      caseRef: "SAG998",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Jake is a first time buyer. Please call Tuesday or Thursday PM, the phone number is for his mum but Jake will be with her.\n\nLegals sold & quote emailed.",
      dateOfReferral: "2022-07-30T16:41:39.3714779",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T07:43:59.4448721",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T08:00:35.6269691",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Shahaab Qader",
      advisor: "Laura Turner",
      referralUser: "Roger Jackson",
      id: 1365,
      caseRef: "SAG999",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 17000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Sold current property, has a deposit of 20k from sale. Needs a MIP  ",
      dateOfReferral: "2022-08-01T08:19:46.0789517",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T08:41:37.157659",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Natasha Stephens",
      advisor: "Nadia Bandula ",
      referralUser: "Praveena Sharma",
      id: 1368,
      caseRef: "SAG1000",
      referredById: 235,
      caseStatusId: 27,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in 2 bed - advised to view the show homes \n\n01/08/22 - Taken by Matthew Laws for qualifying \n      \n",
      dateOfReferral: "2022-08-01T10:06:08.7971073",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T18:22:48.4463973",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 22000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 523,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Harry Harrison",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 1369,
      caseRef: "SAG1001",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Lovely man, 70 year old retired. He wants to move to codsall to be close with family and friends. He has a property to sell in Selby. Advised him he will need to sell that before proceeding with the shared ownership but wanted bit more information. \nThinking of selling the property - speaking to his family but not on the market yet. \n\nPlease call around 1-2pm ",
      dateOfReferral: "2022-08-01T10:24:49.2933741",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T10:30:07.5356537",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-01T17:47:17.7732329",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Harprit Khera",
      advisor: "Shanaz Parbin",
      referralUser: "Roger Jackson",
      id: 1371,
      caseRef: "SAG1002",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 250000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Needs advise on a BTL of  current property, they then will purchase one on the market with us. Has 50k deposit ",
      dateOfReferral: "2022-08-01T11:00:16.4237243",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T12:05:05.6961598",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Alex Gradon",
      advisor: "Nadia Bandula ",
      referralUser: "Sam Bowyer",
      id: 1372,
      caseRef: "SAG1003",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112/113/81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "01/08/22 - Taken by Matthew Laws for qualifying",
      dateOfReferral: "2022-08-01T11:02:09.8550838",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T18:17:14.0652353",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 524,
      closedDate: "2022-08-03T15:43:58.2510226",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Shane Evans",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1375,
      caseRef: "SAG1004",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 225000,
      plotNumber: "216",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Selling his currently proeprty which is under offer. \n\nLooking to buy on his own. \n\nI do not have the service charge information. I have given an estimate. ",
      dateOfReferral: "2022-08-01T13:03:13.4632122",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T13:09:52.0653865",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 80,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-12T14:22:04.1030062",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Roshni Hindocha",
      advisor: "Charlotte Fay",
      referralUser: "Daisie Naughton",
      id: 1377,
      caseRef: "SAG1005",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 452500,
      plotNumber: "B10406",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-01T13:16:39.3952672",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T15:45:31.2471134",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 100000,
      serviceCharge: 208.36,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 521,
      closedDate: "2022-08-02T08:23:49.2634123",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Kieran Dungate",
      advisor: "Ameliah Maio",
      referralUser: "Callum Morton",
      id: 1382,
      caseRef: "SAG1006",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-01T14:11:34.6639947",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T14:12:33.1277574",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-01T14:59:34.9449943",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Alex Tapp",
      advisor: "Paul Parker",
      referralUser: "Natasha Forsyth",
      id: 1383,
      caseRef: "SAG1007",
      referredById: 214,
      caseStatusId: 65,
      developmentId: 107,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB looking to buy with brother - only carried out an online calculator online with his bank so DIP at the moment - looking to buy up to £250k in Sandbach  - thinks he could  go to £260k - said if you call him he may be happy to have a first appointment with you. Good luck :)\n\nIgnore the bottom bit - we have no FS at the moment so have been told to send over leads to you guys for now. \n\n\nAssigned to Paul Parker on 1/8\n\nCalled on 2/8 - no answer and couldn't leave voicemail. sent email to schedule call. Spoke on phone. Has DIP with his bank (Halifax). Not interested in scheduling an appointment at this time but may get back in touch once he has put an offer on a property.",
      dateOfReferral: "2022-08-01T14:15:50.9519033",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T12:14:02.1140321",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-06T09:41:34.8061146",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Lucy Green",
      advisor: "Simon Dyer",
      referralUser: "Natasha Forsyth",
      id: 1384,
      caseRef: "SAG1008",
      referredById: 214,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Lucy is separating from husband - they need to sell their house - not on market yet - needs some advice on affordability. Hoping to get some equity from the sale and sister will buy with her (who has her own home but will have a share in Lucy's house) - could you call and see if we can help out at all?\nPlease ignore the bottom half of lead as we have no FS in branch and have been asked to send possible firsts across to you :)\nShe thinks she could borrow up to £200k\n\nBooked in for 1st Appointment on Thursday 11th @ 2pm. SD 04/08 15:44 \n\nHad to cancel first appointment so have emailed today to try and reschedule appointment and get a new one booked in. SD 17/08 11am\n\nHave emailed a few times since to re-arrange 1st appointment but not heard back, have also left voicemails. SD 20/08 13:48",
      dateOfReferral: "2022-08-01T14:20:04.0106399",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T12:48:21.7816632",
      isDeleted: 0,
      advisorId: 99,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Zaynah Ejaz",
      advisor: "Ravneet Sokhi",
      referralUser: "Shannon Chin-Sewell",
      id: 1386,
      caseRef: "SAG1009",
      referredById: 102,
      caseStatusId: 65,
      developmentId: 22,
      purchasePrice: null,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "-need to know more about her financial situation\n\n- needs to know if she is eligible for the help to by buy scheme.  \n\n-Looking at all of our help to  buy development. \n\n-  has little knowledge of the scheme. \n\nWould qualify at 292900, based on a monthly service charge of 150 with Help to buy, inside London. Zaynah hasnt seen any properties yet but this will give her an indication of what she could now look at. ",
      dateOfReferral: "2022-08-01T14:34:50.7947753",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T14:08:45.549307",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 17000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 533,
      closedDate: "2022-08-16T14:38:35.4602891",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Hannah Sharp",
      advisor: "Nadia Bandula ",
      referralUser: "Jamie Bodle",
      id: 1387,
      caseRef: "SAG1010",
      referredById: 111,
      caseStatusId: 28,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-01T15:11:19.0081534",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T18:29:49.4159091",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Sahar Khamseh",
      advisor: "Charlotte Innes",
      referralUser: "Ali Abbas",
      id: 1389,
      caseRef: "SAG1011",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 375000,
      plotNumber: "b1.05.01",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Shared Ownership Calc fits if we can offer the client a 8% discount of the purchase price or property val of £345000. Client looking to clear her £600 credit card",
      dateOfReferral: "2022-08-01T15:31:07.266055",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T14:58:08.247867",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 171.87,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-04T11:51:13.4954016",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Ash Virk ",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1390,
      caseRef: "SAG1012",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Sold flat - currently a SO L&Q \n\nBuying with partner \n\nLooking to buy minimum possible but explained that this is not the case\n\nWas buying \n\nhad a outright purchase agreed 6 months ago and now cant afford the prices to buy outright. had a previous mortgage offer for 305,000 with HSBC",
      dateOfReferral: "2022-08-01T15:38:31.0411852",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T12:58:52.9844526",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 10003,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-11T14:30:34.5276496",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Rosie Gibbs",
      advisor: "Kritika Dhain",
      referralUser: "Emily Balloch",
      id: 1392,
      caseRef: "SAG1013",
      referredById: 64,
      caseStatusId: 65,
      developmentId: 6,
      purchasePrice: 335000,
      plotNumber: "265",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SSTC - Jackson & Co - sold to a FTB\nEmployed\nspoken to a broker - Jack Mottershead\nAIP with Natwest\n£50,000 deposit\n\nopen to more advice as well ",
      dateOfReferral: "2022-08-01T16:54:05.91634",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-01T17:02:27.4229677",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 50000,
      serviceCharge: 1350,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "2022-08-02T10:10:26.8485409",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Natalie Smith",
      advisor: "Paul Parker",
      referralUser: "Cassie Tovell",
      id: 1393,
      caseRef: "SAG1014",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 450000,
      plotNumber: "1",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Both Employed \n\nlooking at there first time. \n\nlooking at different plots i have available. \n\nPlot 1 is the most expensive at £450,000 - I do have others at £420 & 425 - I don't have the service charge information. \n\n01/08/22 - Taken by Matthew Laws for qualifying \n02/08/22 - VM left\n02/08/22 Taken by Paul Parker\n02/08/22 - called and spoke on phone. Sent document request email.\n\n",
      dateOfReferral: "2022-08-01T17:05:57.9509403",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T14:24:47.7295595",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 527,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Brenda Patterson",
      advisor: "Alison Cathcart",
      referralUser: "George Rowlands ",
      id: 1395,
      caseRef: "SAG1015",
      referredById: 212,
      caseStatusId: 65,
      developmentId: 32,
      purchasePrice: 150750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "lady has agreed to buy a shared ownership property and wants to speak with our FA about affordability and whether to get a mortgage or not",
      dateOfReferral: "2022-08-02T08:17:48.6416289",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T11:54:42.2785186",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: "67",
      housingAssociation: "Heylo",
      financialDetailsId: null,
      closedDate: "2022-08-10T14:19:29.2581738",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Danish Mullazhai",
      advisor: "Alison Cathcart",
      referralUser: "Abhishek Joshi",
      id: 1398,
      caseRef: "SAG1016",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Selling a property; £20k down as deposit\nShared Ownership property will be bought by his Mrs. \nShe is a FTB\nHer income is £26k\nHave confirmed, he will sell his property",
      dateOfReferral: "2022-08-02T08:49:16.387409",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T12:47:25.0667566",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T09:42:27.5483485",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Hazal Erdil",
      advisor: "Kritika Dhain",
      referralUser: "Abhishek Joshi",
      id: 1399,
      caseRef: "SAG1017",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Her + Partner\nFTB\nIncome: £60k\nDEPOSIT: £6,000\n2 bed w/ parking",
      dateOfReferral: "2022-08-02T08:50:53.7625108",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T08:56:43.2084897",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-03T08:34:29.7789808",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Cajetan Fernandes",
      advisor: "Matthew Laws",
      referralUser: "Abhishek Joshi",
      id: 1400,
      caseRef: "SAG1018",
      referredById: 314,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 425000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Owns 20% of a property - she will sell this to her Daughter, and be mortgage/property free.\n\nDeposit approximately around £40k-£50k\n\nIncome: £30k - works for NHS",
      dateOfReferral: "2022-08-02T08:57:28.5557482",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T13:54:35.5023109",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 158.36,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 529,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Maria Rollinson",
      advisor: "Paul Parker",
      referralUser: "Sam Bowyer",
      id: 1401,
      caseRef: "SAG1019",
      referredById: 28,
      caseStatusId: 28,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-02T09:01:46.9207764",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-06T09:39:28.1847747",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 55000,
      serviceCharge: 55,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ahmad Itiani",
      advisor: "Deonne Samuels",
      referralUser: "Abhishek Joshi",
      id: 1403,
      caseRef: "SAG1020",
      referredById: 314,
      caseStatusId: 27,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Ahmad qualifies but for a lower FMV of 368,200 \n\nThere are properties available for him and he is talking to the EA today around options for this.  He doesnt qualify for the 435k which he was originally interested in which also had parking. ",
      dateOfReferral: "2022-08-02T09:04:51.7995574",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T12:21:47.8620679",
      isDeleted: 0,
      advisorId: 40,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 176.19,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 526,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Saul Raine",
      advisor: "Ravneet Sokhi",
      referralUser: "Georgina Addis",
      id: 1406,
      caseRef: "KY2",
      referredById: 418,
      caseStatusId: 65,
      developmentId: 9,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Interested in lodge park, is free for financial check anytime ",
      dateOfReferral: "2022-08-02T10:09:14.95767",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T16:51:30.5062004",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-11T16:51:56.9445979",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Zoe Cross",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Callum Morton",
      id: 1408,
      caseRef: "SAG1021",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-02T11:35:16.0349705",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T12:00:23.2900114",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-08T09:21:24.2895951",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Kasim Beetlestone",
      advisor: "Alison Cathcart",
      referralUser: "Callum Morton",
      id: 1409,
      caseRef: "SAG1022",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-02T11:36:20.6436442",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T10:11:27.9730346",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-10T14:24:15.5122398",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Lynda Mahabir",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 1410,
      caseRef: "SAG1023",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB \n3 bed w/ no parking \nHer income: £31.6k; her + son (he is 18)\n50k depo \n\nDoesnt qualify for this property. Would qualify for 361,500 @25%, checking options at this value ",
      dateOfReferral: "2022-08-02T11:49:39.5047976",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T10:22:13.9886384",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 536,
      closedDate: "2022-08-03T10:45:14.5060041",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Maria Lozendo",
      advisor: "Ravneet Sokhi",
      referralUser: "Ali Abbas",
      id: 1412,
      caseRef: "SAG1024",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 347500,
      plotNumber: "b1.02.05",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-02T12:58:06.0267853",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T14:22:45.9737223",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 214.14,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Lynn Nevitt",
      advisor: "Ameliah Maio",
      referralUser: "Nicola Pike",
      id: 1413,
      caseRef: "SAG1025",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 84000,
      plotNumber: "93",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Lynn is a cash buyer from inheritance just need her qualifying please and HCA to me for application.",
      dateOfReferral: "2022-08-02T12:58:19.1183323",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T15:07:55.7865634",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 84000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-02T15:28:02.3555693",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Sophie Wilkins",
      advisor: "Matthew Laws",
      referralUser: "Gareth Harmer",
      id: 1415,
      caseRef: "SAG1026",
      referredById: 385,
      caseStatusId: 26,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FAP £395k\n50% = £197,500\nWill be selling an existing shared ownership property\n\n02/08/22 - Taken by Matthew Laws for qualifying\n                 - Previously qualified through Mortgages First who will be in contact with sage ",
      dateOfReferral: "2022-08-02T13:35:11.3589079",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T17:48:28.8297959",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 45000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 532,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Kaety Moon",
      advisor: "Kritika Dhain",
      referralUser: "Nicola Pike",
      id: 1418,
      caseRef: "SAG1028",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 140000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegal sold & quote emailed",
      dateOfReferral: "2022-08-02T14:26:52.170546",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-02T14:34:49.6694326",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-04T10:14:36.9753609",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nicola Davina Sabaroche",
      advisor: "Charlotte Fay",
      referralUser: "Shannon Chin-Sewell",
      id: 1419,
      caseRef: "SAG1029",
      referredById: 102,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "not qualified \n\nemployed  full time \n\nlooking for a shared ownership ( motion)",
      dateOfReferral: "2022-08-02T14:49:47.5445971",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T08:14:38.7410487",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 534,
      closedDate: "2022-08-03T08:28:50.2229161",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Karen Shaw",
      advisor: "Charlotte Fay",
      referralUser: "Steven Merralls",
      id: 1420,
      caseRef: "SAG1030",
      referredById: 243,
      caseStatusId: 27,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Disability benefit, not employed\nHas between 150k-190k form cash from sale\n\nThis has been qualified as a cash buyer, EA asked us to keep open as not sure on what is happening with the chain at the moment.\n",
      dateOfReferral: "2022-08-02T14:54:10.8430915",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T15:52:05.4614762",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 117500,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: 540,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Matthew Thorneycroft",
      advisor: "Ameliah Maio",
      referralUser: "Cassie Tovell",
      id: 1422,
      caseRef: "SAG1031",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 327500,
      plotNumber: "19 Dunnock Road",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "This is a second hand property \nfmv is £327,500\n\nowner is selling his 40% so this needs to be 40% min purchase = £131,000 \n\nService charge is £534 \n\n",
      dateOfReferral: "2022-08-02T15:07:01.9108387",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T11:04:10.1878201",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-03T11:05:39.9864476",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sandra Boakye",
      advisor: "Matthew Laws",
      referralUser: "Jas Sagoo",
      id: 1424,
      caseRef: "SAG1033",
      referredById: 299,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "02/08/22 - Taken by Matthew Laws for qualifying \n 03/08/22 - VM left",
      dateOfReferral: "2022-08-02T16:28:47.0347672",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T15:04:45.1546604",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 539,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Saphire Stirling",
      advisor: "Charlotte Fay",
      referralUser: "Jas Sagoo",
      id: 1425,
      caseRef: "SAG1034",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-03T08:52:08.4495687",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T08:53:38.4328958",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 11000,
      serviceCharge: 176.4,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-05T13:02:51.5198531",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "alice brooker",
      advisor: "Alison Cathcart",
      referralUser: "Madison Emery-Hyson",
      id: 1427,
      caseRef: "SAG1035",
      referredById: 231,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "This is for a mortgage appointment not for a house. Alice has got a MIP that she has gone straight to the bank (nationwide) for. she wants to speak to an advisor on Friday as she is off ",
      dateOfReferral: "2022-08-03T08:57:56.3084658",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T09:48:01.5565799",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-14T11:02:44.6099636",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "CHARLOTTE LEWIS",
      advisor: "Simon Dyer",
      referralUser: "Joe Evans",
      id: 1434,
      caseRef: "SAG1036",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT NEW BUILD REFERRAL - Please can someone call Charlotte on Thursday 4/8/22 - she has sold her current house through purple bricks. registered with me looking for 3 bed house/bungalow in stafford up to £240k. said has spoken to PB mortgage adviser. wants 2nd opinion please. JE\n\nHave emailed customer to organise a time to ring her tomorrow. SD 03/08 13:45\n\nHave left voicemail and sent email. SD 04/08 10:27am\n\nHave left voicemail and sent another email. SD 09/08 10:11am",
      dateOfReferral: "2022-08-03T12:05:02.4036593",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T09:11:25.1236478",
      isDeleted: 0,
      advisorId: 99,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-09T09:22:04.6617523",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Yasir Mahmood",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Roger Jackson",
      id: 1435,
      caseRef: "SAG1037",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB, needs MIP please 20k deposit ready \n\n\nNo number saved, sent an email\n\nFound number , left voicemail",
      dateOfReferral: "2022-08-03T12:24:15.7884084",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T08:40:03.8708968",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T08:50:57.7845505",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Olawale Oladokun",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Praveena Sharma",
      id: 1436,
      caseRef: "SAG1038",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Starting his property journey. FTB - Been renting for years. \n\nCall him tomorrow after 1pm \n\n3 bedroom",
      dateOfReferral: "2022-08-03T12:33:27.8254306",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T17:29:33.8356887",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 39,
      depositLevel: 38000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 551,
      closedDate: "2022-08-16T08:35:26.9989654",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Nasrin qayyum",
      advisor: "Gemma Painter",
      referralUser: "Roger Jackson",
      id: 1437,
      caseRef: "SAG1039",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "needs to re mortgage current house on a BTL and then will need a MIP for her onward purchase please ",
      dateOfReferral: "2022-08-03T12:36:00.7278835",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T12:52:16.810837",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Samantha Edwards",
      advisor: "Kritika Dhain",
      referralUser: "Praveena Sharma",
      id: 1441,
      caseRef: "SAG1041",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Her property on the market last week she will sell her property but wants to get some advice on what would be her best option. ",
      dateOfReferral: "2022-08-03T13:40:08.1912208",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T13:41:03.8653045",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 51,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-04T15:11:54.1829937",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lindsey Robertson",
      advisor: "Arjun Dhunna",
      referralUser: "Cassie Tovell",
      id: 1443,
      caseRef: "SAG1043",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 300000,
      plotNumber: "219",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "employed but does have her own business - Wedding photography\n\ndoes have her own adviser. \n\ncall after 5pm as at work",
      dateOfReferral: "2022-08-03T14:09:45.7320004",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T14:14:14.2418329",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-12T17:01:42.3427549",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Mizan Rahman",
      advisor: "Zeeshan Ashraf",
      referralUser: "Taylor Ruff ",
      id: 1445,
      caseRef: "SAG1044",
      referredById: 74,
      caseStatusId: 27,
      developmentId: 30,
      purchasePrice: 460000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Viewing motion tomorrow (thursday) - please call to qualify for shared ownership",
      dateOfReferral: "2022-08-03T14:30:00.328585",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T10:52:24.7648692",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: 553,
      closedDate: "2022-08-04T09:10:59.1608762",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Katie Hayhurst",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Taylor Ruff ",
      id: 1446,
      caseRef: "SAG1045",
      referredById: 74,
      caseStatusId: 27,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Interested in shared ownership - needs to qualify asap and wants to know her HTB budget - in need of an aip ",
      dateOfReferral: "2022-08-03T14:33:10.8698621",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T16:24:24.5893262",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Ghee Oonjai",
      advisor: "Kritika Dhain",
      referralUser: "Taylor Ruff ",
      id: 1447,
      caseRef: "SAG1046",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "needs to talk asap to qualify for shared ownership - viewing this thursday night \n\nKritika Dhain: Called Ghee 2 times and she has not picked up and left VM. 2 emails also sent out asking when I can call",
      dateOfReferral: "2022-08-03T14:36:31.1242303",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T10:16:23.7103399",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-04T15:13:18.1003486",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Moiz Janjua",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Roger Jackson",
      id: 1448,
      caseRef: "SAG1047",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Wants to keep current property, rent out and buy another . Needs a mip to start shopping \n\n\nFirst attempt to call , no answer\n\n08/08/22 - Second attempt, no answer",
      dateOfReferral: "2022-08-03T14:36:49.7611068",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T09:54:45.6997397",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T08:43:23.8317529",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "  Jeremiah Gordon-Yorke",
      advisor: "Kritika Dhain",
      referralUser: "Taylor Ruff ",
      id: 1449,
      caseRef: "SAG1048",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "qualify for shared ownership please - buying with sibling - ftb\n\nKritika Dhain: called Jeremiah 2 times and he has not picked up and no option to leave a VM. 2 emails also sent out asking when I can call",
      dateOfReferral: "2022-08-03T14:38:50.0593452",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T10:18:33.854189",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody",
      financialDetailsId: null,
      closedDate: "2022-08-04T14:46:20.9045997",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Jeremy Poland",
      advisor: "Charlotte Fay",
      referralUser: "Taylor Ruff ",
      id: 1451,
      caseRef: "SAG1050",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Qualify for shared ownership - viewing motion tomorrow ",
      dateOfReferral: "2022-08-03T14:52:51.8593626",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T14:55:52.7309996",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 100000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-04T10:42:04.7612542",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "  Ana Sarateanu",
      advisor: "Kritika Dhain",
      referralUser: "Taylor Ruff ",
      id: 1452,
      caseRef: "SAG1051",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Viewing motion tomorrow please qualify for shared ownership \n\nClients husband will be applying for the mortgage- clients name is- Alexandru Gusu. ",
      dateOfReferral: "2022-08-03T14:54:42.6552121",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T09:42:39.8491071",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-04T10:03:36.4723464",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Samuel Hewitt",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Cassie Tovell",
      id: 1462,
      caseRef: "SAG1059",
      referredById: 373,
      caseStatusId: 28,
      developmentId: 69,
      purchasePrice: 225000,
      plotNumber: "215000",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "single applicant. ",
      dateOfReferral: "2022-08-03T16:13:09.2801775",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T13:59:54.613479",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 16500,
      serviceCharge: 90,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-05T14:21:49.6757947",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "SabrIna Anderson",
      advisor: "Steven Sanderson",
      referralUser: "Cassie Tovell",
      id: 1464,
      caseRef: "SAG1061",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "buying on her own. \n\nI have x3 3 bedroom houses left. \n\n£425,000 is the maximum FMV",
      dateOfReferral: "2022-08-03T16:44:52.9350683",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:51:49.7293834",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 27000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "SAGE",
      financialDetailsId: 542,
      closedDate: "2022-08-21T09:59:14.8610604",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jason Kirby",
      advisor: "Peter Hill",
      referralUser: "Cassie Tovell",
      id: 1465,
      caseRef: "SAG1062",
      referredById: 373,
      caseStatusId: 26,
      developmentId: 66,
      purchasePrice: 380000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Site is not Gilden Way - Its Chalk Hall Farm in Sawbridgeworth - \n\nI have two bedroom houses coming at £380,000 FMV \nI dont have the correct service charge information but around £95 PCM\n\nWould like to know what he can afford. ",
      dateOfReferral: "2022-08-03T17:08:12.7232674",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-03T18:32:12.8463885",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sam Thomas",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1469,
      caseRef: "SAG1063",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 66,
      purchasePrice: 38500,
      plotNumber: "No be discussed ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "sstc - \n\nBEves sold. \n\nthis is a new site in Sawbridgeworth for Sage housing,. \nI am waiting for the go ahead but it should be this week or next week. \n\nI don't have the service charges at the moment so given an estimate. ",
      dateOfReferral: "2022-08-04T08:55:12.0330934",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T09:34:16.6906344",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 90,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Katie Dean ",
      advisor: "Steven Sanderson",
      referralUser: "Charlotte Smith",
      id: 1471,
      caseRef: "SAG1064",
      referredById: 305,
      caseStatusId: 28,
      developmentId: 24,
      purchasePrice: 265000,
      plotNumber: "511, 15 Atchinson",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-04T09:55:48.612132",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T14:21:49.3739857",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: 547,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Jasmine Larter",
      advisor: "Alison Cathcart",
      referralUser: "Charlotte Smith",
      id: 1474,
      caseRef: "SAG1065",
      referredById: 305,
      caseStatusId: 65,
      developmentId: 24,
      purchasePrice: 130000,
      plotNumber: "511, 15 Atchison ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Job Starting end of September. Client just finished uni and has secured a job",
      dateOfReferral: "2022-08-04T10:51:50.8204373",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T13:13:45.0194411",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 75,
      minPercShareAvailable: "50",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-17T17:22:23.6570925",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Denis Ronaldo Travasso",
      advisor: "Arjun Dhunna",
      referralUser: "Jas Sagoo",
      id: 1475,
      caseRef: "SAG1066",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 410000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-04T11:06:22.0766871",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T11:07:58.4413394",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 149.64,
      minPercShareAvailable: "25",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-05T11:22:06.5792225",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Martin Steven Cook",
      advisor: "Arjun Dhunna",
      referralUser: "Cassie Tovell",
      id: 1478,
      caseRef: "SAG1067",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: "Plot 203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "just had a baby 7 weeks ago \n\nmiss on maternity leave \nwould like both on the case \n\n",
      dateOfReferral: "2022-08-04T11:41:43.7316891",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T14:31:05.4504419",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 545,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Justine Concepcion",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 1483,
      caseRef: "SAG1068",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 400000,
      plotNumber: "78",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Dep: £30K-£40k\nTotal Income: £70k\nFTBs - Herself + Partner",
      dateOfReferral: "2022-08-04T12:00:19.7447597",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T12:06:57.4737857",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 136.68,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-09T12:29:18.3910802",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Brogan Read",
      advisor: "Ameliah Maio",
      referralUser: "Jamie Bodle",
      id: 1486,
      caseRef: "SAG1069",
      referredById: 111,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 270000,
      plotNumber: "35",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Applying with partner",
      dateOfReferral: "2022-08-04T14:40:46.7656977",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-04T16:32:00.1927049",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-04T16:32:05.8104574",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Joanna Osuch",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Ali Abbas",
      id: 1487,
      caseRef: "SAG1070",
      referredById: 312,
      caseStatusId: 32,
      developmentId: 38,
      purchasePrice: 465000,
      plotNumber: "b1.07.07",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-04T15:04:58.2222785",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T11:35:39.3250741",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Dario Cifuentes",
      advisor: "Arjun Dhunna",
      referralUser: "Abhishek Joshi",
      id: 1488,
      caseRef: "SAG1071",
      referredById: 314,
      caseStatusId: 27,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit: £20k\nHim + Partner: FTB\nIncome: Mr. £48k - Mrs. = £25k",
      dateOfReferral: "2022-08-04T15:34:16.1622426",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T11:13:37.2505183",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Adedayo Abioye",
      advisor: "Ameliah Maio",
      referralUser: "Cassie Tovell",
      id: 1493,
      caseRef: "SAG1072",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 66,
      purchasePrice: 450000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "call after 2pm as in a work meeting from 10am. \n\nThe sight we are referring for is a new site in Sawbridgeworth. \n\nThey are off plan reservations \n\n3 bedrooms are 450,000 \n2 bedrooms 385000\n\nno service charge info",
      dateOfReferral: "2022-08-05T08:23:44.4973153",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T08:25:48.1418944",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-05T14:09:36.6300192",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Joshua Kirwan",
      advisor: "Ameliah Maio",
      referralUser: "Cassie Tovell",
      id: 1494,
      caseRef: "SAG1073",
      referredById: 373,
      caseStatusId: 65,
      developmentId: 69,
      purchasePrice: 300000,
      plotNumber: "217 & 219",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "full time employed and also has self employed income",
      dateOfReferral: "2022-08-05T08:37:54.7824448",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T08:41:20.1808512",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-08T08:22:33.6115448",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sarah Hanbury",
      advisor: "Peter Hill",
      referralUser: "Praveena Sharma",
      id: 1495,
      caseRef: "SAG1074",
      referredById: 235,
      caseStatusId: 27,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Enquired about the shared ownership in March, wasn't ready to move forward then but now is. \n\nInterested in 2 bed. \n\n\nSarah qualifies for 30% of this property. Her house is only just on the market so not SSTC yet.",
      dateOfReferral: "2022-08-05T09:08:57.2103902",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T12:21:22.9239675",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: 563,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Bari Khan",
      advisor: "Matthew Laws",
      referralUser: "Abhishek Joshi",
      id: 1502,
      caseRef: "SAG1075",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 400000,
      plotNumber: "78",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n£6K-7K DEPO\nIncome: £33k ",
      dateOfReferral: "2022-08-05T10:23:29.799179",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T11:22:07.8577784",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 136.68,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 544,
      closedDate: "2022-08-05T11:28:58.1860682",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Christina Carter",
      advisor: "Peter Hill",
      referralUser: "Jamie Bodle",
      id: 1506,
      caseRef: "SAG1076",
      referredById: 111,
      caseStatusId: 27,
      developmentId: 62,
      purchasePrice: 200000,
      plotNumber: "46",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "05/08/22 - Taken by Matthew Laws for qualifying \n        ",
      dateOfReferral: "2022-08-05T11:21:12.6470168",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T16:26:37.0042784",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 50,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: 549,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 111,
    },
    {
      applicant: "Wing Tsee Law",
      advisor: "Aaron Heer",
      referralUser: "Ali Abbas",
      id: 1508,
      caseRef: "SAG1077",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 347500,
      plotNumber: "b1.02.06",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-05T11:59:22.2740318",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T16:17:54.4063997",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 208.1,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 558,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Harry Ashby",
      advisor: "Steven Sanderson",
      referralUser: "Roger Jackson",
      id: 1509,
      caseRef: "SAG1078",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "FTB, 7k deposit, needs a MIP please ",
      dateOfReferral: "2022-08-05T12:03:59.5797454",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T10:10:45.6224949",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 552,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Daniel Parkes",
      advisor: "Shanaz Parbin",
      referralUser: "Roger Jackson",
      id: 1516,
      caseRef: "SAG1079",
      referredById: 351,
      caseStatusId: 27,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Needs a new MIP asap please. House on market with us, roughly 45k in house, wants to buy around the 250k mark back in Burton ",
      dateOfReferral: "2022-08-05T13:48:53.1093039",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T14:51:20.7641851",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 45000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Kinneh Jarju",
      advisor: "Kritika Dhain",
      referralUser: "Lewis Ward",
      id: 1517,
      caseRef: "SAG1080",
      referredById: 232,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "interested shared ownership or traditional purchase depending on eligibility and affordability, completed on her house now £50K in the bank",
      dateOfReferral: "2022-08-05T13:56:11.6664978",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T13:59:01.097198",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 50000,
      serviceCharge: 50,
      minPercShareAvailable: "40%",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-08T13:57:15.3645679",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Lorna Murray",
      advisor: "Shanaz Parbin",
      referralUser: "Roger Jackson",
      id: 1519,
      caseRef: "SAG1081",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "FTB, needs a MIP ",
      dateOfReferral: "2022-08-05T14:23:05.2264845",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T15:00:06.4089794",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 9000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Emily Billimore",
      advisor: "Kritika Dhain",
      referralUser: "Callum Morton",
      id: 1521,
      caseRef: "SAG1082",
      referredById: 152,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 240000,
      plotNumber: "76",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-05T14:29:39.9335839",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T14:30:47.9163076",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 720,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-08T08:51:48.6870679",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Caroline Owen",
      advisor: "Shanaz Parbin",
      referralUser: "Roger Jackson",
      id: 1522,
      caseRef: "SAG1083",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Buying together ",
      dateOfReferral: "2022-08-05T14:48:10.7512792",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-05T15:08:58.396767",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 150000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Ben Bruton-Holmes and Chloe Bayton",
      advisor: "Steven Sanderson",
      referralUser: "Joe Evans",
      id: 1527,
      caseRef: "SAG1084",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 205000,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "THIS IS NOT A NEW BUILD/SAGE LEAD - They have offered on 48 Burton Bank Lane, ST17 9JW through me at £205,000. they want to put down a 5% deposit. have AIP in place with L&C but open to 2nd opinion and offer qualification. Please call ASAP to do this - tel no provided is for Chloe.\nThanks, Jo",
      dateOfReferral: "2022-08-06T11:52:12.3679997",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-07T12:04:35.305551",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-08T14:11:50.4205751",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Chris Sharples",
      advisor: "Peter Hill",
      referralUser: "Nicola Pike",
      id: 1528,
      caseRef: "SAG1085",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "PLEASE CALL MONDAY \n\nChris is a self employed sports commentator and Sarah works or him on his books.\n\nFTB\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-06T11:52:24.4484373",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-06T12:34:27.0704131",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Ben Blakeborough",
      advisor: "Paul Parker",
      referralUser: "Ryan Cheetham",
      id: 1532,
      caseRef: "SAG1086",
      referredById: 228,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "BEN IS OFF A MONDAY SO WELCOME TO CONTACT ANYTIME .... ",
      dateOfReferral: "2022-08-06T13:36:53.1409794",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T16:26:02.3178134",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 120000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-09T17:26:40.1455107",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Simon Herridge",
      advisor: "Paul Parker",
      referralUser: "Lewis Ward",
      id: 1533,
      caseRef: "SAG1087",
      referredById: 232,
      caseStatusId: 27,
      developmentId: 88,
      purchasePrice: 160000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Simon Is a first time buyer looking for some FS advice, he has no current AIP and has not spoken to any other brokers or lenders.\nHe has looked at shared owner ship and hep to buy but thinks he will be able to buy privately.\nwould prefer to avoid new home if possible.",
      dateOfReferral: "2022-08-06T14:42:18.8182533",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T09:19:07.7143555",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kim Williams",
      advisor: "Paul Parker",
      referralUser: "Ryan Cheetham",
      id: 1534,
      caseRef: "SAG1088",
      referredById: 228,
      caseStatusId: 27,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please contact on Monday, she is a school worker so off now. She needs to know if can afford just based on her income as splitting with ex. Large deposit is to come cash from sale, not under offer yet",
      dateOfReferral: "2022-08-06T14:53:48.7467438",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T17:26:57.2943821",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Myra Ferreira",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1539,
      caseRef: "SAG1089",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 467500,
      plotNumber: "b1.06.08",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-08T09:12:12.6449358",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T09:14:01.4003532",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 220.44,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T07:59:38.2515789",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Nandar Thaw",
      advisor: "Matthew Laws",
      referralUser: "Daisie Naughton",
      id: 1542,
      caseRef: "SAG1090",
      referredById: 311,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 450000,
      plotNumber: "B10605",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-08T10:25:46.3803189",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T17:03:54.4544704",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 560,
      closedDate: "2022-08-08T17:06:57.1873003",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 120,
    },
    {
      applicant: "Yewande Alabi",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 1543,
      caseRef: "SAG1091",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 450000,
      plotNumber: "B1.06.06",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-08T10:42:05.5623212",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T08:15:44.1800893",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 208.36,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-11T08:52:52.056527",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Helen collins",
      advisor: "Ameliah Maio",
      referralUser: "Gareth Harmer",
      id: 1546,
      caseRef: "SAG1092",
      referredById: 385,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 395000,
      plotNumber: "Three Beds",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nFull Market Price on 2 Beds £395 min 50% share = £197,500",
      dateOfReferral: "2022-08-08T11:00:12.9578267",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T14:52:55.8928683",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 88,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T08:03:21.5012926",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Mr Wellington Abayomi",
      advisor: "Aaron Heer",
      referralUser: "Damian Herrelle",
      id: 1547,
      caseRef: "SAG1093",
      referredById: 177,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-08T11:04:07.1514066",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T11:43:45.2273495",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 28000,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing Association",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Emad Nasri ",
      advisor: "Alison Cathcart",
      referralUser: "Taylor Ruff ",
      id: 1548,
      caseRef: "SAG1094",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 457000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "For Motion - FTB - buying with partner - combined earnings around 60K - 20K deposit.",
      dateOfReferral: "2022-08-08T11:08:21.4133265",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T13:51:21.1836604",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: 554,
      closedDate: "2022-08-17T17:35:28.2138298",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Alicia Beautement",
      advisor: "Ameliah Maio",
      referralUser: "Daisy May Tait Davies",
      id: 1549,
      caseRef: "SAG1095",
      referredById: 192,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 140000,
      plotNumber: "150,000",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Due to complete mid sept on her property ",
      dateOfReferral: "2022-08-08T11:14:08.1956301",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T11:15:17.6366482",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Homes ",
      financialDetailsId: null,
      closedDate: "2022-08-10T08:05:23.0454234",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ahmed Hag-Ali",
      advisor: "Arjun Dhunna",
      referralUser: "Ali Abbas",
      id: 1552,
      caseRef: "SAG1096",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 367500,
      plotNumber: "b1.07.10",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-08T12:21:41.432377",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T12:00:20.4204291",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 564,
      closedDate: "2022-08-10T08:43:19.584006",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Nicola Catherine Ford",
      advisor: "Phillip Nutter",
      referralUser: "Nicola Pike",
      id: 1555,
      caseRef: "SAG1097",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call asap\nNikki would like to go for 50% if possible\nLegals sold\n\n50 Gibson Road\nNP12 4QW\n2017\n\n",
      dateOfReferral: "2022-08-08T13:07:01.4459931",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T13:59:34.1173137",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-19T15:53:27.3756953",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Caroline Fernandes",
      advisor: "Paul Parker",
      referralUser: "Jas Sagoo",
      id: 1559,
      caseRef: "SAG1098",
      referredById: 299,
      caseStatusId: 28,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "if it does not fit,we can get a reduction of 3%",
      dateOfReferral: "2022-08-08T14:39:38.1127534",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-22T10:35:16.8112685",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: 559,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Monika Piotras",
      advisor: "Kritika Dhain",
      referralUser: "Abhishek Joshi",
      id: 1562,
      caseRef: "SAG1099",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 410000,
      plotNumber: "43",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\nDeposit: £25k\nIncome: £24k \nHas a Yorkshire Terrier\n",
      dateOfReferral: "2022-08-08T14:59:18.7406734",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T15:00:58.6772821",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 149.46,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T10:12:44.3081276",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Sheyla Tapia",
      advisor: "Arjun Dhunna",
      referralUser: "Taylor Ruff ",
      id: 1563,
      caseRef: "SAG1100",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 480000,
      plotNumber: "235000",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Motion - FTB - 2 bed - deposit 10K - 65K per year. Employed. Has a dog - working in central. ",
      dateOfReferral: "2022-08-08T15:08:33.413825",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T09:47:19.2612966",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 184,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-16T11:54:00.0743741",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Mohomed Sama",
      advisor: "Arjun Dhunna",
      referralUser: "Graham Lang",
      id: 1564,
      caseRef: "SAG1101",
      referredById: 104,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 320000,
      plotNumber: "295",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Earns 42,000 plus £3,000 bonus partner works 7 hours a week and earns £3,000 pa \n\nNo loans or car finance \n£1,700 credit card balance \n\n45% of £320,000 FMV\n\nCan call anytime tomorrow \n",
      dateOfReferral: "2022-08-08T15:22:04.7375738",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T11:28:38.3662362",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 45,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-22T10:40:15.2897288",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Rebecca Adebayo",
      advisor: "Laura Turner",
      referralUser: "Graham Lang",
      id: 1565,
      caseRef: "SAG1102",
      referredById: 104,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "36",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Earns £42,000 \n\nNo loans or credit card balance \n\n2 children ",
      dateOfReferral: "2022-08-08T15:27:43.7674782",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T16:04:08.3970582",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 45,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Homes ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Kirsty Yakub",
      advisor: "Joanna Halliday",
      referralUser: "Vicki Hough",
      id: 1566,
      caseRef: "SAG1103",
      referredById: 322,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Macclesfield applicant.\nBuy to let investor.\nPreviously worked with IFA but hasn't got back in touch,",
      dateOfReferral: "2022-08-08T15:28:58.8982617",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-08T15:44:56.9620967",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-09T10:23:13.1256639",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Veneethamol Thomas",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Roger Jackson",
      id: 1568,
      caseRef: "SAG1104",
      referredById: 351,
      caseStatusId: 65,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "Needs a MIP please. ",
      dateOfReferral: "2022-08-08T16:11:25.9489587",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T08:02:08.6812798",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T08:47:36.1931221",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Jessica Rea ",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Roksanna Floryzak",
      id: 1569,
      caseRef: "SAG1105",
      referredById: 229,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "It's for mortgage not a house. Can have appointment anytime on  Wednesday or Friday.",
      dateOfReferral: "2022-08-08T16:15:42.6559541",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T08:04:34.9838408",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T08:44:14.3417495",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Rebecca King",
      advisor: "Peter Hill",
      referralUser: "Roger Jackson",
      id: 1570,
      caseRef: "SAG1106",
      referredById: 351,
      caseStatusId: 26,
      developmentId: 178,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Rebecca sold her property to buy with her partner who is a first time buyer \n\ncalled and left voice mail and emailed 12th aug\n\nwill try again",
      dateOfReferral: "2022-08-08T16:27:14.4709395",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:44:30.13952",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 34000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Daniel Heatley",
      advisor: "Arjun Dhunna",
      referralUser: "Reuben Gittings",
      id: 1581,
      caseRef: "SAG1107",
      referredById: 215,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Not new build \nFirst time buyer - got £30k deposit and getting other advice\nBest time to call is 12-1 or after 5",
      dateOfReferral: "2022-08-09T09:13:54.1409074",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T09:15:08.2844069",
      isDeleted: 0,
      advisorId: 77,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-18T11:37:28.8961073",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Angelina Osei Owusu",
      advisor: "Charlotte Fay",
      referralUser: "Nicola Pike",
      id: 1583,
      caseRef: "SAG1108",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "Plot 156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Please call asap\n\nThis site is currently sold out but this plot is about to fall through.",
      dateOfReferral: "2022-08-09T09:24:05.8645706",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T14:46:48.5603341",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 561,
      closedDate: "2022-08-09T14:57:19.6099924",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Alice Fox",
      advisor: "Kritika Dhain",
      referralUser: "Nicola Pike",
      id: 1585,
      caseRef: "SAG1109",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 81",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-09T09:51:45.7833505",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T09:54:34.1361523",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T12:31:10.0844391",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Paul Sproston",
      advisor: "Kritika Dhain",
      referralUser: "Nicola Pike",
      id: 1586,
      caseRef: "SAG1110",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-09T10:09:37.4922946",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T10:17:10.7394627",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-10T15:36:58.6426197",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Daniel Walker",
      advisor: "Laura Turner",
      referralUser: "Ryan Laurence",
      id: 1587,
      caseRef: "SAG1111",
      referredById: 142,
      caseStatusId: 27,
      developmentId: 31,
      purchasePrice: 255000,
      plotNumber: "89",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Address is Branch.\n\nDidn't have current address.\nWill ned to speak to mortgage advisor! \nAvailable on Friday",
      dateOfReferral: "2022-08-09T10:19:10.9854078",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:45:04.5592397",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 115,
    },
    {
      applicant: "Priscille Mpouli",
      advisor: "Alison Cathcart",
      referralUser: "Dominka Zych",
      id: 1589,
      caseRef: "SAG1112",
      referredById: 165,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "318 82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-09T11:00:09.3124706",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T13:11:13.9906324",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 11000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Jahedul Alam",
      advisor: "Charlotte Fay",
      referralUser: "Dominka Zych",
      id: 1591,
      caseRef: "SAG1113",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "318 82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-09T11:06:00.2484931",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T11:08:28.3290355",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-11T10:42:33.9653404",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Sophie Willison",
      advisor: "Kritika Dhain",
      referralUser: "Ali Abbas",
      id: 1593,
      caseRef: "SAG1114",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 365000,
      plotNumber: "b1.06.02",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-09T11:52:32.7702947",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T12:07:48.2371709",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T09:59:32.3996782",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Gustavo Giallonardo",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 1594,
      caseRef: "SAG1115",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 362500,
      plotNumber: "b1.06.04",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-09T12:04:40.3321516",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T12:20:17.8957347",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-10T08:36:50.4502898",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Steffi Madub",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 1596,
      caseRef: "SAG1116",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nDeposit: £60k\nIncome: £25k (Lettings Co-ordinator for Savills - works in Waterloo and needs to good transport)\nJust her buying\n\nDoesnt qualify at 435,000, would qualify for anything at 337k",
      dateOfReferral: "2022-08-09T13:22:18.5520933",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T15:27:58.2783316",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 562,
      closedDate: "2022-08-09T15:59:27.6363868",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Elisse Funnell",
      advisor: "Shanaz Parbin",
      referralUser: "Cassie Tovell",
      id: 1598,
      caseRef: "SAG1117",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: "198",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "both employeed \n\n2 bedrooms are £380,000",
      dateOfReferral: "2022-08-09T14:41:36.3908241",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T15:43:04.519765",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Shazia Jaleel",
      advisor: "Ameliah Maio",
      referralUser: "Jas Sagoo",
      id: 1603,
      caseRef: "SAG1118",
      referredById: 299,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Deposit 120k\nIncome 45k\nHusband 37k\nMay want to take mortgage or buy 25% cash",
      dateOfReferral: "2022-08-09T15:37:24.2102798",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T15:39:30.9609469",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 120000,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "2022-08-12T10:55:33.7419914",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Mr Oluwa Mayowa Balogun",
      advisor: "Charlotte Fay",
      referralUser: "Damian Herrelle",
      id: 1605,
      caseRef: "SAG1119",
      referredById: 177,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: null,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Is working in Barcelona this week so better to call next week. The number provided is mum (Mrs Dupe Balogun) Is available via email for now. Ideally looking for a 1 bed apartment not ground floor. ",
      dateOfReferral: "2022-08-09T16:39:18.4688762",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T13:17:25.2367681",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 6,
      serviceCharge: null,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-19T14:02:23.0661202",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Poppy Kasapidis",
      advisor: "Joanna Halliday",
      referralUser: "Natasha Forsyth",
      id: 1606,
      caseRef: "SAG1120",
      referredById: 214,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Ignore bottom half of notes - we are referring to you as we do not have an FS person in branch at the moment\n.\nPoppy and her partner are FTB only been to Bank - Barclays - have an AIP\n- can afford £250k they have an AIP for £180k and deposit of £50,000.\nI offered that JM can call her to see what we can offer as if Barclays are their only option as a bank and things go wrong they could lose out - Barclays also on our panel. \nGood luck :)\nShe seemed open to having a chat. ",
      dateOfReferral: "2022-08-09T16:54:42.0468183",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-09T17:42:39.8206822",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 29,
    },
    {
      applicant: "Lisa Thurley",
      advisor: "Joanna Halliday",
      referralUser: "Cassie Tovell",
      id: 1607,
      caseRef: "SAG1121",
      referredById: 373,
      caseStatusId: 26,
      developmentId: 69,
      purchasePrice: 380000,
      plotNumber: "Sawbridgeworth Park",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking to buyer SO but needs to know what is available \n\nLooking at wither a two bedroom flat in Newhall at £300 FMV \n\nSawbridgeworth Park - 380,000 FMV \n\nPlease help her ",
      dateOfReferral: "2022-08-09T18:46:31.039235",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T05:45:44.6851943",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Jessica Micallef",
      advisor: "Joanna Halliday",
      referralUser: "Nicola Pike",
      id: 1608,
      caseRef: "SAG1122",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 1,
      purchasePrice: 237500,
      plotNumber: "Plot 428",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Orchard View Site - Sanctuary Homes\n\nLegals sold & quote emailed.",
      dateOfReferral: "2022-08-09T19:54:37.8299792",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T05:47:10.961874",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 26.24,
      minPercShareAvailable: "40%",
      housingAssociation: "Sanctuary Housing",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Kwame Gyamerah",
      advisor: "Kritika Dhain",
      referralUser: "Dominka Zych",
      id: 1611,
      caseRef: "SAG1123",
      referredById: 165,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "319 84 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-10T08:55:41.1110091",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T09:11:53.4277166",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-12T12:26:32.3586731",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Marlena Kujawa",
      advisor: "Peter Hill",
      referralUser: "Dominka Zych",
      id: 1612,
      caseRef: "SAG1124",
      referredById: 165,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "319 84 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Client is going on holiday and will be back on 26/08/22",
      dateOfReferral: "2022-08-10T09:10:38.0214108",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T15:27:01.6264",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Josh Quarcoo",
      advisor: "Kritika Dhain",
      referralUser: "Taylor Ruff ",
      id: 1613,
      caseRef: "SAG1125",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 480000,
      plotNumber: "235",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "For motion - FTB - buying on his own - 46K earnings pa - deposit 20K. Employed. ",
      dateOfReferral: "2022-08-10T09:58:53.1919965",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T10:02:29.4208684",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 184,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-15T08:06:10.6205803",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Denise Pierre Powell",
      advisor: "Charlotte Fay",
      referralUser: "Abhishek Joshi",
      id: 1614,
      caseRef: "SAG1126",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 500000,
      plotNumber: "11",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\nTotal income: £55k\nDeposit: £7,500\n4 people in the family\nHusband is main bread winner",
      dateOfReferral: "2022-08-10T10:41:03.5159195",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T15:25:34.2410034",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 7500,
      serviceCharge: 198.06,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 566,
      closedDate: "2022-08-11T15:31:04.2073563",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jonathan Green",
      advisor: "Ameliah Maio",
      referralUser: "Nicola Pike",
      id: 1615,
      caseRef: "SAG1127",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 81 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB \n\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-10T11:20:40.8575258",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T11:22:22.1951195",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T09:19:02.0851248",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Natalie  O'Shaughnessy",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1618,
      caseRef: "SAG1128",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b10708",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-10T14:03:45.5505048",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T14:04:34.3424417",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 220.96,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-12T10:54:01.8550506",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Paresh Davda",
      advisor: "Paul Parker",
      referralUser: "Graham Lang",
      id: 1619,
      caseRef: "SAG1129",
      referredById: 104,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "37",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Household income of £47,000 \n\nNo card balances but car loan £297 pm \n\nPLEASE CALL BEFORE 5pm ",
      dateOfReferral: "2022-08-10T14:07:36.9757895",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T16:15:55.394906",
      isDeleted: 0,
      advisorId: 39,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 45,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Othmane Allaf",
      advisor: "Laura Turner",
      referralUser: "Jas Sagoo",
      id: 1620,
      caseRef: "SAG1130",
      referredById: 299,
      caseStatusId: 27,
      developmentId: 39,
      purchasePrice: 430000,
      plotNumber: "60",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "income 39k \n2 bed with parking ",
      dateOfReferral: "2022-08-10T14:09:52.303896",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T14:46:33.3932775",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 176.76,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Mamoon Ahmad",
      advisor: "Peter Hill",
      referralUser: "Graham Lang",
      id: 1622,
      caseRef: "SAG1131",
      referredById: 104,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "36 or 37 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Household income £40,000\n\n£25K deposit \n\n£400 credit card balance \n\nMamoon was just out of qualification for this property but is looking at others and would still like us to help him with his mortgage for when he finds something please. ",
      dateOfReferral: "2022-08-10T14:51:14.4585374",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T07:43:47.1606602",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 45,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Homes ",
      financialDetailsId: 567,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Robert Morris",
      advisor: "Rachel Davies",
      referralUser: "Reuben Gittings",
      id: 1624,
      caseRef: "SAG1132",
      referredById: 215,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 150750,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Interested in shared ownership, but it is a re-sale. Please ignore notes in 2nd section.\n\nNeeds a mortgage in principal, and open to advice on whether he needs shared ownership or not.",
      dateOfReferral: "2022-08-10T14:59:22.5259826",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-10T15:17:46.605894",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-11T09:34:38.4747277",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Jayram Sony",
      advisor: "Joanna Halliday",
      referralUser: "Taylor Ruff ",
      id: 1629,
      caseRef: "SAG1133",
      referredById: 74,
      caseStatusId: 27,
      developmentId: 30,
      purchasePrice: 480000,
      plotNumber: "235",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "For Motion -  FTB - 55K annual income - self employed - buying alone - 10K deposit. \n\nchecked wiht tayhlor 11.8.22 and property still availbale\n",
      dateOfReferral: "2022-08-10T16:29:48.7212557",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T14:25:25.2244497",
      isDeleted: 0,
      advisorId: 13,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 184,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Sarko ahmad",
      advisor: "Charlotte Fay",
      referralUser: "Reiss Garwood",
      id: 1631,
      caseRef: "SAG1134",
      referredById: 101,
      caseStatusId: 65,
      developmentId: 22,
      purchasePrice: 460000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-10T17:20:05.2985948",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T08:04:47.7197481",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 57000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-15T15:18:05.3766376",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "fsdf",
      advisor: "Keesha Anderson-Williams",
      referralUser: "Trevor Hicks",
      id: 1632,
      caseRef: "SAG1135",
      referredById: 1,
      caseStatusId: 65,
      developmentId: 27,
      purchasePrice: 3,
      plotNumber: "3",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "0001-01-01T00:00:00",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T05:30:39.3912396",
      isDeleted: 0,
      advisorId: 97,
      propertyStatusId: 40,
      depositLevel: 3,
      serviceCharge: 3,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T11:14:46.6416476",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 86,
    },
    {
      applicant: "Stephen Morgan",
      advisor: "Rachel Davies",
      referralUser: "Taylor Ruff ",
      id: 1634,
      caseRef: "SAG1136",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 480000,
      plotNumber: "235",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Motion - viewing tonight please call asap to qualify - Renting at the moment - 120K for deposit - 45K Salary. Employed. ",
      dateOfReferral: "2022-08-11T08:21:11.5792721",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T11:29:00.6863099",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 120000,
      serviceCharge: 184,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-16T14:05:24.5944572",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Mongkol Theeralak",
      advisor: "Rachel Davies",
      referralUser: "Ali Abbas",
      id: 1635,
      caseRef: "SAG1137",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 3675000,
      plotNumber: "b1.07.04",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-11T08:25:15.8053815",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T08:27:38.8863881",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 18000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T14:02:51.9908584",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Dariusz Karczewski",
      advisor: "Charlotte Fay",
      referralUser: "Graham Lang",
      id: 1637,
      caseRef: "SAG1139",
      referredById: 104,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "36 or 37 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Basic £26,860 plus overtime \n\nCash Isa with £12,000\n\nRenting \n\nNo Loans or finance \n\nAvailable now for call ",
      dateOfReferral: "2022-08-11T09:58:02.3747824",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T09:58:53.5806765",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 45,
      minPercShareAvailable: "45",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "2022-08-12T10:55:46.3846196",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Marius Voica",
      advisor: "Peter Hill",
      referralUser: "Ali Abbas",
      id: 1640,
      caseRef: "SAG1140",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 470000,
      plotNumber: "b10708",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Both work at the Sainsburys - Marius hired Gerzena! They are engaged, both FTB",
      dateOfReferral: "2022-08-11T10:39:29.8778739",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T15:46:07.9157644",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 40,
      depositLevel: 60000,
      serviceCharge: 220.96,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 569,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Said Burkhanov",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Ali Abbas",
      id: 1646,
      caseRef: "SAG1141",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 450000,
      plotNumber: "b10605",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "",
      dateOfReferral: "2022-08-11T13:24:50.8513334",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T14:16:21.6503899",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-22T10:12:29.7011562",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Shahzad Ul Hassan",
      advisor: "Laura Turner",
      referralUser: "Cassie Tovell",
      id: 1651,
      caseRef: "SAG1142",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: "Newhall - ideally a house. ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Employed - is married \ndon't want to add wife but if its not enough then she could add on she dont earn alot \n\nDont have the correct service charge. ",
      dateOfReferral: "2022-08-11T15:32:02.132785",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T16:36:17.3768401",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 100000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Katie Cosgriff",
      advisor: "Kritika Dhain",
      referralUser: "Nicola Pike",
      id: 1652,
      caseRef: "SAG1143",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "Plot 112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB currently living with parents\n\nLegals Sold & quote emailed",
      dateOfReferral: "2022-08-11T15:38:20.2064693",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-11T15:39:13.9792735",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-19T14:24:37.0769803",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Adwait Kulkarni",
      advisor: "Ameliah Maio",
      referralUser: "Abhishek Joshi",
      id: 1661,
      caseRef: "SAG1144",
      referredById: 314,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Dep: £35k\nIncome: £60k\n2 bed w/ Parking",
      dateOfReferral: "2022-08-12T08:40:15.4338837",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T08:41:42.6450405",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-18T11:08:53.1087286",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "iwona ",
      advisor: "Alison Cathcart",
      referralUser: "Madison Emery-Hyson",
      id: 1670,
      caseRef: "SAG1146",
      referredById: 231,
      caseStatusId: 26,
      developmentId: 88,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "She wants a mortgage appointment not a house. She hasn't really spoken to anyone about a mortgage. Has 100,000 deposit and is looking at houses to flip. I am showing her round some auction houses on Monday. ",
      dateOfReferral: "2022-08-12T13:02:55.9805795",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T10:49:35.4672844",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "  Iulian Dostelnicu",
      advisor: "Kritika Dhain",
      referralUser: "Corrina Davie",
      id: 1671,
      caseRef: "SAG1147",
      referredById: 180,
      caseStatusId: 65,
      developmentId: 33,
      purchasePrice: 360000,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-12T13:18:56.0381003",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T08:40:16.7455268",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: null,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-17T09:01:39.9214196",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Hedieh Latifoltojar",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1673,
      caseRef: "SAG1148",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 367500,
      plotNumber: "b10703",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-12T13:25:27.604312",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T13:27:10.8717896",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 35000,
      serviceCharge: 225.95,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-12T13:59:10.1492679",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Heather Clack",
      advisor: "Kritika Dhain",
      referralUser: "Katie Rigden",
      id: 1675,
      caseRef: "SAG1149",
      referredById: 244,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Nothing to sell",
      dateOfReferral: "2022-08-12T13:58:13.7764944",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T13:59:26.0918873",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-17T08:57:53.4558379",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Billy whitehead",
      advisor: "Charlotte Fay",
      referralUser: "Katie Rigden",
      id: 1677,
      caseRef: "SAG1150",
      referredById: 244,
      caseStatusId: 65,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "First time buyer",
      dateOfReferral: "2022-08-12T14:12:30.9553293",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T13:51:26.6447361",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-15T14:36:45.1564854",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Charlie Leslie",
      advisor: "Charlotte Fay",
      referralUser: "Josh Taylor",
      id: 1678,
      caseRef: "SAG1151",
      referredById: 114,
      caseStatusId: 65,
      developmentId: 29,
      purchasePrice: 235000,
      plotNumber: "109",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Interested in new build. Needs to be qualified, we are doing referrals on the plots.  Development is Redland Grange in Cottenham. Unsure on her deposit levels ",
      dateOfReferral: "2022-08-12T14:18:11.3500451",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T14:38:23.828354",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 600,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T08:17:58.2897946",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 114,
    },
    {
      applicant: "Alison Whitney",
      advisor: "Kritika Dhain",
      referralUser: "Sam Bowyer",
      id: 1680,
      caseRef: "SAG1152",
      referredById: 28,
      caseStatusId: 65,
      developmentId: 88,
      purchasePrice: 235000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "In rented\n61",
      dateOfReferral: "2022-08-12T15:24:56.3874626",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-12T15:28:14.3259167",
      isDeleted: 0,
      advisorId: 378,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-17T13:15:28.7255444",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Phoebe Hughes",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Ryan Cheetham",
      id: 1692,
      caseRef: "SAG1153",
      referredById: 228,
      caseStatusId: 27,
      developmentId: 88,
      purchasePrice: 94000,
      plotNumber: "112",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Works at a school, so now off. Able to contact anytime today ",
      dateOfReferral: "2022-08-15T08:41:16.5852222",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T13:03:36.9504552",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Mohammad Khan",
      advisor: "Ravneet Sokhi",
      referralUser: "Taylor Ruff ",
      id: 1693,
      caseRef: "SAG1154",
      referredById: 74,
      caseStatusId: 26,
      developmentId: 30,
      purchasePrice: 460000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "For motion - ftb - EMPLOYED with sky and self employed with uber - 42K salary - 15000 for deposit. ",
      dateOfReferral: "2022-08-15T08:46:14.9121756",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T08:48:22.2131064",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Joshua Kirwan",
      advisor: "Ravneet Sokhi",
      referralUser: "Cassie Tovell",
      id: 1695,
      caseRef: "SAG1155",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 300000,
      plotNumber: "217",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Single Applicant \n\nPlease call after 2.30 as he is at work. \n\nLooking at Plot 217 Newhall. \n\ndeposit - please discuss this with Joshua as i spoke to his partner and she was not 100% sure. \n\nAddress given is partners not his.. \n",
      dateOfReferral: "2022-08-15T09:01:29.7680373",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T14:28:11.6097693",
      isDeleted: 0,
      advisorId: 92,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Myra Ferreira",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1697,
      caseRef: "SAG1156",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 467500,
      plotNumber: "b1.06.08",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-15T09:21:39.452487",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:37:45.135435",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 8000,
      serviceCharge: 220.44,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-15T09:37:52.2258659",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jack Davis",
      advisor: "Aaron Heer",
      referralUser: "Praveena Sharma",
      id: 1699,
      caseRef: "SAG1157",
      referredById: 235,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ftb - 3 beds - girlfriend called to say her boyfriend is interested in these properties. Was keen to know if they could purchase more than 75% share as well. \nDepo: 15,000 \nEmployed - Paramedic \n",
      dateOfReferral: "2022-08-15T09:37:31.2045154",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T09:39:00.9698451",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Zeeshan Muhamamd Iqbal",
      advisor: "Matthew Laws",
      referralUser: "Reiss Garwood",
      id: 1700,
      caseRef: "SAG1158",
      referredById: 101,
      caseStatusId: 65,
      developmentId: 22,
      purchasePrice: 114000,
      plotNumber: "203 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "15/08/22 - Taken by Matthew Laws for Qualifying \n                - VM left \n16/08/22 - VM left \n17/08/22 - VM left \n\n***Max calls Reached***",
      dateOfReferral: "2022-08-15T09:45:36.1995483",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T09:42:19.2147332",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody",
      financialDetailsId: null,
      closedDate: "2022-08-17T09:56:26.9363326",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Benjamin Hewitt",
      advisor: "Adam Faulkner",
      referralUser: "Taylor Ruff ",
      id: 1701,
      caseRef: "SAG1159",
      referredById: 74,
      caseStatusId: 27,
      developmentId: 30,
      purchasePrice: 480000,
      plotNumber: "235",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Motion - FTB - Deposit 15000 - Annual income 70K - Buying with partner. Employed. ",
      dateOfReferral: "2022-08-15T10:12:02.4480759",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T10:45:07.2355867",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 184,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Gabby Stropute",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 1702,
      caseRef: "SAG1160",
      referredById: 235,
      caseStatusId: 65,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "113",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Spilt up with her partner so he is taking her out of the share. She is looking for a 3 bed ideally, her deposit will come from the sale of her share.\n\n15/08/22 - Taken by Matthew Laws for qualifying \n                - No longer interested in property as will be too close to where her current home is ",
      dateOfReferral: "2022-08-15T10:49:48.2160624",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T14:20:23.4153287",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-15T14:25:35.3300161",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lauren Brown",
      advisor: "Charlotte Innes",
      referralUser: "Cassie Tovell",
      id: 1710,
      caseRef: "SAG1162",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 66,
      purchasePrice: 490000,
      plotNumber: "Sawbridge park ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Both Employed \nDeposit - has 6k saved \n\nSawbridge park is a new site and i don't have the service charge information as yet. ",
      dateOfReferral: "2022-08-15T13:31:32.8673559",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T17:47:46.0496257",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 6000,
      serviceCharge: 95,
      minPercShareAvailable: "25%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Bevon Burke",
      advisor: "Steven Sanderson",
      referralUser: "Cassie Tovell",
      id: 1711,
      caseRef: "SAG1163",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 66,
      purchasePrice: 420000,
      plotNumber: "Sawbridge Park ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "In rented \nFTB\n\nMr self employed - 4/5 years - photographer. set up as ltd company. has accountant for the work. \n\n\nmiss ft in nhs - radiographer - working there 4 years \n\nsavings through money box \n£6,000 combined \n\nwe will have two bedrooms available that will be around £470,000/460,000",
      dateOfReferral: "2022-08-15T13:43:28.1140515",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T08:56:28.9233731",
      isDeleted: 0,
      advisorId: 57,
      propertyStatusId: 39,
      depositLevel: 5250,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage ",
      financialDetailsId: 576,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Mrs Ann Marie Jervis",
      advisor: "Nadia Bandula ",
      referralUser: "Joe Evans",
      id: 1712,
      caseRef: "SAG1164",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 3,
      purchasePrice: 250000,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Can you please call Ann Marie within the next 24 hours. she called about Sage shared ownership, which we have no plots left atm but wants to check her eligibility now in case we get anymore. she is looking for a property in Penkridge only. her ex husband is buying her out of marital home. she thinks she can go up to £250k.\n\nPlease call Ann Marie Tuesday between 5:15 - 6:45\n\n",
      dateOfReferral: "2022-08-15T15:34:42.2962297",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T07:51:47.5121516",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 574,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Beth Mackintosh",
      advisor: "Matthew Laws",
      referralUser: "Praveena Sharma",
      id: 1713,
      caseRef: "SAG1165",
      referredById: 235,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 235000,
      plotNumber: "111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Already has a mortgage with redrow house mortgage interested in 2 or 3 bed properties\n has 5-10% depo\n\n15/08/22 - Taken by Matthew Laws for qualifying \n                - Conducted half of qualifying call but then Beth had to go\n16/08/22 - VM left \n17/08/22 - VM left and email sent ",
      dateOfReferral: "2022-08-15T15:39:15.5133142",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T10:01:02.40227",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Natalia Protab",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 1715,
      caseRef: "SAG1166",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 367500,
      plotNumber: "b10702",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "15/08/22 - Taken by Matthew Laws for qualifying \n                - VM left\n17/08/22 - VM left and email sent \n                - Currently in Madrid. Will be calling Monday ",
      dateOfReferral: "2022-08-15T16:08:59.1919042",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-22T11:15:48.7344834",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jeff Christian Marcos",
      advisor: "Kelly Powers",
      referralUser: "Vicki Hough",
      id: 1717,
      caseRef: "SAG1167",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 200000,
      plotNumber: "0000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Congleton Applicant\nNot new build\nFTB\nViewing Hutton Drive (160k) and Clayton Avenue (200k).\nCurrent AIP up to £220,000 with Nationwide.\nWould like to explore the rest of the market.",
      dateOfReferral: "2022-08-15T16:31:13.0057743",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-15T16:54:35.9553565",
      isDeleted: 0,
      advisorId: 94,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Sacha Dennett",
      advisor: "Ameliah Maio",
      referralUser: "Emilio Williams",
      id: 1721,
      caseRef: "SAG1168",
      referredById: 300,
      caseStatusId: 65,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "29",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-16T08:49:34.7893314",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T08:51:46.9758871",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 176.79,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-16T11:58:15.74182",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Michaela Cooke",
      advisor: "Charlotte Innes",
      referralUser: "Derran Dooley",
      id: 1726,
      caseRef: "SAG1169",
      referredById: 175,
      caseStatusId: 27,
      developmentId: 25,
      purchasePrice: 1700000,
      plotNumber: "288",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Exchanging ASAP, completion aimed for 9th Sepetember\n\ntried on 16/08/2022 and left VM",
      dateOfReferral: "2022-08-16T09:46:56.9951656",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T10:50:32.9679221",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 30000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "David Ship",
      advisor: "Charlotte Innes",
      referralUser: "Derran Dooley",
      id: 1727,
      caseRef: "SAG1170",
      referredById: 175,
      caseStatusId: 27,
      developmentId: 25,
      purchasePrice: 170000,
      plotNumber: "288",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-16T09:52:49.7432273",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T17:47:25.5270145",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Leanne Rodriguez-Reid",
      advisor: "Jessica Allison",
      referralUser: "Dominka Zych",
      id: 1731,
      caseRef: "SAG1171",
      referredById: 165,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "318 82 Morpheth Crescent Houghton Regis LU5 6QW",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-16T10:42:41.0239767",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T10:48:16.7557275",
      isDeleted: 0,
      advisorId: 100,
      propertyStatusId: 39,
      depositLevel: 70000,
      serviceCharge: 579.15,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Tania Lali",
      advisor: "Aaron Heer",
      referralUser: "Graham Lang",
      id: 1733,
      caseRef: "SAG1172",
      referredById: 104,
      caseStatusId: 28,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "34 or 36 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ICU Nurse \n\nI spoke to mother and she didn't know salary for Tania \n\nPLEASE CALL AFTER 5pm TODAY - she is on shifts \n\nNo Loans or CC balances \n\nHas £20,000 deposit and could get gift from family if needed ",
      dateOfReferral: "2022-08-16T11:22:05.0018647",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T13:51:25.9791282",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Homes",
      financialDetailsId: 581,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Anushalini Rayichandran",
      advisor: "Aaron Heer",
      referralUser: "Graham Lang",
      id: 1734,
      caseRef: "SAG1173",
      referredById: 104,
      caseStatusId: 27,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "34 or 36 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "These details are for the wife \n\nhe has 2 jobs \n\nF/T - £24,000\nP/T - £9,665\n\nNo Loans \n\n\nCall at anytime ",
      dateOfReferral: "2022-08-16T11:29:01.9976903",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T16:21:49.7201305",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 39,
      depositLevel: 21000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Brandon Wilson",
      advisor: "Charlotte Fay",
      referralUser: "Nicola Pike",
      id: 1737,
      caseRef: "SAG1174",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-16T12:53:14.0799298",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T12:55:20.8848789",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 60000,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "2022-08-17T09:02:01.8888256",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Farrukh Shahzad",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1739,
      caseRef: "SAG1175",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: "b10509",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-16T12:59:18.3569311",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T13:01:34.3229954",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-16T14:40:48.8757402",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Alex Reade",
      advisor: "Rachel Davies",
      referralUser: "Vicki Hough",
      id: 1743,
      caseRef: "SAG1178",
      referredById: 322,
      caseStatusId: 27,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0000000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Macclesfield Applicant - not new build.\n\nMortgage purchase – spoken to Nationwide & Natwest. Already spoken to Northwich’s just mortgages advisor but they didn’t follow up with them. \n\nIn rented.\n\nPurchasing independently.\n\nWanting to view Newton Street in Macclesfield.\n",
      dateOfReferral: "2022-08-16T13:32:14.5010952",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T12:44:13.8950673",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Jessica Oldfield",
      advisor: "Laura Turner",
      referralUser: "Steven Merralls",
      id: 1747,
      caseRef: "SAG1180",
      referredById: 243,
      caseStatusId: 27,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Works for NHS\nAnytime today available\nBetween 11am-3pm Wednesday is ok",
      dateOfReferral: "2022-08-16T14:30:35.4088778",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T11:00:28.0920828",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 35000,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Younes Niazi",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1749,
      caseRef: "SAG1181",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: "b10607",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-16T14:48:16.337351",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-16T14:50:54.1155354",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Alice Nestor",
      advisor: "Matthew Laws",
      referralUser: "Taylor Ruff ",
      id: 1752,
      caseRef: "SAG1182",
      referredById: 74,
      caseStatusId: 65,
      developmentId: 30,
      purchasePrice: 460000,
      plotNumber: "203",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Motion - 33K annual salary - FTB - teacher - 20K deposit. ",
      dateOfReferral: "2022-08-16T16:46:35.4197311",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T12:19:10.4185741",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: 580,
      closedDate: "2022-08-17T12:19:17.188064",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "MR RYAN TILL",
      advisor: "Jessica Allison",
      referralUser: "Joe Evans",
      id: 1757,
      caseRef: "SAG1183",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT A NEW BUILD/SHARED OWNERSHIP LEAD - we have valued his property today which is just in his name. he is looking to buy with his partner for their new property. current lender is nationwide and has £112k outstanding. is 2 years into a 5 year fixed deal. he is an engineer and she is a care worker. PLEASE CALL FRIDAY 19/08/2022 IN THE AFTERNOON. thanks. Jo",
      dateOfReferral: "2022-08-17T10:03:37.7377162",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T13:51:08.2257699",
      isDeleted: 0,
      advisorId: 100,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ruben Wharton",
      advisor: "Charlotte Innes",
      referralUser: "Charlotte Fay",
      id: 1759,
      caseRef: "SAG1184",
      referredById: 307,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 140000,
      plotNumber: "N/a",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Full time, permeant: Industrial Site Maintenance Ltd\n\nJob title: Mobile Operative \n\nDeals with waste management, industrial maintenance, visiting sites - works out on site. \n\nHas seen a few properties he is interested in.. Currently looking at FMV between 140 - 170k.  Working out what deposit he would be able to put down. \n\nFTB.  Currently private tenant.  Would like to look at standard purchase. \n26,000 basic. Earns around 12 - 15k each year in over time. \n\n",
      dateOfReferral: "2022-08-17T10:20:28.9768797",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T11:13:23.3855362",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 579,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 384,
    },
    {
      applicant: "Kirstie Partington",
      advisor: "Aaron Heer",
      referralUser: "Sara Dickens",
      id: 1761,
      caseRef: "SAG1185",
      referredById: 202,
      caseStatusId: 28,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "plot 156 4 Billington Place ",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Kirsties partner will be applying for the mortgage and shared ownership on his own.",
      dateOfReferral: "2022-08-17T10:54:53.7194312",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-14T15:37:57.4274165",
      isDeleted: 0,
      advisorId: 98,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "sage Homes ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Stephnie Lyon",
      advisor: "Laura Turner",
      referralUser: "Steven Merralls",
      id: 1762,
      caseRef: "SAG1186",
      referredById: 243,
      caseStatusId: 26,
      developmentId: 65,
      purchasePrice: 235000,
      plotNumber: "79",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Looking to see if she can afford these property\nHas a house to sell\n25-30k deposit",
      dateOfReferral: "2022-08-17T10:56:32.1772646",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T10:58:02.435032",
      isDeleted: 0,
      advisorId: 8,
      propertyStatusId: 39,
      depositLevel: 25,
      serviceCharge: 80,
      minPercShareAvailable: "50",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 121,
    },
    {
      applicant: "Mat Bonner",
      advisor: "Fiona Wilson",
      referralUser: "Charlotte Fay",
      id: 1769,
      caseRef: "SAG1187",
      referredById: 307,
      caseStatusId: 26,
      developmentId: 27,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Home mover, employed. \n\nWas originally looking to port his current mortgage but now considering other options as he thinks he may be charged too much to do this.  He is happy to look at options as a comparison. \n\nHe has a solicitor in place already, family friend, who he is happy with. \n\nHe has see a property with Haart he would like to put an offer in on but just waiting for confirmation his cat, Chewy would be able to move in with him too. Chewy was a lock down companion and a non-negotiable! \n\nOpportunity for insurances as he thinking of those too now. \n\nMat and his partner have separated (reason for move), amicable and still sees her family.   ",
      dateOfReferral: "2022-08-17T12:21:07.2580011",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T12:55:25.2710709",
      isDeleted: 0,
      advisorId: 86,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 384,
    },
    {
      applicant: "Sarah Bugliarello",
      advisor: "Lindsay Davey",
      referralUser: "Nicola Pike",
      id: 1771,
      caseRef: "SAG1188",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "Plot 156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Legals Sold & Quote Emailed",
      dateOfReferral: "2022-08-17T13:00:31.5081651",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:35:47.1699478",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 120000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Graham Boon",
      advisor: "Rachel Davies",
      referralUser: "Vicki Hough",
      id: 1776,
      caseRef: "SAG1189",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "REMORTGAGE INQUIRY\nAvailable telephone appt time Mon - Fri from 10am -8pm\nBut he would love also to visit your office if needed.\nPls call him ASAP\nDon't want to give any other details except for his phone and email address.\n\nThanks, OLT",
      dateOfReferral: "2022-08-17T14:01:27.3934394",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T14:10:47.3905951",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Petronela Mascan",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 1777,
      caseRef: "SAG1190",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 290000,
      plotNumber: "Plot 144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "17/08/22 - Taken by Matthew Laws for qualifying \n                - VM left ",
      dateOfReferral: "2022-08-17T14:13:30.7901014",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T14:57:55.3098059",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "40%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "David Allen",
      advisor: "Peter Hill",
      referralUser: "Cassie Tovell",
      id: 1779,
      caseRef: "SAG1191",
      referredById: 373,
      caseStatusId: 26,
      developmentId: 69,
      purchasePrice: 425000,
      plotNumber: "203, 1 Spindle walk",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Kritika Dhain- Client has qualified for 55% share but may be able to put in extra £750 as a deposit to qualify for 60% share",
      dateOfReferral: "2022-08-17T14:16:23.1592472",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T11:17:19.7932915",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 95,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Sophia Ha",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 1781,
      caseRef: "SAG1193",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 450000,
      plotNumber: "b10605",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "If not affordable at £450k can you try £437500, service charge is all the same. ",
      dateOfReferral: "2022-08-17T14:35:07.2416844",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T15:36:29.9102614",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 582,
      closedDate: "2022-08-17T16:05:12.9922869",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Xuxin Wang",
      advisor: "Medihya Akram",
      referralUser: "Jas Sagoo",
      id: 1784,
      caseRef: "SAG1195",
      referredById: 299,
      caseStatusId: 27,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-17T15:14:31.2863395",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-17T16:55:35.553767",
      isDeleted: 0,
      advisorId: 78,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: 585,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Paul and Natalie Robey",
      advisor: "Phillip Nutter",
      referralUser: "Joe Evans",
      id: 1789,
      caseRef: "SAG1197",
      referredById: 35,
      caseStatusId: 27,
      developmentId: 23,
      purchasePrice: 250000,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT A NEW BUILD OR SAGE HOUSE - THEY HAVE JUST COME OTM WITH US FOR OFFERS OVER £250,000 - THEY ARE LOOKING TO STAY LOCAL BUT BUY A BIGGER HOUSE. PLEASE CALL WITHIN THE NEXT 24 HOURS. MANY THANKS, JO\n\nPaul Edwin 08/02/1975\nNatalie 08/10/1985\n\n18 months current property - West Brom os £59,000 2 year fixed nov 2022.\n\n54 Highfied Grove\nST17 9RF\n5 years\n\nPaul employed Coleena - just started Warehouse order picker - £25,591pa. Stone Group - 3 months, Screwfix 2 years\n\nNatalie Care Promise - 5 Months - £350pcm/£400pcm.\n\nChildren 7 and 3. Child benefit\n\n£6000 CC Aqua - Nataliec- to be repaid\n£15000 loan Natwest £300pcm Paul - to be repaid\n\nNo credit issues.\n\n£270k property. £110k Mortgage.\n ",
      dateOfReferral: "2022-08-17T15:45:39.421273",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T14:32:08.5907157",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Adenike Adebambox",
      advisor: "Jason White",
      referralUser: "Nicola Pike",
      id: 1795,
      caseRef: "SAG1198",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 295000,
      plotNumber: "Plot 144",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: "FTB\n\nLegals Sold & Quote Emailed",
      dateOfReferral: "2022-08-18T09:05:35.2084251",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T13:23:01.3409167",
      isDeleted: 0,
      advisorId: 439,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Samantha Wilson",
      advisor: "Agne Slepetyte",
      referralUser: "Vicki Hough",
      id: 1798,
      caseRef: "SAG1199",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Congleton Applicant\nNot new build\nCurrently going through a divorce\nGoing to court to confirm division of equity on her current property - valued at £300,000 - used Help to Buy.\nLooking to move to Congleton - has no idea of what her budget should be.",
      dateOfReferral: "2022-08-18T09:17:39.0788498",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T10:05:38.5900628",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Lukasz Domagalski",
      advisor: "Agne Slepetyte",
      referralUser: "Vicki Hough",
      id: 1801,
      caseRef: "SAG1200",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "FTB\nGOT AIP FROM HALIFAX WITH MAX £160K.\nHe wants to see Hutton Drive OIEO £160k. But I suggested to have FS appt to get better mortgage deals normally property now is sold more than the asking price. Maybe he can have higher AIP plus low interest.\n\nThanks, OLT. Pls keep us posted.",
      dateOfReferral: "2022-08-18T09:58:22.4157312",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T10:07:00.2985059",
      isDeleted: 0,
      advisorId: 95,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Chun Ling Pang",
      advisor: "Rachel Davies",
      referralUser: "Ali Abbas",
      id: 1802,
      caseRef: "SAG1201",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 3675000,
      plotNumber: "b10710",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She is looking at the 1 and 2 bedrooms, just wants to know what she can qualify for.\n\nIf you can send me an email before calling her I can send you the price list for both and you can see if she can afford a 2 bedroom if not how much can she afford for a 1 bedroom. \n\nThank you. \n\n",
      dateOfReferral: "2022-08-18T10:16:18.4658899",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T12:02:54.4276856",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 173.18,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 586,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 110,
    },
    {
      applicant: "Carol Morse",
      advisor: "Phillip Nutter",
      referralUser: "Callum Morton",
      id: 1803,
      caseRef: "SAG1202",
      referredById: 152,
      caseStatusId: 26,
      developmentId: 29,
      purchasePrice: 0,
      plotNumber: "TBC",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Called to register with us for properties but is new to the shared ownership scheme and wants to discuss mortgages and deposits. She has not yet seen a property but wanted to speak to someone early on in the process",
      dateOfReferral: "2022-08-18T10:45:58.2856436",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T12:25:29.5363023",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: "TBC",
      housingAssociation: "TBC",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Martina Croconbe ",
      advisor: "Alison Cathcart",
      referralUser: "Kathryn Gibb",
      id: 1806,
      caseRef: "SAG1203",
      referredById: 191,
      caseStatusId: 27,
      developmentId: 41,
      purchasePrice: null,
      plotNumber: null,
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Martina & Kivanc have previously been qualified by JM and were interested in this property previously.  The timing wasn't quite right as they were about to have their second child but are now ready to proceed. ",
      dateOfReferral: "2022-08-18T11:39:06.2265471",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T09:24:32.3150684",
      isDeleted: 0,
      advisorId: 93,
      propertyStatusId: 39,
      depositLevel: 23000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE ",
      financialDetailsId: 596,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Konah William",
      advisor: "Ameliah Maio",
      referralUser: "Ali Abbas",
      id: 1807,
      caseRef: "SAG1204",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 462500,
      plotNumber: "b10609",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-18T11:40:12.9201368",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T11:40:56.2198843",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "James Moss",
      advisor: "Phillip Nutter",
      referralUser: "Reuben Gittings",
      id: 1808,
      caseRef: "SAG1205",
      referredById: 215,
      caseStatusId: 27,
      developmentId: 23,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Wants to upsize to bigger property. Selling with us, does not have a mortgage in principal yet. Please call to assist. Thanks",
      dateOfReferral: "2022-08-18T12:07:37.810842",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T15:43:18.134698",
      isDeleted: 0,
      advisorId: 58,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Sammie Williams",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 1809,
      caseRef: "SAG1206",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "Plot 156",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\n\nPlease can someone call asap as this is the final plot\n\nLegals Sold & Quote Emailed\n\n18/08/22 - Taken by Matthew Laws for qualifying\n                - Qualifying call booked in at 17:30",
      dateOfReferral: "2022-08-18T12:17:44.8642327",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T17:15:52.0905115",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 587,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Mr Christopher Barry Davies",
      advisor: "Shanaz Parbin",
      referralUser: "Joe Evans",
      id: 1811,
      caseRef: "SAG1207",
      referredById: 35,
      caseStatusId: 65,
      developmentId: 23,
      purchasePrice: 215000,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT A NEW BUILD/SHARED OWNERSHIP REFERRAL - Please call Barry asap today - he has offered on 5 Park Crescent, ST17 9BQ through us at £215,000 (property is on market for offers over £200k) - has said he is putting £125k deposit down and has AIP in place with halifax for up to £103k. said we will need to do financial checks to verify offer. PLEASE CALL ASAP TODAY - BARRY 07970 371579. Thanks, Jo at BJB Stafford",
      dateOfReferral: "2022-08-18T13:26:20.9506499",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T13:44:22.7989919",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 125000,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-18T14:26:01.4590542",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Ethan Gilbert",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Elliot Piper",
      id: 1812,
      caseRef: "SAG1208",
      referredById: 144,
      caseStatusId: 27,
      developmentId: 27,
      purchasePrice: 315000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "PLEASE NOTE THIS IS ACUALLY FOR SKYLARK WAY LONG MELFORD",
      dateOfReferral: "2022-08-18T13:42:34.5711946",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T14:34:10.5332508",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: "SAGE",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Sophia Ha",
      advisor: "Charlotte Fay",
      referralUser: "Ali Abbas",
      id: 1813,
      caseRef: "SAG1209",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 437500,
      plotNumber: "b10305",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-18T14:05:51.1106157",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T08:39:48.8999346",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 588,
      closedDate: "2022-08-19T08:46:51.7183135",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Mustak Master ",
      advisor: "Charlotte Fay",
      referralUser: "Graham Lang",
      id: 1814,
      caseRef: "SAG1210",
      referredById: 104,
      caseStatusId: 65,
      developmentId: 60,
      purchasePrice: 275000,
      plotNumber: "36",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Says he earns £30,000\n\nNeed a quick turnaround on this as I have others that are interested in the plot please call asap ",
      dateOfReferral: "2022-08-18T14:08:21.3629793",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T14:10:09.8776797",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "45",
      housingAssociation: "Sage Housing",
      financialDetailsId: null,
      closedDate: "2022-08-19T13:43:59.7807837",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 104,
    },
    {
      applicant: "Mr Daryl Archer",
      advisor: "Shanaz Parbin",
      referralUser: "Damian Herrelle",
      id: 1815,
      caseRef: "SAG1211",
      referredById: 177,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "318",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Cash buying from sale sale of [property. Not on market yet but going on with ",
      dateOfReferral: "2022-08-18T14:25:38.6258911",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T14:27:35.9246409",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 390000,
      serviceCharge: 579,
      minPercShareAvailable: "50",
      housingAssociation: "Sage Housing Association",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Jilna Solanki",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 1816,
      caseRef: "SAG1212",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 450000,
      plotNumber: "b10605",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes:
        "Has previously been qualified but cant find her HCA, \nShe can afford up to 450k and has been qualified for 75% ownership as they will be using cash to purchase. \n\nShe just wants to know what the monthly rent will be and also she is also buying parking which is an extra 30k which is not included in the property purchase price. ",
      dateOfReferral: "2022-08-18T14:28:52.8350113",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T14:37:27.1094064",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 337500,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-18T15:15:14.7132129",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jessica Welch",
      advisor: "Ameliah Maio",
      referralUser: "Reiss Garwood",
      id: 1817,
      caseRef: "SAG1213",
      referredById: 101,
      caseStatusId: 65,
      developmentId: 22,
      purchasePrice: 480000,
      plotNumber: "235",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "Wants to be called on monday in possible ",
      dateOfReferral: "2022-08-18T14:35:10.8685082",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T14:38:18.1058345",
      isDeleted: 0,
      advisorId: 416,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "peabody ",
      financialDetailsId: null,
      closedDate: "2022-08-22T08:45:57.1506675",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "James Norbury",
      advisor: "Rachel Davies",
      referralUser: "Vicki Hough",
      id: 1819,
      caseRef: "SAG1214",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "00000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Congleton Applicant\nNot New Build\nPURCHASING WITH ZOE COOPER\nFirst Time Buyers\nPreviously spoken to the broker at Reeds Rains but ntohing up to date.\nViewing Hutton Drive @ £160,000.",
      dateOfReferral: "2022-08-18T15:17:02.1562391",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-18T16:12:27.1480474",
      isDeleted: 0,
      advisorId: 85,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Rohan Davids",
      advisor: "Lindsay Davey",
      referralUser: "Reiss Garwood",
      id: 1825,
      caseRef: "SAG1215",
      referredById: 101,
      caseStatusId: 27,
      developmentId: 22,
      purchasePrice: 480000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-18T16:43:53.9639909",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T16:26:44.5081404",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 6000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody",
      financialDetailsId: 591,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Jaz Singh",
      advisor: "Gemma Painter",
      referralUser: "Ali Abbas",
      id: 1827,
      caseRef: "SAG1216",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: "b10509",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-19T08:16:12.615895",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T08:20:34.7936347",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 40,
      depositLevel: 40000,
      serviceCharge: 217.55,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Catherine Gell",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 1828,
      caseRef: "SAG1217",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 240000,
      plotNumber: "Plot 111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB living with parents have been speaking with the mortgage brain has talked to her about using us as it keeps it in house and that you guys more than likely get them a better deal.\n\nThey are on Honeymoon and will be back on Wednesday, could you please call her then. This is the last plot so hopefully will be still available.\n\nLegals Sold & quote emailed",
      dateOfReferral: "2022-08-19T08:38:20.6900961",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T08:39:40.33992",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 12000,
      serviceCharge: 50,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Mary Ann Macalino",
      advisor: "Matthew Laws",
      referralUser: "Ali Abbas",
      id: 1830,
      caseRef: "SAG1218",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 355000,
      plotNumber: "b10404",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "19/08/22 - Taken by Matthew Laws for qualifying \n                - No answer, email sent ",
      dateOfReferral: "2022-08-19T09:12:07.216652",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T12:29:21.0288282",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 592,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Nicola Scott",
      advisor: "Lindsay Davey",
      referralUser: "Nicola Pike",
      id: 1831,
      caseRef: "SAG1219",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 295000,
      plotNumber: "Plot 144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Could this be called ASAP as will be a cash purchase just needs qualifying please.\n\nLegals Sold & Quote emailed.\n\nCASH PURCHASE \nThis is qualified and has been passed back to the EA - the milestone is just not showing on the case. ",
      dateOfReferral: "2022-08-19T09:24:07.5326112",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:35:25.397775",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 39,
      depositLevel: null,
      serviceCharge: 221250,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: 590,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Lorna Greig",
      advisor: "Charlotte Fay",
      referralUser: "Stephen Heath",
      id: 1832,
      caseRef: "SAG1220",
      referredById: 194,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 98000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 1,
      so: 1,
      keyNotes: "Has pension coming in on monthly basis",
      dateOfReferral: "2022-08-19T09:33:58.3643909",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T09:35:06.2443766",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 119999,
      serviceCharge: 720,
      minPercShareAvailable: "35",
      housingAssociation: "Sage Homes",
      financialDetailsId: null,
      closedDate: "2022-08-19T13:46:55.1482863",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Simeon Sealby",
      advisor: "Gemma Painter",
      referralUser: "Nicola Pike",
      id: 1833,
      caseRef: "SAG1221",
      referredById: 29,
      caseStatusId: 27,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB currently in rented\nLooking to buy 50%\nMr is employed and Mrs a housewife\n\nLegals Sold & Quote Emailed",
      dateOfReferral: "2022-08-19T09:48:12.9199978",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T16:47:22.7952159",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "35%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Iwona Zakaria",
      advisor: "Matthew Laws",
      referralUser: "Nicola Pike",
      id: 1834,
      caseRef: "SAG1222",
      referredById: 29,
      caseStatusId: 65,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB currently renting\n\nLegals Sold & quote emailed",
      dateOfReferral: "2022-08-19T10:32:25.8740584",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T17:19:56.0538151",
      isDeleted: 0,
      advisorId: 308,
      propertyStatusId: 39,
      depositLevel: 7000,
      serviceCharge: 60,
      minPercShareAvailable: "35%",
      housingAssociation: "Sage",
      financialDetailsId: 595,
      closedDate: "2022-08-19T17:24:03.4517851",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Melban Travasso",
      advisor: "Lindsay Davey",
      referralUser: "Emilio Williams",
      id: 1835,
      caseRef: "SAG1223",
      referredById: 300,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 435000,
      plotNumber: "44",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-19T11:01:28.7564816",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:35:05.2911417",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 25000,
      serviceCharge: 176.13,
      minPercShareAvailable: "25",
      housingAssociation: "Sage housing ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Andena  Yearwood ",
      advisor: "Charlotte Fay",
      referralUser: "Corrina Davie",
      id: 1836,
      caseRef: "SAG1224",
      referredById: 180,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: 220000,
      plotNumber: "335",
      htb: 1,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "She is interested in the Craster Road development which is not been completed and not due until October however just wants to get qualified and on the waiting list.  ",
      dateOfReferral: "2022-08-19T11:18:22.5497661",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T11:19:20.8263771",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 39,
      depositLevel: 20000,
      serviceCharge: 575000,
      minPercShareAvailable: "50% ",
      housingAssociation: "Sage ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Philip and Heather Boffey",
      advisor: "Gemma Painter",
      referralUser: "Joe Evans",
      id: 1838,
      caseRef: "SAG1225",
      referredById: 35,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 400000,
      plotNumber: "00",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "NOT A NEW BUILD/SAGE LEAD - They have offered on a property through us (63 Heronswood, ST17 4QD) they have sold through Caley & Kulen. said has AIP in pace with Lloyds. need offer qualification doing today please. Thanks, Jo",
      dateOfReferral: "2022-08-19T12:18:58.9668465",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T16:48:03.2732192",
      isDeleted: 0,
      advisorId: 17,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Chris Dunn",
      advisor: "Zeeshan Ashraf",
      referralUser: "Danielle Broxham",
      id: 1842,
      caseRef: "SAG1226",
      referredById: 162,
      caseStatusId: 27,
      developmentId: 33,
      purchasePrice: 390000,
      plotNumber: "320",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Really interested in the plot\nLast plot available - please let me know as soon as possible ",
      dateOfReferral: "2022-08-19T14:00:02.1035664",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T12:56:09.0831985",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 673,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 593,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 162,
    },
    {
      applicant: "Paulo Mctaggart",
      advisor: "Shanaz Parbin",
      referralUser: "Cassie Tovell",
      id: 1843,
      caseRef: "SAG1227",
      referredById: 373,
      caseStatusId: 27,
      developmentId: 69,
      purchasePrice: 385000,
      plotNumber: "Sawbrdige Park",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "single buyer \nemployed\n\nNew Site that is coming over in Sawbridge Park\nI don't have the correct service charge just now. x",
      dateOfReferral: "2022-08-19T14:28:45.2279885",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T17:42:31.0362926",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 39,
      depositLevel: 15000,
      serviceCharge: 95,
      minPercShareAvailable: "40",
      housingAssociation: "Sage",
      financialDetailsId: 594,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 19,
    },
    {
      applicant: "Mary Keeling ",
      advisor: "Charlotte Fay",
      referralUser: "Reiss Garwood",
      id: 1845,
      caseRef: "SAG1228",
      referredById: 101,
      caseStatusId: 26,
      developmentId: 22,
      purchasePrice: 114000,
      plotNumber: "199",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-19T15:00:45.3052321",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-20T15:06:15.712019",
      isDeleted: 0,
      advisorId: 307,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Claire Woodward",
      advisor: "Shanaz Parbin",
      referralUser: "Nicola Pike",
      id: 1847,
      caseRef: "SAG1229",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 42,
      purchasePrice: 210000,
      plotNumber: "Plot 156 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Currently living with family \nUnsure of what mortgage she can get as she is 60\n\nLegals sold & quote emailed",
      dateOfReferral: "2022-08-19T16:33:50.1436247",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-19T17:45:06.3831156",
      isDeleted: 0,
      advisorId: 123,
      propertyStatusId: 40,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Laura Binns",
      advisor: "Adam Faulkner",
      referralUser: "Praveena Sharma",
      id: 1848,
      caseRef: "SAG1230",
      referredById: 235,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "ftb- will be purchasing with her partner. her mum called and she didn't have the info for her daughters partner hence no 2nd applicant\n\nShe said Laura has started her mortgage application but not sure if its with us. She's got her deposit saved in Help to buy.\n\nInterested in 3 beds.",
      dateOfReferral: "2022-08-20T09:01:20.35191",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T10:02:43.709295",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 25000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Matthew Clarke",
      advisor: "Adam Faulkner",
      referralUser: "Nicola Pike",
      id: 1849,
      caseRef: "SAG1231",
      referredById: 29,
      caseStatusId: 27,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "Plot 150 ",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\n\nIdeally please call Monday morning\n\nLegals Sold & Quote emailed",
      dateOfReferral: "2022-08-20T09:41:45.8472012",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-22T10:31:59.7182444",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 60,
      minPercShareAvailable: "35%",
      housingAssociation: "Saje",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Carla McIntyre",
      advisor: "Adam Faulkner",
      referralUser: "Ali Abbas",
      id: 1850,
      caseRef: "SAG1232",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 362500,
      plotNumber: "b10604",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-20T09:52:10.5181062",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T10:38:47.327322",
      isDeleted: 0,
      advisorId: 14,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 203.64,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Jigna Bhudiavvvv",
      advisor: "Nadia Bandula ",
      referralUser: "Joanna Gregoriou",
      id: 1851,
      caseRef: "SAG1233",
      referredById: 411,
      caseStatusId: 26,
      developmentId: 58,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Jigna visited office to register for her property search. She purchased her first home through haart in Colindale & now wants to change her mortgage to a btl & will then look to buy in the Barnet area. Currently nothing to offer her but set match profile. Would like an FS appointment on Friday 26th August at 17:00",
      dateOfReferral: "2022-08-20T10:22:30.6409176",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-16T13:35:16.2162518",
      isDeleted: 0,
      advisorId: 44,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Kirsty Roberts",
      advisor: "Zeeshan Ashraf",
      referralUser: "Nicola Pike",
      id: 1853,
      caseRef: "SAG1235",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 41,
      purchasePrice: 280000,
      plotNumber: "150",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB\n\nLooking to only put the mortgage in Kirsty's name as her partner has an IVA.\n\nLegals Sold & Quote emailed",
      dateOfReferral: "2022-08-20T10:34:08.3187091",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T11:03:01.5537448",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 13000,
      serviceCharge: 60,
      minPercShareAvailable: "35%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Konah William",
      advisor: "Charlotte Innes",
      referralUser: "Ali Abbas",
      id: 1854,
      caseRef: "SAG1236",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 460000,
      plotNumber: "b10607",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-20T10:35:46.6458635",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T11:09:55.4734631",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 217.02,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Varsha Panjwani",
      advisor: "Charlotte Innes",
      referralUser: "Ali Abbas",
      id: 1855,
      caseRef: "SAG1237",
      referredById: 312,
      caseStatusId: 27,
      developmentId: 38,
      purchasePrice: 3675000,
      plotNumber: "b10703",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-20T10:47:16.6090838",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-22T07:30:47.846931",
      isDeleted: 0,
      advisorId: 90,
      propertyStatusId: 40,
      depositLevel: 90000,
      serviceCharge: 225.95,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Christopher Cleary",
      advisor: "Peter Hill",
      referralUser: "Praveena Sharma",
      id: 1856,
      caseRef: "SAG1238",
      referredById: 235,
      caseStatusId: 26,
      developmentId: 46,
      purchasePrice: 285000,
      plotNumber: "144",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: "FTB - interested in 3 beds ",
      dateOfReferral: "2022-08-20T11:22:39.2435159",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T13:39:44.4460374",
      isDeleted: 0,
      advisorId: 76,
      propertyStatusId: 39,
      depositLevel: 5000,
      serviceCharge: 50,
      minPercShareAvailable: "50",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Jennifer Blake",
      advisor: "Zeeshan Ashraf",
      referralUser: "Nicola Pike",
      id: 1857,
      caseRef: "SAG1239",
      referredById: 29,
      caseStatusId: 26,
      developmentId: 58,
      purchasePrice: 240000,
      plotNumber: "Plot 111",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "FTB - has had some mortgage advice but was months ago\n\nLegals Sold & Quote Emailed",
      dateOfReferral: "2022-08-20T11:55:03.1669843",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-20T12:04:18.679514",
      isDeleted: 0,
      advisorId: 82,
      propertyStatusId: 39,
      depositLevel: 10000,
      serviceCharge: 60,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Julie & David Prest",
      advisor: "Lindsay Davey",
      referralUser: "Vicki Hough",
      id: 1858,
      caseRef: "SAG1240",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "00000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Congleton Applicant\nNot new build\nTheir current property is just in David's name. They are looking to move to Congleton but nothing they like at the moment. \nThey have spoken to an advisor before through their estate agents at Jordan Fishwick who wouldn't do them an AIP until they found a property.\nThey would be purchasing in joint names.\nContact number is for Julie. Can you please call to arrange a time for them to both speak to you together.",
      dateOfReferral: "2022-08-20T11:55:25.3938349",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:33:51.7501708",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Alex Stordy",
      advisor: "Lindsay Davey",
      referralUser: "Vicki Hough",
      id: 1859,
      caseRef: "SAG1241",
      referredById: 322,
      caseStatusId: 26,
      developmentId: 23,
      purchasePrice: 0,
      plotNumber: "00000",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Congleton Applicant\nNot new build\nWe sold Alex's house for him last year. He is now staying with family. Interested in viewing properties but does not have an in date AIP.\n",
      dateOfReferral: "2022-08-20T12:39:22.1481308",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:33:41.0159114",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 0,
      serviceCharge: 2,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 27,
    },
    {
      applicant: "Xue Xu",
      advisor: "Lindsay Davey",
      referralUser: "Abhishek Joshi",
      id: 1862,
      caseRef: "SAG1242",
      referredById: 314,
      caseStatusId: 26,
      developmentId: 39,
      purchasePrice: 410000,
      plotNumber: "43",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "You may pronounce name like: 'Mr. Shu'\nBluenote - Hayes\n2 bedroom\nShared Ownership\nIncome: £25k\nDeposit: £20k-£30k\nFTB",
      dateOfReferral: "2022-08-22T08:24:33.3040773",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:34:07.6722629",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 149.64,
      minPercShareAvailable: "25",
      housingAssociation: "Sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Nathalie Wilson",
      advisor: "Lindsay Davey",
      referralUser: "Ali Abbas",
      id: 1863,
      caseRef: "SAG1243",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 360000,
      plotNumber: "b10410",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-22T08:35:27.229369",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:34:13.984386",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 15000,
      serviceCharge: 171.34,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Miss Julie Badger",
      advisor: "Lindsay Davey",
      referralUser: "Joe Evans",
      id: 1865,
      caseRef: "SAG1244",
      referredById: 35,
      caseStatusId: 26,
      developmentId: 3,
      purchasePrice: 0,
      plotNumber: "0",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "SAGE QUALIFICATION -  Julie called to enquire about shared ownership houses in penkridge. All plots are sstc and no more plots coming up atm. she is in housing association rented atm and has had NO mortgage advice so far. i said she needs to get full mortgage advice asap so if another plot comes up she is ready to act on it straight away. PLease call within next 24 hours. JE ",
      dateOfReferral: "2022-08-22T08:44:38.4583232",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:35:15.8050005",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 39,
      depositLevel: 0,
      serviceCharge: 0,
      minPercShareAvailable: "25",
      housingAssociation: "sage",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 28,
    },
    {
      applicant: "Juliet Francis",
      advisor: "Lindsay Davey",
      referralUser: "Ali Abbas",
      id: 1866,
      caseRef: "SAG1245",
      referredById: 312,
      caseStatusId: 26,
      developmentId: 38,
      purchasePrice: 437500,
      plotNumber: "b10305",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-22T08:50:22.5266736",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:34:22.0432643",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: 597,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 108,
    },
    {
      applicant: "Kerri Heath",
      advisor: "Jon-Luigi Maio ",
      referralUser: "Ali Abbas",
      id: 1868,
      caseRef: "SAG1246",
      referredById: 312,
      caseStatusId: 65,
      developmentId: 38,
      purchasePrice: 437500,
      plotNumber: "b10305",
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes:
        "Enquired about shared ownership but wage/deposit not high enough. Current deposit 3,000 and saving approx 300pcm. \n\nPartner is currently an apprentice but wage increases July next year to 40k. Applicant earns 19.2k \n\n1 child\n\nWants to speak to an adviser so they have someone on hand for when they are ready to buy next year. ",
      dateOfReferral: "2022-08-22T09:14:07.0383405",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-08-22T10:17:26.1406294",
      isDeleted: 0,
      advisorId: 45,
      propertyStatusId: 40,
      depositLevel: 3000,
      serviceCharge: 213.88,
      minPercShareAvailable: "25",
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "2022-08-22T10:22:08.3593072",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 110,
    },
    {
      applicant: "Almira Gabdullina",
      advisor: "Lindsay Davey",
      referralUser: "Reiss Garwood",
      id: 1877,
      caseRef: "SAG1247",
      referredById: 101,
      caseStatusId: 26,
      developmentId: 22,
      purchasePrice: 630000,
      plotNumber: "34",
      htb: 1,
      cashBuyer: 0,
      so: 0,
      keyNotes:
        "Needs to know  her help to buy budget before Thursday where she views the Scene from Peabody ",
      dateOfReferral: "2022-08-22T10:48:05.0171378",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:32:06.373326",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 30000,
      serviceCharge: 168,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 101,
    },
    {
      applicant: "Peter Gough ",
      advisor: "Lindsay Davey",
      referralUser: "Corrina Davie",
      id: 1879,
      caseRef: "SAG1248",
      referredById: 180,
      caseStatusId: 26,
      developmentId: 33,
      purchasePrice: null,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 1,
      keyNotes: null,
      dateOfReferral: "2022-08-22T11:03:59.663566",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-11-01T15:31:58.2597812",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 39,
      depositLevel: 40000,
      serviceCharge: null,
      minPercShareAvailable: "50%",
      housingAssociation: "Sage Housing  ",
      financialDetailsId: null,
      closedDate: "0001-01-01T00:00:00",
      isClosed: 0,
      administratorId: null,
      lnhManagerId: 107,
    },
    {
      applicant: "Ciprian Hutanu",
      advisor: "Lindsay Davey",
      referralUser: "Reiss Garwood",
      id: 1881,
      caseRef: "SAG1249",
      referredById: 101,
      caseStatusId: 65,
      developmentId: 22,
      purchasePrice: 457000,
      plotNumber: "199 ",
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-08-22T11:15:10.1741495",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-22T14:59:04.5703956",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: 20000,
      serviceCharge: 194,
      minPercShareAvailable: "25",
      housingAssociation: "Peabody ",
      financialDetailsId: null,
      closedDate: "2022-10-14T10:12:44.2945587",
      isClosed: 1,
      administratorId: 47,
      lnhManagerId: 101,
    },
    {
      applicant: "Bob Bobson",
      advisor: "Lindsay Davey",
      referralUser: "Jason White",
      id: 1883,
      caseRef: "SAG1250",
      referredById: 439,
      caseStatusId: 65,
      developmentId: 51,
      purchasePrice: 50000,
      plotNumber: null,
      htb: 0,
      cashBuyer: 0,
      so: 0,
      keyNotes: null,
      dateOfReferral: "2022-09-20T11:16:25.9361759",
      offerExpiryDate: "0001-01-01T00:00:00",
      updatedDate: "2022-09-22T14:58:48.6016475",
      isDeleted: 0,
      advisorId: 4,
      propertyStatusId: 40,
      depositLevel: null,
      serviceCharge: null,
      minPercShareAvailable: null,
      housingAssociation: null,
      financialDetailsId: 601,
      closedDate: "2022-10-14T10:13:23.3550097",
      isClosed: 1,
      administratorId: null,
      lnhManagerId: 124,
    },
  ];
}
